// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/common/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IBidsClient {
    getList(param: DataListGetParamsOfBidListFilters | null): Promise<DataListResultOfBidModelListView>;
    sendBidEmail(model: SendBidEmailModel | null): Promise<void>;
    sendBidEmailForce(model: SendBidEmailModel | null): Promise<void>;
    createBid(model: CreateBidModel | null): Promise<void>;
    rejectBid(id: number): Promise<void>;
    createOrder(id: number): Promise<number>;
    createOrderForce(id: number): Promise<number>;
    setAsViewed(id: number): Promise<void>;
    hideBid(id: number): Promise<void>;
    getBidInfo(externalOrderBidId: number | undefined): Promise<BidModelView>;
    getNewBidInfo(externalOrderId: number | undefined): Promise<BidModelView>;
    getRecommendedRate(originState: string | null | undefined, destinationState: string | null | undefined, vehicleType: VehicleType | undefined): Promise<number | null>;
    recalculateRoute(postedOrderId: number | undefined, vehicleId: number | undefined): Promise<PostedRouteSummary>;
}

export class BidsClient extends AuthorizedApiBase implements IBidsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfBidListFilters | null, signal?: AbortSignal): Promise<DataListResultOfBidModelListView> {
        let url_ = this.baseUrl + "/company/Bids/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfBidModelListView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfBidModelListView.fromJS(resultData200);
            return Promise.resolve<DataListResultOfBidModelListView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfBidModelListView>(null as any);
    }

    sendBidEmail(model: SendBidEmailModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/SendBidEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendBidEmail(_response);
        });
    }

    protected processSendBidEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendBidEmailForce(model: SendBidEmailModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/SendBidEmailForce";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendBidEmailForce(_response);
        });
    }

    protected processSendBidEmailForce(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createBid(model: CreateBidModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/CreateBid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBid(_response);
        });
    }

    protected processCreateBid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    rejectBid(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/RejectBid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectBid(_response);
        });
    }

    protected processRejectBid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createOrder(id: number, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Bids/CreateOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    createOrderForce(id: number, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Bids/CreateOrderForce/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrderForce(_response);
        });
    }

    protected processCreateOrderForce(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    setAsViewed(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/SetAsViewed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetAsViewed(_response);
        });
    }

    protected processSetAsViewed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    hideBid(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Bids/HideBid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHideBid(_response);
        });
    }

    protected processHideBid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getBidInfo(externalOrderBidId: number | undefined, signal?: AbortSignal): Promise<BidModelView> {
        let url_ = this.baseUrl + "/company/Bids/GetBidInfo?";
        if (externalOrderBidId === null)
            throw new Error("The parameter 'externalOrderBidId' cannot be null.");
        else if (externalOrderBidId !== undefined)
            url_ += "externalOrderBidId=" + encodeURIComponent("" + externalOrderBidId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBidInfo(_response);
        });
    }

    protected processGetBidInfo(response: AxiosResponse): Promise<BidModelView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidModelView.fromJS(resultData200);
            return Promise.resolve<BidModelView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidModelView>(null as any);
    }

    getNewBidInfo(externalOrderId: number | undefined, signal?: AbortSignal): Promise<BidModelView> {
        let url_ = this.baseUrl + "/company/Bids/GetNewBidInfo?";
        if (externalOrderId === null)
            throw new Error("The parameter 'externalOrderId' cannot be null.");
        else if (externalOrderId !== undefined)
            url_ += "externalOrderId=" + encodeURIComponent("" + externalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewBidInfo(_response);
        });
    }

    protected processGetNewBidInfo(response: AxiosResponse): Promise<BidModelView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidModelView.fromJS(resultData200);
            return Promise.resolve<BidModelView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidModelView>(null as any);
    }

    getRecommendedRate(originState: string | null | undefined, destinationState: string | null | undefined, vehicleType: VehicleType | undefined, signal?: AbortSignal): Promise<number | null> {
        let url_ = this.baseUrl + "/company/Bids/GetRecommendedRate?";
        if (originState !== undefined && originState !== null)
            url_ += "originState=" + encodeURIComponent("" + originState) + "&";
        if (destinationState !== undefined && destinationState !== null)
            url_ += "destinationState=" + encodeURIComponent("" + destinationState) + "&";
        if (vehicleType === null)
            throw new Error("The parameter 'vehicleType' cannot be null.");
        else if (vehicleType !== undefined)
            url_ += "vehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecommendedRate(_response);
        });
    }

    protected processGetRecommendedRate(response: AxiosResponse): Promise<number | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number | null>(null as any);
    }

    recalculateRoute(postedOrderId: number | undefined, vehicleId: number | undefined, signal?: AbortSignal): Promise<PostedRouteSummary> {
        let url_ = this.baseUrl + "/company/Bids/RecalculateRoute?";
        if (postedOrderId === null)
            throw new Error("The parameter 'postedOrderId' cannot be null.");
        else if (postedOrderId !== undefined)
            url_ += "postedOrderId=" + encodeURIComponent("" + postedOrderId) + "&";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculateRoute(_response);
        });
    }

    protected processRecalculateRoute(response: AxiosResponse): Promise<PostedRouteSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostedRouteSummary.fromJS(resultData200);
            return Promise.resolve<PostedRouteSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostedRouteSummary>(null as any);
    }
}

export interface ICarrierClient {
    getList(param: DataListGetParamsOfCarrierListFilters | null): Promise<DataListResultOfCarrierListModel>;
    getShortList(): Promise<CarrierShortListModel[]>;
    upsert(model: CarrierEditModel | null): Promise<void>;
    activate(id: number): Promise<void>;
    getById(id: number): Promise<CarrierEditModel>;
    deactivate(id: number): Promise<void>;
    addOrderRating(model: RatingEditModel | null): Promise<void>;
    addOrderRatingNote(model: CarrierRatingNoteEditModel | null): Promise<void>;
}

export class CarrierClient extends AuthorizedApiBase implements ICarrierClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfCarrierListFilters | null, signal?: AbortSignal): Promise<DataListResultOfCarrierListModel> {
        let url_ = this.baseUrl + "/company/Carrier/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfCarrierListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfCarrierListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfCarrierListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfCarrierListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<CarrierShortListModel[]> {
        let url_ = this.baseUrl + "/company/Carrier/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<CarrierShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarrierShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierShortListModel[]>(null as any);
    }

    upsert(model: CarrierEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Carrier/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Carrier/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<CarrierEditModel> {
        let url_ = this.baseUrl + "/company/Carrier/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CarrierEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarrierEditModel.fromJS(resultData200);
            return Promise.resolve<CarrierEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierEditModel>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Carrier/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addOrderRating(model: RatingEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Carrier/AddOrderRating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderRating(_response);
        });
    }

    protected processAddOrderRating(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addOrderRatingNote(model: CarrierRatingNoteEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Carrier/AddOrderRatingNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderRatingNote(_response);
        });
    }

    protected processAddOrderRatingNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICompanyIntegrationClient {
    getEmailSmtpSettingTypes(): Promise<EmailSmtpSettingType[]>;
    getList(param: DataListGetParamsOfCompanyIntegrationListFilters | null): Promise<DataListResultOfCompanyIntegrationListModel>;
    getLogList(param: DataListGetParamsOfCompanyIntegrationLogListFilters | null): Promise<DataListResultOfCompanyIntegrationLogListModel>;
    getShortListByType(type: number | null | undefined): Promise<NamedValueLong[]>;
    getShortListForSmtpSender(): Promise<NamedValueLong[]>;
    upsert(model: CompanyIntegrationEditModel | null): Promise<number>;
    activate(id: number): Promise<void>;
    getById(id: number): Promise<CompanyIntegrationEditModel>;
    deactivate(id: number): Promise<void>;
    upsertUserSettings(model: CompanyIntegrationUserEditModel | null): Promise<void>;
    getUserSettings(type: CompanyIntegrationType | undefined): Promise<CompanyIntegrationUserListModel[]>;
    refreshIntegrationDataForCurrentUser(integrationId: number | undefined): Promise<void>;
    generateForwardEmail(): Promise<string>;
    upsertIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | null | undefined, name: string | null | undefined, type: IntegrationSettingType | undefined, setting: string | null | undefined): Promise<IntegrationSetting>;
    deleteIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | undefined): Promise<void>;
    getIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | undefined): Promise<IntegrationSetting>;
    getIntegrationSettings(integrationId: number | undefined): Promise<IntegrationSetting[]>;
    authorizeQBO(integrationId: number): Promise<FileResponse>;
    refreshQBOTokenPOST(): Promise<void>;
    refreshQBOTokenGET(id: number): Promise<void>;
    getQBOAccounts(): Promise<QBOAccountItem[]>;
    getQBOAccounts2(id: number): Promise<QBOAccountItem[]>;
}

export class CompanyIntegrationClient extends AuthorizedApiBase implements ICompanyIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getEmailSmtpSettingTypes(signal?: AbortSignal): Promise<EmailSmtpSettingType[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetEmailSmtpSettingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailSmtpSettingTypes(_response);
        });
    }

    protected processGetEmailSmtpSettingTypes(response: AxiosResponse): Promise<EmailSmtpSettingType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailSmtpSettingType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailSmtpSettingType[]>(null as any);
    }

    getList(param: DataListGetParamsOfCompanyIntegrationListFilters | null, signal?: AbortSignal): Promise<DataListResultOfCompanyIntegrationListModel> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfCompanyIntegrationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfCompanyIntegrationListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfCompanyIntegrationListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfCompanyIntegrationListModel>(null as any);
    }

    getLogList(param: DataListGetParamsOfCompanyIntegrationLogListFilters | null, signal?: AbortSignal): Promise<DataListResultOfCompanyIntegrationLogListModel> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogList(_response);
        });
    }

    protected processGetLogList(response: AxiosResponse): Promise<DataListResultOfCompanyIntegrationLogListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfCompanyIntegrationLogListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfCompanyIntegrationLogListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfCompanyIntegrationLogListModel>(null as any);
    }

    getShortListByType(type: number | null | undefined, signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetShortListByType?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortListByType(_response);
        });
    }

    protected processGetShortListByType(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    getShortListForSmtpSender(signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetShortListForSmtpSender";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortListForSmtpSender(_response);
        });
    }

    protected processGetShortListForSmtpSender(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    upsert(model: CompanyIntegrationEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<CompanyIntegrationEditModel> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CompanyIntegrationEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyIntegrationEditModel.fromJS(resultData200);
            return Promise.resolve<CompanyIntegrationEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyIntegrationEditModel>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertUserSettings(model: CompanyIntegrationUserEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/UpsertUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertUserSettings(_response);
        });
    }

    protected processUpsertUserSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserSettings(type: CompanyIntegrationType | undefined, signal?: AbortSignal): Promise<CompanyIntegrationUserListModel[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetUserSettings?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSettings(_response);
        });
    }

    protected processGetUserSettings(response: AxiosResponse): Promise<CompanyIntegrationUserListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyIntegrationUserListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompanyIntegrationUserListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyIntegrationUserListModel[]>(null as any);
    }

    refreshIntegrationDataForCurrentUser(integrationId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/RefreshIntegrationDataForCurrentUser?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshIntegrationDataForCurrentUser(_response);
        });
    }

    protected processRefreshIntegrationDataForCurrentUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateForwardEmail(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GenerateForwardEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateForwardEmail(_response);
        });
    }

    protected processGenerateForwardEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    upsertIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | null | undefined, name: string | null | undefined, type: IntegrationSettingType | undefined, setting: string | null | undefined, signal?: AbortSignal): Promise<IntegrationSetting> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/UpsertIntegrationSetting?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        if (integrationSettingId !== undefined && integrationSettingId !== null)
            url_ += "integrationSettingId=" + encodeURIComponent("" + integrationSettingId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (setting !== undefined && setting !== null)
            url_ += "setting=" + encodeURIComponent("" + setting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertIntegrationSetting(_response);
        });
    }

    protected processUpsertIntegrationSetting(response: AxiosResponse): Promise<IntegrationSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationSetting.fromJS(resultData200);
            return Promise.resolve<IntegrationSetting>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationSetting>(null as any);
    }

    deleteIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/DeleteIntegrationSetting?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        if (integrationSettingId === null)
            throw new Error("The parameter 'integrationSettingId' cannot be null.");
        else if (integrationSettingId !== undefined)
            url_ += "integrationSettingId=" + encodeURIComponent("" + integrationSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIntegrationSetting(_response);
        });
    }

    protected processDeleteIntegrationSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getIntegrationSetting(integrationId: number | undefined, integrationSettingId: number | undefined, signal?: AbortSignal): Promise<IntegrationSetting> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetIntegrationSetting?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        if (integrationSettingId === null)
            throw new Error("The parameter 'integrationSettingId' cannot be null.");
        else if (integrationSettingId !== undefined)
            url_ += "integrationSettingId=" + encodeURIComponent("" + integrationSettingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationSetting(_response);
        });
    }

    protected processGetIntegrationSetting(response: AxiosResponse): Promise<IntegrationSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationSetting.fromJS(resultData200);
            return Promise.resolve<IntegrationSetting>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationSetting>(null as any);
    }

    getIntegrationSettings(integrationId: number | undefined, signal?: AbortSignal): Promise<IntegrationSetting[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetIntegrationSettings?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationSettings(_response);
        });
    }

    protected processGetIntegrationSettings(response: AxiosResponse): Promise<IntegrationSetting[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationSetting[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationSetting[]>(null as any);
    }

    authorizeQBO(integrationId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/AuthorizeQBO/{integrationId}";
        if (integrationId === undefined || integrationId === null)
            throw new Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthorizeQBO(_response);
        });
    }

    protected processAuthorizeQBO(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    refreshQBOTokenPOST(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/RefreshQBOToken/RefreshQBOToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshQBOTokenPOST(_response);
        });
    }

    protected processRefreshQBOTokenPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    refreshQBOTokenGET(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/RefreshQBOToken/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshQBOTokenGET(_response);
        });
    }

    protected processRefreshQBOTokenGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getQBOAccounts(signal?: AbortSignal): Promise<QBOAccountItem[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetQBOAccounts/GetQBOAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQBOAccounts(_response);
        });
    }

    protected processGetQBOAccounts(response: AxiosResponse): Promise<QBOAccountItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QBOAccountItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QBOAccountItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QBOAccountItem[]>(null as any);
    }

    getQBOAccounts2(id: number, signal?: AbortSignal): Promise<QBOAccountItem[]> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/GetQBOAccounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQBOAccounts2(_response);
        });
    }

    protected processGetQBOAccounts2(response: AxiosResponse): Promise<QBOAccountItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QBOAccountItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QBOAccountItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QBOAccountItem[]>(null as any);
    }
}

export interface IContactClient {
    getCustomerList(param: DataListGetParamsOfCustomerListFilters | null): Promise<DataListResultOfCustomerListModel>;
    getContactList(param: DataListGetParamsOfContactListFilters | null): Promise<DataListResultOfContactListModel>;
    customerUpsert(model: CustomerEditModel | null): Promise<number>;
    getCustomerDetails(id: number): Promise<CustomerEditModel>;
    contactUpsert(model: ContactEditModel | null): Promise<number>;
    getContactDetails(id: number): Promise<ContactViewModel>;
}

export class ContactClient extends AuthorizedApiBase implements IContactClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getCustomerList(param: DataListGetParamsOfCustomerListFilters | null, signal?: AbortSignal): Promise<DataListResultOfCustomerListModel> {
        let url_ = this.baseUrl + "/company/Contact/GetCustomerList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerList(_response);
        });
    }

    protected processGetCustomerList(response: AxiosResponse): Promise<DataListResultOfCustomerListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfCustomerListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfCustomerListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfCustomerListModel>(null as any);
    }

    getContactList(param: DataListGetParamsOfContactListFilters | null, signal?: AbortSignal): Promise<DataListResultOfContactListModel> {
        let url_ = this.baseUrl + "/company/Contact/GetContactList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContactList(_response);
        });
    }

    protected processGetContactList(response: AxiosResponse): Promise<DataListResultOfContactListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfContactListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfContactListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfContactListModel>(null as any);
    }

    customerUpsert(model: CustomerEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Contact/CustomerUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomerUpsert(_response);
        });
    }

    protected processCustomerUpsert(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCustomerDetails(id: number, signal?: AbortSignal): Promise<CustomerEditModel> {
        let url_ = this.baseUrl + "/company/Contact/GetCustomerDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerDetails(_response);
        });
    }

    protected processGetCustomerDetails(response: AxiosResponse): Promise<CustomerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerEditModel.fromJS(resultData200);
            return Promise.resolve<CustomerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerEditModel>(null as any);
    }

    contactUpsert(model: ContactEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Contact/ContactUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactUpsert(_response);
        });
    }

    protected processContactUpsert(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getContactDetails(id: number, signal?: AbortSignal): Promise<ContactViewModel> {
        let url_ = this.baseUrl + "/company/Contact/GetContactDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContactDetails(_response);
        });
    }

    protected processGetContactDetails(response: AxiosResponse): Promise<ContactViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactViewModel.fromJS(resultData200);
            return Promise.resolve<ContactViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactViewModel>(null as any);
    }
}

export interface IDevClient {
    importZipCodes(): Promise<void>;
    returnTimeZones(): Promise<any[]>;
    getVehicleOrders(id: number | undefined): Promise<FileResponse>;
    getAllOrders(): Promise<FileResponse>;
    clearEmailBox(integrationId: number | undefined): Promise<void>;
    refreshAllVehicleOrders(): Promise<void>;
    setRecurringMasterJobs(): Promise<void>;
    refreshVehicleAvailability(): Promise<void>;
    populateOrderMetrics(): Promise<void>;
    sylectusReadVehicles(): Promise<void>;
    getVehicleAvailabilityRedis(): Promise<VehicleAvailability[]>;
}

export class DevClient extends AuthorizedApiBase implements IDevClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    importZipCodes(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/ImportZipCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportZipCodes(_response);
        });
    }

    protected processImportZipCodes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    returnTimeZones(signal?: AbortSignal): Promise<any[]> {
        let url_ = this.baseUrl + "/company/Dev/ReturnTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReturnTimeZones(_response);
        });
    }

    protected processReturnTimeZones(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    getVehicleOrders(id: number | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/Dev/GetVehicleOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleOrders(_response);
        });
    }

    protected processGetVehicleOrders(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllOrders(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/Dev/GetAllOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOrders(_response);
        });
    }

    protected processGetAllOrders(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    clearEmailBox(integrationId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/ClearEmailBox?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearEmailBox(_response);
        });
    }

    protected processClearEmailBox(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    refreshAllVehicleOrders(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/RefreshAllVehicleOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshAllVehicleOrders(_response);
        });
    }

    protected processRefreshAllVehicleOrders(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setRecurringMasterJobs(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/SetRecurringMasterJobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRecurringMasterJobs(_response);
        });
    }

    protected processSetRecurringMasterJobs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    refreshVehicleAvailability(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/RefreshVehicleAvailability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshVehicleAvailability(_response);
        });
    }

    protected processRefreshVehicleAvailability(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    populateOrderMetrics(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/PopulateOrderMetrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPopulateOrderMetrics(_response);
        });
    }

    protected processPopulateOrderMetrics(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sylectusReadVehicles(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Dev/SylectusReadVehicles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSylectusReadVehicles(_response);
        });
    }

    protected processSylectusReadVehicles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVehicleAvailabilityRedis(signal?: AbortSignal): Promise<VehicleAvailability[]> {
        let url_ = this.baseUrl + "/company/Dev/GetVehicleAvailabilityRedis";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleAvailabilityRedis(_response);
        });
    }

    protected processGetVehicleAvailabilityRedis(response: AxiosResponse): Promise<VehicleAvailability[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleAvailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleAvailability[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleAvailability[]>(null as any);
    }
}

export interface IDriverClient {
    getList(param: DataListGetParamsOfDriverListFilters | null): Promise<DataListResultOfDriverListModel>;
    getShortList(): Promise<DriverShortListModel[]>;
    upsert(model: DriverEditModel | null): Promise<void>;
    activate(id: number): Promise<void>;
    getById(id: number): Promise<DriverEditModel>;
    deactivate(id: number): Promise<void>;
    addOrderRatingNote(model: DriverRatingNoteEditModel | null): Promise<void>;
}

export class DriverClient extends AuthorizedApiBase implements IDriverClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfDriverListFilters | null, signal?: AbortSignal): Promise<DataListResultOfDriverListModel> {
        let url_ = this.baseUrl + "/company/Driver/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfDriverListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfDriverListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfDriverListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfDriverListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<DriverShortListModel[]> {
        let url_ = this.baseUrl + "/company/Driver/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<DriverShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DriverShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DriverShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverShortListModel[]>(null as any);
    }

    upsert(model: DriverEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Driver/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Driver/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<DriverEditModel> {
        let url_ = this.baseUrl + "/company/Driver/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DriverEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DriverEditModel.fromJS(resultData200);
            return Promise.resolve<DriverEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverEditModel>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Driver/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addOrderRatingNote(model: DriverRatingNoteEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Driver/AddOrderRatingNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrderRatingNote(_response);
        });
    }

    protected processAddOrderRatingNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEmailInboxClient {
    getEmailMessages(integrationId: number, filter_Search: string | null | undefined, filter_From: string | null | undefined, filter_Subject: string | null | undefined, filter_ReceivedDateFrom: moment.Moment | null | undefined, filter_ReceivedDateTo: moment.Moment | null | undefined, filter_ShowUnreadOnly: boolean | undefined, pageSize: number | undefined, offset: number | undefined): Promise<DataListResultOfEmailMessageListItem>;
    getEmailThread(messageId: number): Promise<EmailMessageThreadItem[]>;
    getEmailDetails(messageId: number): Promise<EmailMessageThreadItem>;
    replyToEmail(messageId: number, content: string | null | undefined, toEmails: string[] | null | undefined, ccEmails: string[] | null | undefined, attachments: FileParameter[] | null | undefined): Promise<FileResponse>;
    markAsRead(messageId: number): Promise<FileResponse>;
    getEmailIntegrations(): Promise<EmailIntegrationItem[]>;
    extractParamsFromEmail(integrationId: number, emailId: number, type: IntegrationSettingOrderParserType | undefined): Promise<ExtractedObject>;
}

export class EmailInboxClient extends AuthorizedApiBase implements IEmailInboxClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getEmailMessages(integrationId: number, filter_Search: string | null | undefined, filter_From: string | null | undefined, filter_Subject: string | null | undefined, filter_ReceivedDateFrom: moment.Moment | null | undefined, filter_ReceivedDateTo: moment.Moment | null | undefined, filter_ShowUnreadOnly: boolean | undefined, pageSize: number | undefined, offset: number | undefined, signal?: AbortSignal): Promise<DataListResultOfEmailMessageListItem> {
        let url_ = this.baseUrl + "/company/EmailInbox/GetEmailMessages/{integrationId}?";
        if (integrationId === undefined || integrationId === null)
            throw new Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        if (filter_Search !== undefined && filter_Search !== null)
            url_ += "Filter.Search=" + encodeURIComponent("" + filter_Search) + "&";
        if (filter_From !== undefined && filter_From !== null)
            url_ += "Filter.From=" + encodeURIComponent("" + filter_From) + "&";
        if (filter_Subject !== undefined && filter_Subject !== null)
            url_ += "Filter.Subject=" + encodeURIComponent("" + filter_Subject) + "&";
        if (filter_ReceivedDateFrom !== undefined && filter_ReceivedDateFrom !== null)
            url_ += "Filter.ReceivedDateFrom=" + encodeURIComponent(filter_ReceivedDateFrom ? "" + filter_ReceivedDateFrom.toISOString() : "") + "&";
        if (filter_ReceivedDateTo !== undefined && filter_ReceivedDateTo !== null)
            url_ += "Filter.ReceivedDateTo=" + encodeURIComponent(filter_ReceivedDateTo ? "" + filter_ReceivedDateTo.toISOString() : "") + "&";
        if (filter_ShowUnreadOnly === null)
            throw new Error("The parameter 'filter_ShowUnreadOnly' cannot be null.");
        else if (filter_ShowUnreadOnly !== undefined)
            url_ += "Filter.ShowUnreadOnly=" + encodeURIComponent("" + filter_ShowUnreadOnly) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailMessages(_response);
        });
    }

    protected processGetEmailMessages(response: AxiosResponse): Promise<DataListResultOfEmailMessageListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfEmailMessageListItem.fromJS(resultData200);
            return Promise.resolve<DataListResultOfEmailMessageListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfEmailMessageListItem>(null as any);
    }

    getEmailThread(messageId: number, signal?: AbortSignal): Promise<EmailMessageThreadItem[]> {
        let url_ = this.baseUrl + "/company/EmailInbox/GetEmailThread/thread/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailThread(_response);
        });
    }

    protected processGetEmailThread(response: AxiosResponse): Promise<EmailMessageThreadItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailMessageThreadItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailMessageThreadItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailMessageThreadItem[]>(null as any);
    }

    getEmailDetails(messageId: number, signal?: AbortSignal): Promise<EmailMessageThreadItem> {
        let url_ = this.baseUrl + "/company/EmailInbox/GetEmailDetails/messages/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailDetails(_response);
        });
    }

    protected processGetEmailDetails(response: AxiosResponse): Promise<EmailMessageThreadItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailMessageThreadItem.fromJS(resultData200);
            return Promise.resolve<EmailMessageThreadItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailMessageThreadItem>(null as any);
    }

    replyToEmail(messageId: number, content: string | null | undefined, toEmails: string[] | null | undefined, ccEmails: string[] | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/EmailInbox/ReplyToEmail/reply/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (toEmails !== null && toEmails !== undefined)
            toEmails.forEach(item_ => content_.append("ToEmails", item_.toString()));
        if (ccEmails !== null && ccEmails !== undefined)
            ccEmails.forEach(item_ => content_.append("CcEmails", item_.toString()));
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplyToEmail(_response);
        });
    }

    protected processReplyToEmail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    markAsRead(messageId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/EmailInbox/MarkAsRead/read/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailIntegrations(signal?: AbortSignal): Promise<EmailIntegrationItem[]> {
        let url_ = this.baseUrl + "/company/EmailInbox/GetEmailIntegrations/integrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailIntegrations(_response);
        });
    }

    protected processGetEmailIntegrations(response: AxiosResponse): Promise<EmailIntegrationItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailIntegrationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailIntegrationItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailIntegrationItem[]>(null as any);
    }

    extractParamsFromEmail(integrationId: number, emailId: number, type: IntegrationSettingOrderParserType | undefined, signal?: AbortSignal): Promise<ExtractedObject> {
        let url_ = this.baseUrl + "/company/EmailInbox/ExtractParamsFromEmail/extract/{integrationId}/{emailId}?";
        if (integrationId === undefined || integrationId === null)
            throw new Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtractParamsFromEmail(_response);
        });
    }

    protected processExtractParamsFromEmail(response: AxiosResponse): Promise<ExtractedObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExtractedObject.fromJS(resultData200);
            return Promise.resolve<ExtractedObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExtractedObject>(null as any);
    }
}

export interface IFileClient {
    upload(fileType: FileType | undefined, id: number | undefined, description: string | null | undefined, itemType: FileItemType | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Promise<void>;
    getFile(id: number | undefined, itemType: FileItemType | undefined): Promise<FileResponse>;
    getEmailAttachment(messageId: number, fileName: string): Promise<FileResponse>;
    getEmailEmbedding(messageId: number, fileName: string): Promise<FileResponse>;
    deleteFile(id: number | undefined, itemType: FileItemType | undefined): Promise<void>;
    getList(id: number | undefined, itemType: FileItemType | undefined, fileType: FileType | undefined): Promise<FileListItem[]>;
}

export class FileClient extends AuthorizedApiBase implements IFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upload(fileType: FileType | undefined, id: number | undefined, description: string | null | undefined, itemType: FileItemType | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/File/Upload?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (itemType === null)
            throw new Error("The parameter 'itemType' cannot be null.");
        else if (itemType !== undefined)
            url_ += "itemType=" + encodeURIComponent("" + itemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFile(id: number | undefined, itemType: FileItemType | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/File/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (itemType === null)
            throw new Error("The parameter 'itemType' cannot be null.");
        else if (itemType !== undefined)
            url_ += "itemType=" + encodeURIComponent("" + itemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailAttachment(messageId: number, fileName: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/file/email/attachments/{messageId}/{fileName}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailAttachment(_response);
        });
    }

    protected processGetEmailAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailEmbedding(messageId: number, fileName: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/file/email/embeddings/{messageId}/{fileName}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailEmbedding(_response);
        });
    }

    protected processGetEmailEmbedding(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFile(id: number | undefined, itemType: FileItemType | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/File/DeleteFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (itemType === null)
            throw new Error("The parameter 'itemType' cannot be null.");
        else if (itemType !== undefined)
            url_ += "itemType=" + encodeURIComponent("" + itemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getList(id: number | undefined, itemType: FileItemType | undefined, fileType: FileType | undefined, signal?: AbortSignal): Promise<FileListItem[]> {
        let url_ = this.baseUrl + "/company/File/GetList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (itemType === null)
            throw new Error("The parameter 'itemType' cannot be null.");
        else if (itemType !== undefined)
            url_ += "itemType=" + encodeURIComponent("" + itemType) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<FileListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileListItem[]>(null as any);
    }
}

export interface IIntegrationClient {
    getList(param: DataListGetParamsOfIntegrationListFilters | null): Promise<DataListResultOfIntegrationListModel>;
    upsert(model: IntegrationEditModel | null): Promise<number>;
    activate(id: number): Promise<void>;
    getById(id: number): Promise<IntegrationEditModel>;
    getAllEldDrivers(id: number): Promise<NamedValue[]>;
    getAllEldVehicles(id: number): Promise<NamedValue[]>;
    deactivate(id: number): Promise<void>;
}

export class IntegrationClient extends AuthorizedApiBase implements IIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfIntegrationListFilters | null, signal?: AbortSignal): Promise<DataListResultOfIntegrationListModel> {
        let url_ = this.baseUrl + "/company/Integration/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfIntegrationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfIntegrationListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfIntegrationListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfIntegrationListModel>(null as any);
    }

    upsert(model: IntegrationEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Integration/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Integration/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<IntegrationEditModel> {
        let url_ = this.baseUrl + "/company/Integration/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IntegrationEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IntegrationEditModel.fromJS(resultData200);
            return Promise.resolve<IntegrationEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationEditModel>(null as any);
    }

    getAllEldDrivers(id: number, signal?: AbortSignal): Promise<NamedValue[]> {
        let url_ = this.baseUrl + "/company/Integration/GetAllEldDrivers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEldDrivers(_response);
        });
    }

    protected processGetAllEldDrivers(response: AxiosResponse): Promise<NamedValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValue[]>(null as any);
    }

    getAllEldVehicles(id: number, signal?: AbortSignal): Promise<NamedValue[]> {
        let url_ = this.baseUrl + "/company/Integration/GetAllEldVehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEldVehicles(_response);
        });
    }

    protected processGetAllEldVehicles(response: AxiosResponse): Promise<NamedValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValue[]>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Integration/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IInvoiceClient {
    getList(param: DataListGetParamsOfInvoiceListFilters | null): Promise<DataListResultOfInvoiceListModel>;
    createInvoiceBasedOnOrder(model: NewInvoiceBasedOnOrderEditModel | null): Promise<void>;
    getLatestInvoiceNumber(): Promise<number>;
    getOpenInvoicesByCustomer(customerId: number | undefined): Promise<OpenInvoicesByCustomerModel[]>;
    getShortInvoiceInfo(invoiceIds: number[] | null): Promise<InvoiceShortModel[]>;
    removeOpenInvoice(id: number): Promise<void>;
    getInvoiceMetrics(model: InvoiceMetricsRequest | null): Promise<InvoiceMetrics>;
    getARMetrics(): Promise<ARMetrics>;
}

export class InvoiceClient extends AuthorizedApiBase implements IInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfInvoiceListFilters | null, signal?: AbortSignal): Promise<DataListResultOfInvoiceListModel> {
        let url_ = this.baseUrl + "/company/Invoice/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfInvoiceListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfInvoiceListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfInvoiceListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfInvoiceListModel>(null as any);
    }

    createInvoiceBasedOnOrder(model: NewInvoiceBasedOnOrderEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Invoice/CreateInvoiceBasedOnOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceBasedOnOrder(_response);
        });
    }

    protected processCreateInvoiceBasedOnOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLatestInvoiceNumber(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Invoice/GetLatestInvoiceNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestInvoiceNumber(_response);
        });
    }

    protected processGetLatestInvoiceNumber(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getOpenInvoicesByCustomer(customerId: number | undefined, signal?: AbortSignal): Promise<OpenInvoicesByCustomerModel[]> {
        let url_ = this.baseUrl + "/company/Invoice/GetOpenInvoicesByCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenInvoicesByCustomer(_response);
        });
    }

    protected processGetOpenInvoicesByCustomer(response: AxiosResponse): Promise<OpenInvoicesByCustomerModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenInvoicesByCustomerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OpenInvoicesByCustomerModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenInvoicesByCustomerModel[]>(null as any);
    }

    getShortInvoiceInfo(invoiceIds: number[] | null, signal?: AbortSignal): Promise<InvoiceShortModel[]> {
        let url_ = this.baseUrl + "/company/Invoice/GetShortInvoiceInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortInvoiceInfo(_response);
        });
    }

    protected processGetShortInvoiceInfo(response: AxiosResponse): Promise<InvoiceShortModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceShortModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceShortModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceShortModel[]>(null as any);
    }

    removeOpenInvoice(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Invoice/RemoveOpenInvoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOpenInvoice(_response);
        });
    }

    protected processRemoveOpenInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getInvoiceMetrics(model: InvoiceMetricsRequest | null, signal?: AbortSignal): Promise<InvoiceMetrics> {
        let url_ = this.baseUrl + "/company/Invoice/GetInvoiceMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceMetrics(_response);
        });
    }

    protected processGetInvoiceMetrics(response: AxiosResponse): Promise<InvoiceMetrics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceMetrics.fromJS(resultData200);
            return Promise.resolve<InvoiceMetrics>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceMetrics>(null as any);
    }

    getARMetrics(signal?: AbortSignal): Promise<ARMetrics> {
        let url_ = this.baseUrl + "/company/Invoice/GetARMetrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetARMetrics(_response);
        });
    }

    protected processGetARMetrics(response: AxiosResponse): Promise<ARMetrics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ARMetrics.fromJS(resultData200);
            return Promise.resolve<ARMetrics>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ARMetrics>(null as any);
    }
}

export interface IMobileClient {
    getLogList(param: DataListGetParamsOfMessageLogListFilters | null): Promise<DataListResultOfMessageLogListModel>;
}

export class MobileClient extends AuthorizedApiBase implements IMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getLogList(param: DataListGetParamsOfMessageLogListFilters | null, signal?: AbortSignal): Promise<DataListResultOfMessageLogListModel> {
        let url_ = this.baseUrl + "/company/Mobile/GetLogList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogList(_response);
        });
    }

    protected processGetLogList(response: AxiosResponse): Promise<DataListResultOfMessageLogListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfMessageLogListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfMessageLogListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfMessageLogListModel>(null as any);
    }
}

export interface INoteClient {
    addNote(model: NewNoteModel | null): Promise<void>;
    getList(id: number | undefined, itemType: NoteItemType | undefined, fileType: NoteType | undefined): Promise<NoteListItem[]>;
}

export class NoteClient extends AuthorizedApiBase implements INoteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    addNote(model: NewNoteModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Note/AddNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNote(_response);
        });
    }

    protected processAddNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getList(id: number | undefined, itemType: NoteItemType | undefined, fileType: NoteType | undefined, signal?: AbortSignal): Promise<NoteListItem[]> {
        let url_ = this.baseUrl + "/company/Note/GetList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (itemType === null)
            throw new Error("The parameter 'itemType' cannot be null.");
        else if (itemType !== undefined)
            url_ += "itemType=" + encodeURIComponent("" + itemType) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<NoteListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NoteListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteListItem[]>(null as any);
    }
}

export interface IOrderClient {
    getList(param: DataListGetParamsOfOrderListFilters | null): Promise<DataListResultOfOrderModelListView>;
    getOpenOrdersList(param: DataListGetParamsOfOrderCompleteListFilters | null): Promise<DataListResultOfOrderModelListView>;
    getById(id: number): Promise<OrderViewModel>;
    getOrderStops(id: number): Promise<OrderStopViewModel[]>;
    getOrderItems(id: number): Promise<OrderItemViewModel[]>;
    getFullOrderInfo(id: number): Promise<OrderFullInfo>;
    deleteOrderItem(id: number, itemId: number): Promise<void>;
    upsertOrderItem(id: number, item: OrderItemViewModel | null): Promise<void>;
    deleteOrderStop(id: number, stopId: number): Promise<void>;
    upsertOrderStop(id: number, item: OrderStopEditModel | null): Promise<void>;
    setArrivalDate(id: number, stopId: number, model: DateRequest | null): Promise<void>;
    setDepartDate(id: number, stopId: number, model: DateRequest | null): Promise<void>;
    setVehicle(id: number, vehicleId: number | null | undefined): Promise<void>;
    setDrivers(id: number, driverIds: number[] | null): Promise<void>;
    setSharedNotes(id: number, sharedNotes: string | null): Promise<void>;
    setRate(id: number, value: number): Promise<void>;
    recalculateRating(): Promise<void>;
    setCarrierRate(id: number, value: number): Promise<void>;
    setOrderNumber(id: number, orderNumber: string | null): Promise<void>;
    setCustomer(id: number, customerId: number | undefined, contactId: number | null | undefined): Promise<void>;
    createNewBlankOrder(): Promise<number>;
    markAsDraft(id: number): Promise<void>;
    markAsOnHold(id: number): Promise<void>;
    markAsReady(id: number): Promise<void>;
    markAsInProgress(id: number): Promise<void>;
    markAsCanceled(id: number): Promise<void>;
    markAsCompleted(id: number): Promise<void>;
    updateLocation(id: number, location: string | null | undefined): Promise<void>;
    updateLocationBasedOnVehicle(id: number, value: boolean | undefined): Promise<void>;
    markAsClosed(id: number): Promise<void>;
    sendOrderNotification(id: number): Promise<void>;
    getInProgressStops(): Promise<InProgressStopGroup[]>;
    searchOrderStopAddresses(param: DataListGetParamsOfOrderStopAddressListFilters | null): Promise<DataListResultOfOrderStopAddressModel>;
    upsertOrderStopAddresses(model: OrderStopAddressModel | null): Promise<OrderStopAddressModel>;
    generateCustomerExternalLink(orderId: number | undefined): Promise<string>;
}

export class OrderClient extends AuthorizedApiBase implements IOrderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfOrderListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrderModelListView> {
        let url_ = this.baseUrl + "/company/Order/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfOrderModelListView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrderModelListView.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrderModelListView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrderModelListView>(null as any);
    }

    getOpenOrdersList(param: DataListGetParamsOfOrderCompleteListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrderModelListView> {
        let url_ = this.baseUrl + "/company/Order/GetOpenOrdersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenOrdersList(_response);
        });
    }

    protected processGetOpenOrdersList(response: AxiosResponse): Promise<DataListResultOfOrderModelListView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrderModelListView.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrderModelListView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrderModelListView>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/company/Order/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderViewModel.fromJS(resultData200);
            return Promise.resolve<OrderViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderViewModel>(null as any);
    }

    getOrderStops(id: number, signal?: AbortSignal): Promise<OrderStopViewModel[]> {
        let url_ = this.baseUrl + "/company/Order/GetOrderStops/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStops(_response);
        });
    }

    protected processGetOrderStops(response: AxiosResponse): Promise<OrderStopViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderStopViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderStopViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStopViewModel[]>(null as any);
    }

    getOrderItems(id: number, signal?: AbortSignal): Promise<OrderItemViewModel[]> {
        let url_ = this.baseUrl + "/company/Order/GetOrderItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderItems(_response);
        });
    }

    protected processGetOrderItems(response: AxiosResponse): Promise<OrderItemViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderItemViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderItemViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderItemViewModel[]>(null as any);
    }

    getFullOrderInfo(id: number, signal?: AbortSignal): Promise<OrderFullInfo> {
        let url_ = this.baseUrl + "/company/Order/GetFullOrderInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFullOrderInfo(_response);
        });
    }

    protected processGetFullOrderInfo(response: AxiosResponse): Promise<OrderFullInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderFullInfo.fromJS(resultData200);
            return Promise.resolve<OrderFullInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderFullInfo>(null as any);
    }

    deleteOrderItem(id: number, itemId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/DeleteOrderItem/{id}/{itemId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderItem(_response);
        });
    }

    protected processDeleteOrderItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertOrderItem(id: number, item: OrderItemViewModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/UpsertOrderItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertOrderItem(_response);
        });
    }

    protected processUpsertOrderItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteOrderStop(id: number, stopId: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/DeleteOrderStop/{id}/{stopId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stopId === undefined || stopId === null)
            throw new Error("The parameter 'stopId' must be defined.");
        url_ = url_.replace("{stopId}", encodeURIComponent("" + stopId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderStop(_response);
        });
    }

    protected processDeleteOrderStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertOrderStop(id: number, item: OrderStopEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/UpsertOrderStop/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertOrderStop(_response);
        });
    }

    protected processUpsertOrderStop(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setArrivalDate(id: number, stopId: number, model: DateRequest | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetArrivalDate/{id}/{stopId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stopId === undefined || stopId === null)
            throw new Error("The parameter 'stopId' must be defined.");
        url_ = url_.replace("{stopId}", encodeURIComponent("" + stopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetArrivalDate(_response);
        });
    }

    protected processSetArrivalDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setDepartDate(id: number, stopId: number, model: DateRequest | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetDepartDate/{id}/{stopId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (stopId === undefined || stopId === null)
            throw new Error("The parameter 'stopId' must be defined.");
        url_ = url_.replace("{stopId}", encodeURIComponent("" + stopId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDepartDate(_response);
        });
    }

    protected processSetDepartDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setVehicle(id: number, vehicleId: number | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetVehicle/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (vehicleId !== undefined && vehicleId !== null)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetVehicle(_response);
        });
    }

    protected processSetVehicle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setDrivers(id: number, driverIds: number[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetDrivers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(driverIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDrivers(_response);
        });
    }

    protected processSetDrivers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setSharedNotes(id: number, sharedNotes: string | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetSharedNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sharedNotes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSharedNotes(_response);
        });
    }

    protected processSetSharedNotes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setRate(id: number, value: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetRate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRate(_response);
        });
    }

    protected processSetRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    recalculateRating(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/RecalculateRating";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculateRating(_response);
        });
    }

    protected processRecalculateRating(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setCarrierRate(id: number, value: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetCarrierRate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCarrierRate(_response);
        });
    }

    protected processSetCarrierRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setOrderNumber(id: number, orderNumber: string | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetOrderNumber/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderNumber);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOrderNumber(_response);
        });
    }

    protected processSetOrderNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setCustomer(id: number, customerId: number | undefined, contactId: number | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SetCustomer/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCustomer(_response);
        });
    }

    protected processSetCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createNewBlankOrder(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/Order/CreateNewBlankOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNewBlankOrder(_response);
        });
    }

    protected processCreateNewBlankOrder(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    markAsDraft(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsDraft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsDraft(_response);
        });
    }

    protected processMarkAsDraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsOnHold(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsOnHold/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsOnHold(_response);
        });
    }

    protected processMarkAsOnHold(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsReady(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsReady/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsReady(_response);
        });
    }

    protected processMarkAsReady(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsInProgress(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsInProgress/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsInProgress(_response);
        });
    }

    protected processMarkAsInProgress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsCanceled(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsCanceled/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsCanceled(_response);
        });
    }

    protected processMarkAsCanceled(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsCompleted(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsCompleted/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsCompleted(_response);
        });
    }

    protected processMarkAsCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateLocation(id: number, location: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/UpdateLocation/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateLocationBasedOnVehicle(id: number, value: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/UpdateLocationBasedOnVehicle/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocationBasedOnVehicle(_response);
        });
    }

    protected processUpdateLocationBasedOnVehicle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markAsClosed(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/MarkAsClosed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAsClosed(_response);
        });
    }

    protected processMarkAsClosed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendOrderNotification(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Order/SendOrderNotification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendOrderNotification(_response);
        });
    }

    protected processSendOrderNotification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getInProgressStops(signal?: AbortSignal): Promise<InProgressStopGroup[]> {
        let url_ = this.baseUrl + "/company/Order/GetInProgressStops";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInProgressStops(_response);
        });
    }

    protected processGetInProgressStops(response: AxiosResponse): Promise<InProgressStopGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InProgressStopGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InProgressStopGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InProgressStopGroup[]>(null as any);
    }

    searchOrderStopAddresses(param: DataListGetParamsOfOrderStopAddressListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrderStopAddressModel> {
        let url_ = this.baseUrl + "/company/Order/SearchOrderStopAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchOrderStopAddresses(_response);
        });
    }

    protected processSearchOrderStopAddresses(response: AxiosResponse): Promise<DataListResultOfOrderStopAddressModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrderStopAddressModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrderStopAddressModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrderStopAddressModel>(null as any);
    }

    upsertOrderStopAddresses(model: OrderStopAddressModel | null, signal?: AbortSignal): Promise<OrderStopAddressModel> {
        let url_ = this.baseUrl + "/company/Order/UpsertOrderStopAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertOrderStopAddresses(_response);
        });
    }

    protected processUpsertOrderStopAddresses(response: AxiosResponse): Promise<OrderStopAddressModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderStopAddressModel.fromJS(resultData200);
            return Promise.resolve<OrderStopAddressModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStopAddressModel>(null as any);
    }

    generateCustomerExternalLink(orderId: number | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/company/Order/GenerateCustomerExternalLink?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateCustomerExternalLink(_response);
        });
    }

    protected processGenerateCustomerExternalLink(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IOrderQuoteClient {
    getQuoteDetails(id: number): Promise<OrderQuoteModelView>;
    getList(param: DataListGetParamsOfOrderQuoteListFilters | null): Promise<DataListResultOfOrderQuoteModelListView>;
    upsertQuote(model: OrderQuoteModel | null): Promise<number>;
    postQuote(id: number): Promise<void>;
    cancelQuote(id: number): Promise<void>;
}

export class OrderQuoteClient extends AuthorizedApiBase implements IOrderQuoteClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getQuoteDetails(id: number, signal?: AbortSignal): Promise<OrderQuoteModelView> {
        let url_ = this.baseUrl + "/company/OrderQuote/GetQuoteDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuoteDetails(_response);
        });
    }

    protected processGetQuoteDetails(response: AxiosResponse): Promise<OrderQuoteModelView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderQuoteModelView.fromJS(resultData200);
            return Promise.resolve<OrderQuoteModelView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderQuoteModelView>(null as any);
    }

    getList(param: DataListGetParamsOfOrderQuoteListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrderQuoteModelListView> {
        let url_ = this.baseUrl + "/company/OrderQuote/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfOrderQuoteModelListView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrderQuoteModelListView.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrderQuoteModelListView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrderQuoteModelListView>(null as any);
    }

    upsertQuote(model: OrderQuoteModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/company/OrderQuote/UpsertQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertQuote(_response);
        });
    }

    protected processUpsertQuote(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    postQuote(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OrderQuote/PostQuote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostQuote(_response);
        });
    }

    protected processPostQuote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelQuote(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OrderQuote/CancelQuote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelQuote(_response);
        });
    }

    protected processCancelQuote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOrderTaskClient {
    getList(param: DataListGetParamsOfOrderTaskListFilters | null): Promise<DataListResultOfOrderTaskListModel>;
    upsert(model: OrderTaskModel | null): Promise<void>;
    getById(id: number): Promise<OrderTaskModel>;
    assignTo(model: OrderTaskAssignRequest | null): Promise<void>;
    finish(model: OrderTaskFinishRequest | null): Promise<void>;
}

export class OrderTaskClient extends AuthorizedApiBase implements IOrderTaskClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfOrderTaskListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOrderTaskListModel> {
        let url_ = this.baseUrl + "/company/OrderTask/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfOrderTaskListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOrderTaskListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOrderTaskListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOrderTaskListModel>(null as any);
    }

    upsert(model: OrderTaskModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OrderTask/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<OrderTaskModel> {
        let url_ = this.baseUrl + "/company/OrderTask/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrderTaskModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderTaskModel.fromJS(resultData200);
            return Promise.resolve<OrderTaskModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderTaskModel>(null as any);
    }

    assignTo(model: OrderTaskAssignRequest | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OrderTask/AssignTo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignTo(_response);
        });
    }

    protected processAssignTo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    finish(model: OrderTaskFinishRequest | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OrderTask/Finish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinish(_response);
        });
    }

    protected processFinish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOwnerAccountClient {
    getList(param: DataListGetParamsOfOwnerAccountListFilters | null): Promise<DataListResultOfOwnerAccountListModel>;
    create(model: OwnerAccountNewModel | null): Promise<void>;
    update(model: OwnerAccountEditModel | null): Promise<void>;
    activate(id: number): Promise<void>;
    deactivate(id: number): Promise<void>;
    getDetails(id: number | undefined): Promise<OwnerAccountEditViewModel>;
}

export class OwnerAccountClient extends AuthorizedApiBase implements IOwnerAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfOwnerAccountListFilters | null, signal?: AbortSignal): Promise<DataListResultOfOwnerAccountListModel> {
        let url_ = this.baseUrl + "/company/OwnerAccount/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfOwnerAccountListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfOwnerAccountListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfOwnerAccountListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfOwnerAccountListModel>(null as any);
    }

    create(model: OwnerAccountNewModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OwnerAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    update(model: OwnerAccountEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OwnerAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OwnerAccount/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/OwnerAccount/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number | undefined, signal?: AbortSignal): Promise<OwnerAccountEditViewModel> {
        let url_ = this.baseUrl + "/company/OwnerAccount/GetDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<OwnerAccountEditViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OwnerAccountEditViewModel.fromJS(resultData200);
            return Promise.resolve<OwnerAccountEditViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OwnerAccountEditViewModel>(null as any);
    }
}

export interface IPaymentClient {
    getPaymentNetTermList(param: DataListGetParamsOfPaymentNetTermListFilters | null): Promise<DataListResultOfPaymentNetTermListModel>;
    getPaymentList(param: DataListGetParamsOfPaymentListFilters | null): Promise<DataListResultOfPaymentListModel>;
    getPaymentNetTerms(): Promise<NamedValueLong[]>;
    upsertPaymentNetTerm(model: PaymentNetTermEditModel | null): Promise<void>;
    createPayment(model: PaymentEditModel | null): Promise<void>;
    deletePayment(id: number): Promise<void>;
    getPaymentNetTermById(id: number): Promise<PaymentNetTermEditModel>;
    importRTSPurchaseOrderInvoices(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Promise<RTSImportRecordResponseOfRTSPurchaseResult[]>;
    removePayment(id: number): Promise<void>;
}

export class PaymentClient extends AuthorizedApiBase implements IPaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getPaymentNetTermList(param: DataListGetParamsOfPaymentNetTermListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPaymentNetTermListModel> {
        let url_ = this.baseUrl + "/company/Payment/GetPaymentNetTermList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentNetTermList(_response);
        });
    }

    protected processGetPaymentNetTermList(response: AxiosResponse): Promise<DataListResultOfPaymentNetTermListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPaymentNetTermListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPaymentNetTermListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPaymentNetTermListModel>(null as any);
    }

    getPaymentList(param: DataListGetParamsOfPaymentListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPaymentListModel> {
        let url_ = this.baseUrl + "/company/Payment/GetPaymentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentList(_response);
        });
    }

    protected processGetPaymentList(response: AxiosResponse): Promise<DataListResultOfPaymentListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPaymentListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPaymentListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPaymentListModel>(null as any);
    }

    getPaymentNetTerms(signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/company/Payment/GetPaymentNetTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentNetTerms(_response);
        });
    }

    protected processGetPaymentNetTerms(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    upsertPaymentNetTerm(model: PaymentNetTermEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Payment/UpsertPaymentNetTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertPaymentNetTerm(_response);
        });
    }

    protected processUpsertPaymentNetTerm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createPayment(model: PaymentEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePayment(_response);
        });
    }

    protected processCreatePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deletePayment(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Payment/DeletePayment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePayment(_response);
        });
    }

    protected processDeletePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPaymentNetTermById(id: number, signal?: AbortSignal): Promise<PaymentNetTermEditModel> {
        let url_ = this.baseUrl + "/company/Payment/GetPaymentNetTermById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentNetTermById(_response);
        });
    }

    protected processGetPaymentNetTermById(response: AxiosResponse): Promise<PaymentNetTermEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentNetTermEditModel.fromJS(resultData200);
            return Promise.resolve<PaymentNetTermEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentNetTermEditModel>(null as any);
    }

    importRTSPurchaseOrderInvoices(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, signal?: AbortSignal): Promise<RTSImportRecordResponseOfRTSPurchaseResult[]> {
        let url_ = this.baseUrl + "/company/Payment/ImportRTSPurchaseOrderInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportRTSPurchaseOrderInvoices(_response);
        });
    }

    protected processImportRTSPurchaseOrderInvoices(response: AxiosResponse): Promise<RTSImportRecordResponseOfRTSPurchaseResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RTSImportRecordResponseOfRTSPurchaseResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RTSImportRecordResponseOfRTSPurchaseResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RTSImportRecordResponseOfRTSPurchaseResult[]>(null as any);
    }

    removePayment(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Payment/RemovePayment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePayment(_response);
        });
    }

    protected processRemovePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPayoutAccountClient {
    getPayoutAccountsList(param: DataListGetParamsOfPayoutAccountListFilters | null): Promise<DataListResultOfPayoutAccountListModel>;
    getPayoutAccountDetails(id: number | undefined): Promise<PayoutAccountEditModel>;
    adjustBalance(model: PayoutAccountAdjustBalanceEdit | null): Promise<void>;
    removeAdjustBalance(id: number): Promise<void>;
    payoutAccountUpsert(model: PayoutAccountEditModel | null): Promise<void>;
    getDriverCompensations(id: number): Promise<DriverCompensationEdit[]>;
    getCarrierCompensations(id: number): Promise<CarrierCompensationEdit[]>;
    getExpenses(id: number): Promise<OrderExpenseEdit[]>;
    createSummary(id: number | undefined): Promise<void>;
    upsertDriverCompensation(id: number, model: DriverCompensationEdit | null): Promise<void>;
    deleteDriverCompensation(id: number): Promise<void>;
    upsertCarrierCompensation(id: number, model: CarrierCompensationEdit | null): Promise<void>;
    deleteCarrierCompensation(id: number): Promise<void>;
    upsertExpense(id: number, model: OrderExpenseEdit | null): Promise<void>;
    deleteExpense(id: number): Promise<void>;
    closeOrderPayout(id: number): Promise<void>;
    reopenOrderPayout(id: number): Promise<void>;
}

export class PayoutAccountClient extends AuthorizedApiBase implements IPayoutAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getPayoutAccountsList(param: DataListGetParamsOfPayoutAccountListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPayoutAccountListModel> {
        let url_ = this.baseUrl + "/company/PayoutAccount/GetPayoutAccountsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayoutAccountsList(_response);
        });
    }

    protected processGetPayoutAccountsList(response: AxiosResponse): Promise<DataListResultOfPayoutAccountListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPayoutAccountListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPayoutAccountListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPayoutAccountListModel>(null as any);
    }

    getPayoutAccountDetails(id: number | undefined, signal?: AbortSignal): Promise<PayoutAccountEditModel> {
        let url_ = this.baseUrl + "/company/PayoutAccount/GetPayoutAccountDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayoutAccountDetails(_response);
        });
    }

    protected processGetPayoutAccountDetails(response: AxiosResponse): Promise<PayoutAccountEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PayoutAccountEditModel.fromJS(resultData200);
            return Promise.resolve<PayoutAccountEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoutAccountEditModel>(null as any);
    }

    adjustBalance(model: PayoutAccountAdjustBalanceEdit | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/AdjustBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdjustBalance(_response);
        });
    }

    protected processAdjustBalance(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeAdjustBalance(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/RemoveAdjustBalance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAdjustBalance(_response);
        });
    }

    protected processRemoveAdjustBalance(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    payoutAccountUpsert(model: PayoutAccountEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/PayoutAccountUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayoutAccountUpsert(_response);
        });
    }

    protected processPayoutAccountUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDriverCompensations(id: number, signal?: AbortSignal): Promise<DriverCompensationEdit[]> {
        let url_ = this.baseUrl + "/company/PayoutAccount/GetDriverCompensations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverCompensations(_response);
        });
    }

    protected processGetDriverCompensations(response: AxiosResponse): Promise<DriverCompensationEdit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DriverCompensationEdit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DriverCompensationEdit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverCompensationEdit[]>(null as any);
    }

    getCarrierCompensations(id: number, signal?: AbortSignal): Promise<CarrierCompensationEdit[]> {
        let url_ = this.baseUrl + "/company/PayoutAccount/GetCarrierCompensations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarrierCompensations(_response);
        });
    }

    protected processGetCarrierCompensations(response: AxiosResponse): Promise<CarrierCompensationEdit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierCompensationEdit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CarrierCompensationEdit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarrierCompensationEdit[]>(null as any);
    }

    getExpenses(id: number, signal?: AbortSignal): Promise<OrderExpenseEdit[]> {
        let url_ = this.baseUrl + "/company/PayoutAccount/GetExpenses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpenses(_response);
        });
    }

    protected processGetExpenses(response: AxiosResponse): Promise<OrderExpenseEdit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderExpenseEdit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrderExpenseEdit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderExpenseEdit[]>(null as any);
    }

    createSummary(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/CreateSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSummary(_response);
        });
    }

    protected processCreateSummary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertDriverCompensation(id: number, model: DriverCompensationEdit | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/UpsertDriverCompensation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertDriverCompensation(_response);
        });
    }

    protected processUpsertDriverCompensation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteDriverCompensation(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/DeleteDriverCompensation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDriverCompensation(_response);
        });
    }

    protected processDeleteDriverCompensation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertCarrierCompensation(id: number, model: CarrierCompensationEdit | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/UpsertCarrierCompensation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertCarrierCompensation(_response);
        });
    }

    protected processUpsertCarrierCompensation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCarrierCompensation(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/DeleteCarrierCompensation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCarrierCompensation(_response);
        });
    }

    protected processDeleteCarrierCompensation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertExpense(id: number, model: OrderExpenseEdit | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/UpsertExpense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertExpense(_response);
        });
    }

    protected processUpsertExpense(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteExpense(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/DeleteExpense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExpense(_response);
        });
    }

    protected processDeleteExpense(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    closeOrderPayout(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/CloseOrderPayout/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseOrderPayout(_response);
        });
    }

    protected processCloseOrderPayout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reopenOrderPayout(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/PayoutAccount/ReopenOrderPayout/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReopenOrderPayout(_response);
        });
    }

    protected processReopenOrderPayout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPusherClient {
    auth(): Promise<FileResponse>;
}

export class PusherClient extends AuthorizedApiBase implements IPusherClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    auth(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/Pusher/Auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IQBOAuthCallbackClient {
    qBOCallback(code: string | null | undefined, state: string | null | undefined, realmId: string | null | undefined, realmIdSnake: string | null | undefined): Promise<FileResponse>;
}

export class QBOAuthCallbackClient extends AuthorizedApiBase implements IQBOAuthCallbackClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    qBOCallback(code: string | null | undefined, state: string | null | undefined, realmId: string | null | undefined, realmIdSnake: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/company/CompanyIntegration/QBOCallback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (realmId !== undefined && realmId !== null)
            url_ += "realmId=" + encodeURIComponent("" + realmId) + "&";
        if (realmIdSnake !== undefined && realmIdSnake !== null)
            url_ += "realm_id=" + encodeURIComponent("" + realmIdSnake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQBOCallback(_response);
        });
    }

    protected processQBOCallback(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRadarClient {
    getRadarInfo(vehicleIds: number[] | null): Promise<RadarData>;
    getOrders(param: DataListGetParamsOfGetOrdersSearchParams | null): Promise<RadarSearchDataResponse>;
    getClosestZipcodeInfo(lon: number | undefined, lat: number | undefined): Promise<ZipCodeInfo>;
    getOrderVehicleMatchDebug(request: OrderVehicleMatchDebugRequest | null): Promise<OrderVehicleMatchDebugResponse>;
}

export class RadarClient extends AuthorizedApiBase implements IRadarClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getRadarInfo(vehicleIds: number[] | null, signal?: AbortSignal): Promise<RadarData> {
        let url_ = this.baseUrl + "/company/Radar/GetRadarInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vehicleIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRadarInfo(_response);
        });
    }

    protected processGetRadarInfo(response: AxiosResponse): Promise<RadarData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RadarData.fromJS(resultData200);
            return Promise.resolve<RadarData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadarData>(null as any);
    }

    getOrders(param: DataListGetParamsOfGetOrdersSearchParams | null, signal?: AbortSignal): Promise<RadarSearchDataResponse> {
        let url_ = this.baseUrl + "/company/Radar/GetOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrders(_response);
        });
    }

    protected processGetOrders(response: AxiosResponse): Promise<RadarSearchDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RadarSearchDataResponse.fromJS(resultData200);
            return Promise.resolve<RadarSearchDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RadarSearchDataResponse>(null as any);
    }

    getClosestZipcodeInfo(lon: number | undefined, lat: number | undefined, signal?: AbortSignal): Promise<ZipCodeInfo> {
        let url_ = this.baseUrl + "/company/Radar/GetClosestZipcodeInfo?";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClosestZipcodeInfo(_response);
        });
    }

    protected processGetClosestZipcodeInfo(response: AxiosResponse): Promise<ZipCodeInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ZipCodeInfo.fromJS(resultData200);
            return Promise.resolve<ZipCodeInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZipCodeInfo>(null as any);
    }

    getOrderVehicleMatchDebug(request: OrderVehicleMatchDebugRequest | null, signal?: AbortSignal): Promise<OrderVehicleMatchDebugResponse> {
        let url_ = this.baseUrl + "/company/Radar/GetOrderVehicleMatchDebug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderVehicleMatchDebug(_response);
        });
    }

    protected processGetOrderVehicleMatchDebug(response: AxiosResponse): Promise<OrderVehicleMatchDebugResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderVehicleMatchDebugResponse.fromJS(resultData200);
            return Promise.resolve<OrderVehicleMatchDebugResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderVehicleMatchDebugResponse>(null as any);
    }
}

export interface IRateSettingsClient {
    getCurrentRates(): Promise<RateEntry[]>;
    saveRates(rates: RateEntry[] | null): Promise<void>;
    getRegionDefinitions(): Promise<RegionDefinition[]>;
    getBidRateSettings(): Promise<BidRateSettings>;
    setBidRateSettings(param: BidRateSettings | null): Promise<void>;
}

export class RateSettingsClient extends AuthorizedApiBase implements IRateSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getCurrentRates(signal?: AbortSignal): Promise<RateEntry[]> {
        let url_ = this.baseUrl + "/company/RateSettings/GetCurrentRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentRates(_response);
        });
    }

    protected processGetCurrentRates(response: AxiosResponse): Promise<RateEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RateEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RateEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateEntry[]>(null as any);
    }

    saveRates(rates: RateEntry[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/RateSettings/SaveRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveRates(_response);
        });
    }

    protected processSaveRates(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRegionDefinitions(signal?: AbortSignal): Promise<RegionDefinition[]> {
        let url_ = this.baseUrl + "/company/RateSettings/GetRegionDefinitions/region-definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegionDefinitions(_response);
        });
    }

    protected processGetRegionDefinitions(response: AxiosResponse): Promise<RegionDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RegionDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegionDefinition[]>(null as any);
    }

    getBidRateSettings(signal?: AbortSignal): Promise<BidRateSettings> {
        let url_ = this.baseUrl + "/company/RateSettings/GetBidRateSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBidRateSettings(_response);
        });
    }

    protected processGetBidRateSettings(response: AxiosResponse): Promise<BidRateSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidRateSettings.fromJS(resultData200);
            return Promise.resolve<BidRateSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidRateSettings>(null as any);
    }

    setBidRateSettings(param: BidRateSettings | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/RateSettings/SetBidRateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBidRateSettings(_response);
        });
    }

    protected processSetBidRateSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISettingsClient {
    getBidSmtpSettings(): Promise<BidSmtpSettings>;
    setBidSmtpSettings(param: BidSmtpSettings | null): Promise<void>;
    getCompanySettings(): Promise<CompanySettings>;
    setCompanySettings(param: CompanySettings | null): Promise<void>;
    getEmailBidSettings(): Promise<EmailBidSettings>;
    setEmailBidSettings(param: EmailBidSettings | null): Promise<void>;
    getEmailBidSettingParams(): Promise<EmailBidSettingParam[]>;
    getCarrierEmailBidSettingParams(carrierId: number | undefined, integrationId: number | undefined): Promise<EmailBidSettingParam[]>;
    testEmail(model: SendTestBidEmailModel | null): Promise<void>;
    getLogoSettings(): Promise<LogoSettings>;
    setLogoSettings(param: LogoSettings | null): Promise<void>;
}

export class SettingsClient extends AuthorizedApiBase implements ISettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getBidSmtpSettings(signal?: AbortSignal): Promise<BidSmtpSettings> {
        let url_ = this.baseUrl + "/company/Settings/GetBidSmtpSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBidSmtpSettings(_response);
        });
    }

    protected processGetBidSmtpSettings(response: AxiosResponse): Promise<BidSmtpSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BidSmtpSettings.fromJS(resultData200);
            return Promise.resolve<BidSmtpSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BidSmtpSettings>(null as any);
    }

    setBidSmtpSettings(param: BidSmtpSettings | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Settings/SetBidSmtpSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBidSmtpSettings(_response);
        });
    }

    protected processSetBidSmtpSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getCompanySettings(signal?: AbortSignal): Promise<CompanySettings> {
        let url_ = this.baseUrl + "/company/Settings/GetCompanySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanySettings(_response);
        });
    }

    protected processGetCompanySettings(response: AxiosResponse): Promise<CompanySettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanySettings.fromJS(resultData200);
            return Promise.resolve<CompanySettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanySettings>(null as any);
    }

    setCompanySettings(param: CompanySettings | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Settings/SetCompanySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCompanySettings(_response);
        });
    }

    protected processSetCompanySettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getEmailBidSettings(signal?: AbortSignal): Promise<EmailBidSettings> {
        let url_ = this.baseUrl + "/company/Settings/GetEmailBidSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailBidSettings(_response);
        });
    }

    protected processGetEmailBidSettings(response: AxiosResponse): Promise<EmailBidSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailBidSettings.fromJS(resultData200);
            return Promise.resolve<EmailBidSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailBidSettings>(null as any);
    }

    setEmailBidSettings(param: EmailBidSettings | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Settings/SetEmailBidSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmailBidSettings(_response);
        });
    }

    protected processSetEmailBidSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getEmailBidSettingParams(signal?: AbortSignal): Promise<EmailBidSettingParam[]> {
        let url_ = this.baseUrl + "/company/Settings/GetEmailBidSettingParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailBidSettingParams(_response);
        });
    }

    protected processGetEmailBidSettingParams(response: AxiosResponse): Promise<EmailBidSettingParam[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailBidSettingParam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailBidSettingParam[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailBidSettingParam[]>(null as any);
    }

    getCarrierEmailBidSettingParams(carrierId: number | undefined, integrationId: number | undefined, signal?: AbortSignal): Promise<EmailBidSettingParam[]> {
        let url_ = this.baseUrl + "/company/Settings/GetCarrierEmailBidSettingParams?";
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarrierEmailBidSettingParams(_response);
        });
    }

    protected processGetCarrierEmailBidSettingParams(response: AxiosResponse): Promise<EmailBidSettingParam[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailBidSettingParam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailBidSettingParam[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailBidSettingParam[]>(null as any);
    }

    testEmail(model: SendTestBidEmailModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Settings/TestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestEmail(_response);
        });
    }

    protected processTestEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLogoSettings(signal?: AbortSignal): Promise<LogoSettings> {
        let url_ = this.baseUrl + "/company/Settings/GetLogoSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogoSettings(_response);
        });
    }

    protected processGetLogoSettings(response: AxiosResponse): Promise<LogoSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LogoSettings.fromJS(resultData200);
            return Promise.resolve<LogoSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LogoSettings>(null as any);
    }

    setLogoSettings(param: LogoSettings | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Settings/SetLogoSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetLogoSettings(_response);
        });
    }

    protected processSetLogoSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITelegramClient {
    getList(param: DataListGetParamsOfTelegramChannelListFilters | null): Promise<DataListResultOfTelegramChannelListModel>;
    getSettingsList(param: DataListGetParamsOfTelegramChannelSettingsListFilters | null): Promise<DataListResultOfTelegramChannelSettingsListModel>;
    generateAuthCode(): Promise<string>;
    update(model: TelegramChannelModel | null): Promise<void>;
    upsertSettings(model: TelegramChannelSettingsModel | null): Promise<void>;
    getDetails(id: number): Promise<TelegramChannelModel>;
    getSettingsDetails(id: number): Promise<TelegramChannelSettingsModel>;
    getTelegramChannelLinks(): Promise<NamedValueLong[]>;
    deleteTelegramChannelSettings(settingId: number | undefined): Promise<void>;
    deleteTelegramChannelLink(linkId: number | undefined): Promise<void>;
}

export class TelegramClient extends AuthorizedApiBase implements ITelegramClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfTelegramChannelListFilters | null, signal?: AbortSignal): Promise<DataListResultOfTelegramChannelListModel> {
        let url_ = this.baseUrl + "/company/Telegram/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfTelegramChannelListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfTelegramChannelListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfTelegramChannelListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfTelegramChannelListModel>(null as any);
    }

    getSettingsList(param: DataListGetParamsOfTelegramChannelSettingsListFilters | null, signal?: AbortSignal): Promise<DataListResultOfTelegramChannelSettingsListModel> {
        let url_ = this.baseUrl + "/company/Telegram/GetSettingsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsList(_response);
        });
    }

    protected processGetSettingsList(response: AxiosResponse): Promise<DataListResultOfTelegramChannelSettingsListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfTelegramChannelSettingsListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfTelegramChannelSettingsListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfTelegramChannelSettingsListModel>(null as any);
    }

    generateAuthCode(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/company/Telegram/GenerateAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateAuthCode(_response);
        });
    }

    protected processGenerateAuthCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    update(model: TelegramChannelModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Telegram/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    upsertSettings(model: TelegramChannelSettingsModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Telegram/UpsertSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertSettings(_response);
        });
    }

    protected processUpsertSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number, signal?: AbortSignal): Promise<TelegramChannelModel> {
        let url_ = this.baseUrl + "/company/Telegram/GetDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<TelegramChannelModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TelegramChannelModel.fromJS(resultData200);
            return Promise.resolve<TelegramChannelModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TelegramChannelModel>(null as any);
    }

    getSettingsDetails(id: number, signal?: AbortSignal): Promise<TelegramChannelSettingsModel> {
        let url_ = this.baseUrl + "/company/Telegram/GetSettingsDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsDetails(_response);
        });
    }

    protected processGetSettingsDetails(response: AxiosResponse): Promise<TelegramChannelSettingsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TelegramChannelSettingsModel.fromJS(resultData200);
            return Promise.resolve<TelegramChannelSettingsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TelegramChannelSettingsModel>(null as any);
    }

    getTelegramChannelLinks(signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/company/Telegram/GetTelegramChannelLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTelegramChannelLinks(_response);
        });
    }

    protected processGetTelegramChannelLinks(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    deleteTelegramChannelSettings(settingId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Telegram/DeleteTelegramChannelSettings?";
        if (settingId === null)
            throw new Error("The parameter 'settingId' cannot be null.");
        else if (settingId !== undefined)
            url_ += "settingId=" + encodeURIComponent("" + settingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTelegramChannelSettings(_response);
        });
    }

    protected processDeleteTelegramChannelSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTelegramChannelLink(linkId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Telegram/DeleteTelegramChannelLink?";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTelegramChannelLink(_response);
        });
    }

    protected processDeleteTelegramChannelLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITenantDataProviderClient {
    getUserData(): Promise<UserInfo>;
    getTenantData(): Promise<TenantInfo>;
    getVerifiedDomains(): Promise<string[]>;
    getUsers(): Promise<NamedValue[]>;
}

export class TenantDataProviderClient extends AuthorizedApiBase implements ITenantDataProviderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUserData(signal?: AbortSignal): Promise<UserInfo> {
        let url_ = this.baseUrl + "/company/TenantDataProvider/GetUserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserData(_response);
        });
    }

    protected processGetUserData(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    getTenantData(signal?: AbortSignal): Promise<TenantInfo> {
        let url_ = this.baseUrl + "/company/TenantDataProvider/GetTenantData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantData(_response);
        });
    }

    protected processGetTenantData(response: AxiosResponse): Promise<TenantInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantInfo.fromJS(resultData200);
            return Promise.resolve<TenantInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantInfo>(null as any);
    }

    getVerifiedDomains(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/company/TenantDataProvider/GetVerifiedDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVerifiedDomains(_response);
        });
    }

    protected processGetVerifiedDomains(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUsers(signal?: AbortSignal): Promise<NamedValue[]> {
        let url_ = this.baseUrl + "/company/TenantDataProvider/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<NamedValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValue[]>(null as any);
    }
}

export interface ITrackingDeviceClient {
    getList(param: DataListGetParamsOfTrackingDeviceListFilters | null): Promise<DataListResultOfTrackingDeviceModel>;
    generateInvitationCode(): Promise<string>;
    update(model: TrackingDeviceEditModel | null): Promise<void>;
    getDetails(id: number | undefined): Promise<TrackingDeviceEditModel>;
}

export class TrackingDeviceClient extends AuthorizedApiBase implements ITrackingDeviceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfTrackingDeviceListFilters | null, signal?: AbortSignal): Promise<DataListResultOfTrackingDeviceModel> {
        let url_ = this.baseUrl + "/company/TrackingDevice/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfTrackingDeviceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfTrackingDeviceModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfTrackingDeviceModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfTrackingDeviceModel>(null as any);
    }

    generateInvitationCode(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/company/TrackingDevice/GenerateInvitationCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateInvitationCode(_response);
        });
    }

    protected processGenerateInvitationCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    update(model: TrackingDeviceEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/TrackingDevice/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number | undefined, signal?: AbortSignal): Promise<TrackingDeviceEditModel> {
        let url_ = this.baseUrl + "/company/TrackingDevice/GetDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<TrackingDeviceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackingDeviceEditModel.fromJS(resultData200);
            return Promise.resolve<TrackingDeviceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackingDeviceEditModel>(null as any);
    }
}

export interface IVehicleClient {
    getList(param: DataListGetParamsOfVehicleListFilters | null): Promise<DataListResultOfVehicleListModel>;
    getShortList(): Promise<VehicleShortListModel[]>;
    getVehicleAvailabilityModels(): Promise<VehicleAvailabilityModel[]>;
    updateVehicleAvailability(model: UpdateVehicleAvailabilityModel | null): Promise<VehicleAvailabilityModel>;
    getFleetViewList(): Promise<VehicleFleetViewModel[]>;
    upsert(model: VehicleEditModel | null): Promise<void>;
    activate(id: number): Promise<void>;
    getById(id: number): Promise<VehicleEditModel>;
    deactivate(id: number): Promise<void>;
    getVehicleTrackingDataById(id: number): Promise<VehicleTrackingData>;
    vehicleLocationHistoryPoints(model: VehicleLocationHistoryPointsRequest | null): Promise<VehicleLocationHistoryPoint[]>;
}

export class VehicleClient extends AuthorizedApiBase implements IVehicleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfVehicleListFilters | null, signal?: AbortSignal): Promise<DataListResultOfVehicleListModel> {
        let url_ = this.baseUrl + "/company/Vehicle/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfVehicleListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfVehicleListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfVehicleListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfVehicleListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<VehicleShortListModel[]> {
        let url_ = this.baseUrl + "/company/Vehicle/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<VehicleShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleShortListModel[]>(null as any);
    }

    getVehicleAvailabilityModels(signal?: AbortSignal): Promise<VehicleAvailabilityModel[]> {
        let url_ = this.baseUrl + "/company/Vehicle/GetVehicleAvailabilityModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleAvailabilityModels(_response);
        });
    }

    protected processGetVehicleAvailabilityModels(response: AxiosResponse): Promise<VehicleAvailabilityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleAvailabilityModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleAvailabilityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleAvailabilityModel[]>(null as any);
    }

    updateVehicleAvailability(model: UpdateVehicleAvailabilityModel | null, signal?: AbortSignal): Promise<VehicleAvailabilityModel> {
        let url_ = this.baseUrl + "/company/Vehicle/UpdateVehicleAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVehicleAvailability(_response);
        });
    }

    protected processUpdateVehicleAvailability(response: AxiosResponse): Promise<VehicleAvailabilityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleAvailabilityModel.fromJS(resultData200);
            return Promise.resolve<VehicleAvailabilityModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleAvailabilityModel>(null as any);
    }

    getFleetViewList(signal?: AbortSignal): Promise<VehicleFleetViewModel[]> {
        let url_ = this.baseUrl + "/company/Vehicle/GetFleetViewList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFleetViewList(_response);
        });
    }

    protected processGetFleetViewList(response: AxiosResponse): Promise<VehicleFleetViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleFleetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleFleetViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFleetViewModel[]>(null as any);
    }

    upsert(model: VehicleEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Vehicle/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Vehicle/Activate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number, signal?: AbortSignal): Promise<VehicleEditModel> {
        let url_ = this.baseUrl + "/company/Vehicle/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VehicleEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleEditModel.fromJS(resultData200);
            return Promise.resolve<VehicleEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleEditModel>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/Vehicle/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getVehicleTrackingDataById(id: number, signal?: AbortSignal): Promise<VehicleTrackingData> {
        let url_ = this.baseUrl + "/company/Vehicle/GetVehicleTrackingDataById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleTrackingDataById(_response);
        });
    }

    protected processGetVehicleTrackingDataById(response: AxiosResponse): Promise<VehicleTrackingData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleTrackingData.fromJS(resultData200);
            return Promise.resolve<VehicleTrackingData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleTrackingData>(null as any);
    }

    vehicleLocationHistoryPoints(model: VehicleLocationHistoryPointsRequest | null, signal?: AbortSignal): Promise<VehicleLocationHistoryPoint[]> {
        let url_ = this.baseUrl + "/company/Vehicle/VehicleLocationHistoryPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleLocationHistoryPoints(_response);
        });
    }

    protected processVehicleLocationHistoryPoints(response: AxiosResponse): Promise<VehicleLocationHistoryPoint[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleLocationHistoryPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleLocationHistoryPoint[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleLocationHistoryPoint[]>(null as any);
    }
}

export interface IUserClient {
    selectTenant(tenantId: number | undefined): Promise<void>;
}

export class UserClient extends AuthorizedApiBase implements IUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    selectTenant(tenantId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/company/User/SelectTenant?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectTenant(_response);
        });
    }

    protected processSelectTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DataListResultOfBidModelListView implements IDataListResultOfBidModelListView {
    items?: BidModelListView[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfBidModelListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(BidModelListView.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfBidModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfBidModelListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfBidModelListView {
        const json = this.toJSON();
        let result = new DataListResultOfBidModelListView();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfBidModelListView {
    items?: BidModelListView[] | undefined;
    count?: number;
}

export class CarrierListRatingModel implements ICarrierListRatingModel {
    rating?: RatingModel | undefined;
    customPeriodRating?: RatingModel | undefined;

    constructor(data?: ICarrierListRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rating = _data["Rating"] ? RatingModel.fromJS(_data["Rating"]) : <any>undefined;
            this.customPeriodRating = _data["CustomPeriodRating"] ? RatingModel.fromJS(_data["CustomPeriodRating"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarrierListRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierListRatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["CustomPeriodRating"] = this.customPeriodRating ? this.customPeriodRating.toJSON() : <any>undefined;
        return data;
    }

    clone(): CarrierListRatingModel {
        const json = this.toJSON();
        let result = new CarrierListRatingModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierListRatingModel {
    rating?: RatingModel | undefined;
    customPeriodRating?: RatingModel | undefined;
}

export class BidModelListView extends CarrierListRatingModel implements IBidModelListView {
    id?: number;
    rate?: number;
    carrierRate?: number;
    pays?: number | undefined;
    miles?: number;
    weight?: number;
    vehicle?: string | undefined;
    dims?: string | undefined;
    carrier?: string | undefined;
    customMessage?: string | undefined;
    milesOut?: number | undefined;
    orderNumber?: string | undefined;
    integration?: string | undefined;
    integrationId?: number | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    postedByPhone?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    pickUpAddress?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    deliveryAddress?: string | undefined;
    status?: ExternalOrderBidStatus;
    customer?: string | undefined;
    customerMC?: number | undefined;
    isBidSend?: boolean;
    rejectedWithRate?: number | undefined;
    orderId?: number | undefined;
    postedOrderId?: number | undefined;
    hazardous?: boolean;
    vehicleType?: string | undefined;
    pieces?: number;
    createdBy?: string | undefined;
    sentBy?: string | undefined;
    pickUpLon?: number | undefined;
    pickUpLat?: number | undefined;
    vehicleLon?: number | undefined;
    vehicleLat?: number | undefined;
    deadhead?: number | undefined;
    createdAt?: moment.Moment;
    orderQuoteId?: number | undefined;
    orderSourceType?: OrderSourceType;
    driverNotes?: string | undefined;
    vehicleRating?: RatingModel | undefined;
    vehicleCustomPeriodRating?: RatingModel | undefined;
    recommendedRate?: number | undefined;

    constructor(data?: IBidModelListView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.rate = _data["Rate"];
            this.carrierRate = _data["CarrierRate"];
            this.pays = _data["Pays"];
            this.miles = _data["Miles"];
            this.weight = _data["Weight"];
            this.vehicle = _data["Vehicle"];
            this.dims = _data["Dims"];
            this.carrier = _data["Carrier"];
            this.customMessage = _data["CustomMessage"];
            this.milesOut = _data["MilesOut"];
            this.orderNumber = _data["OrderNumber"];
            this.integration = _data["Integration"];
            this.integrationId = _data["IntegrationId"];
            this.postedBy = _data["PostedBy"];
            this.postedByEmail = _data["PostedByEmail"];
            this.postedByPhone = _data["PostedByPhone"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpDateTimeOffset = _data["PickUpDateTimeOffset"];
            this.pickUpAddress = _data["PickUpAddress"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryDateTimeOffset = _data["DeliveryDateTimeOffset"];
            this.deliveryAddress = _data["DeliveryAddress"];
            this.status = _data["Status"];
            this.customer = _data["Customer"];
            this.customerMC = _data["CustomerMC"];
            this.isBidSend = _data["IsBidSend"];
            this.rejectedWithRate = _data["RejectedWithRate"];
            this.orderId = _data["OrderId"];
            this.postedOrderId = _data["PostedOrderId"];
            this.hazardous = _data["Hazardous"];
            this.vehicleType = _data["VehicleType"];
            this.pieces = _data["Pieces"];
            this.createdBy = _data["CreatedBy"];
            this.sentBy = _data["SentBy"];
            this.pickUpLon = _data["PickUpLon"];
            this.pickUpLat = _data["PickUpLat"];
            this.vehicleLon = _data["VehicleLon"];
            this.vehicleLat = _data["VehicleLat"];
            this.deadhead = _data["Deadhead"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.orderQuoteId = _data["OrderQuoteId"];
            this.orderSourceType = _data["OrderSourceType"];
            this.driverNotes = _data["DriverNotes"];
            this.vehicleRating = _data["VehicleRating"] ? RatingModel.fromJS(_data["VehicleRating"]) : <any>undefined;
            this.vehicleCustomPeriodRating = _data["VehicleCustomPeriodRating"] ? RatingModel.fromJS(_data["VehicleCustomPeriodRating"]) : <any>undefined;
            this.recommendedRate = _data["RecommendedRate"];
        }
    }

    static override fromJS(data: any): BidModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new BidModelListView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Rate"] = this.rate;
        data["CarrierRate"] = this.carrierRate;
        data["Pays"] = this.pays;
        data["Miles"] = this.miles;
        data["Weight"] = this.weight;
        data["Vehicle"] = this.vehicle;
        data["Dims"] = this.dims;
        data["Carrier"] = this.carrier;
        data["CustomMessage"] = this.customMessage;
        data["MilesOut"] = this.milesOut;
        data["OrderNumber"] = this.orderNumber;
        data["Integration"] = this.integration;
        data["IntegrationId"] = this.integrationId;
        data["PostedBy"] = this.postedBy;
        data["PostedByEmail"] = this.postedByEmail;
        data["PostedByPhone"] = this.postedByPhone;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpDateTimeOffset"] = this.pickUpDateTimeOffset;
        data["PickUpAddress"] = this.pickUpAddress;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryDateTimeOffset"] = this.deliveryDateTimeOffset;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["Status"] = this.status;
        data["Customer"] = this.customer;
        data["CustomerMC"] = this.customerMC;
        data["IsBidSend"] = this.isBidSend;
        data["RejectedWithRate"] = this.rejectedWithRate;
        data["OrderId"] = this.orderId;
        data["PostedOrderId"] = this.postedOrderId;
        data["Hazardous"] = this.hazardous;
        data["VehicleType"] = this.vehicleType;
        data["Pieces"] = this.pieces;
        data["CreatedBy"] = this.createdBy;
        data["SentBy"] = this.sentBy;
        data["PickUpLon"] = this.pickUpLon;
        data["PickUpLat"] = this.pickUpLat;
        data["VehicleLon"] = this.vehicleLon;
        data["VehicleLat"] = this.vehicleLat;
        data["Deadhead"] = this.deadhead;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["OrderQuoteId"] = this.orderQuoteId;
        data["OrderSourceType"] = this.orderSourceType;
        data["DriverNotes"] = this.driverNotes;
        data["VehicleRating"] = this.vehicleRating ? this.vehicleRating.toJSON() : <any>undefined;
        data["VehicleCustomPeriodRating"] = this.vehicleCustomPeriodRating ? this.vehicleCustomPeriodRating.toJSON() : <any>undefined;
        data["RecommendedRate"] = this.recommendedRate;
        super.toJSON(data);
        return data;
    }

    clone(): BidModelListView {
        const json = this.toJSON();
        let result = new BidModelListView();
        result.init(json);
        return result;
    }
}

export interface IBidModelListView extends ICarrierListRatingModel {
    id?: number;
    rate?: number;
    carrierRate?: number;
    pays?: number | undefined;
    miles?: number;
    weight?: number;
    vehicle?: string | undefined;
    dims?: string | undefined;
    carrier?: string | undefined;
    customMessage?: string | undefined;
    milesOut?: number | undefined;
    orderNumber?: string | undefined;
    integration?: string | undefined;
    integrationId?: number | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    postedByPhone?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    pickUpAddress?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    deliveryAddress?: string | undefined;
    status?: ExternalOrderBidStatus;
    customer?: string | undefined;
    customerMC?: number | undefined;
    isBidSend?: boolean;
    rejectedWithRate?: number | undefined;
    orderId?: number | undefined;
    postedOrderId?: number | undefined;
    hazardous?: boolean;
    vehicleType?: string | undefined;
    pieces?: number;
    createdBy?: string | undefined;
    sentBy?: string | undefined;
    pickUpLon?: number | undefined;
    pickUpLat?: number | undefined;
    vehicleLon?: number | undefined;
    vehicleLat?: number | undefined;
    deadhead?: number | undefined;
    createdAt?: moment.Moment;
    orderQuoteId?: number | undefined;
    orderSourceType?: OrderSourceType;
    driverNotes?: string | undefined;
    vehicleRating?: RatingModel | undefined;
    vehicleCustomPeriodRating?: RatingModel | undefined;
    recommendedRate?: number | undefined;
}

/** 1 = Requested 2 = Processed 3 = Rejected */
export enum ExternalOrderBidStatus {
    Requested = 1,
    Processed = 2,
    Rejected = 3,
}

/** 1 = External 2 = Internal */
export enum OrderSourceType {
    External = 1,
    Internal = 2,
}

export class RatingModel implements IRatingModel {
    rating?: number;
    pickUpOnTime?: number;
    deliverOnTime?: number;
    communicationOnTime?: number;
    trackingUpdate?: number;
    failToDeliver?: number;
    ratingOrders?: number;

    constructor(data?: IRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rating = _data["Rating"];
            this.pickUpOnTime = _data["PickUpOnTime"];
            this.deliverOnTime = _data["DeliverOnTime"];
            this.communicationOnTime = _data["CommunicationOnTime"];
            this.trackingUpdate = _data["TrackingUpdate"];
            this.failToDeliver = _data["FailToDeliver"];
            this.ratingOrders = _data["RatingOrders"];
        }
    }

    static fromJS(data: any): RatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rating"] = this.rating;
        data["PickUpOnTime"] = this.pickUpOnTime;
        data["DeliverOnTime"] = this.deliverOnTime;
        data["CommunicationOnTime"] = this.communicationOnTime;
        data["TrackingUpdate"] = this.trackingUpdate;
        data["FailToDeliver"] = this.failToDeliver;
        data["RatingOrders"] = this.ratingOrders;
        return data;
    }

    clone(): RatingModel {
        const json = this.toJSON();
        let result = new RatingModel();
        result.init(json);
        return result;
    }
}

export interface IRatingModel {
    rating?: number;
    pickUpOnTime?: number;
    deliverOnTime?: number;
    communicationOnTime?: number;
    trackingUpdate?: number;
    failToDeliver?: number;
    ratingOrders?: number;
}

export class DataListGetParamsOfBidListFilters implements IDataListGetParamsOfBidListFilters {
    filter?: BidListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfBidListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? BidListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfBidListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfBidListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfBidListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfBidListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfBidListFilters {
    filter?: BidListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class BidListFilters implements IBidListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    statuses?: ExternalOrderBidStatus[] | undefined;
    isBidSend?: boolean | undefined;

    constructor(data?: IBidListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["Statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["Statuses"])
                    this.statuses!.push(item);
            }
            this.isBidSend = _data["IsBidSend"];
        }
    }

    static fromJS(data: any): BidListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new BidListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["Statuses"] = [];
            for (let item of this.statuses)
                data["Statuses"].push(item);
        }
        data["IsBidSend"] = this.isBidSend;
        return data;
    }

    clone(): BidListFilters {
        const json = this.toJSON();
        let result = new BidListFilters();
        result.init(json);
        return result;
    }
}

export interface IBidListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    statuses?: ExternalOrderBidStatus[] | undefined;
    isBidSend?: boolean | undefined;
}

export class CreateBidModel implements ICreateBidModel {
    orderId?: number;
    vehicleId?: number | undefined;
    customMessage?: string | undefined;
    driverNotes?: string | undefined;
    rate?: number;
    milesOut?: number | undefined;
    miles?: number | undefined;

    constructor(data?: ICreateBidModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.vehicleId = _data["VehicleId"];
            this.customMessage = _data["CustomMessage"];
            this.driverNotes = _data["DriverNotes"];
            this.rate = _data["Rate"];
            this.milesOut = _data["MilesOut"];
            this.miles = _data["Miles"];
        }
    }

    static fromJS(data: any): CreateBidModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBidModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["VehicleId"] = this.vehicleId;
        data["CustomMessage"] = this.customMessage;
        data["DriverNotes"] = this.driverNotes;
        data["Rate"] = this.rate;
        data["MilesOut"] = this.milesOut;
        data["Miles"] = this.miles;
        return data;
    }

    clone(): CreateBidModel {
        const json = this.toJSON();
        let result = new CreateBidModel();
        result.init(json);
        return result;
    }
}

export interface ICreateBidModel {
    orderId?: number;
    vehicleId?: number | undefined;
    customMessage?: string | undefined;
    driverNotes?: string | undefined;
    rate?: number;
    milesOut?: number | undefined;
    miles?: number | undefined;
}

export class SendBidEmailModel extends CreateBidModel implements ISendBidEmailModel {
    externalOrderBidId?: number | undefined;

    constructor(data?: ISendBidEmailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalOrderBidId = _data["ExternalOrderBidId"];
        }
    }

    static override fromJS(data: any): SendBidEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendBidEmailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalOrderBidId"] = this.externalOrderBidId;
        super.toJSON(data);
        return data;
    }

    clone(): SendBidEmailModel {
        const json = this.toJSON();
        let result = new SendBidEmailModel();
        result.init(json);
        return result;
    }
}

export interface ISendBidEmailModel extends ICreateBidModel {
    externalOrderBidId?: number | undefined;
}

export class BidModelView implements IBidModelView {
    bidId?: number | undefined;
    vehicleId?: number | undefined;
    rate?: number | undefined;
    carrierRate?: number | undefined;
    pays?: number | undefined;
    miles?: number;
    weight?: number;
    dims?: string | undefined;
    vehicleType?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    notes?: string | undefined;
    driverNotes?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    companyName?: string | undefined;
    customerName?: string | undefined;
    customerMCNumber?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    companyAddress?: string | undefined;
    companyCityState?: string | undefined;
    companyPhone?: string | undefined;
    pieces?: number;
    deliveryAddress?: string | undefined;
    pickUpAddress?: string | undefined;
    hazardous?: boolean;
    status?: ExternalOrderBidStatus | undefined;
    postedOrderId?: number;
    emailMessageId?: number | undefined;

    constructor(data?: IBidModelView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bidId = _data["BidId"];
            this.vehicleId = _data["VehicleId"];
            this.rate = _data["Rate"];
            this.carrierRate = _data["CarrierRate"];
            this.pays = _data["Pays"];
            this.miles = _data["Miles"];
            this.weight = _data["Weight"];
            this.dims = _data["Dims"];
            this.vehicleType = _data["VehicleType"];
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpDateTimeOffset = _data["PickUpDateTimeOffset"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryDateTimeOffset = _data["DeliveryDateTimeOffset"];
            this.notes = _data["Notes"];
            this.driverNotes = _data["DriverNotes"];
            this.postedBy = _data["PostedBy"];
            this.postedByEmail = _data["PostedByEmail"];
            this.phone = _data["Phone"];
            this.fax = _data["Fax"];
            this.companyName = _data["CompanyName"];
            this.customerName = _data["CustomerName"];
            this.customerMCNumber = _data["CustomerMCNumber"];
            this.customerNoteType = _data["CustomerNoteType"];
            this.customerNote = _data["CustomerNote"];
            this.companyAddress = _data["CompanyAddress"];
            this.companyCityState = _data["CompanyCityState"];
            this.companyPhone = _data["CompanyPhone"];
            this.pieces = _data["Pieces"];
            this.deliveryAddress = _data["DeliveryAddress"];
            this.pickUpAddress = _data["PickUpAddress"];
            this.hazardous = _data["Hazardous"];
            this.status = _data["Status"];
            this.postedOrderId = _data["PostedOrderId"];
            this.emailMessageId = _data["EmailMessageId"];
        }
    }

    static fromJS(data: any): BidModelView {
        data = typeof data === 'object' ? data : {};
        let result = new BidModelView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BidId"] = this.bidId;
        data["VehicleId"] = this.vehicleId;
        data["Rate"] = this.rate;
        data["CarrierRate"] = this.carrierRate;
        data["Pays"] = this.pays;
        data["Miles"] = this.miles;
        data["Weight"] = this.weight;
        data["Dims"] = this.dims;
        data["VehicleType"] = this.vehicleType;
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpDateTimeOffset"] = this.pickUpDateTimeOffset;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryDateTimeOffset"] = this.deliveryDateTimeOffset;
        data["Notes"] = this.notes;
        data["DriverNotes"] = this.driverNotes;
        data["PostedBy"] = this.postedBy;
        data["PostedByEmail"] = this.postedByEmail;
        data["Phone"] = this.phone;
        data["Fax"] = this.fax;
        data["CompanyName"] = this.companyName;
        data["CustomerName"] = this.customerName;
        data["CustomerMCNumber"] = this.customerMCNumber;
        data["CustomerNoteType"] = this.customerNoteType;
        data["CustomerNote"] = this.customerNote;
        data["CompanyAddress"] = this.companyAddress;
        data["CompanyCityState"] = this.companyCityState;
        data["CompanyPhone"] = this.companyPhone;
        data["Pieces"] = this.pieces;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["PickUpAddress"] = this.pickUpAddress;
        data["Hazardous"] = this.hazardous;
        data["Status"] = this.status;
        data["PostedOrderId"] = this.postedOrderId;
        data["EmailMessageId"] = this.emailMessageId;
        return data;
    }

    clone(): BidModelView {
        const json = this.toJSON();
        let result = new BidModelView();
        result.init(json);
        return result;
    }
}

export interface IBidModelView {
    bidId?: number | undefined;
    vehicleId?: number | undefined;
    rate?: number | undefined;
    carrierRate?: number | undefined;
    pays?: number | undefined;
    miles?: number;
    weight?: number;
    dims?: string | undefined;
    vehicleType?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    notes?: string | undefined;
    driverNotes?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    companyName?: string | undefined;
    customerName?: string | undefined;
    customerMCNumber?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    companyAddress?: string | undefined;
    companyCityState?: string | undefined;
    companyPhone?: string | undefined;
    pieces?: number;
    deliveryAddress?: string | undefined;
    pickUpAddress?: string | undefined;
    hazardous?: boolean;
    status?: ExternalOrderBidStatus | undefined;
    postedOrderId?: number;
    emailMessageId?: number | undefined;
}

/** 0 = None 1 = Preferable 2 = Warning 4 = Avoid */
export enum CustomerNoteType {
    None = 0,
    Preferable = 1,
    Warning = 2,
    Avoid = 4,
}

/** 1 = LargeStraight 2 = SmallStraight 3 = CargoVan 4 = Tractor */
export enum VehicleType {
    LargeStraight = 1,
    SmallStraight = 2,
    CargoVan = 3,
    Tractor = 4,
}

export class PostedRouteSummary implements IPostedRouteSummary {
    milesOut?: number;
    routeMiles?: number;
    pUTime?: number;
    transitionTime?: number;
    transitionTimeSolo?: number;
    transitionTimeTeam?: number;

    constructor(data?: IPostedRouteSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.milesOut = _data["MilesOut"];
            this.routeMiles = _data["RouteMiles"];
            this.pUTime = _data["PUTime"];
            this.transitionTime = _data["TransitionTime"];
            this.transitionTimeSolo = _data["TransitionTimeSolo"];
            this.transitionTimeTeam = _data["TransitionTimeTeam"];
        }
    }

    static fromJS(data: any): PostedRouteSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PostedRouteSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MilesOut"] = this.milesOut;
        data["RouteMiles"] = this.routeMiles;
        data["PUTime"] = this.pUTime;
        data["TransitionTime"] = this.transitionTime;
        data["TransitionTimeSolo"] = this.transitionTimeSolo;
        data["TransitionTimeTeam"] = this.transitionTimeTeam;
        return data;
    }

    clone(): PostedRouteSummary {
        const json = this.toJSON();
        let result = new PostedRouteSummary();
        result.init(json);
        return result;
    }
}

export interface IPostedRouteSummary {
    milesOut?: number;
    routeMiles?: number;
    pUTime?: number;
    transitionTime?: number;
    transitionTimeSolo?: number;
    transitionTimeTeam?: number;
}

export class DataListResultOfCarrierListModel implements IDataListResultOfCarrierListModel {
    items?: CarrierListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfCarrierListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CarrierListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfCarrierListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfCarrierListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfCarrierListModel {
        const json = this.toJSON();
        let result = new DataListResultOfCarrierListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfCarrierListModel {
    items?: CarrierListModel[] | undefined;
    count?: number;
}

export class CarrierListModel extends CarrierListRatingModel implements ICarrierListModel {
    id?: number;
    createdAt?: moment.Moment;
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    eIN?: number;
    active?: boolean;
    mC?: string | undefined;
    vehicles?: number;
    drivers?: number;
    insuranceExpirationDate?: moment.Moment;

    constructor(data?: ICarrierListModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.displayName = _data["DisplayName"];
            this.name = _data["Name"];
            this.dbaName = _data["DbaName"];
            this.uSDOT = _data["USDOT"];
            this.eIN = _data["EIN"];
            this.active = _data["Active"];
            this.mC = _data["MC"];
            this.vehicles = _data["Vehicles"];
            this.drivers = _data["Drivers"];
            this.insuranceExpirationDate = _data["InsuranceExpirationDate"] ? moment(_data["InsuranceExpirationDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CarrierListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierListModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Name"] = this.name;
        data["DbaName"] = this.dbaName;
        data["USDOT"] = this.uSDOT;
        data["EIN"] = this.eIN;
        data["Active"] = this.active;
        data["MC"] = this.mC;
        data["Vehicles"] = this.vehicles;
        data["Drivers"] = this.drivers;
        data["InsuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): CarrierListModel {
        const json = this.toJSON();
        let result = new CarrierListModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierListModel extends ICarrierListRatingModel {
    id?: number;
    createdAt?: moment.Moment;
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    eIN?: number;
    active?: boolean;
    mC?: string | undefined;
    vehicles?: number;
    drivers?: number;
    insuranceExpirationDate?: moment.Moment;
}

export class DataListGetParamsOfCarrierListFilters implements IDataListGetParamsOfCarrierListFilters {
    filter?: CarrierListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfCarrierListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? CarrierListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfCarrierListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfCarrierListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfCarrierListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfCarrierListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfCarrierListFilters {
    filter?: CarrierListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class CarrierListFilters implements ICarrierListFilters {
    search?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ICarrierListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): CarrierListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        return data;
    }

    clone(): CarrierListFilters {
        const json = this.toJSON();
        let result = new CarrierListFilters();
        result.init(json);
        return result;
    }
}

export interface ICarrierListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
}

export class CarrierShortListModel extends CarrierListRatingModel implements ICarrierShortListModel {
    id?: number;
    displayName?: string | undefined;

    constructor(data?: ICarrierShortListModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.displayName = _data["DisplayName"];
        }
    }

    static override fromJS(data: any): CarrierShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierShortListModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DisplayName"] = this.displayName;
        super.toJSON(data);
        return data;
    }

    clone(): CarrierShortListModel {
        const json = this.toJSON();
        let result = new CarrierShortListModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierShortListModel extends ICarrierListRatingModel {
    id?: number;
    displayName?: string | undefined;
}

export class CarrierEditModel implements ICarrierEditModel {
    id?: number | undefined;
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    mC?: string | undefined;
    eIN?: number;
    active?: boolean | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    carrierEmailEditModel?: CarrierEmailEditModel | undefined;
    insuranceExpirationDate?: moment.Moment;
    allowAutoBid?: boolean;
    autoBidRate?: number | undefined;
    bypassRateRangeValidation?: boolean;

    constructor(data?: ICarrierEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.displayName = _data["DisplayName"];
            this.name = _data["Name"];
            this.dbaName = _data["DbaName"];
            this.uSDOT = _data["USDOT"];
            this.mC = _data["MC"];
            this.eIN = _data["EIN"];
            this.active = _data["Active"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.phone = _data["Phone"];
            this.carrierEmailEditModel = _data["CarrierEmailEditModel"] ? CarrierEmailEditModel.fromJS(_data["CarrierEmailEditModel"]) : <any>undefined;
            this.insuranceExpirationDate = _data["InsuranceExpirationDate"] ? moment(_data["InsuranceExpirationDate"].toString()) : <any>undefined;
            this.allowAutoBid = _data["AllowAutoBid"];
            this.autoBidRate = _data["AutoBidRate"];
            this.bypassRateRangeValidation = _data["BypassRateRangeValidation"];
        }
    }

    static fromJS(data: any): CarrierEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DisplayName"] = this.displayName;
        data["Name"] = this.name;
        data["DbaName"] = this.dbaName;
        data["USDOT"] = this.uSDOT;
        data["MC"] = this.mC;
        data["EIN"] = this.eIN;
        data["Active"] = this.active;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["Phone"] = this.phone;
        data["CarrierEmailEditModel"] = this.carrierEmailEditModel ? this.carrierEmailEditModel.toJSON() : <any>undefined;
        data["InsuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : <any>undefined;
        data["AllowAutoBid"] = this.allowAutoBid;
        data["AutoBidRate"] = this.autoBidRate;
        data["BypassRateRangeValidation"] = this.bypassRateRangeValidation;
        return data;
    }

    clone(): CarrierEditModel {
        const json = this.toJSON();
        let result = new CarrierEditModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierEditModel {
    id?: number | undefined;
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    mC?: string | undefined;
    eIN?: number;
    active?: boolean | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
    carrierEmailEditModel?: CarrierEmailEditModel | undefined;
    insuranceExpirationDate?: moment.Moment;
    allowAutoBid?: boolean;
    autoBidRate?: number | undefined;
    bypassRateRangeValidation?: boolean;
}

export class CarrierEmailEditModel implements ICarrierEmailEditModel {
    inboxIntegrationId?: number | undefined;
    bidSettings?: CarrierBidSettings | undefined;

    constructor(data?: ICarrierEmailEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inboxIntegrationId = _data["InboxIntegrationId"];
            this.bidSettings = _data["BidSettings"] ? CarrierBidSettings.fromJS(_data["BidSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarrierEmailEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierEmailEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InboxIntegrationId"] = this.inboxIntegrationId;
        data["BidSettings"] = this.bidSettings ? this.bidSettings.toJSON() : <any>undefined;
        return data;
    }

    clone(): CarrierEmailEditModel {
        const json = this.toJSON();
        let result = new CarrierEmailEditModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierEmailEditModel {
    inboxIntegrationId?: number | undefined;
    bidSettings?: CarrierBidSettings | undefined;
}

export class CarrierBidSettings implements ICarrierBidSettings {
    subjectTemplate?: string | undefined;
    bodyTemplate?: string | undefined;

    constructor(data?: ICarrierBidSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectTemplate = _data["SubjectTemplate"];
            this.bodyTemplate = _data["BodyTemplate"];
        }
    }

    static fromJS(data: any): CarrierBidSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierBidSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubjectTemplate"] = this.subjectTemplate;
        data["BodyTemplate"] = this.bodyTemplate;
        return data;
    }

    clone(): CarrierBidSettings {
        const json = this.toJSON();
        let result = new CarrierBidSettings();
        result.init(json);
        return result;
    }
}

export interface ICarrierBidSettings {
    subjectTemplate?: string | undefined;
    bodyTemplate?: string | undefined;
}

export class RatingEditModel implements IRatingEditModel {
    carrierId?: number;
    orderId?: number;
    pickUpOnTime?: boolean;
    deliverOnTime?: boolean;
    communicationOnTime?: boolean;
    trackingUpdate?: boolean;
    failToDeliver?: boolean;

    constructor(data?: IRatingEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["CarrierId"];
            this.orderId = _data["OrderId"];
            this.pickUpOnTime = _data["PickUpOnTime"];
            this.deliverOnTime = _data["DeliverOnTime"];
            this.communicationOnTime = _data["CommunicationOnTime"];
            this.trackingUpdate = _data["TrackingUpdate"];
            this.failToDeliver = _data["FailToDeliver"];
        }
    }

    static fromJS(data: any): RatingEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new RatingEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CarrierId"] = this.carrierId;
        data["OrderId"] = this.orderId;
        data["PickUpOnTime"] = this.pickUpOnTime;
        data["DeliverOnTime"] = this.deliverOnTime;
        data["CommunicationOnTime"] = this.communicationOnTime;
        data["TrackingUpdate"] = this.trackingUpdate;
        data["FailToDeliver"] = this.failToDeliver;
        return data;
    }

    clone(): RatingEditModel {
        const json = this.toJSON();
        let result = new RatingEditModel();
        result.init(json);
        return result;
    }
}

export interface IRatingEditModel {
    carrierId?: number;
    orderId?: number;
    pickUpOnTime?: boolean;
    deliverOnTime?: boolean;
    communicationOnTime?: boolean;
    trackingUpdate?: boolean;
    failToDeliver?: boolean;
}

export class CarrierRatingNoteEditModel implements ICarrierRatingNoteEditModel {
    carrierId?: number;
    orderId?: number;
    note?: string | undefined;
    type?: CarrierRatingNoteType;

    constructor(data?: ICarrierRatingNoteEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierId = _data["CarrierId"];
            this.orderId = _data["OrderId"];
            this.note = _data["Note"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): CarrierRatingNoteEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierRatingNoteEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CarrierId"] = this.carrierId;
        data["OrderId"] = this.orderId;
        data["Note"] = this.note;
        data["Type"] = this.type;
        return data;
    }

    clone(): CarrierRatingNoteEditModel {
        const json = this.toJSON();
        let result = new CarrierRatingNoteEditModel();
        result.init(json);
        return result;
    }
}

export interface ICarrierRatingNoteEditModel {
    carrierId?: number;
    orderId?: number;
    note?: string | undefined;
    type?: CarrierRatingNoteType;
}

/** 1 = Negative 2 = Neutral 3 = Positive */
export enum CarrierRatingNoteType {
    Negative = 1,
    Neutral = 2,
    Positive = 3,
}

/** 1 = GMail 2 = Outlook 3 = Yahoo 4 = Hotmail 5 = Office365 */
export enum EmailSmtpSettingType {
    GMail = 1,
    Outlook = 2,
    Yahoo = 3,
    Hotmail = 4,
    Office365 = 5,
}

export class DataListResultOfCompanyIntegrationListModel implements IDataListResultOfCompanyIntegrationListModel {
    items?: CompanyIntegrationListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfCompanyIntegrationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CompanyIntegrationListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfCompanyIntegrationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfCompanyIntegrationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfCompanyIntegrationListModel {
        const json = this.toJSON();
        let result = new DataListResultOfCompanyIntegrationListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfCompanyIntegrationListModel {
    items?: CompanyIntegrationListModel[] | undefined;
    count?: number;
}

export class CompanyIntegrationListModel implements ICompanyIntegrationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
    createdAt?: moment.Moment;

    constructor(data?: ICompanyIntegrationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.settingsJSON = _data["SettingsJSON"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyIntegrationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["SettingsJSON"] = this.settingsJSON;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): CompanyIntegrationListModel {
        const json = this.toJSON();
        let result = new CompanyIntegrationListModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
    createdAt?: moment.Moment;
}

/** 1 = Sylectus 2 = SMTP 4 = DAT 6 = Inbox 8 = QBO 16 = VerifiedSmtpSender */
export enum CompanyIntegrationType {
    Sylectus = 1,
    SMTP = 2,
    DAT = 4,
    Inbox = 6,
    QBO = 8,
    VerifiedSmtpSender = 16,
}

export class DataListGetParamsOfCompanyIntegrationListFilters implements IDataListGetParamsOfCompanyIntegrationListFilters {
    filter?: CompanyIntegrationListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfCompanyIntegrationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? CompanyIntegrationListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfCompanyIntegrationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfCompanyIntegrationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfCompanyIntegrationListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfCompanyIntegrationListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfCompanyIntegrationListFilters {
    filter?: CompanyIntegrationListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class CompanyIntegrationListFilters implements ICompanyIntegrationListFilters {
    search?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ICompanyIntegrationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): CompanyIntegrationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        return data;
    }

    clone(): CompanyIntegrationListFilters {
        const json = this.toJSON();
        let result = new CompanyIntegrationListFilters();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
}

export class DataListResultOfCompanyIntegrationLogListModel implements IDataListResultOfCompanyIntegrationLogListModel {
    items?: CompanyIntegrationLogListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfCompanyIntegrationLogListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CompanyIntegrationLogListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfCompanyIntegrationLogListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfCompanyIntegrationLogListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfCompanyIntegrationLogListModel {
        const json = this.toJSON();
        let result = new DataListResultOfCompanyIntegrationLogListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfCompanyIntegrationLogListModel {
    items?: CompanyIntegrationLogListModel[] | undefined;
    count?: number;
}

export class CompanyIntegrationLogListModel implements ICompanyIntegrationLogListModel {
    id?: number;
    log?: string | undefined;
    type?: CompanyIntegrationLogType;
    createdAt?: moment.Moment;

    constructor(data?: ICompanyIntegrationLogListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.log = _data["Log"];
            this.type = _data["Type"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyIntegrationLogListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationLogListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Log"] = this.log;
        data["Type"] = this.type;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): CompanyIntegrationLogListModel {
        const json = this.toJSON();
        let result = new CompanyIntegrationLogListModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationLogListModel {
    id?: number;
    log?: string | undefined;
    type?: CompanyIntegrationLogType;
    createdAt?: moment.Moment;
}

/** 1 = Error 2 = Info 3 = Warning */
export enum CompanyIntegrationLogType {
    Error = 1,
    Info = 2,
    Warning = 3,
}

export class DataListGetParamsOfCompanyIntegrationLogListFilters implements IDataListGetParamsOfCompanyIntegrationLogListFilters {
    filter?: CompanyIntegrationLogListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfCompanyIntegrationLogListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? CompanyIntegrationLogListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfCompanyIntegrationLogListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfCompanyIntegrationLogListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfCompanyIntegrationLogListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfCompanyIntegrationLogListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfCompanyIntegrationLogListFilters {
    filter?: CompanyIntegrationLogListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class CompanyIntegrationLogListFilters implements ICompanyIntegrationLogListFilters {
    type?: CompanyIntegrationLogType | undefined;
    companyIntegrationId?: number;

    constructor(data?: ICompanyIntegrationLogListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.companyIntegrationId = _data["CompanyIntegrationId"];
        }
    }

    static fromJS(data: any): CompanyIntegrationLogListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationLogListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["CompanyIntegrationId"] = this.companyIntegrationId;
        return data;
    }

    clone(): CompanyIntegrationLogListFilters {
        const json = this.toJSON();
        let result = new CompanyIntegrationLogListFilters();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationLogListFilters {
    type?: CompanyIntegrationLogType | undefined;
    companyIntegrationId?: number;
}

export class NamedValueLong implements INamedValueLong {
    id?: number;
    name?: string | undefined;

    constructor(data?: INamedValueLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValueLong {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValueLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValueLong {
        const json = this.toJSON();
        let result = new NamedValueLong();
        result.init(json);
        return result;
    }
}

export interface INamedValueLong {
    id?: number;
    name?: string | undefined;
}

export class CompanyIntegrationEditModel implements ICompanyIntegrationEditModel {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;

    constructor(data?: ICompanyIntegrationEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.settingsJSON = _data["SettingsJSON"];
        }
    }

    static fromJS(data: any): CompanyIntegrationEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["SettingsJSON"] = this.settingsJSON;
        return data;
    }

    clone(): CompanyIntegrationEditModel {
        const json = this.toJSON();
        let result = new CompanyIntegrationEditModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationEditModel {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
}

export class CompanyIntegrationUserEditModel implements ICompanyIntegrationUserEditModel {
    id?: number;
    settingsJSON?: string | undefined;

    constructor(data?: ICompanyIntegrationUserEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.settingsJSON = _data["SettingsJSON"];
        }
    }

    static fromJS(data: any): CompanyIntegrationUserEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationUserEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SettingsJSON"] = this.settingsJSON;
        return data;
    }

    clone(): CompanyIntegrationUserEditModel {
        const json = this.toJSON();
        let result = new CompanyIntegrationUserEditModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationUserEditModel {
    id?: number;
    settingsJSON?: string | undefined;
}

export class CompanyIntegrationUserListModel implements ICompanyIntegrationUserListModel {
    id?: number;
    name?: string | undefined;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;

    constructor(data?: ICompanyIntegrationUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.settingsJSON = _data["SettingsJSON"];
        }
    }

    static fromJS(data: any): CompanyIntegrationUserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationUserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SettingsJSON"] = this.settingsJSON;
        return data;
    }

    clone(): CompanyIntegrationUserListModel {
        const json = this.toJSON();
        let result = new CompanyIntegrationUserListModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationUserListModel {
    id?: number;
    name?: string | undefined;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
}

export abstract class BaseModel implements IBaseModel {
    id?: number;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    createdBy?: string | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? moment(_data["UpdatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        return data;
    }

    clone(): BaseModel {
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }
}

export interface IBaseModel {
    id?: number;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    createdBy?: string | undefined;
}

export class IntegrationSetting extends BaseModel implements IIntegrationSetting {
    name?: string | undefined;
    type?: IntegrationSettingType;
    settingsJSON?: string | undefined;
    integration?: CompanyIntegration | undefined;
    integrationId?: number;

    constructor(data?: IIntegrationSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.settingsJSON = _data["SettingsJSON"];
            this.integration = _data["Integration"] ? CompanyIntegration.fromJS(_data["Integration"]) : <any>undefined;
            this.integrationId = _data["IntegrationId"];
        }
    }

    static override fromJS(data: any): IntegrationSetting {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SettingsJSON"] = this.settingsJSON;
        data["Integration"] = this.integration ? this.integration.toJSON() : <any>undefined;
        data["IntegrationId"] = this.integrationId;
        super.toJSON(data);
        return data;
    }

    clone(): IntegrationSetting {
        const json = this.toJSON();
        let result = new IntegrationSetting();
        result.init(json);
        return result;
    }
}

export interface IIntegrationSetting extends IBaseModel {
    name?: string | undefined;
    type?: IntegrationSettingType;
    settingsJSON?: string | undefined;
    integration?: CompanyIntegration | undefined;
    integrationId?: number;
}

/** 1 = Filter 2 = OrderAiParser */
export enum IntegrationSettingType {
    Filter = 1,
    OrderAiParser = 2,
}

export class CompanyIntegration extends BaseModel implements ICompanyIntegration {
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
    logs?: CompanyIntegrationLogs[] | undefined;
    orders?: ExternalPostedOrder[] | undefined;
    userSettings?: CompanyIntegrationUserSettings[] | undefined;
    integrationSettings?: IntegrationSetting[] | undefined;
    latestLogMessage?: string | undefined;
    latestLogType?: CompanyIntegrationLogType | undefined;
    latestLogCreatedAt?: moment.Moment | undefined;

    constructor(data?: ICompanyIntegration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.settingsJSON = _data["SettingsJSON"];
            if (Array.isArray(_data["Logs"])) {
                this.logs = [] as any;
                for (let item of _data["Logs"])
                    this.logs!.push(CompanyIntegrationLogs.fromJS(item));
            }
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(ExternalPostedOrder.fromJS(item));
            }
            if (Array.isArray(_data["UserSettings"])) {
                this.userSettings = [] as any;
                for (let item of _data["UserSettings"])
                    this.userSettings!.push(CompanyIntegrationUserSettings.fromJS(item));
            }
            if (Array.isArray(_data["IntegrationSettings"])) {
                this.integrationSettings = [] as any;
                for (let item of _data["IntegrationSettings"])
                    this.integrationSettings!.push(IntegrationSetting.fromJS(item));
            }
            this.latestLogMessage = _data["LatestLogMessage"];
            this.latestLogType = _data["LatestLogType"];
            this.latestLogCreatedAt = _data["LatestLogCreatedAt"] ? moment(_data["LatestLogCreatedAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CompanyIntegration {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["SettingsJSON"] = this.settingsJSON;
        if (Array.isArray(this.logs)) {
            data["Logs"] = [];
            for (let item of this.logs)
                data["Logs"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        if (Array.isArray(this.userSettings)) {
            data["UserSettings"] = [];
            for (let item of this.userSettings)
                data["UserSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.integrationSettings)) {
            data["IntegrationSettings"] = [];
            for (let item of this.integrationSettings)
                data["IntegrationSettings"].push(item.toJSON());
        }
        data["LatestLogMessage"] = this.latestLogMessage;
        data["LatestLogType"] = this.latestLogType;
        data["LatestLogCreatedAt"] = this.latestLogCreatedAt ? this.latestLogCreatedAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyIntegration {
        const json = this.toJSON();
        let result = new CompanyIntegration();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegration extends IBaseModel {
    name?: string | undefined;
    active?: boolean;
    type?: CompanyIntegrationType;
    settingsJSON?: string | undefined;
    logs?: CompanyIntegrationLogs[] | undefined;
    orders?: ExternalPostedOrder[] | undefined;
    userSettings?: CompanyIntegrationUserSettings[] | undefined;
    integrationSettings?: IntegrationSetting[] | undefined;
    latestLogMessage?: string | undefined;
    latestLogType?: CompanyIntegrationLogType | undefined;
    latestLogCreatedAt?: moment.Moment | undefined;
}

export class CompanyIntegrationLogs extends BaseModel implements ICompanyIntegrationLogs {
    log?: string | undefined;
    type?: CompanyIntegrationLogType;
    companyIntegrationId?: number;
    companyIntegration?: CompanyIntegration | undefined;

    constructor(data?: ICompanyIntegrationLogs) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.log = _data["Log"];
            this.type = _data["Type"];
            this.companyIntegrationId = _data["CompanyIntegrationId"];
            this.companyIntegration = _data["CompanyIntegration"] ? CompanyIntegration.fromJS(_data["CompanyIntegration"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CompanyIntegrationLogs {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationLogs();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Log"] = this.log;
        data["Type"] = this.type;
        data["CompanyIntegrationId"] = this.companyIntegrationId;
        data["CompanyIntegration"] = this.companyIntegration ? this.companyIntegration.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyIntegrationLogs {
        const json = this.toJSON();
        let result = new CompanyIntegrationLogs();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationLogs extends IBaseModel {
    log?: string | undefined;
    type?: CompanyIntegrationLogType;
    companyIntegrationId?: number;
    companyIntegration?: CompanyIntegration | undefined;
}

export class ExternalPostedOrder extends BaseModel implements IExternalPostedOrder {
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    deliveryAddress?: string | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    vehicleType?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    orderNumber?: string | undefined;
    externalId?: string | undefined;
    companyName?: string | undefined;
    customerName?: string | undefined;
    customerMCNumber?: string | undefined;
    companyAddress?: string | undefined;
    companyCityState?: string | undefined;
    companyPhone?: string | undefined;
    notes?: string | undefined;
    expirationDateTime?: moment.Moment;
    stackable?: boolean;
    hazardous?: boolean;
    fastLoad?: boolean;
    dockLevel?: boolean;
    pays?: number | undefined;
    customer?: Customer | undefined;
    customerId?: number | undefined;
    source?: OrderSource;
    integrationId?: number | undefined;
    integration?: CompanyIntegration | undefined;
    emailMessageId?: number | undefined;
    orderBids?: ExternalOrderBid[] | undefined;
    isHidden?: boolean;
    isViewed?: boolean;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;
    orderDetailsUrl?: string | undefined;
    isDetailsLoaded?: boolean;
    externalPostedOrderVehicles?: ExternalPostedOrderVehicle[] | undefined;
    palletDetailsJson?: string | undefined;

    constructor(data?: IExternalPostedOrder) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpDateTimeOffset = _data["PickUpDateTimeOffset"];
            this.pickUpAddress = _data["PickUpAddress"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryDateTimeOffset = _data["DeliveryDateTimeOffset"];
            this.deliveryAddress = _data["DeliveryAddress"];
            this.miles = _data["Miles"];
            this.pieces = _data["Pieces"];
            this.weight = _data["Weight"];
            this.dims = _data["Dims"];
            this.vehicleType = _data["VehicleType"];
            this.phone = _data["Phone"];
            this.fax = _data["Fax"];
            this.postedBy = _data["PostedBy"];
            this.postedByEmail = _data["PostedByEmail"];
            this.orderNumber = _data["OrderNumber"];
            this.externalId = _data["ExternalId"];
            this.companyName = _data["CompanyName"];
            this.customerName = _data["CustomerName"];
            this.customerMCNumber = _data["CustomerMCNumber"];
            this.companyAddress = _data["CompanyAddress"];
            this.companyCityState = _data["CompanyCityState"];
            this.companyPhone = _data["CompanyPhone"];
            this.notes = _data["Notes"];
            this.expirationDateTime = _data["ExpirationDateTime"] ? moment(_data["ExpirationDateTime"].toString()) : <any>undefined;
            this.stackable = _data["Stackable"];
            this.hazardous = _data["Hazardous"];
            this.fastLoad = _data["FastLoad"];
            this.dockLevel = _data["DockLevel"];
            this.pays = _data["Pays"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.source = _data["Source"];
            this.integrationId = _data["IntegrationId"];
            this.integration = _data["Integration"] ? CompanyIntegration.fromJS(_data["Integration"]) : <any>undefined;
            this.emailMessageId = _data["EmailMessageId"];
            if (Array.isArray(_data["OrderBids"])) {
                this.orderBids = [] as any;
                for (let item of _data["OrderBids"])
                    this.orderBids!.push(ExternalOrderBid.fromJS(item));
            }
            this.isHidden = _data["IsHidden"];
            this.isViewed = _data["IsViewed"];
            if (Array.isArray(_data["TelegramChannelFeedPosts"])) {
                this.telegramChannelFeedPosts = [] as any;
                for (let item of _data["TelegramChannelFeedPosts"])
                    this.telegramChannelFeedPosts!.push(TelegramChannelFeedPost.fromJS(item));
            }
            this.orderDetailsUrl = _data["OrderDetailsUrl"];
            this.isDetailsLoaded = _data["IsDetailsLoaded"];
            if (Array.isArray(_data["ExternalPostedOrderVehicles"])) {
                this.externalPostedOrderVehicles = [] as any;
                for (let item of _data["ExternalPostedOrderVehicles"])
                    this.externalPostedOrderVehicles!.push(ExternalPostedOrderVehicle.fromJS(item));
            }
            this.palletDetailsJson = _data["PalletDetailsJson"];
        }
    }

    static override fromJS(data: any): ExternalPostedOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPostedOrder();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpDateTimeOffset"] = this.pickUpDateTimeOffset;
        data["PickUpAddress"] = this.pickUpAddress;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryDateTimeOffset"] = this.deliveryDateTimeOffset;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["Miles"] = this.miles;
        data["Pieces"] = this.pieces;
        data["Weight"] = this.weight;
        data["Dims"] = this.dims;
        data["VehicleType"] = this.vehicleType;
        data["Phone"] = this.phone;
        data["Fax"] = this.fax;
        data["PostedBy"] = this.postedBy;
        data["PostedByEmail"] = this.postedByEmail;
        data["OrderNumber"] = this.orderNumber;
        data["ExternalId"] = this.externalId;
        data["CompanyName"] = this.companyName;
        data["CustomerName"] = this.customerName;
        data["CustomerMCNumber"] = this.customerMCNumber;
        data["CompanyAddress"] = this.companyAddress;
        data["CompanyCityState"] = this.companyCityState;
        data["CompanyPhone"] = this.companyPhone;
        data["Notes"] = this.notes;
        data["ExpirationDateTime"] = this.expirationDateTime ? this.expirationDateTime.toISOString() : <any>undefined;
        data["Stackable"] = this.stackable;
        data["Hazardous"] = this.hazardous;
        data["FastLoad"] = this.fastLoad;
        data["DockLevel"] = this.dockLevel;
        data["Pays"] = this.pays;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["Source"] = this.source;
        data["IntegrationId"] = this.integrationId;
        data["Integration"] = this.integration ? this.integration.toJSON() : <any>undefined;
        data["EmailMessageId"] = this.emailMessageId;
        if (Array.isArray(this.orderBids)) {
            data["OrderBids"] = [];
            for (let item of this.orderBids)
                data["OrderBids"].push(item.toJSON());
        }
        data["IsHidden"] = this.isHidden;
        data["IsViewed"] = this.isViewed;
        if (Array.isArray(this.telegramChannelFeedPosts)) {
            data["TelegramChannelFeedPosts"] = [];
            for (let item of this.telegramChannelFeedPosts)
                data["TelegramChannelFeedPosts"].push(item.toJSON());
        }
        data["OrderDetailsUrl"] = this.orderDetailsUrl;
        data["IsDetailsLoaded"] = this.isDetailsLoaded;
        if (Array.isArray(this.externalPostedOrderVehicles)) {
            data["ExternalPostedOrderVehicles"] = [];
            for (let item of this.externalPostedOrderVehicles)
                data["ExternalPostedOrderVehicles"].push(item.toJSON());
        }
        data["PalletDetailsJson"] = this.palletDetailsJson;
        super.toJSON(data);
        return data;
    }

    clone(): ExternalPostedOrder {
        const json = this.toJSON();
        let result = new ExternalPostedOrder();
        result.init(json);
        return result;
    }
}

export interface IExternalPostedOrder extends IBaseModel {
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpDateTimeOffset?: number | undefined;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryDateTimeOffset?: number | undefined;
    deliveryAddress?: string | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    vehicleType?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    orderNumber?: string | undefined;
    externalId?: string | undefined;
    companyName?: string | undefined;
    customerName?: string | undefined;
    customerMCNumber?: string | undefined;
    companyAddress?: string | undefined;
    companyCityState?: string | undefined;
    companyPhone?: string | undefined;
    notes?: string | undefined;
    expirationDateTime?: moment.Moment;
    stackable?: boolean;
    hazardous?: boolean;
    fastLoad?: boolean;
    dockLevel?: boolean;
    pays?: number | undefined;
    customer?: Customer | undefined;
    customerId?: number | undefined;
    source?: OrderSource;
    integrationId?: number | undefined;
    integration?: CompanyIntegration | undefined;
    emailMessageId?: number | undefined;
    orderBids?: ExternalOrderBid[] | undefined;
    isHidden?: boolean;
    isViewed?: boolean;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;
    orderDetailsUrl?: string | undefined;
    isDetailsLoaded?: boolean;
    externalPostedOrderVehicles?: ExternalPostedOrderVehicle[] | undefined;
    palletDetailsJson?: string | undefined;
}

export class Customer extends BaseModel implements ICustomer {
    name?: string | undefined;
    companyName?: string | undefined;
    mcNumberPrefix?: string | undefined;
    mcNumber?: number | undefined;
    uSDOT?: string | undefined;
    customerAddress?: Address | undefined;
    customerRemitAddress?: Address | undefined;
    phone?: string | undefined;
    noteType?: CustomerNoteType;
    notes?: string | undefined;
    defaultPaymentNetTerm?: PaymentNetTerm | undefined;
    defaultPaymentNetTermId?: number | undefined;
    defaultPayer?: Customer | undefined;
    defaultPayerId?: number | undefined;
    displayName?: string | undefined;
    contacts?: Contact[] | undefined;
    externalPostedOrders?: ExternalPostedOrder[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    orders?: Order[] | undefined;
    invoices?: Invoice[] | undefined;
    payableInvoices?: Invoice[] | undefined;
    payments?: Payment[] | undefined;
    defaultPayee?: Customer[] | undefined;
    files?: FileCustomer[] | undefined;

    constructor(data?: ICustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.companyName = _data["CompanyName"];
            this.mcNumberPrefix = _data["McNumberPrefix"];
            this.mcNumber = _data["McNumber"];
            this.uSDOT = _data["USDOT"];
            this.customerAddress = _data["CustomerAddress"] ? Address.fromJS(_data["CustomerAddress"]) : <any>undefined;
            this.customerRemitAddress = _data["CustomerRemitAddress"] ? Address.fromJS(_data["CustomerRemitAddress"]) : <any>undefined;
            this.phone = _data["Phone"];
            this.noteType = _data["NoteType"];
            this.notes = _data["Notes"];
            this.defaultPaymentNetTerm = _data["DefaultPaymentNetTerm"] ? PaymentNetTerm.fromJS(_data["DefaultPaymentNetTerm"]) : <any>undefined;
            this.defaultPaymentNetTermId = _data["DefaultPaymentNetTermId"];
            this.defaultPayer = _data["DefaultPayer"] ? Customer.fromJS(_data["DefaultPayer"]) : <any>undefined;
            this.defaultPayerId = _data["DefaultPayerId"];
            this.displayName = _data["DisplayName"];
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
            if (Array.isArray(_data["ExternalPostedOrders"])) {
                this.externalPostedOrders = [] as any;
                for (let item of _data["ExternalPostedOrders"])
                    this.externalPostedOrders!.push(ExternalPostedOrder.fromJS(item));
            }
            if (Array.isArray(_data["ExternalOrderBids"])) {
                this.externalOrderBids = [] as any;
                for (let item of _data["ExternalOrderBids"])
                    this.externalOrderBids!.push(ExternalOrderBid.fromJS(item));
            }
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["PayableInvoices"])) {
                this.payableInvoices = [] as any;
                for (let item of _data["PayableInvoices"])
                    this.payableInvoices!.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["Payments"])) {
                this.payments = [] as any;
                for (let item of _data["Payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            if (Array.isArray(_data["DefaultPayee"])) {
                this.defaultPayee = [] as any;
                for (let item of _data["DefaultPayee"])
                    this.defaultPayee!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileCustomer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["CompanyName"] = this.companyName;
        data["McNumberPrefix"] = this.mcNumberPrefix;
        data["McNumber"] = this.mcNumber;
        data["USDOT"] = this.uSDOT;
        data["CustomerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["CustomerRemitAddress"] = this.customerRemitAddress ? this.customerRemitAddress.toJSON() : <any>undefined;
        data["Phone"] = this.phone;
        data["NoteType"] = this.noteType;
        data["Notes"] = this.notes;
        data["DefaultPaymentNetTerm"] = this.defaultPaymentNetTerm ? this.defaultPaymentNetTerm.toJSON() : <any>undefined;
        data["DefaultPaymentNetTermId"] = this.defaultPaymentNetTermId;
        data["DefaultPayer"] = this.defaultPayer ? this.defaultPayer.toJSON() : <any>undefined;
        data["DefaultPayerId"] = this.defaultPayerId;
        data["DisplayName"] = this.displayName;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.externalPostedOrders)) {
            data["ExternalPostedOrders"] = [];
            for (let item of this.externalPostedOrders)
                data["ExternalPostedOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.externalOrderBids)) {
            data["ExternalOrderBids"] = [];
            for (let item of this.externalOrderBids)
                data["ExternalOrderBids"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.payableInvoices)) {
            data["PayableInvoices"] = [];
            for (let item of this.payableInvoices)
                data["PayableInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["Payments"] = [];
            for (let item of this.payments)
                data["Payments"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultPayee)) {
            data["DefaultPayee"] = [];
            for (let item of this.defaultPayee)
                data["DefaultPayee"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer extends IBaseModel {
    name?: string | undefined;
    companyName?: string | undefined;
    mcNumberPrefix?: string | undefined;
    mcNumber?: number | undefined;
    uSDOT?: string | undefined;
    customerAddress?: Address | undefined;
    customerRemitAddress?: Address | undefined;
    phone?: string | undefined;
    noteType?: CustomerNoteType;
    notes?: string | undefined;
    defaultPaymentNetTerm?: PaymentNetTerm | undefined;
    defaultPaymentNetTermId?: number | undefined;
    defaultPayer?: Customer | undefined;
    defaultPayerId?: number | undefined;
    displayName?: string | undefined;
    contacts?: Contact[] | undefined;
    externalPostedOrders?: ExternalPostedOrder[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    orders?: Order[] | undefined;
    invoices?: Invoice[] | undefined;
    payableInvoices?: Invoice[] | undefined;
    payments?: Payment[] | undefined;
    defaultPayee?: Customer[] | undefined;
    files?: FileCustomer[] | undefined;
}

export abstract class AddressBase extends BaseModel implements IAddressBase {
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    fullAddress?: string | undefined;
    shortAddress?: string | undefined;

    constructor(data?: IAddressBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.note = _data["Note"];
            this.fullAddress = _data["FullAddress"];
            this.shortAddress = _data["ShortAddress"];
        }
    }

    static override fromJS(data: any): AddressBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AddressBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["Note"] = this.note;
        data["FullAddress"] = this.fullAddress;
        data["ShortAddress"] = this.shortAddress;
        super.toJSON(data);
        return data;
    }

    clone(): AddressBase {
        throw new Error("The abstract class 'AddressBase' cannot be instantiated.");
    }
}

export interface IAddressBase extends IBaseModel {
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    fullAddress?: string | undefined;
    shortAddress?: string | undefined;
}

export class Address extends AddressBase implements IAddress {

    constructor(data?: IAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress extends IAddressBase {
}

export class PaymentNetTerm extends BaseModel implements IPaymentNetTerm {
    name?: string | undefined;
    netTerm?: number;
    commission?: number;
    invoices?: Invoice[] | undefined;
    customers?: Customer[] | undefined;

    constructor(data?: IPaymentNetTerm) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.netTerm = _data["NetTerm"];
            this.commission = _data["Commission"];
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["Customers"])) {
                this.customers = [] as any;
                for (let item of _data["Customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PaymentNetTerm {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNetTerm();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["NetTerm"] = this.netTerm;
        data["Commission"] = this.commission;
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["Customers"] = [];
            for (let item of this.customers)
                data["Customers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PaymentNetTerm {
        const json = this.toJSON();
        let result = new PaymentNetTerm();
        result.init(json);
        return result;
    }
}

export interface IPaymentNetTerm extends IBaseModel {
    name?: string | undefined;
    netTerm?: number;
    commission?: number;
    invoices?: Invoice[] | undefined;
    customers?: Customer[] | undefined;
}

export class Invoice extends BaseModel implements IInvoice {
    number?: number;
    amount?: number;
    paidAmount?: number;
    commission?: number;
    dueDate?: moment.Moment;
    invoiceDate?: moment.Moment;
    status?: InvoiceStatus;
    closedOn?: moment.Moment | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number;
    paymentNetTerm?: PaymentNetTerm | undefined;
    paymentNetTermId?: number;
    payer?: Customer | undefined;
    payerId?: number;
    payments?: PaymentInvoice[] | undefined;
    order?: Order | undefined;
    orderId?: number;
    reference?: string | undefined;

    constructor(data?: IInvoice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["Number"];
            this.amount = _data["Amount"];
            this.paidAmount = _data["PaidAmount"];
            this.commission = _data["Commission"];
            this.dueDate = _data["DueDate"] ? moment(_data["DueDate"].toString()) : <any>undefined;
            this.invoiceDate = _data["InvoiceDate"] ? moment(_data["InvoiceDate"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.closedOn = _data["ClosedOn"] ? moment(_data["ClosedOn"].toString()) : <any>undefined;
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.paymentNetTerm = _data["PaymentNetTerm"] ? PaymentNetTerm.fromJS(_data["PaymentNetTerm"]) : <any>undefined;
            this.paymentNetTermId = _data["PaymentNetTermId"];
            this.payer = _data["Payer"] ? Customer.fromJS(_data["Payer"]) : <any>undefined;
            this.payerId = _data["PayerId"];
            if (Array.isArray(_data["Payments"])) {
                this.payments = [] as any;
                for (let item of _data["Payments"])
                    this.payments!.push(PaymentInvoice.fromJS(item));
            }
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.reference = _data["Reference"];
        }
    }

    static override fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["Amount"] = this.amount;
        data["PaidAmount"] = this.paidAmount;
        data["Commission"] = this.commission;
        data["DueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["ClosedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["PaymentNetTerm"] = this.paymentNetTerm ? this.paymentNetTerm.toJSON() : <any>undefined;
        data["PaymentNetTermId"] = this.paymentNetTermId;
        data["Payer"] = this.payer ? this.payer.toJSON() : <any>undefined;
        data["PayerId"] = this.payerId;
        if (Array.isArray(this.payments)) {
            data["Payments"] = [];
            for (let item of this.payments)
                data["Payments"].push(item.toJSON());
        }
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["Reference"] = this.reference;
        super.toJSON(data);
        return data;
    }

    clone(): Invoice {
        const json = this.toJSON();
        let result = new Invoice();
        result.init(json);
        return result;
    }
}

export interface IInvoice extends IBaseModel {
    number?: number;
    amount?: number;
    paidAmount?: number;
    commission?: number;
    dueDate?: moment.Moment;
    invoiceDate?: moment.Moment;
    status?: InvoiceStatus;
    closedOn?: moment.Moment | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number;
    paymentNetTerm?: PaymentNetTerm | undefined;
    paymentNetTermId?: number;
    payer?: Customer | undefined;
    payerId?: number;
    payments?: PaymentInvoice[] | undefined;
    order?: Order | undefined;
    orderId?: number;
    reference?: string | undefined;
}

/** 1 = Open 2 = Closed */
export enum InvoiceStatus {
    Open = 1,
    Closed = 2,
}

export class PaymentInvoice implements IPaymentInvoice {
    payment?: Payment | undefined;
    paymentId?: number;
    invoice?: Invoice | undefined;
    invoiceId?: number;
    amount?: number;

    constructor(data?: IPaymentInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment = _data["Payment"] ? Payment.fromJS(_data["Payment"]) : <any>undefined;
            this.paymentId = _data["PaymentId"];
            this.invoice = _data["Invoice"] ? Invoice.fromJS(_data["Invoice"]) : <any>undefined;
            this.invoiceId = _data["InvoiceId"];
            this.amount = _data["Amount"];
        }
    }

    static fromJS(data: any): PaymentInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["PaymentId"] = this.paymentId;
        data["Invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["InvoiceId"] = this.invoiceId;
        data["Amount"] = this.amount;
        return data;
    }

    clone(): PaymentInvoice {
        const json = this.toJSON();
        let result = new PaymentInvoice();
        result.init(json);
        return result;
    }
}

export interface IPaymentInvoice {
    payment?: Payment | undefined;
    paymentId?: number;
    invoice?: Invoice | undefined;
    invoiceId?: number;
    amount?: number;
}

export class Payment extends BaseModel implements IPayment {
    amount?: number;
    type?: PaymentMethodType;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    description?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number;
    paymentDate?: moment.Moment;
    paymentInvoices?: PaymentInvoice[] | undefined;

    constructor(data?: IPayment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["Amount"];
            this.type = _data["Type"];
            this.reference = _data["Reference"];
            this.checkNumber = _data["CheckNumber"];
            this.description = _data["Description"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.paymentDate = _data["PaymentDate"] ? moment(_data["PaymentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["PaymentInvoices"])) {
                this.paymentInvoices = [] as any;
                for (let item of _data["PaymentInvoices"])
                    this.paymentInvoices!.push(PaymentInvoice.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Amount"] = this.amount;
        data["Type"] = this.type;
        data["Reference"] = this.reference;
        data["CheckNumber"] = this.checkNumber;
        data["Description"] = this.description;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["PaymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.paymentInvoices)) {
            data["PaymentInvoices"] = [];
            for (let item of this.paymentInvoices)
                data["PaymentInvoices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Payment {
        const json = this.toJSON();
        let result = new Payment();
        result.init(json);
        return result;
    }
}

export interface IPayment extends IBaseModel {
    amount?: number;
    type?: PaymentMethodType;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    description?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number;
    paymentDate?: moment.Moment;
    paymentInvoices?: PaymentInvoice[] | undefined;
}

/** 1 = Cash 2 = Check 3 = ACH 4 = CreditCard */
export enum PaymentMethodType {
    Cash = 1,
    Check = 2,
    ACH = 3,
    CreditCard = 4,
}

export class Order extends BaseModel implements IOrder {
    customer?: Customer | undefined;
    customerId?: number | undefined;
    contact?: Contact | undefined;
    contactId?: number | undefined;
    orderNo?: string | undefined;
    miles?: number;
    team?: boolean;
    muteNotifications?: boolean;
    driverSharedNotes?: string | undefined;
    rate?: number;
    finalRate?: number;
    carrierRate?: number;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    muteWarningNotificationTill?: moment.Moment | undefined;
    updateLocationBasedOnVehicle?: boolean;
    lat?: number | undefined;
    lon?: number | undefined;
    locationDescription?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    externalOrderBidId?: number | undefined;
    status?: OrderStatus;
    orderCustomerExternalLinks?: OrderCustomerExternalLink[] | undefined;
    files?: FileOrder[] | undefined;
    notes?: NotesOrder[] | undefined;
    drivers?: Driver[] | undefined;
    orderNotes?: OrderLogs[] | undefined;
    stops?: OrderStop[] | undefined;
    cargoItems?: OrderCargoItem[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    carrierRatingNotes?: CarrierRatingNote[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number | undefined;
    metrics?: OrderMetrics | undefined;
    metricsId?: number | undefined;
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutId?: number | undefined;
    invoice?: Invoice | undefined;
    canUpdateDrivers?: boolean;
    canUpdateVehicle?: boolean;
    canUpdateLocation?: boolean;
    canUpdateStops?: boolean;
    canUpdateItems?: boolean;
    canUpdate?: boolean;
    canUpdateRate?: boolean;
    canUpdateCustomer?: boolean;
    displayRate?: number;
    canMarkAsDraft?: boolean;
    canMarkAsReady?: boolean;
    canMarkAsInProgress?: boolean;
    canMarkAsCanceled?: boolean;
    canMarkAsCompleted?: boolean;
    canMarkAsOnHold?: boolean;
    canMarkAsClosed?: boolean;

    constructor(data?: IOrder) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.contact = _data["Contact"] ? Contact.fromJS(_data["Contact"]) : <any>undefined;
            this.contactId = _data["ContactId"];
            this.orderNo = _data["OrderNo"];
            this.miles = _data["Miles"];
            this.team = _data["Team"];
            this.muteNotifications = _data["MuteNotifications"];
            this.driverSharedNotes = _data["DriverSharedNotes"];
            this.rate = _data["Rate"];
            this.finalRate = _data["FinalRate"];
            this.carrierRate = _data["CarrierRate"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.muteWarningNotificationTill = _data["MuteWarningNotificationTill"] ? moment(_data["MuteWarningNotificationTill"].toString()) : <any>undefined;
            this.updateLocationBasedOnVehicle = _data["UpdateLocationBasedOnVehicle"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.locationDescription = _data["LocationDescription"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["ExternalOrderBids"])) {
                this.externalOrderBids = [] as any;
                for (let item of _data["ExternalOrderBids"])
                    this.externalOrderBids!.push(ExternalOrderBid.fromJS(item));
            }
            this.externalOrderBidId = _data["ExternalOrderBidId"];
            this.status = _data["Status"];
            if (Array.isArray(_data["OrderCustomerExternalLinks"])) {
                this.orderCustomerExternalLinks = [] as any;
                for (let item of _data["OrderCustomerExternalLinks"])
                    this.orderCustomerExternalLinks!.push(OrderCustomerExternalLink.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileOrder.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NotesOrder.fromJS(item));
            }
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(Driver.fromJS(item));
            }
            if (Array.isArray(_data["OrderNotes"])) {
                this.orderNotes = [] as any;
                for (let item of _data["OrderNotes"])
                    this.orderNotes!.push(OrderLogs.fromJS(item));
            }
            if (Array.isArray(_data["Stops"])) {
                this.stops = [] as any;
                for (let item of _data["Stops"])
                    this.stops!.push(OrderStop.fromJS(item));
            }
            if (Array.isArray(_data["CargoItems"])) {
                this.cargoItems = [] as any;
                for (let item of _data["CargoItems"])
                    this.cargoItems!.push(OrderCargoItem.fromJS(item));
            }
            if (Array.isArray(_data["DriverRatings"])) {
                this.driverRatings = [] as any;
                for (let item of _data["DriverRatings"])
                    this.driverRatings!.push(DriverRatingNote.fromJS(item));
            }
            if (Array.isArray(_data["CarrierRatingNotes"])) {
                this.carrierRatingNotes = [] as any;
                for (let item of _data["CarrierRatingNotes"])
                    this.carrierRatingNotes!.push(CarrierRatingNote.fromJS(item));
            }
            if (Array.isArray(_data["CarrierRatings"])) {
                this.carrierRatings = [] as any;
                for (let item of _data["CarrierRatings"])
                    this.carrierRatings!.push(CarrierRating.fromJS(item));
            }
            if (Array.isArray(_data["OrderTasks"])) {
                this.orderTasks = [] as any;
                for (let item of _data["OrderTasks"])
                    this.orderTasks!.push(OrderTask.fromJS(item));
            }
            this.orderQuote = _data["OrderQuote"] ? OrderQuote.fromJS(_data["OrderQuote"]) : <any>undefined;
            this.orderQuoteId = _data["OrderQuoteId"];
            this.metrics = _data["Metrics"] ? OrderMetrics.fromJS(_data["Metrics"]) : <any>undefined;
            this.metricsId = _data["MetricsId"];
            this.orderPayoutSummary = _data["OrderPayoutSummary"] ? OrderPayoutSummary.fromJS(_data["OrderPayoutSummary"]) : <any>undefined;
            this.orderPayoutId = _data["OrderPayoutId"];
            this.invoice = _data["Invoice"] ? Invoice.fromJS(_data["Invoice"]) : <any>undefined;
            this.canUpdateDrivers = _data["CanUpdateDrivers"];
            this.canUpdateVehicle = _data["CanUpdateVehicle"];
            this.canUpdateLocation = _data["CanUpdateLocation"];
            this.canUpdateStops = _data["CanUpdateStops"];
            this.canUpdateItems = _data["CanUpdateItems"];
            this.canUpdate = _data["CanUpdate"];
            this.canUpdateRate = _data["CanUpdateRate"];
            this.canUpdateCustomer = _data["CanUpdateCustomer"];
            this.displayRate = _data["DisplayRate"];
            this.canMarkAsDraft = _data["CanMarkAsDraft"];
            this.canMarkAsReady = _data["CanMarkAsReady"];
            this.canMarkAsInProgress = _data["CanMarkAsInProgress"];
            this.canMarkAsCanceled = _data["CanMarkAsCanceled"];
            this.canMarkAsCompleted = _data["CanMarkAsCompleted"];
            this.canMarkAsOnHold = _data["CanMarkAsOnHold"];
            this.canMarkAsClosed = _data["CanMarkAsClosed"];
        }
    }

    static override fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["Contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["ContactId"] = this.contactId;
        data["OrderNo"] = this.orderNo;
        data["Miles"] = this.miles;
        data["Team"] = this.team;
        data["MuteNotifications"] = this.muteNotifications;
        data["DriverSharedNotes"] = this.driverSharedNotes;
        data["Rate"] = this.rate;
        data["FinalRate"] = this.finalRate;
        data["CarrierRate"] = this.carrierRate;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["MuteWarningNotificationTill"] = this.muteWarningNotificationTill ? this.muteWarningNotificationTill.toISOString() : <any>undefined;
        data["UpdateLocationBasedOnVehicle"] = this.updateLocationBasedOnVehicle;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["LocationDescription"] = this.locationDescription;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.externalOrderBids)) {
            data["ExternalOrderBids"] = [];
            for (let item of this.externalOrderBids)
                data["ExternalOrderBids"].push(item.toJSON());
        }
        data["ExternalOrderBidId"] = this.externalOrderBidId;
        data["Status"] = this.status;
        if (Array.isArray(this.orderCustomerExternalLinks)) {
            data["OrderCustomerExternalLinks"] = [];
            for (let item of this.orderCustomerExternalLinks)
                data["OrderCustomerExternalLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.orderNotes)) {
            data["OrderNotes"] = [];
            for (let item of this.orderNotes)
                data["OrderNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.stops)) {
            data["Stops"] = [];
            for (let item of this.stops)
                data["Stops"].push(item.toJSON());
        }
        if (Array.isArray(this.cargoItems)) {
            data["CargoItems"] = [];
            for (let item of this.cargoItems)
                data["CargoItems"].push(item.toJSON());
        }
        if (Array.isArray(this.driverRatings)) {
            data["DriverRatings"] = [];
            for (let item of this.driverRatings)
                data["DriverRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierRatingNotes)) {
            data["CarrierRatingNotes"] = [];
            for (let item of this.carrierRatingNotes)
                data["CarrierRatingNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierRatings)) {
            data["CarrierRatings"] = [];
            for (let item of this.carrierRatings)
                data["CarrierRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.orderTasks)) {
            data["OrderTasks"] = [];
            for (let item of this.orderTasks)
                data["OrderTasks"].push(item.toJSON());
        }
        data["OrderQuote"] = this.orderQuote ? this.orderQuote.toJSON() : <any>undefined;
        data["OrderQuoteId"] = this.orderQuoteId;
        data["Metrics"] = this.metrics ? this.metrics.toJSON() : <any>undefined;
        data["MetricsId"] = this.metricsId;
        data["OrderPayoutSummary"] = this.orderPayoutSummary ? this.orderPayoutSummary.toJSON() : <any>undefined;
        data["OrderPayoutId"] = this.orderPayoutId;
        data["Invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["CanUpdateDrivers"] = this.canUpdateDrivers;
        data["CanUpdateVehicle"] = this.canUpdateVehicle;
        data["CanUpdateLocation"] = this.canUpdateLocation;
        data["CanUpdateStops"] = this.canUpdateStops;
        data["CanUpdateItems"] = this.canUpdateItems;
        data["CanUpdate"] = this.canUpdate;
        data["CanUpdateRate"] = this.canUpdateRate;
        data["CanUpdateCustomer"] = this.canUpdateCustomer;
        data["DisplayRate"] = this.displayRate;
        data["CanMarkAsDraft"] = this.canMarkAsDraft;
        data["CanMarkAsReady"] = this.canMarkAsReady;
        data["CanMarkAsInProgress"] = this.canMarkAsInProgress;
        data["CanMarkAsCanceled"] = this.canMarkAsCanceled;
        data["CanMarkAsCompleted"] = this.canMarkAsCompleted;
        data["CanMarkAsOnHold"] = this.canMarkAsOnHold;
        data["CanMarkAsClosed"] = this.canMarkAsClosed;
        super.toJSON(data);
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder extends IBaseModel {
    customer?: Customer | undefined;
    customerId?: number | undefined;
    contact?: Contact | undefined;
    contactId?: number | undefined;
    orderNo?: string | undefined;
    miles?: number;
    team?: boolean;
    muteNotifications?: boolean;
    driverSharedNotes?: string | undefined;
    rate?: number;
    finalRate?: number;
    carrierRate?: number;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    muteWarningNotificationTill?: moment.Moment | undefined;
    updateLocationBasedOnVehicle?: boolean;
    lat?: number | undefined;
    lon?: number | undefined;
    locationDescription?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    externalOrderBidId?: number | undefined;
    status?: OrderStatus;
    orderCustomerExternalLinks?: OrderCustomerExternalLink[] | undefined;
    files?: FileOrder[] | undefined;
    notes?: NotesOrder[] | undefined;
    drivers?: Driver[] | undefined;
    orderNotes?: OrderLogs[] | undefined;
    stops?: OrderStop[] | undefined;
    cargoItems?: OrderCargoItem[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    carrierRatingNotes?: CarrierRatingNote[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    orderTasks?: OrderTask[] | undefined;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number | undefined;
    metrics?: OrderMetrics | undefined;
    metricsId?: number | undefined;
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutId?: number | undefined;
    invoice?: Invoice | undefined;
    canUpdateDrivers?: boolean;
    canUpdateVehicle?: boolean;
    canUpdateLocation?: boolean;
    canUpdateStops?: boolean;
    canUpdateItems?: boolean;
    canUpdate?: boolean;
    canUpdateRate?: boolean;
    canUpdateCustomer?: boolean;
    displayRate?: number;
    canMarkAsDraft?: boolean;
    canMarkAsReady?: boolean;
    canMarkAsInProgress?: boolean;
    canMarkAsCanceled?: boolean;
    canMarkAsCompleted?: boolean;
    canMarkAsOnHold?: boolean;
    canMarkAsClosed?: boolean;
}

export class Contact extends BaseModel implements IContact {
    fullName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    note?: string | undefined;
    customers?: Customer[] | undefined;
    orders?: Order[] | undefined;

    constructor(data?: IContact) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["FullName"];
            this.phone = _data["Phone"];
            this.extension = _data["Extension"];
            this.email = _data["Email"];
            this.title = _data["Title"];
            this.note = _data["Note"];
            if (Array.isArray(_data["Customers"])) {
                this.customers = [] as any;
                for (let item of _data["Customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(Order.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Phone"] = this.phone;
        data["Extension"] = this.extension;
        data["Email"] = this.email;
        data["Title"] = this.title;
        data["Note"] = this.note;
        if (Array.isArray(this.customers)) {
            data["Customers"] = [];
            for (let item of this.customers)
                data["Customers"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact extends IBaseModel {
    fullName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    note?: string | undefined;
    customers?: Customer[] | undefined;
    orders?: Order[] | undefined;
}

export class Vehicle extends BaseModel implements IVehicle {
    number?: number;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    active?: boolean;
    type?: VehicleType;
    fuelType?: FuelType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    doorWidth?: number;
    doorHeight?: number;
    boxHeight?: number;
    boxWidth?: number;
    boxLength?: number;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    liftGate?: number | undefined;
    hasAirRide?: boolean;
    hasETrack?: boolean;
    hasStraps?: boolean;
    hasBlankets?: boolean;
    maxLoad?: number;
    hasPalletJack?: boolean;
    hasTeam?: boolean;
    floorType?: VehicleFloorType;
    hasSideDoor?: boolean;
    hasRamps?: boolean;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    registrationExpirationDate?: moment.Moment;
    trackingDevices?: TrackingDevice[] | undefined;
    rating?: RatingMetrics | undefined;
    customPeriodRating?: RatingMetrics | undefined;
    trackingDetails?: VehicleTrackingDetails | undefined;
    vehicleAvailabilitySettings?: VehicleAvailabilitySettings | undefined;
    defaultDrivers?: Driver[] | undefined;
    integrations?: IntegrationVehicle[] | undefined;
    files?: FileVehicle[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    orders?: Order[] | undefined;
    notes?: NotesVehicle[] | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;
    vehicleTrackingHistory?: VehicleTrackingHistory[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    externalPostedOrderVehicles?: ExternalPostedOrderVehicle[] | undefined;
    orderQuotePostVehicles?: OrderQuotePostVehicle[] | undefined;
    ownerAccounts?: OwnerAccount[] | undefined;
    latestBidAt?: moment.Moment | undefined;
    displayName?: string | undefined;
    displayNumber?: string | undefined;
    boxDims?: string | undefined;
    doorDims?: string | undefined;
    dims?: string | undefined;
    specs?: string | undefined;
    fullSpecs?: string | undefined;

    constructor(data?: IVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["Number"];
            this.vIN = _data["VIN"];
            this.year = _data["Year"];
            this.make = _data["Make"];
            this.model = _data["Model"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.fuelType = _data["FuelType"];
            this.licenseState = _data["LicenseState"];
            this.licenseNumber = _data["LicenseNumber"];
            this.doorWidth = _data["DoorWidth"];
            this.doorHeight = _data["DoorHeight"];
            this.boxHeight = _data["BoxHeight"];
            this.boxWidth = _data["BoxWidth"];
            this.boxLength = _data["BoxLength"];
            this.isDockHigh = _data["IsDockHigh"];
            this.hasLiftGate = _data["HasLiftGate"];
            this.liftGate = _data["LiftGate"];
            this.hasAirRide = _data["HasAirRide"];
            this.hasETrack = _data["HasETrack"];
            this.hasStraps = _data["HasStraps"];
            this.hasBlankets = _data["HasBlankets"];
            this.maxLoad = _data["MaxLoad"];
            this.hasPalletJack = _data["HasPalletJack"];
            this.hasTeam = _data["HasTeam"];
            this.floorType = _data["FloorType"];
            this.hasSideDoor = _data["HasSideDoor"];
            this.hasRamps = _data["HasRamps"];
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.registrationExpirationDate = _data["RegistrationExpirationDate"] ? moment(_data["RegistrationExpirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["TrackingDevices"])) {
                this.trackingDevices = [] as any;
                for (let item of _data["TrackingDevices"])
                    this.trackingDevices!.push(TrackingDevice.fromJS(item));
            }
            this.rating = _data["Rating"] ? RatingMetrics.fromJS(_data["Rating"]) : <any>undefined;
            this.customPeriodRating = _data["CustomPeriodRating"] ? RatingMetrics.fromJS(_data["CustomPeriodRating"]) : <any>undefined;
            this.trackingDetails = _data["TrackingDetails"] ? VehicleTrackingDetails.fromJS(_data["TrackingDetails"]) : <any>undefined;
            this.vehicleAvailabilitySettings = _data["VehicleAvailabilitySettings"] ? VehicleAvailabilitySettings.fromJS(_data["VehicleAvailabilitySettings"]) : <any>undefined;
            if (Array.isArray(_data["DefaultDrivers"])) {
                this.defaultDrivers = [] as any;
                for (let item of _data["DefaultDrivers"])
                    this.defaultDrivers!.push(Driver.fromJS(item));
            }
            if (Array.isArray(_data["Integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["Integrations"])
                    this.integrations!.push(IntegrationVehicle.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileVehicle.fromJS(item));
            }
            if (Array.isArray(_data["ExternalOrderBids"])) {
                this.externalOrderBids = [] as any;
                for (let item of _data["ExternalOrderBids"])
                    this.externalOrderBids!.push(ExternalOrderBid.fromJS(item));
            }
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NotesVehicle.fromJS(item));
            }
            if (Array.isArray(_data["TelegramChannelSettings"])) {
                this.telegramChannelSettings = [] as any;
                for (let item of _data["TelegramChannelSettings"])
                    this.telegramChannelSettings!.push(TelegramChannelSettings.fromJS(item));
            }
            if (Array.isArray(_data["VehicleTrackingHistory"])) {
                this.vehicleTrackingHistory = [] as any;
                for (let item of _data["VehicleTrackingHistory"])
                    this.vehicleTrackingHistory!.push(VehicleTrackingHistory.fromJS(item));
            }
            if (Array.isArray(_data["CarrierRatings"])) {
                this.carrierRatings = [] as any;
                for (let item of _data["CarrierRatings"])
                    this.carrierRatings!.push(CarrierRating.fromJS(item));
            }
            if (Array.isArray(_data["ExternalPostedOrderVehicles"])) {
                this.externalPostedOrderVehicles = [] as any;
                for (let item of _data["ExternalPostedOrderVehicles"])
                    this.externalPostedOrderVehicles!.push(ExternalPostedOrderVehicle.fromJS(item));
            }
            if (Array.isArray(_data["OrderQuotePostVehicles"])) {
                this.orderQuotePostVehicles = [] as any;
                for (let item of _data["OrderQuotePostVehicles"])
                    this.orderQuotePostVehicles!.push(OrderQuotePostVehicle.fromJS(item));
            }
            if (Array.isArray(_data["OwnerAccounts"])) {
                this.ownerAccounts = [] as any;
                for (let item of _data["OwnerAccounts"])
                    this.ownerAccounts!.push(OwnerAccount.fromJS(item));
            }
            this.latestBidAt = _data["LatestBidAt"] ? moment(_data["LatestBidAt"].toString()) : <any>undefined;
            this.displayName = _data["DisplayName"];
            this.displayNumber = _data["DisplayNumber"];
            this.boxDims = _data["BoxDims"];
            this.doorDims = _data["DoorDims"];
            this.dims = _data["Dims"];
            this.specs = _data["Specs"];
            this.fullSpecs = _data["FullSpecs"];
        }
    }

    static override fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["VIN"] = this.vIN;
        data["Year"] = this.year;
        data["Make"] = this.make;
        data["Model"] = this.model;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["FuelType"] = this.fuelType;
        data["LicenseState"] = this.licenseState;
        data["LicenseNumber"] = this.licenseNumber;
        data["DoorWidth"] = this.doorWidth;
        data["DoorHeight"] = this.doorHeight;
        data["BoxHeight"] = this.boxHeight;
        data["BoxWidth"] = this.boxWidth;
        data["BoxLength"] = this.boxLength;
        data["IsDockHigh"] = this.isDockHigh;
        data["HasLiftGate"] = this.hasLiftGate;
        data["LiftGate"] = this.liftGate;
        data["HasAirRide"] = this.hasAirRide;
        data["HasETrack"] = this.hasETrack;
        data["HasStraps"] = this.hasStraps;
        data["HasBlankets"] = this.hasBlankets;
        data["MaxLoad"] = this.maxLoad;
        data["HasPalletJack"] = this.hasPalletJack;
        data["HasTeam"] = this.hasTeam;
        data["FloorType"] = this.floorType;
        data["HasSideDoor"] = this.hasSideDoor;
        data["HasRamps"] = this.hasRamps;
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["RegistrationExpirationDate"] = this.registrationExpirationDate ? this.registrationExpirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.trackingDevices)) {
            data["TrackingDevices"] = [];
            for (let item of this.trackingDevices)
                data["TrackingDevices"].push(item.toJSON());
        }
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["CustomPeriodRating"] = this.customPeriodRating ? this.customPeriodRating.toJSON() : <any>undefined;
        data["TrackingDetails"] = this.trackingDetails ? this.trackingDetails.toJSON() : <any>undefined;
        data["VehicleAvailabilitySettings"] = this.vehicleAvailabilitySettings ? this.vehicleAvailabilitySettings.toJSON() : <any>undefined;
        if (Array.isArray(this.defaultDrivers)) {
            data["DefaultDrivers"] = [];
            for (let item of this.defaultDrivers)
                data["DefaultDrivers"].push(item.toJSON());
        }
        if (Array.isArray(this.integrations)) {
            data["Integrations"] = [];
            for (let item of this.integrations)
                data["Integrations"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.externalOrderBids)) {
            data["ExternalOrderBids"] = [];
            for (let item of this.externalOrderBids)
                data["ExternalOrderBids"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.telegramChannelSettings)) {
            data["TelegramChannelSettings"] = [];
            for (let item of this.telegramChannelSettings)
                data["TelegramChannelSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleTrackingHistory)) {
            data["VehicleTrackingHistory"] = [];
            for (let item of this.vehicleTrackingHistory)
                data["VehicleTrackingHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierRatings)) {
            data["CarrierRatings"] = [];
            for (let item of this.carrierRatings)
                data["CarrierRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.externalPostedOrderVehicles)) {
            data["ExternalPostedOrderVehicles"] = [];
            for (let item of this.externalPostedOrderVehicles)
                data["ExternalPostedOrderVehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.orderQuotePostVehicles)) {
            data["OrderQuotePostVehicles"] = [];
            for (let item of this.orderQuotePostVehicles)
                data["OrderQuotePostVehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerAccounts)) {
            data["OwnerAccounts"] = [];
            for (let item of this.ownerAccounts)
                data["OwnerAccounts"].push(item.toJSON());
        }
        data["LatestBidAt"] = this.latestBidAt ? this.latestBidAt.toISOString() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["DisplayNumber"] = this.displayNumber;
        data["BoxDims"] = this.boxDims;
        data["DoorDims"] = this.doorDims;
        data["Dims"] = this.dims;
        data["Specs"] = this.specs;
        data["FullSpecs"] = this.fullSpecs;
        super.toJSON(data);
        return data;
    }

    clone(): Vehicle {
        const json = this.toJSON();
        let result = new Vehicle();
        result.init(json);
        return result;
    }
}

export interface IVehicle extends IBaseModel {
    number?: number;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    active?: boolean;
    type?: VehicleType;
    fuelType?: FuelType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    doorWidth?: number;
    doorHeight?: number;
    boxHeight?: number;
    boxWidth?: number;
    boxLength?: number;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    liftGate?: number | undefined;
    hasAirRide?: boolean;
    hasETrack?: boolean;
    hasStraps?: boolean;
    hasBlankets?: boolean;
    maxLoad?: number;
    hasPalletJack?: boolean;
    hasTeam?: boolean;
    floorType?: VehicleFloorType;
    hasSideDoor?: boolean;
    hasRamps?: boolean;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    registrationExpirationDate?: moment.Moment;
    trackingDevices?: TrackingDevice[] | undefined;
    rating?: RatingMetrics | undefined;
    customPeriodRating?: RatingMetrics | undefined;
    trackingDetails?: VehicleTrackingDetails | undefined;
    vehicleAvailabilitySettings?: VehicleAvailabilitySettings | undefined;
    defaultDrivers?: Driver[] | undefined;
    integrations?: IntegrationVehicle[] | undefined;
    files?: FileVehicle[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    orders?: Order[] | undefined;
    notes?: NotesVehicle[] | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;
    vehicleTrackingHistory?: VehicleTrackingHistory[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    externalPostedOrderVehicles?: ExternalPostedOrderVehicle[] | undefined;
    orderQuotePostVehicles?: OrderQuotePostVehicle[] | undefined;
    ownerAccounts?: OwnerAccount[] | undefined;
    latestBidAt?: moment.Moment | undefined;
    displayName?: string | undefined;
    displayNumber?: string | undefined;
    boxDims?: string | undefined;
    doorDims?: string | undefined;
    dims?: string | undefined;
    specs?: string | undefined;
    fullSpecs?: string | undefined;
}

/** 1 = Gas 2 = Diesel */
export enum FuelType {
    Gas = 1,
    Diesel = 2,
}

/** 1 = Wooden 2 = Rubber 3 = PlasticTiles 4 = Steel */
export enum VehicleFloorType {
    Wooden = 1,
    Rubber = 2,
    PlasticTiles = 3,
    Steel = 4,
}

export class Carrier extends BaseModel implements ICarrier {
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    mcNumber?: string | undefined;
    eIN?: number;
    active?: boolean;
    carrierAddress?: Address | undefined;
    phone?: string | undefined;
    insuranceExpirationDate?: moment.Moment;
    rating?: RatingMetrics | undefined;
    customPeriodRating?: RatingMetrics | undefined;
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number | undefined;
    allowAutoBid?: boolean;
    autoBidRate?: number | undefined;
    bypassRateRangeValidation?: boolean;
    inboxIntegrationId?: number | undefined;
    emailSettings?: string | undefined;
    drivers?: Driver[] | undefined;
    vehicles?: Vehicle[] | undefined;
    files?: FileCarrier[] | undefined;
    integrations?: Integration[] | undefined;
    notes?: NotesCarrier[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    carrierRatingNotes?: CarrierRatingNote[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    ownerAccounts?: OwnerAccount[] | undefined;
    compensations?: OrderPayoutCarrierCompensation[] | undefined;

    constructor(data?: ICarrier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["DisplayName"];
            this.name = _data["Name"];
            this.dbaName = _data["DbaName"];
            this.uSDOT = _data["USDOT"];
            this.mcNumber = _data["McNumber"];
            this.eIN = _data["EIN"];
            this.active = _data["Active"];
            this.carrierAddress = _data["CarrierAddress"] ? Address.fromJS(_data["CarrierAddress"]) : <any>undefined;
            this.phone = _data["Phone"];
            this.insuranceExpirationDate = _data["InsuranceExpirationDate"] ? moment(_data["InsuranceExpirationDate"].toString()) : <any>undefined;
            this.rating = _data["Rating"] ? RatingMetrics.fromJS(_data["Rating"]) : <any>undefined;
            this.customPeriodRating = _data["CustomPeriodRating"] ? RatingMetrics.fromJS(_data["CustomPeriodRating"]) : <any>undefined;
            this.payoutAccount = _data["PayoutAccount"] ? PayoutAccount.fromJS(_data["PayoutAccount"]) : <any>undefined;
            this.payoutAccountId = _data["PayoutAccountId"];
            this.allowAutoBid = _data["AllowAutoBid"];
            this.autoBidRate = _data["AutoBidRate"];
            this.bypassRateRangeValidation = _data["BypassRateRangeValidation"];
            this.inboxIntegrationId = _data["InboxIntegrationId"];
            this.emailSettings = _data["EmailSettings"];
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(Driver.fromJS(item));
            }
            if (Array.isArray(_data["Vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["Vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileCarrier.fromJS(item));
            }
            if (Array.isArray(_data["Integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["Integrations"])
                    this.integrations!.push(Integration.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NotesCarrier.fromJS(item));
            }
            if (Array.isArray(_data["DriverRatings"])) {
                this.driverRatings = [] as any;
                for (let item of _data["DriverRatings"])
                    this.driverRatings!.push(DriverRatingNote.fromJS(item));
            }
            if (Array.isArray(_data["CarrierRatingNotes"])) {
                this.carrierRatingNotes = [] as any;
                for (let item of _data["CarrierRatingNotes"])
                    this.carrierRatingNotes!.push(CarrierRatingNote.fromJS(item));
            }
            if (Array.isArray(_data["CarrierRatings"])) {
                this.carrierRatings = [] as any;
                for (let item of _data["CarrierRatings"])
                    this.carrierRatings!.push(CarrierRating.fromJS(item));
            }
            if (Array.isArray(_data["OwnerAccounts"])) {
                this.ownerAccounts = [] as any;
                for (let item of _data["OwnerAccounts"])
                    this.ownerAccounts!.push(OwnerAccount.fromJS(item));
            }
            if (Array.isArray(_data["Compensations"])) {
                this.compensations = [] as any;
                for (let item of _data["Compensations"])
                    this.compensations!.push(OrderPayoutCarrierCompensation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Carrier {
        data = typeof data === 'object' ? data : {};
        let result = new Carrier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DisplayName"] = this.displayName;
        data["Name"] = this.name;
        data["DbaName"] = this.dbaName;
        data["USDOT"] = this.uSDOT;
        data["McNumber"] = this.mcNumber;
        data["EIN"] = this.eIN;
        data["Active"] = this.active;
        data["CarrierAddress"] = this.carrierAddress ? this.carrierAddress.toJSON() : <any>undefined;
        data["Phone"] = this.phone;
        data["InsuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : <any>undefined;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["CustomPeriodRating"] = this.customPeriodRating ? this.customPeriodRating.toJSON() : <any>undefined;
        data["PayoutAccount"] = this.payoutAccount ? this.payoutAccount.toJSON() : <any>undefined;
        data["PayoutAccountId"] = this.payoutAccountId;
        data["AllowAutoBid"] = this.allowAutoBid;
        data["AutoBidRate"] = this.autoBidRate;
        data["BypassRateRangeValidation"] = this.bypassRateRangeValidation;
        data["InboxIntegrationId"] = this.inboxIntegrationId;
        data["EmailSettings"] = this.emailSettings;
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["Vehicles"] = [];
            for (let item of this.vehicles)
                data["Vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.integrations)) {
            data["Integrations"] = [];
            for (let item of this.integrations)
                data["Integrations"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.driverRatings)) {
            data["DriverRatings"] = [];
            for (let item of this.driverRatings)
                data["DriverRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierRatingNotes)) {
            data["CarrierRatingNotes"] = [];
            for (let item of this.carrierRatingNotes)
                data["CarrierRatingNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierRatings)) {
            data["CarrierRatings"] = [];
            for (let item of this.carrierRatings)
                data["CarrierRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerAccounts)) {
            data["OwnerAccounts"] = [];
            for (let item of this.ownerAccounts)
                data["OwnerAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.compensations)) {
            data["Compensations"] = [];
            for (let item of this.compensations)
                data["Compensations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Carrier {
        const json = this.toJSON();
        let result = new Carrier();
        result.init(json);
        return result;
    }
}

export interface ICarrier extends IBaseModel {
    displayName?: string | undefined;
    name?: string | undefined;
    dbaName?: string | undefined;
    uSDOT?: number;
    mcNumber?: string | undefined;
    eIN?: number;
    active?: boolean;
    carrierAddress?: Address | undefined;
    phone?: string | undefined;
    insuranceExpirationDate?: moment.Moment;
    rating?: RatingMetrics | undefined;
    customPeriodRating?: RatingMetrics | undefined;
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number | undefined;
    allowAutoBid?: boolean;
    autoBidRate?: number | undefined;
    bypassRateRangeValidation?: boolean;
    inboxIntegrationId?: number | undefined;
    emailSettings?: string | undefined;
    drivers?: Driver[] | undefined;
    vehicles?: Vehicle[] | undefined;
    files?: FileCarrier[] | undefined;
    integrations?: Integration[] | undefined;
    notes?: NotesCarrier[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    carrierRatingNotes?: CarrierRatingNote[] | undefined;
    carrierRatings?: CarrierRating[] | undefined;
    ownerAccounts?: OwnerAccount[] | undefined;
    compensations?: OrderPayoutCarrierCompensation[] | undefined;
}

export class RatingMetrics extends BaseModel implements IRatingMetrics {
    rating?: number;
    pickUpOnTime?: number;
    deliverOnTime?: number;
    communicationOnTime?: number;
    trackingUpdate?: number;
    failToDeliver?: number;
    ratingOrders?: number;

    constructor(data?: IRatingMetrics) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rating = _data["Rating"];
            this.pickUpOnTime = _data["PickUpOnTime"];
            this.deliverOnTime = _data["DeliverOnTime"];
            this.communicationOnTime = _data["CommunicationOnTime"];
            this.trackingUpdate = _data["TrackingUpdate"];
            this.failToDeliver = _data["FailToDeliver"];
            this.ratingOrders = _data["RatingOrders"];
        }
    }

    static override fromJS(data: any): RatingMetrics {
        data = typeof data === 'object' ? data : {};
        let result = new RatingMetrics();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rating"] = this.rating;
        data["PickUpOnTime"] = this.pickUpOnTime;
        data["DeliverOnTime"] = this.deliverOnTime;
        data["CommunicationOnTime"] = this.communicationOnTime;
        data["TrackingUpdate"] = this.trackingUpdate;
        data["FailToDeliver"] = this.failToDeliver;
        data["RatingOrders"] = this.ratingOrders;
        super.toJSON(data);
        return data;
    }

    clone(): RatingMetrics {
        const json = this.toJSON();
        let result = new RatingMetrics();
        result.init(json);
        return result;
    }
}

export interface IRatingMetrics extends IBaseModel {
    rating?: number;
    pickUpOnTime?: number;
    deliverOnTime?: number;
    communicationOnTime?: number;
    trackingUpdate?: number;
    failToDeliver?: number;
    ratingOrders?: number;
}

export class PayoutAccount extends BaseModel implements IPayoutAccount {
    name?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    type?: PayoutAccountType;
    taxNumber?: string | undefined;
    balance?: number;
    carriers?: Carrier[] | undefined;
    drivers?: Driver[] | undefined;
    balanceAdjustment?: PayoutAccountBalanceAdjustment[] | undefined;
    payoutAccountTransactions?: PayoutAccountTransaction[] | undefined;

    constructor(data?: IPayoutAccount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.street = _data["Street"];
            this.street2 = _data["Street2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipcode = _data["Zipcode"];
            this.type = _data["Type"];
            this.taxNumber = _data["TaxNumber"];
            this.balance = _data["Balance"];
            if (Array.isArray(_data["Carriers"])) {
                this.carriers = [] as any;
                for (let item of _data["Carriers"])
                    this.carriers!.push(Carrier.fromJS(item));
            }
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(Driver.fromJS(item));
            }
            if (Array.isArray(_data["BalanceAdjustment"])) {
                this.balanceAdjustment = [] as any;
                for (let item of _data["BalanceAdjustment"])
                    this.balanceAdjustment!.push(PayoutAccountBalanceAdjustment.fromJS(item));
            }
            if (Array.isArray(_data["PayoutAccountTransactions"])) {
                this.payoutAccountTransactions = [] as any;
                for (let item of _data["PayoutAccountTransactions"])
                    this.payoutAccountTransactions!.push(PayoutAccountTransaction.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PayoutAccount {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccount();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Street"] = this.street;
        data["Street2"] = this.street2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zipcode"] = this.zipcode;
        data["Type"] = this.type;
        data["TaxNumber"] = this.taxNumber;
        data["Balance"] = this.balance;
        if (Array.isArray(this.carriers)) {
            data["Carriers"] = [];
            for (let item of this.carriers)
                data["Carriers"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.balanceAdjustment)) {
            data["BalanceAdjustment"] = [];
            for (let item of this.balanceAdjustment)
                data["BalanceAdjustment"].push(item.toJSON());
        }
        if (Array.isArray(this.payoutAccountTransactions)) {
            data["PayoutAccountTransactions"] = [];
            for (let item of this.payoutAccountTransactions)
                data["PayoutAccountTransactions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PayoutAccount {
        const json = this.toJSON();
        let result = new PayoutAccount();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccount extends IBaseModel {
    name?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    type?: PayoutAccountType;
    taxNumber?: string | undefined;
    balance?: number;
    carriers?: Carrier[] | undefined;
    drivers?: Driver[] | undefined;
    balanceAdjustment?: PayoutAccountBalanceAdjustment[] | undefined;
    payoutAccountTransactions?: PayoutAccountTransaction[] | undefined;
}

/** 1 = Personal 2 = Business */
export enum PayoutAccountType {
    Personal = 1,
    Business = 2,
}

export class Driver extends BaseModel implements IDriver {
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    active?: boolean;
    availableAt?: moment.Moment | undefined;
    driverAddress?: Address | undefined;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    hOS_JSON?: string | undefined;
    hOS?: Driver_HOS | undefined;
    trackingDevice?: TrackingDevice | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    note?: string | undefined;
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number | undefined;
    integrations?: IntegrationDriver[] | undefined;
    files?: FileDriver[] | undefined;
    orders?: Order[] | undefined;
    notes?: NotesDriver[] | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    compensations?: OrderPayoutDriverCompensation[] | undefined;

    constructor(data?: IDriver) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.active = _data["Active"];
            this.availableAt = _data["AvailableAt"] ? moment(_data["AvailableAt"].toString()) : <any>undefined;
            this.driverAddress = _data["DriverAddress"] ? Address.fromJS(_data["DriverAddress"]) : <any>undefined;
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.hOS_JSON = _data["HOS_JSON"];
            this.hOS = _data["HOS"] ? Driver_HOS.fromJS(_data["HOS"]) : <any>undefined;
            this.trackingDevice = _data["TrackingDevice"] ? TrackingDevice.fromJS(_data["TrackingDevice"]) : <any>undefined;
            this.driverLicenseExpiration = _data["DriverLicenseExpiration"] ? moment(_data["DriverLicenseExpiration"].toString()) : <any>undefined;
            this.medicalExpiration = _data["MedicalExpiration"] ? moment(_data["MedicalExpiration"].toString()) : <any>undefined;
            this.twicExpiration = _data["TwicExpiration"] ? moment(_data["TwicExpiration"].toString()) : <any>undefined;
            this.driverLicenseState = _data["DriverLicenseState"];
            this.driverLicense = _data["DriverLicense"];
            this.note = _data["Note"];
            this.payoutAccount = _data["PayoutAccount"] ? PayoutAccount.fromJS(_data["PayoutAccount"]) : <any>undefined;
            this.payoutAccountId = _data["PayoutAccountId"];
            if (Array.isArray(_data["Integrations"])) {
                this.integrations = [] as any;
                for (let item of _data["Integrations"])
                    this.integrations!.push(IntegrationDriver.fromJS(item));
            }
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileDriver.fromJS(item));
            }
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NotesDriver.fromJS(item));
            }
            if (Array.isArray(_data["TelegramChannelSettings"])) {
                this.telegramChannelSettings = [] as any;
                for (let item of _data["TelegramChannelSettings"])
                    this.telegramChannelSettings!.push(TelegramChannelSettings.fromJS(item));
            }
            if (Array.isArray(_data["DriverRatings"])) {
                this.driverRatings = [] as any;
                for (let item of _data["DriverRatings"])
                    this.driverRatings!.push(DriverRatingNote.fromJS(item));
            }
            if (Array.isArray(_data["Compensations"])) {
                this.compensations = [] as any;
                for (let item of _data["Compensations"])
                    this.compensations!.push(OrderPayoutDriverCompensation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Driver {
        data = typeof data === 'object' ? data : {};
        let result = new Driver();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Active"] = this.active;
        data["AvailableAt"] = this.availableAt ? this.availableAt.toISOString() : <any>undefined;
        data["DriverAddress"] = this.driverAddress ? this.driverAddress.toJSON() : <any>undefined;
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["HOS_JSON"] = this.hOS_JSON;
        data["HOS"] = this.hOS ? this.hOS.toJSON() : <any>undefined;
        data["TrackingDevice"] = this.trackingDevice ? this.trackingDevice.toJSON() : <any>undefined;
        data["DriverLicenseExpiration"] = this.driverLicenseExpiration ? this.driverLicenseExpiration.toISOString() : <any>undefined;
        data["MedicalExpiration"] = this.medicalExpiration ? this.medicalExpiration.toISOString() : <any>undefined;
        data["TwicExpiration"] = this.twicExpiration ? this.twicExpiration.toISOString() : <any>undefined;
        data["DriverLicenseState"] = this.driverLicenseState;
        data["DriverLicense"] = this.driverLicense;
        data["Note"] = this.note;
        data["PayoutAccount"] = this.payoutAccount ? this.payoutAccount.toJSON() : <any>undefined;
        data["PayoutAccountId"] = this.payoutAccountId;
        if (Array.isArray(this.integrations)) {
            data["Integrations"] = [];
            for (let item of this.integrations)
                data["Integrations"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.telegramChannelSettings)) {
            data["TelegramChannelSettings"] = [];
            for (let item of this.telegramChannelSettings)
                data["TelegramChannelSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.driverRatings)) {
            data["DriverRatings"] = [];
            for (let item of this.driverRatings)
                data["DriverRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.compensations)) {
            data["Compensations"] = [];
            for (let item of this.compensations)
                data["Compensations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): Driver {
        const json = this.toJSON();
        let result = new Driver();
        result.init(json);
        return result;
    }
}

export interface IDriver extends IBaseModel {
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    active?: boolean;
    availableAt?: moment.Moment | undefined;
    driverAddress?: Address | undefined;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    hOS_JSON?: string | undefined;
    hOS?: Driver_HOS | undefined;
    trackingDevice?: TrackingDevice | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    note?: string | undefined;
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number | undefined;
    integrations?: IntegrationDriver[] | undefined;
    files?: FileDriver[] | undefined;
    orders?: Order[] | undefined;
    notes?: NotesDriver[] | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;
    driverRatings?: DriverRatingNote[] | undefined;
    compensations?: OrderPayoutDriverCompensation[] | undefined;
}

export class Driver_HOS implements IDriver_HOS {
    dutyStatus?: DutyStatus;
    availableTime?: Driver_HOS_AvailableTime | undefined;
    lastHosStatus?: HOS_Status | undefined;

    constructor(data?: IDriver_HOS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dutyStatus = _data["DutyStatus"];
            this.availableTime = _data["AvailableTime"] ? Driver_HOS_AvailableTime.fromJS(_data["AvailableTime"]) : <any>undefined;
            this.lastHosStatus = _data["LastHosStatus"] ? HOS_Status.fromJS(_data["LastHosStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Driver_HOS {
        data = typeof data === 'object' ? data : {};
        let result = new Driver_HOS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DutyStatus"] = this.dutyStatus;
        data["AvailableTime"] = this.availableTime ? this.availableTime.toJSON() : <any>undefined;
        data["LastHosStatus"] = this.lastHosStatus ? this.lastHosStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): Driver_HOS {
        const json = this.toJSON();
        let result = new Driver_HOS();
        result.init(json);
        return result;
    }
}

export interface IDriver_HOS {
    dutyStatus?: DutyStatus;
    availableTime?: Driver_HOS_AvailableTime | undefined;
    lastHosStatus?: HOS_Status | undefined;
}

/** 1 = OffDuty 2 = SleeperBed 3 = Driving 4 = OnDuty 5 = YardMove 6 = PersonalConveyance */
export enum DutyStatus {
    OffDuty = 1,
    SleeperBed = 2,
    Driving = 3,
    OnDuty = 4,
    YardMove = 5,
    PersonalConveyance = 6,
}

export class Driver_HOS_AvailableTime implements IDriver_HOS_AvailableTime {
    cycle?: number;
    shift?: number;
    drive?: number;
    break?: number;
    splitShift?: number;
    splitDrive?: number;
    splitCycle?: number;
    splitBreak?: number;
    splitInProgress?: boolean;

    constructor(data?: IDriver_HOS_AvailableTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle = _data["Cycle"];
            this.shift = _data["Shift"];
            this.drive = _data["Drive"];
            this.break = _data["Break"];
            this.splitShift = _data["SplitShift"];
            this.splitDrive = _data["SplitDrive"];
            this.splitCycle = _data["SplitCycle"];
            this.splitBreak = _data["SplitBreak"];
            this.splitInProgress = _data["SplitInProgress"];
        }
    }

    static fromJS(data: any): Driver_HOS_AvailableTime {
        data = typeof data === 'object' ? data : {};
        let result = new Driver_HOS_AvailableTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Cycle"] = this.cycle;
        data["Shift"] = this.shift;
        data["Drive"] = this.drive;
        data["Break"] = this.break;
        data["SplitShift"] = this.splitShift;
        data["SplitDrive"] = this.splitDrive;
        data["SplitCycle"] = this.splitCycle;
        data["SplitBreak"] = this.splitBreak;
        data["SplitInProgress"] = this.splitInProgress;
        return data;
    }

    clone(): Driver_HOS_AvailableTime {
        const json = this.toJSON();
        let result = new Driver_HOS_AvailableTime();
        result.init(json);
        return result;
    }
}

export interface IDriver_HOS_AvailableTime {
    cycle?: number;
    shift?: number;
    drive?: number;
    break?: number;
    splitShift?: number;
    splitDrive?: number;
    splitCycle?: number;
    splitBreak?: number;
    splitInProgress?: boolean;
}

export class HOS_Status implements IHOS_Status {
    status?: string | undefined;
    time?: moment.Moment;

    constructor(data?: IHOS_Status) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.time = _data["Time"] ? moment(_data["Time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HOS_Status {
        data = typeof data === 'object' ? data : {};
        let result = new HOS_Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["Time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data;
    }

    clone(): HOS_Status {
        const json = this.toJSON();
        let result = new HOS_Status();
        result.init(json);
        return result;
    }
}

export interface IHOS_Status {
    status?: string | undefined;
    time?: moment.Moment;
}

export class TrackingDevice extends BaseModel implements ITrackingDevice {
    phoneNumber?: number;
    name?: string | undefined;
    driver?: Driver | undefined;
    driverId?: number | undefined;
    enableVehicleLocationUpdate?: boolean;
    active?: boolean;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    speed?: number | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    locatedAt?: moment.Moment | undefined;
    lastDeviceDataJSON?: string | undefined;
    isDeviceTrackingEnabled?: boolean;
    lastDeviceData?: DeviceData | undefined;

    constructor(data?: ITrackingDevice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phoneNumber = _data["PhoneNumber"];
            this.name = _data["Name"];
            this.driver = _data["Driver"] ? Driver.fromJS(_data["Driver"]) : <any>undefined;
            this.driverId = _data["DriverId"];
            this.enableVehicleLocationUpdate = _data["EnableVehicleLocationUpdate"];
            this.active = _data["Active"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.speed = _data["Speed"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.lastDeviceDataJSON = _data["LastDeviceDataJSON"];
            this.isDeviceTrackingEnabled = _data["IsDeviceTrackingEnabled"];
            this.lastDeviceData = _data["LastDeviceData"] ? DeviceData.fromJS(_data["LastDeviceData"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TrackingDevice {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingDevice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PhoneNumber"] = this.phoneNumber;
        data["Name"] = this.name;
        data["Driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["DriverId"] = this.driverId;
        data["EnableVehicleLocationUpdate"] = this.enableVehicleLocationUpdate;
        data["Active"] = this.active;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["Speed"] = this.speed;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["LastDeviceDataJSON"] = this.lastDeviceDataJSON;
        data["IsDeviceTrackingEnabled"] = this.isDeviceTrackingEnabled;
        data["LastDeviceData"] = this.lastDeviceData ? this.lastDeviceData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TrackingDevice {
        const json = this.toJSON();
        let result = new TrackingDevice();
        result.init(json);
        return result;
    }
}

export interface ITrackingDevice extends IBaseModel {
    phoneNumber?: number;
    name?: string | undefined;
    driver?: Driver | undefined;
    driverId?: number | undefined;
    enableVehicleLocationUpdate?: boolean;
    active?: boolean;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    speed?: number | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    locatedAt?: moment.Moment | undefined;
    lastDeviceDataJSON?: string | undefined;
    isDeviceTrackingEnabled?: boolean;
    lastDeviceData?: DeviceData | undefined;
}

export class DeviceData implements IDeviceData {
    version?: string | undefined;
    system?: string | undefined;
    device?: string | undefined;
    platform?: string | undefined;
    trackingSetting?: string | undefined;
    locatedAt?: number | undefined;

    constructor(data?: IDeviceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["Version"];
            this.system = _data["System"];
            this.device = _data["Device"];
            this.platform = _data["Platform"];
            this.trackingSetting = _data["TrackingSetting"];
            this.locatedAt = _data["LocatedAt"];
        }
    }

    static fromJS(data: any): DeviceData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Version"] = this.version;
        data["System"] = this.system;
        data["Device"] = this.device;
        data["Platform"] = this.platform;
        data["TrackingSetting"] = this.trackingSetting;
        data["LocatedAt"] = this.locatedAt;
        return data;
    }

    clone(): DeviceData {
        const json = this.toJSON();
        let result = new DeviceData();
        result.init(json);
        return result;
    }
}

export interface IDeviceData {
    version?: string | undefined;
    system?: string | undefined;
    device?: string | undefined;
    platform?: string | undefined;
    trackingSetting?: string | undefined;
    locatedAt?: number | undefined;
}

export class IntegrationDriver extends BaseModel implements IIntegrationDriver {
    settings?: string | undefined;
    externalId?: string | undefined;
    integrationId?: number;
    driverId?: number;
    driver?: Driver | undefined;
    integration?: Integration | undefined;

    constructor(data?: IIntegrationDriver) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.settings = _data["Settings"];
            this.externalId = _data["ExternalId"];
            this.integrationId = _data["IntegrationId"];
            this.driverId = _data["DriverId"];
            this.driver = _data["Driver"] ? Driver.fromJS(_data["Driver"]) : <any>undefined;
            this.integration = _data["Integration"] ? Integration.fromJS(_data["Integration"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): IntegrationDriver {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDriver();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Settings"] = this.settings;
        data["ExternalId"] = this.externalId;
        data["IntegrationId"] = this.integrationId;
        data["DriverId"] = this.driverId;
        data["Driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["Integration"] = this.integration ? this.integration.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): IntegrationDriver {
        const json = this.toJSON();
        let result = new IntegrationDriver();
        result.init(json);
        return result;
    }
}

export interface IIntegrationDriver extends IBaseModel {
    settings?: string | undefined;
    externalId?: string | undefined;
    integrationId?: number;
    driverId?: number;
    driver?: Driver | undefined;
    integration?: Integration | undefined;
}

export class Integration extends BaseModel implements IIntegration {
    name?: string | undefined;
    active?: boolean;
    type?: IntegrationType;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    personalizedUserId?: string | undefined;
    driverIntegrations?: IntegrationDriver[] | undefined;
    vehicleIntegrations?: IntegrationVehicle[] | undefined;
    settingsJSON?: string | undefined;
    settings?: IntegrationSettings | undefined;

    constructor(data?: IIntegration) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.personalizedUserId = _data["PersonalizedUserId"];
            if (Array.isArray(_data["DriverIntegrations"])) {
                this.driverIntegrations = [] as any;
                for (let item of _data["DriverIntegrations"])
                    this.driverIntegrations!.push(IntegrationDriver.fromJS(item));
            }
            if (Array.isArray(_data["VehicleIntegrations"])) {
                this.vehicleIntegrations = [] as any;
                for (let item of _data["VehicleIntegrations"])
                    this.vehicleIntegrations!.push(IntegrationVehicle.fromJS(item));
            }
            this.settingsJSON = _data["SettingsJSON"];
            this.settings = _data["Settings"] ? IntegrationSettings.fromJS(_data["Settings"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Integration {
        data = typeof data === 'object' ? data : {};
        let result = new Integration();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["PersonalizedUserId"] = this.personalizedUserId;
        if (Array.isArray(this.driverIntegrations)) {
            data["DriverIntegrations"] = [];
            for (let item of this.driverIntegrations)
                data["DriverIntegrations"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleIntegrations)) {
            data["VehicleIntegrations"] = [];
            for (let item of this.vehicleIntegrations)
                data["VehicleIntegrations"].push(item.toJSON());
        }
        data["SettingsJSON"] = this.settingsJSON;
        data["Settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): Integration {
        const json = this.toJSON();
        let result = new Integration();
        result.init(json);
        return result;
    }
}

export interface IIntegration extends IBaseModel {
    name?: string | undefined;
    active?: boolean;
    type?: IntegrationType;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    personalizedUserId?: string | undefined;
    driverIntegrations?: IntegrationDriver[] | undefined;
    vehicleIntegrations?: IntegrationVehicle[] | undefined;
    settingsJSON?: string | undefined;
    settings?: IntegrationSettings | undefined;
}

/** 1 = KeepTruckin 2 = Samsara 3 = Geotab 4 = InternalCarrier 5 = Linxup */
export enum IntegrationType {
    KeepTruckin = 1,
    Samsara = 2,
    Geotab = 3,
    InternalCarrier = 4,
    Linxup = 5,
}

export class IntegrationVehicle extends BaseModel implements IIntegrationVehicle {
    externalId?: string | undefined;
    settings?: string | undefined;
    integrationId?: number;
    vehicleId?: number;
    vehicle?: Vehicle | undefined;
    integration?: Integration | undefined;

    constructor(data?: IIntegrationVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalId = _data["ExternalId"];
            this.settings = _data["Settings"];
            this.integrationId = _data["IntegrationId"];
            this.vehicleId = _data["VehicleId"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.integration = _data["Integration"] ? Integration.fromJS(_data["Integration"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): IntegrationVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationVehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalId"] = this.externalId;
        data["Settings"] = this.settings;
        data["IntegrationId"] = this.integrationId;
        data["VehicleId"] = this.vehicleId;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["Integration"] = this.integration ? this.integration.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): IntegrationVehicle {
        const json = this.toJSON();
        let result = new IntegrationVehicle();
        result.init(json);
        return result;
    }
}

export interface IIntegrationVehicle extends IBaseModel {
    externalId?: string | undefined;
    settings?: string | undefined;
    integrationId?: number;
    vehicleId?: number;
    vehicle?: Vehicle | undefined;
    integration?: Integration | undefined;
}

export class ELDIntegrationSettingOfString implements IELDIntegrationSettingOfString {
    eldVehicles?: ELDIntegrationSettingItemOfString | undefined;
    eldUsers?: ELDIntegrationSettingItemOfString | undefined;

    constructor(data?: IELDIntegrationSettingOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eldVehicles = _data["EldVehicles"] ? ELDIntegrationSettingItemOfString.fromJS(_data["EldVehicles"]) : <any>undefined;
            this.eldUsers = _data["EldUsers"] ? ELDIntegrationSettingItemOfString.fromJS(_data["EldUsers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ELDIntegrationSettingOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ELDIntegrationSettingOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EldVehicles"] = this.eldVehicles ? this.eldVehicles.toJSON() : <any>undefined;
        data["EldUsers"] = this.eldUsers ? this.eldUsers.toJSON() : <any>undefined;
        return data;
    }

    clone(): ELDIntegrationSettingOfString {
        const json = this.toJSON();
        let result = new ELDIntegrationSettingOfString();
        result.init(json);
        return result;
    }
}

export interface IELDIntegrationSettingOfString {
    eldVehicles?: ELDIntegrationSettingItemOfString | undefined;
    eldUsers?: ELDIntegrationSettingItemOfString | undefined;
}

export class IntegrationSettings extends ELDIntegrationSettingOfString implements IIntegrationSettings {
    params?: IntegrationSettingsParam[] | undefined;

    constructor(data?: IIntegrationSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Params"])) {
                this.params = [] as any;
                for (let item of _data["Params"])
                    this.params!.push(IntegrationSettingsParam.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): IntegrationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.params)) {
            data["Params"] = [];
            for (let item of this.params)
                data["Params"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): IntegrationSettings {
        const json = this.toJSON();
        let result = new IntegrationSettings();
        result.init(json);
        return result;
    }
}

export interface IIntegrationSettings extends IELDIntegrationSettingOfString {
    params?: IntegrationSettingsParam[] | undefined;
}

export class IntegrationSettingsParam implements IIntegrationSettingsParam {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IIntegrationSettingsParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): IntegrationSettingsParam {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationSettingsParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Value"] = this.value;
        return data;
    }

    clone(): IntegrationSettingsParam {
        const json = this.toJSON();
        let result = new IntegrationSettingsParam();
        result.init(json);
        return result;
    }
}

export interface IIntegrationSettingsParam {
    name?: string | undefined;
    value?: string | undefined;
}

export class ELDIntegrationSettingItemOfString implements IELDIntegrationSettingItemOfString {
    enable?: boolean;
    ids?: string[] | undefined;

    constructor(data?: IELDIntegrationSettingItemOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["Enable"];
            if (Array.isArray(_data["Ids"])) {
                this.ids = [] as any;
                for (let item of _data["Ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ELDIntegrationSettingItemOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ELDIntegrationSettingItemOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enable"] = this.enable;
        if (Array.isArray(this.ids)) {
            data["Ids"] = [];
            for (let item of this.ids)
                data["Ids"].push(item);
        }
        return data;
    }

    clone(): ELDIntegrationSettingItemOfString {
        const json = this.toJSON();
        let result = new ELDIntegrationSettingItemOfString();
        result.init(json);
        return result;
    }
}

export interface IELDIntegrationSettingItemOfString {
    enable?: boolean;
    ids?: string[] | undefined;
}

export abstract class File extends BaseModel implements IFile {
    name?: string | undefined;
    referenceId?: number;
    type?: FileType;
    description?: string | undefined;
    externalPath?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.referenceId = _data["ReferenceId"];
            this.type = _data["Type"];
            this.description = _data["Description"];
            this.externalPath = _data["ExternalPath"];
            this.isDeleted = _data["IsDeleted"];
        }
    }

    static override fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'File' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ReferenceId"] = this.referenceId;
        data["Type"] = this.type;
        data["Description"] = this.description;
        data["ExternalPath"] = this.externalPath;
        data["IsDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }

    clone(): File {
        throw new Error("The abstract class 'File' cannot be instantiated.");
    }
}

export interface IFile extends IBaseModel {
    name?: string | undefined;
    referenceId?: number;
    type?: FileType;
    description?: string | undefined;
    externalPath?: string | undefined;
    isDeleted?: boolean;
}

export class FileDriver extends File implements IFileDriver {
    driver?: Driver | undefined;

    constructor(data?: IFileDriver) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.driver = _data["Driver"] ? Driver.fromJS(_data["Driver"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileDriver {
        data = typeof data === 'object' ? data : {};
        let result = new FileDriver();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileDriver {
        const json = this.toJSON();
        let result = new FileDriver();
        result.init(json);
        return result;
    }
}

export interface IFileDriver extends IFile {
    driver?: Driver | undefined;
}

/** 1 = RateConfirmation 2 = BillOfLanding 3 = DocumentsToPrint 4 = Receipts 5 = ProofOfDelivery 6 = Note 7 = DriverLicense 8 = DriverMedicalExam 9 = Agreement 10 = VehicleRegistration 11 = OrderCargo 14 = DriverApplication 15 = Insurance 16 = Authority 17 = W9 18 = VoidCheck 19 = Certificates 20 = QuickPayLetter 21 = FactoringReleaseLetter 22 = IdentificationDocuments 23 = Photo 24 = TWIC */
export enum FileType {
    RateConfirmation = 1,
    BillOfLanding = 2,
    DocumentsToPrint = 3,
    Receipts = 4,
    ProofOfDelivery = 5,
    Note = 6,
    DriverLicense = 7,
    DriverMedicalExam = 8,
    Agreement = 9,
    VehicleRegistration = 10,
    OrderCargo = 11,
    DriverApplication = 14,
    Insurance = 15,
    Authority = 16,
    W9 = 17,
    VoidCheck = 18,
    Certificates = 19,
    QuickPayLetter = 20,
    FactoringReleaseLetter = 21,
    IdentificationDocuments = 22,
    Photo = 23,
    TWIC = 24,
}

export class Notes extends BaseModel implements INotes {
    note?: string | undefined;
    referenceId?: number;
    type?: NoteType;
    isDeleted?: boolean;

    constructor(data?: INotes) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["Note"];
            this.referenceId = _data["ReferenceId"];
            this.type = _data["Type"];
            this.isDeleted = _data["IsDeleted"];
        }
    }

    static override fromJS(data: any): Notes {
        data = typeof data === 'object' ? data : {};
        let result = new Notes();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Note"] = this.note;
        data["ReferenceId"] = this.referenceId;
        data["Type"] = this.type;
        data["IsDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }

    clone(): Notes {
        const json = this.toJSON();
        let result = new Notes();
        result.init(json);
        return result;
    }
}

export interface INotes extends IBaseModel {
    note?: string | undefined;
    referenceId?: number;
    type?: NoteType;
    isDeleted?: boolean;
}

export class NotesDriver extends Notes implements INotesDriver {
    driver?: Driver | undefined;

    constructor(data?: INotesDriver) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.driver = _data["Driver"] ? Driver.fromJS(_data["Driver"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotesDriver {
        data = typeof data === 'object' ? data : {};
        let result = new NotesDriver();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NotesDriver {
        const json = this.toJSON();
        let result = new NotesDriver();
        result.init(json);
        return result;
    }
}

export interface INotesDriver extends INotes {
    driver?: Driver | undefined;
}

/** 1 = Order 2 = OrderAccounting 3 = Carrier 4 = Vehicle 5 = Driver */
export enum NoteType {
    Order = 1,
    OrderAccounting = 2,
    Carrier = 3,
    Vehicle = 4,
    Driver = 5,
}

export class TelegramChannelSettings extends BaseModel implements ITelegramChannelSettings {
    active?: boolean;
    telegramChannel?: TelegramChannel | undefined;
    type?: TelegramChannelType;
    drivers?: Driver[] | undefined;
    vehicles?: Vehicle[] | undefined;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;
    settingsJSON?: string | undefined;
    lastError?: string | undefined;
    orderFeedSettings?: OrderFeedSettings | undefined;

    constructor(data?: ITelegramChannelSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["Active"];
            this.telegramChannel = _data["TelegramChannel"] ? TelegramChannel.fromJS(_data["TelegramChannel"]) : <any>undefined;
            this.type = _data["Type"];
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(Driver.fromJS(item));
            }
            if (Array.isArray(_data["Vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["Vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            if (Array.isArray(_data["TelegramChannelFeedPosts"])) {
                this.telegramChannelFeedPosts = [] as any;
                for (let item of _data["TelegramChannelFeedPosts"])
                    this.telegramChannelFeedPosts!.push(TelegramChannelFeedPost.fromJS(item));
            }
            this.settingsJSON = _data["SettingsJSON"];
            this.lastError = _data["LastError"];
            this.orderFeedSettings = _data["OrderFeedSettings"] ? OrderFeedSettings.fromJS(_data["OrderFeedSettings"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TelegramChannelSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Active"] = this.active;
        data["TelegramChannel"] = this.telegramChannel ? this.telegramChannel.toJSON() : <any>undefined;
        data["Type"] = this.type;
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["Vehicles"] = [];
            for (let item of this.vehicles)
                data["Vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.telegramChannelFeedPosts)) {
            data["TelegramChannelFeedPosts"] = [];
            for (let item of this.telegramChannelFeedPosts)
                data["TelegramChannelFeedPosts"].push(item.toJSON());
        }
        data["SettingsJSON"] = this.settingsJSON;
        data["LastError"] = this.lastError;
        data["OrderFeedSettings"] = this.orderFeedSettings ? this.orderFeedSettings.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TelegramChannelSettings {
        const json = this.toJSON();
        let result = new TelegramChannelSettings();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelSettings extends IBaseModel {
    active?: boolean;
    telegramChannel?: TelegramChannel | undefined;
    type?: TelegramChannelType;
    drivers?: Driver[] | undefined;
    vehicles?: Vehicle[] | undefined;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;
    settingsJSON?: string | undefined;
    lastError?: string | undefined;
    orderFeedSettings?: OrderFeedSettings | undefined;
}

export class TelegramChannel extends BaseModel implements ITelegramChannel {
    channelId?: number;
    title?: string | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;

    constructor(data?: ITelegramChannel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.channelId = _data["ChannelId"];
            this.title = _data["Title"];
            if (Array.isArray(_data["TelegramChannelSettings"])) {
                this.telegramChannelSettings = [] as any;
                for (let item of _data["TelegramChannelSettings"])
                    this.telegramChannelSettings!.push(TelegramChannelSettings.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TelegramChannel {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ChannelId"] = this.channelId;
        data["Title"] = this.title;
        if (Array.isArray(this.telegramChannelSettings)) {
            data["TelegramChannelSettings"] = [];
            for (let item of this.telegramChannelSettings)
                data["TelegramChannelSettings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): TelegramChannel {
        const json = this.toJSON();
        let result = new TelegramChannel();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannel extends IBaseModel {
    channelId?: number;
    title?: string | undefined;
    telegramChannelSettings?: TelegramChannelSettings[] | undefined;
}

/** 1 = OrderInfo 2 = OrderFeed 3 = AwardedOrders 4 = ContractorFeed */
export enum TelegramChannelType {
    OrderInfo = 1,
    OrderFeed = 2,
    AwardedOrders = 3,
    ContractorFeed = 4,
}

export class TelegramChannelFeedPost extends BaseModel implements ITelegramChannelFeedPost {
    telegramChannelSettings?: TelegramChannelSettings | undefined;
    telegramChannelSettingsId?: number;
    channelId?: number;
    messageId?: number;
    message?: string | undefined;
    externalPostedOrder?: ExternalPostedOrder | undefined;
    externalPostedOrderId?: number | undefined;
    internalOrderQuote?: OrderQuote | undefined;
    internalOrderQuoteId?: number | undefined;
    externalOrderBid?: ExternalOrderBid | undefined;
    externalOrderBidId?: number | undefined;

    constructor(data?: ITelegramChannelFeedPost) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.telegramChannelSettings = _data["TelegramChannelSettings"] ? TelegramChannelSettings.fromJS(_data["TelegramChannelSettings"]) : <any>undefined;
            this.telegramChannelSettingsId = _data["TelegramChannelSettingsId"];
            this.channelId = _data["ChannelId"];
            this.messageId = _data["MessageId"];
            this.message = _data["Message"];
            this.externalPostedOrder = _data["ExternalPostedOrder"] ? ExternalPostedOrder.fromJS(_data["ExternalPostedOrder"]) : <any>undefined;
            this.externalPostedOrderId = _data["ExternalPostedOrderId"];
            this.internalOrderQuote = _data["InternalOrderQuote"] ? OrderQuote.fromJS(_data["InternalOrderQuote"]) : <any>undefined;
            this.internalOrderQuoteId = _data["InternalOrderQuoteId"];
            this.externalOrderBid = _data["ExternalOrderBid"] ? ExternalOrderBid.fromJS(_data["ExternalOrderBid"]) : <any>undefined;
            this.externalOrderBidId = _data["ExternalOrderBidId"];
        }
    }

    static override fromJS(data: any): TelegramChannelFeedPost {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelFeedPost();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TelegramChannelSettings"] = this.telegramChannelSettings ? this.telegramChannelSettings.toJSON() : <any>undefined;
        data["TelegramChannelSettingsId"] = this.telegramChannelSettingsId;
        data["ChannelId"] = this.channelId;
        data["MessageId"] = this.messageId;
        data["Message"] = this.message;
        data["ExternalPostedOrder"] = this.externalPostedOrder ? this.externalPostedOrder.toJSON() : <any>undefined;
        data["ExternalPostedOrderId"] = this.externalPostedOrderId;
        data["InternalOrderQuote"] = this.internalOrderQuote ? this.internalOrderQuote.toJSON() : <any>undefined;
        data["InternalOrderQuoteId"] = this.internalOrderQuoteId;
        data["ExternalOrderBid"] = this.externalOrderBid ? this.externalOrderBid.toJSON() : <any>undefined;
        data["ExternalOrderBidId"] = this.externalOrderBidId;
        super.toJSON(data);
        return data;
    }

    clone(): TelegramChannelFeedPost {
        const json = this.toJSON();
        let result = new TelegramChannelFeedPost();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelFeedPost extends IBaseModel {
    telegramChannelSettings?: TelegramChannelSettings | undefined;
    telegramChannelSettingsId?: number;
    channelId?: number;
    messageId?: number;
    message?: string | undefined;
    externalPostedOrder?: ExternalPostedOrder | undefined;
    externalPostedOrderId?: number | undefined;
    internalOrderQuote?: OrderQuote | undefined;
    internalOrderQuoteId?: number | undefined;
    externalOrderBid?: ExternalOrderBid | undefined;
    externalOrderBidId?: number | undefined;
}

export class OrderQuote extends BaseModel implements IOrderQuote {
    rate?: number | undefined;
    visibility?: OrderQuoteVisibilityType;
    customer?: Customer | undefined;
    customerId?: number;
    status?: OrderQuoteStatus;
    vehicleType?: VehicleType;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpInside?: boolean;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryInside?: boolean;
    deliveryAddress?: string | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    overrideDriversPreferences?: boolean;
    order?: Order | undefined;
    orderId?: number | undefined;
    lastPostedAt?: moment.Moment | undefined;
    orderQuotePosts?: OrderQuotePost[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;

    constructor(data?: IOrderQuote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["Rate"];
            this.visibility = _data["Visibility"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.status = _data["Status"];
            this.vehicleType = _data["VehicleType"];
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpInside = _data["PickUpInside"];
            this.pickUpAddress = _data["PickUpAddress"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryInside = _data["DeliveryInside"];
            this.deliveryAddress = _data["DeliveryAddress"];
            this.miles = _data["Miles"];
            this.pieces = _data["Pieces"];
            this.weight = _data["Weight"];
            this.dims = _data["Dims"];
            this.notes = _data["Notes"];
            this.orderNumber = _data["OrderNumber"];
            this.dockLevel = _data["DockLevel"];
            this.hazardous = _data["Hazardous"];
            this.liftGate = _data["LiftGate"];
            this.palletJack = _data["PalletJack"];
            this.overrideDriversPreferences = _data["OverrideDriversPreferences"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.lastPostedAt = _data["LastPostedAt"] ? moment(_data["LastPostedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["OrderQuotePosts"])) {
                this.orderQuotePosts = [] as any;
                for (let item of _data["OrderQuotePosts"])
                    this.orderQuotePosts!.push(OrderQuotePost.fromJS(item));
            }
            if (Array.isArray(_data["ExternalOrderBids"])) {
                this.externalOrderBids = [] as any;
                for (let item of _data["ExternalOrderBids"])
                    this.externalOrderBids!.push(ExternalOrderBid.fromJS(item));
            }
            if (Array.isArray(_data["TelegramChannelFeedPosts"])) {
                this.telegramChannelFeedPosts = [] as any;
                for (let item of _data["TelegramChannelFeedPosts"])
                    this.telegramChannelFeedPosts!.push(TelegramChannelFeedPost.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OrderQuote {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rate"] = this.rate;
        data["Visibility"] = this.visibility;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["Status"] = this.status;
        data["VehicleType"] = this.vehicleType;
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpInside"] = this.pickUpInside;
        data["PickUpAddress"] = this.pickUpAddress;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryInside"] = this.deliveryInside;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["Miles"] = this.miles;
        data["Pieces"] = this.pieces;
        data["Weight"] = this.weight;
        data["Dims"] = this.dims;
        data["Notes"] = this.notes;
        data["OrderNumber"] = this.orderNumber;
        data["DockLevel"] = this.dockLevel;
        data["Hazardous"] = this.hazardous;
        data["LiftGate"] = this.liftGate;
        data["PalletJack"] = this.palletJack;
        data["OverrideDriversPreferences"] = this.overrideDriversPreferences;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["LastPostedAt"] = this.lastPostedAt ? this.lastPostedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.orderQuotePosts)) {
            data["OrderQuotePosts"] = [];
            for (let item of this.orderQuotePosts)
                data["OrderQuotePosts"].push(item.toJSON());
        }
        if (Array.isArray(this.externalOrderBids)) {
            data["ExternalOrderBids"] = [];
            for (let item of this.externalOrderBids)
                data["ExternalOrderBids"].push(item.toJSON());
        }
        if (Array.isArray(this.telegramChannelFeedPosts)) {
            data["TelegramChannelFeedPosts"] = [];
            for (let item of this.telegramChannelFeedPosts)
                data["TelegramChannelFeedPosts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrderQuote {
        const json = this.toJSON();
        let result = new OrderQuote();
        result.init(json);
        return result;
    }
}

export interface IOrderQuote extends IBaseModel {
    rate?: number | undefined;
    visibility?: OrderQuoteVisibilityType;
    customer?: Customer | undefined;
    customerId?: number;
    status?: OrderQuoteStatus;
    vehicleType?: VehicleType;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpInside?: boolean;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryInside?: boolean;
    deliveryAddress?: string | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    overrideDriversPreferences?: boolean;
    order?: Order | undefined;
    orderId?: number | undefined;
    lastPostedAt?: moment.Moment | undefined;
    orderQuotePosts?: OrderQuotePost[] | undefined;
    externalOrderBids?: ExternalOrderBid[] | undefined;
    telegramChannelFeedPosts?: TelegramChannelFeedPost[] | undefined;
}

/** 1 = All */
export enum OrderQuoteVisibilityType {
    All = 1,
}

/** 1 = Open 2 = Covered 3 = Canceled */
export enum OrderQuoteStatus {
    Open = 1,
    Covered = 2,
    Canceled = 3,
}

export class OrderQuotePost extends BaseModel implements IOrderQuotePost {
    expiredAt?: moment.Moment;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number;
    orderQuotePostVehicles?: OrderQuotePostVehicle[] | undefined;

    constructor(data?: IOrderQuotePost) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.expiredAt = _data["ExpiredAt"] ? moment(_data["ExpiredAt"].toString()) : <any>undefined;
            this.orderQuote = _data["OrderQuote"] ? OrderQuote.fromJS(_data["OrderQuote"]) : <any>undefined;
            this.orderQuoteId = _data["OrderQuoteId"];
            if (Array.isArray(_data["OrderQuotePostVehicles"])) {
                this.orderQuotePostVehicles = [] as any;
                for (let item of _data["OrderQuotePostVehicles"])
                    this.orderQuotePostVehicles!.push(OrderQuotePostVehicle.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OrderQuotePost {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuotePost();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExpiredAt"] = this.expiredAt ? this.expiredAt.toISOString() : <any>undefined;
        data["OrderQuote"] = this.orderQuote ? this.orderQuote.toJSON() : <any>undefined;
        data["OrderQuoteId"] = this.orderQuoteId;
        if (Array.isArray(this.orderQuotePostVehicles)) {
            data["OrderQuotePostVehicles"] = [];
            for (let item of this.orderQuotePostVehicles)
                data["OrderQuotePostVehicles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrderQuotePost {
        const json = this.toJSON();
        let result = new OrderQuotePost();
        result.init(json);
        return result;
    }
}

export interface IOrderQuotePost extends IBaseModel {
    expiredAt?: moment.Moment;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number;
    orderQuotePostVehicles?: OrderQuotePostVehicle[] | undefined;
}

export class OrderQuotePostVehicle extends BaseModel implements IOrderQuotePostVehicle {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    orderQuotePost?: OrderQuotePost | undefined;
    orderQuotePostId?: number;

    constructor(data?: IOrderQuotePostVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.orderQuotePost = _data["OrderQuotePost"] ? OrderQuotePost.fromJS(_data["OrderQuotePost"]) : <any>undefined;
            this.orderQuotePostId = _data["OrderQuotePostId"];
        }
    }

    static override fromJS(data: any): OrderQuotePostVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuotePostVehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["OrderQuotePost"] = this.orderQuotePost ? this.orderQuotePost.toJSON() : <any>undefined;
        data["OrderQuotePostId"] = this.orderQuotePostId;
        super.toJSON(data);
        return data;
    }

    clone(): OrderQuotePostVehicle {
        const json = this.toJSON();
        let result = new OrderQuotePostVehicle();
        result.init(json);
        return result;
    }
}

export interface IOrderQuotePostVehicle extends IBaseModel {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    orderQuotePost?: OrderQuotePost | undefined;
    orderQuotePostId?: number;
}

export class ExternalOrderBid extends BaseModel implements IExternalOrderBid {
    rate?: number;
    carrierRate?: number;
    rejectedWithRate?: number | undefined;
    miles?: number;
    weight?: number;
    dims?: string | undefined;
    pieces?: number;
    hazardous?: boolean;
    sentBy?: string | undefined;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    vehicleType?: string | undefined;
    customMessage?: string | undefined;
    milesOut?: number | undefined;
    orderNumber?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    postedByPhone?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryAddress?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number | undefined;
    postedOrder?: ExternalPostedOrder | undefined;
    postedOrderId?: number | undefined;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number | undefined;
    isBidSend?: boolean;
    order?: Order | undefined;
    orderId?: number | undefined;
    status?: ExternalOrderBidStatus;
    notes?: string | undefined;
    driverNotes?: string | undefined;
    telegramChannelFeedPost?: TelegramChannelFeedPost | undefined;
    pickUpLon?: number | undefined;
    pickUpLat?: number | undefined;
    vehicleLon?: number | undefined;
    vehicleLat?: number | undefined;

    constructor(data?: IExternalOrderBid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["Rate"];
            this.carrierRate = _data["CarrierRate"];
            this.rejectedWithRate = _data["RejectedWithRate"];
            this.miles = _data["Miles"];
            this.weight = _data["Weight"];
            this.dims = _data["Dims"];
            this.pieces = _data["Pieces"];
            this.hazardous = _data["Hazardous"];
            this.sentBy = _data["SentBy"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.vehicleType = _data["VehicleType"];
            this.customMessage = _data["CustomMessage"];
            this.milesOut = _data["MilesOut"];
            this.orderNumber = _data["OrderNumber"];
            this.postedBy = _data["PostedBy"];
            this.postedByEmail = _data["PostedByEmail"];
            this.postedByPhone = _data["PostedByPhone"];
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpAddress = _data["PickUpAddress"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryAddress = _data["DeliveryAddress"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
            this.customerId = _data["CustomerId"];
            this.postedOrder = _data["PostedOrder"] ? ExternalPostedOrder.fromJS(_data["PostedOrder"]) : <any>undefined;
            this.postedOrderId = _data["PostedOrderId"];
            this.orderQuote = _data["OrderQuote"] ? OrderQuote.fromJS(_data["OrderQuote"]) : <any>undefined;
            this.orderQuoteId = _data["OrderQuoteId"];
            this.isBidSend = _data["IsBidSend"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.status = _data["Status"];
            this.notes = _data["Notes"];
            this.driverNotes = _data["DriverNotes"];
            this.telegramChannelFeedPost = _data["TelegramChannelFeedPost"] ? TelegramChannelFeedPost.fromJS(_data["TelegramChannelFeedPost"]) : <any>undefined;
            this.pickUpLon = _data["PickUpLon"];
            this.pickUpLat = _data["PickUpLat"];
            this.vehicleLon = _data["VehicleLon"];
            this.vehicleLat = _data["VehicleLat"];
        }
    }

    static override fromJS(data: any): ExternalOrderBid {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalOrderBid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rate"] = this.rate;
        data["CarrierRate"] = this.carrierRate;
        data["RejectedWithRate"] = this.rejectedWithRate;
        data["Miles"] = this.miles;
        data["Weight"] = this.weight;
        data["Dims"] = this.dims;
        data["Pieces"] = this.pieces;
        data["Hazardous"] = this.hazardous;
        data["SentBy"] = this.sentBy;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["VehicleType"] = this.vehicleType;
        data["CustomMessage"] = this.customMessage;
        data["MilesOut"] = this.milesOut;
        data["OrderNumber"] = this.orderNumber;
        data["PostedBy"] = this.postedBy;
        data["PostedByEmail"] = this.postedByEmail;
        data["PostedByPhone"] = this.postedByPhone;
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpAddress"] = this.pickUpAddress;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CustomerId"] = this.customerId;
        data["PostedOrder"] = this.postedOrder ? this.postedOrder.toJSON() : <any>undefined;
        data["PostedOrderId"] = this.postedOrderId;
        data["OrderQuote"] = this.orderQuote ? this.orderQuote.toJSON() : <any>undefined;
        data["OrderQuoteId"] = this.orderQuoteId;
        data["IsBidSend"] = this.isBidSend;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["Status"] = this.status;
        data["Notes"] = this.notes;
        data["DriverNotes"] = this.driverNotes;
        data["TelegramChannelFeedPost"] = this.telegramChannelFeedPost ? this.telegramChannelFeedPost.toJSON() : <any>undefined;
        data["PickUpLon"] = this.pickUpLon;
        data["PickUpLat"] = this.pickUpLat;
        data["VehicleLon"] = this.vehicleLon;
        data["VehicleLat"] = this.vehicleLat;
        super.toJSON(data);
        return data;
    }

    clone(): ExternalOrderBid {
        const json = this.toJSON();
        let result = new ExternalOrderBid();
        result.init(json);
        return result;
    }
}

export interface IExternalOrderBid extends IBaseModel {
    rate?: number;
    carrierRate?: number;
    rejectedWithRate?: number | undefined;
    miles?: number;
    weight?: number;
    dims?: string | undefined;
    pieces?: number;
    hazardous?: boolean;
    sentBy?: string | undefined;
    vehicle?: Vehicle | undefined;
    vehicleId?: number | undefined;
    vehicleType?: string | undefined;
    customMessage?: string | undefined;
    milesOut?: number | undefined;
    orderNumber?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    postedByPhone?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryAddress?: string | undefined;
    customer?: Customer | undefined;
    customerId?: number | undefined;
    postedOrder?: ExternalPostedOrder | undefined;
    postedOrderId?: number | undefined;
    orderQuote?: OrderQuote | undefined;
    orderQuoteId?: number | undefined;
    isBidSend?: boolean;
    order?: Order | undefined;
    orderId?: number | undefined;
    status?: ExternalOrderBidStatus;
    notes?: string | undefined;
    driverNotes?: string | undefined;
    telegramChannelFeedPost?: TelegramChannelFeedPost | undefined;
    pickUpLon?: number | undefined;
    pickUpLat?: number | undefined;
    vehicleLon?: number | undefined;
    vehicleLat?: number | undefined;
}

export class OrderFeedSettings implements IOrderFeedSettings {
    vehicleTypeFilters?: string[] | undefined;

    constructor(data?: IOrderFeedSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["VehicleTypeFilters"])) {
                this.vehicleTypeFilters = [] as any;
                for (let item of _data["VehicleTypeFilters"])
                    this.vehicleTypeFilters!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderFeedSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFeedSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicleTypeFilters)) {
            data["VehicleTypeFilters"] = [];
            for (let item of this.vehicleTypeFilters)
                data["VehicleTypeFilters"].push(item);
        }
        return data;
    }

    clone(): OrderFeedSettings {
        const json = this.toJSON();
        let result = new OrderFeedSettings();
        result.init(json);
        return result;
    }
}

export interface IOrderFeedSettings {
    vehicleTypeFilters?: string[] | undefined;
}

export class DriverRatingNote extends BaseModel implements IDriverRatingNote {
    licenceNumber?: string | undefined;
    state?: string | undefined;
    orderId?: number;
    order?: Order | undefined;
    carrierId?: number;
    carrier?: Carrier | undefined;
    note?: string | undefined;
    type?: CarrierRatingNoteType;

    constructor(data?: IDriverRatingNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenceNumber = _data["LicenceNumber"];
            this.state = _data["State"];
            this.orderId = _data["OrderId"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.note = _data["Note"];
            this.type = _data["Type"];
        }
    }

    static override fromJS(data: any): DriverRatingNote {
        data = typeof data === 'object' ? data : {};
        let result = new DriverRatingNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenceNumber"] = this.licenceNumber;
        data["State"] = this.state;
        data["OrderId"] = this.orderId;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["Note"] = this.note;
        data["Type"] = this.type;
        super.toJSON(data);
        return data;
    }

    clone(): DriverRatingNote {
        const json = this.toJSON();
        let result = new DriverRatingNote();
        result.init(json);
        return result;
    }
}

export interface IDriverRatingNote extends IBaseModel {
    licenceNumber?: string | undefined;
    state?: string | undefined;
    orderId?: number;
    order?: Order | undefined;
    carrierId?: number;
    carrier?: Carrier | undefined;
    note?: string | undefined;
    type?: CarrierRatingNoteType;
}

export class OrderPayoutDriverCompensation extends BaseModel implements IOrderPayoutDriverCompensation {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    driver?: Driver | undefined;
    driverId?: number;
    type?: OrderPayoutDriverCompensationType;
    description?: string | undefined;
    payoutAccountTransaction?: PayoutAccountTransaction | undefined;
    payoutAccountTransactionId?: number | undefined;

    constructor(data?: IOrderPayoutDriverCompensation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderPayoutSummary = _data["OrderPayoutSummary"] ? OrderPayoutSummary.fromJS(_data["OrderPayoutSummary"]) : <any>undefined;
            this.orderPayoutSummaryId = _data["OrderPayoutSummaryId"];
            this.amount = _data["Amount"];
            this.driver = _data["Driver"] ? Driver.fromJS(_data["Driver"]) : <any>undefined;
            this.driverId = _data["DriverId"];
            this.type = _data["Type"];
            this.description = _data["Description"];
            this.payoutAccountTransaction = _data["PayoutAccountTransaction"] ? PayoutAccountTransaction.fromJS(_data["PayoutAccountTransaction"]) : <any>undefined;
            this.payoutAccountTransactionId = _data["PayoutAccountTransactionId"];
        }
    }

    static override fromJS(data: any): OrderPayoutDriverCompensation {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPayoutDriverCompensation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderPayoutSummary"] = this.orderPayoutSummary ? this.orderPayoutSummary.toJSON() : <any>undefined;
        data["OrderPayoutSummaryId"] = this.orderPayoutSummaryId;
        data["Amount"] = this.amount;
        data["Driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["DriverId"] = this.driverId;
        data["Type"] = this.type;
        data["Description"] = this.description;
        data["PayoutAccountTransaction"] = this.payoutAccountTransaction ? this.payoutAccountTransaction.toJSON() : <any>undefined;
        data["PayoutAccountTransactionId"] = this.payoutAccountTransactionId;
        super.toJSON(data);
        return data;
    }

    clone(): OrderPayoutDriverCompensation {
        const json = this.toJSON();
        let result = new OrderPayoutDriverCompensation();
        result.init(json);
        return result;
    }
}

export interface IOrderPayoutDriverCompensation extends IBaseModel {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    driver?: Driver | undefined;
    driverId?: number;
    type?: OrderPayoutDriverCompensationType;
    description?: string | undefined;
    payoutAccountTransaction?: PayoutAccountTransaction | undefined;
    payoutAccountTransactionId?: number | undefined;
}

export class OrderPayoutSummary implements IOrderPayoutSummary {
    order?: Order | undefined;
    orderId?: number;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    closedDate?: moment.Moment | undefined;
    rate?: number;
    factoring?: number;
    compensation?: number;
    expenses?: number;
    profit?: number;
    driverCompensations?: OrderPayoutDriverCompensation[] | undefined;
    carrierCompensations?: OrderPayoutCarrierCompensation[] | undefined;
    orderExpenses?: OrderExpense[] | undefined;

    constructor(data?: IOrderPayoutSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.closedDate = _data["ClosedDate"] ? moment(_data["ClosedDate"].toString()) : <any>undefined;
            this.rate = _data["Rate"];
            this.factoring = _data["Factoring"];
            this.compensation = _data["Compensation"];
            this.expenses = _data["Expenses"];
            this.profit = _data["Profit"];
            if (Array.isArray(_data["DriverCompensations"])) {
                this.driverCompensations = [] as any;
                for (let item of _data["DriverCompensations"])
                    this.driverCompensations!.push(OrderPayoutDriverCompensation.fromJS(item));
            }
            if (Array.isArray(_data["CarrierCompensations"])) {
                this.carrierCompensations = [] as any;
                for (let item of _data["CarrierCompensations"])
                    this.carrierCompensations!.push(OrderPayoutCarrierCompensation.fromJS(item));
            }
            if (Array.isArray(_data["OrderExpenses"])) {
                this.orderExpenses = [] as any;
                for (let item of _data["OrderExpenses"])
                    this.orderExpenses!.push(OrderExpense.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderPayoutSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPayoutSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["ClosedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["Rate"] = this.rate;
        data["Factoring"] = this.factoring;
        data["Compensation"] = this.compensation;
        data["Expenses"] = this.expenses;
        data["Profit"] = this.profit;
        if (Array.isArray(this.driverCompensations)) {
            data["DriverCompensations"] = [];
            for (let item of this.driverCompensations)
                data["DriverCompensations"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierCompensations)) {
            data["CarrierCompensations"] = [];
            for (let item of this.carrierCompensations)
                data["CarrierCompensations"].push(item.toJSON());
        }
        if (Array.isArray(this.orderExpenses)) {
            data["OrderExpenses"] = [];
            for (let item of this.orderExpenses)
                data["OrderExpenses"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderPayoutSummary {
        const json = this.toJSON();
        let result = new OrderPayoutSummary();
        result.init(json);
        return result;
    }
}

export interface IOrderPayoutSummary {
    order?: Order | undefined;
    orderId?: number;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    closedDate?: moment.Moment | undefined;
    rate?: number;
    factoring?: number;
    compensation?: number;
    expenses?: number;
    profit?: number;
    driverCompensations?: OrderPayoutDriverCompensation[] | undefined;
    carrierCompensations?: OrderPayoutCarrierCompensation[] | undefined;
    orderExpenses?: OrderExpense[] | undefined;
}

export class OrderPayoutCarrierCompensation extends BaseModel implements IOrderPayoutCarrierCompensation {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    carrier?: Carrier | undefined;
    carrierId?: number;
    description?: string | undefined;
    payoutAccountTransaction?: PayoutAccountTransaction | undefined;
    payoutAccountTransactionId?: number | undefined;

    constructor(data?: IOrderPayoutCarrierCompensation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderPayoutSummary = _data["OrderPayoutSummary"] ? OrderPayoutSummary.fromJS(_data["OrderPayoutSummary"]) : <any>undefined;
            this.orderPayoutSummaryId = _data["OrderPayoutSummaryId"];
            this.amount = _data["Amount"];
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.description = _data["Description"];
            this.payoutAccountTransaction = _data["PayoutAccountTransaction"] ? PayoutAccountTransaction.fromJS(_data["PayoutAccountTransaction"]) : <any>undefined;
            this.payoutAccountTransactionId = _data["PayoutAccountTransactionId"];
        }
    }

    static override fromJS(data: any): OrderPayoutCarrierCompensation {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPayoutCarrierCompensation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderPayoutSummary"] = this.orderPayoutSummary ? this.orderPayoutSummary.toJSON() : <any>undefined;
        data["OrderPayoutSummaryId"] = this.orderPayoutSummaryId;
        data["Amount"] = this.amount;
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["Description"] = this.description;
        data["PayoutAccountTransaction"] = this.payoutAccountTransaction ? this.payoutAccountTransaction.toJSON() : <any>undefined;
        data["PayoutAccountTransactionId"] = this.payoutAccountTransactionId;
        super.toJSON(data);
        return data;
    }

    clone(): OrderPayoutCarrierCompensation {
        const json = this.toJSON();
        let result = new OrderPayoutCarrierCompensation();
        result.init(json);
        return result;
    }
}

export interface IOrderPayoutCarrierCompensation extends IBaseModel {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    carrier?: Carrier | undefined;
    carrierId?: number;
    description?: string | undefined;
    payoutAccountTransaction?: PayoutAccountTransaction | undefined;
    payoutAccountTransactionId?: number | undefined;
}

export class PayoutAccountTransaction extends BaseModel implements IPayoutAccountTransaction {
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number;
    paidDate?: moment.Moment | undefined;
    payoutAmount?: number;
    driverCompensations?: OrderPayoutDriverCompensation[] | undefined;
    carrierCompensations?: OrderPayoutCarrierCompensation[] | undefined;

    constructor(data?: IPayoutAccountTransaction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payoutAccount = _data["PayoutAccount"] ? PayoutAccount.fromJS(_data["PayoutAccount"]) : <any>undefined;
            this.payoutAccountId = _data["PayoutAccountId"];
            this.paidDate = _data["PaidDate"] ? moment(_data["PaidDate"].toString()) : <any>undefined;
            this.payoutAmount = _data["PayoutAmount"];
            if (Array.isArray(_data["DriverCompensations"])) {
                this.driverCompensations = [] as any;
                for (let item of _data["DriverCompensations"])
                    this.driverCompensations!.push(OrderPayoutDriverCompensation.fromJS(item));
            }
            if (Array.isArray(_data["CarrierCompensations"])) {
                this.carrierCompensations = [] as any;
                for (let item of _data["CarrierCompensations"])
                    this.carrierCompensations!.push(OrderPayoutCarrierCompensation.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PayoutAccountTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountTransaction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PayoutAccount"] = this.payoutAccount ? this.payoutAccount.toJSON() : <any>undefined;
        data["PayoutAccountId"] = this.payoutAccountId;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["PayoutAmount"] = this.payoutAmount;
        if (Array.isArray(this.driverCompensations)) {
            data["DriverCompensations"] = [];
            for (let item of this.driverCompensations)
                data["DriverCompensations"].push(item.toJSON());
        }
        if (Array.isArray(this.carrierCompensations)) {
            data["CarrierCompensations"] = [];
            for (let item of this.carrierCompensations)
                data["CarrierCompensations"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): PayoutAccountTransaction {
        const json = this.toJSON();
        let result = new PayoutAccountTransaction();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountTransaction extends IBaseModel {
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number;
    paidDate?: moment.Moment | undefined;
    payoutAmount?: number;
    driverCompensations?: OrderPayoutDriverCompensation[] | undefined;
    carrierCompensations?: OrderPayoutCarrierCompensation[] | undefined;
}

export class OrderExpense extends BaseModel implements IOrderExpense {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    type?: OrderExpenseType;
    description?: string | undefined;

    constructor(data?: IOrderExpense) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderPayoutSummary = _data["OrderPayoutSummary"] ? OrderPayoutSummary.fromJS(_data["OrderPayoutSummary"]) : <any>undefined;
            this.orderPayoutSummaryId = _data["OrderPayoutSummaryId"];
            this.amount = _data["Amount"];
            this.type = _data["Type"];
            this.description = _data["Description"];
        }
    }

    static override fromJS(data: any): OrderExpense {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExpense();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderPayoutSummary"] = this.orderPayoutSummary ? this.orderPayoutSummary.toJSON() : <any>undefined;
        data["OrderPayoutSummaryId"] = this.orderPayoutSummaryId;
        data["Amount"] = this.amount;
        data["Type"] = this.type;
        data["Description"] = this.description;
        super.toJSON(data);
        return data;
    }

    clone(): OrderExpense {
        const json = this.toJSON();
        let result = new OrderExpense();
        result.init(json);
        return result;
    }
}

export interface IOrderExpense extends IBaseModel {
    orderPayoutSummary?: OrderPayoutSummary | undefined;
    orderPayoutSummaryId?: number;
    amount?: number;
    type?: OrderExpenseType;
    description?: string | undefined;
}

/** 1 = Diesel 2 = Tolls 3 = Other */
export enum OrderExpenseType {
    Diesel = 1,
    Tolls = 2,
    Other = 3,
}

/** 1 = Compensation 2 = Detantion 3 = Other */
export enum OrderPayoutDriverCompensationType {
    Compensation = 1,
    Detantion = 2,
    Other = 3,
}

export class PayoutAccountBalanceAdjustment extends BaseModel implements IPayoutAccountBalanceAdjustment {
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number;
    amount?: number;
    description?: string | undefined;

    constructor(data?: IPayoutAccountBalanceAdjustment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payoutAccount = _data["PayoutAccount"] ? PayoutAccount.fromJS(_data["PayoutAccount"]) : <any>undefined;
            this.payoutAccountId = _data["PayoutAccountId"];
            this.amount = _data["Amount"];
            this.description = _data["Description"];
        }
    }

    static override fromJS(data: any): PayoutAccountBalanceAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountBalanceAdjustment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PayoutAccount"] = this.payoutAccount ? this.payoutAccount.toJSON() : <any>undefined;
        data["PayoutAccountId"] = this.payoutAccountId;
        data["Amount"] = this.amount;
        data["Description"] = this.description;
        super.toJSON(data);
        return data;
    }

    clone(): PayoutAccountBalanceAdjustment {
        const json = this.toJSON();
        let result = new PayoutAccountBalanceAdjustment();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountBalanceAdjustment extends IBaseModel {
    payoutAccount?: PayoutAccount | undefined;
    payoutAccountId?: number;
    amount?: number;
    description?: string | undefined;
}

export class FileCarrier extends File implements IFileCarrier {
    carrier?: Carrier | undefined;

    constructor(data?: IFileCarrier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new FileCarrier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileCarrier {
        const json = this.toJSON();
        let result = new FileCarrier();
        result.init(json);
        return result;
    }
}

export interface IFileCarrier extends IFile {
    carrier?: Carrier | undefined;
}

export class NotesCarrier extends Notes implements INotesCarrier {
    carrier?: Carrier | undefined;

    constructor(data?: INotesCarrier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotesCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new NotesCarrier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NotesCarrier {
        const json = this.toJSON();
        let result = new NotesCarrier();
        result.init(json);
        return result;
    }
}

export interface INotesCarrier extends INotes {
    carrier?: Carrier | undefined;
}

export class CarrierRatingNote extends BaseModel implements ICarrierRatingNote {
    carrier?: Carrier | undefined;
    carrierId?: number;
    orderId?: number;
    order?: Order | undefined;
    note?: string | undefined;
    type?: CarrierRatingNoteType;

    constructor(data?: ICarrierRatingNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.orderId = _data["OrderId"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.note = _data["Note"];
            this.type = _data["Type"];
        }
    }

    static override fromJS(data: any): CarrierRatingNote {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierRatingNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["OrderId"] = this.orderId;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["Note"] = this.note;
        data["Type"] = this.type;
        super.toJSON(data);
        return data;
    }

    clone(): CarrierRatingNote {
        const json = this.toJSON();
        let result = new CarrierRatingNote();
        result.init(json);
        return result;
    }
}

export interface ICarrierRatingNote extends IBaseModel {
    carrier?: Carrier | undefined;
    carrierId?: number;
    orderId?: number;
    order?: Order | undefined;
    note?: string | undefined;
    type?: CarrierRatingNoteType;
}

export class CarrierRating extends BaseModel implements ICarrierRating {
    carrier?: Carrier | undefined;
    carrierId?: number;
    orderId?: number;
    order?: Order | undefined;
    vehicleId?: number | undefined;
    vehicle?: Vehicle | undefined;
    pickUpOnTime?: boolean;
    deliverOnTime?: boolean;
    communicationOnTime?: boolean;
    trackingUpdate?: boolean;
    failToDeliver?: boolean;

    constructor(data?: ICarrierRating) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.orderId = _data["OrderId"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.pickUpOnTime = _data["PickUpOnTime"];
            this.deliverOnTime = _data["DeliverOnTime"];
            this.communicationOnTime = _data["CommunicationOnTime"];
            this.trackingUpdate = _data["TrackingUpdate"];
            this.failToDeliver = _data["FailToDeliver"];
        }
    }

    static override fromJS(data: any): CarrierRating {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierRating();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["OrderId"] = this.orderId;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["PickUpOnTime"] = this.pickUpOnTime;
        data["DeliverOnTime"] = this.deliverOnTime;
        data["CommunicationOnTime"] = this.communicationOnTime;
        data["TrackingUpdate"] = this.trackingUpdate;
        data["FailToDeliver"] = this.failToDeliver;
        super.toJSON(data);
        return data;
    }

    clone(): CarrierRating {
        const json = this.toJSON();
        let result = new CarrierRating();
        result.init(json);
        return result;
    }
}

export interface ICarrierRating extends IBaseModel {
    carrier?: Carrier | undefined;
    carrierId?: number;
    orderId?: number;
    order?: Order | undefined;
    vehicleId?: number | undefined;
    vehicle?: Vehicle | undefined;
    pickUpOnTime?: boolean;
    deliverOnTime?: boolean;
    communicationOnTime?: boolean;
    trackingUpdate?: boolean;
    failToDeliver?: boolean;
}

export class OwnerAccount extends BaseModel implements IOwnerAccount {
    name?: string | undefined;
    email?: string | undefined;
    externalId?: string | undefined;
    vehicles?: Vehicle[] | undefined;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    status?: TenantOwnerStatus;

    constructor(data?: IOwnerAccount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.externalId = _data["ExternalId"];
            if (Array.isArray(_data["Vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["Vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            this.carrier = _data["Carrier"] ? Carrier.fromJS(_data["Carrier"]) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.status = _data["Status"];
        }
    }

    static override fromJS(data: any): OwnerAccount {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccount();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["ExternalId"] = this.externalId;
        if (Array.isArray(this.vehicles)) {
            data["Vehicles"] = [];
            for (let item of this.vehicles)
                data["Vehicles"].push(item.toJSON());
        }
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["Status"] = this.status;
        super.toJSON(data);
        return data;
    }

    clone(): OwnerAccount {
        const json = this.toJSON();
        let result = new OwnerAccount();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccount extends IBaseModel {
    name?: string | undefined;
    email?: string | undefined;
    externalId?: string | undefined;
    vehicles?: Vehicle[] | undefined;
    carrier?: Carrier | undefined;
    carrierId?: number | undefined;
    status?: TenantOwnerStatus;
}

/** 1 = Active 2 = Inactive 3 = Suspended 4 = InfoRequested 5 = Invited */
export enum TenantOwnerStatus {
    Active = 1,
    Inactive = 2,
    Suspended = 3,
    InfoRequested = 4,
    Invited = 5,
}

export class VehicleTrackingDetails extends BaseModel implements IVehicleTrackingDetails {
    lat?: number | undefined;
    lon?: number | undefined;
    bearing?: number;
    odometer?: number;
    fuel?: number;
    engineHours?: number;
    description?: string | undefined;
    speed?: number;
    vehicle?: Vehicle | undefined;
    vehicleId?: number;

    constructor(data?: IVehicleTrackingDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.bearing = _data["Bearing"];
            this.odometer = _data["Odometer"];
            this.fuel = _data["Fuel"];
            this.engineHours = _data["EngineHours"];
            this.description = _data["Description"];
            this.speed = _data["Speed"];
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
        }
    }

    static override fromJS(data: any): VehicleTrackingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTrackingDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["Bearing"] = this.bearing;
        data["Odometer"] = this.odometer;
        data["Fuel"] = this.fuel;
        data["EngineHours"] = this.engineHours;
        data["Description"] = this.description;
        data["Speed"] = this.speed;
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        super.toJSON(data);
        return data;
    }

    clone(): VehicleTrackingDetails {
        const json = this.toJSON();
        let result = new VehicleTrackingDetails();
        result.init(json);
        return result;
    }
}

export interface IVehicleTrackingDetails extends IBaseModel {
    lat?: number | undefined;
    lon?: number | undefined;
    bearing?: number;
    odometer?: number;
    fuel?: number;
    engineHours?: number;
    description?: string | undefined;
    speed?: number;
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
}

export class VehicleAvailabilitySettings extends BaseModel implements IVehicleAvailabilitySettings {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    partial?: boolean;
    status?: VehicleAvailabilityStatus;
    availableAt?: moment.Moment | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number;
    note?: string | undefined;
    statesJSON?: string | undefined;
    states?: string[] | undefined;

    constructor(data?: IVehicleAvailabilitySettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.partial = _data["Partial"];
            this.status = _data["Status"];
            this.availableAt = _data["AvailableAt"] ? moment(_data["AvailableAt"].toString()) : <any>undefined;
            this.maxMiles = _data["MaxMiles"];
            this.pickUpRadius = _data["PickUpRadius"];
            this.note = _data["Note"];
            this.statesJSON = _data["StatesJSON"];
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(item);
            }
        }
    }

    static override fromJS(data: any): VehicleAvailabilitySettings {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAvailabilitySettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["Partial"] = this.partial;
        data["Status"] = this.status;
        data["AvailableAt"] = this.availableAt ? this.availableAt.toISOString() : <any>undefined;
        data["MaxMiles"] = this.maxMiles;
        data["PickUpRadius"] = this.pickUpRadius;
        data["Note"] = this.note;
        data["StatesJSON"] = this.statesJSON;
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): VehicleAvailabilitySettings {
        const json = this.toJSON();
        let result = new VehicleAvailabilitySettings();
        result.init(json);
        return result;
    }
}

export interface IVehicleAvailabilitySettings extends IBaseModel {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    partial?: boolean;
    status?: VehicleAvailabilityStatus;
    availableAt?: moment.Moment | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number;
    note?: string | undefined;
    statesJSON?: string | undefined;
    states?: string[] | undefined;
}

/** 1 = Available 2 = Broken 3 = Unavailable */
export enum VehicleAvailabilityStatus {
    Available = 1,
    Broken = 2,
    Unavailable = 3,
}

export class FileVehicle extends File implements IFileVehicle {
    vehicle?: Vehicle | undefined;

    constructor(data?: IFileVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new FileVehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileVehicle {
        const json = this.toJSON();
        let result = new FileVehicle();
        result.init(json);
        return result;
    }
}

export interface IFileVehicle extends IFile {
    vehicle?: Vehicle | undefined;
}

export class NotesVehicle extends Notes implements INotesVehicle {
    vehicle?: Vehicle | undefined;

    constructor(data?: INotesVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotesVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new NotesVehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NotesVehicle {
        const json = this.toJSON();
        let result = new NotesVehicle();
        result.init(json);
        return result;
    }
}

export interface INotesVehicle extends INotes {
    vehicle?: Vehicle | undefined;
}

export class VehicleTrackingHistory extends BaseModel implements IVehicleTrackingHistory {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    lat?: number;
    lon?: number;
    description?: string | undefined;
    speed?: number;
    distance?: number;

    constructor(data?: IVehicleTrackingHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.description = _data["Description"];
            this.speed = _data["Speed"];
            this.distance = _data["Distance"];
        }
    }

    static override fromJS(data: any): VehicleTrackingHistory {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTrackingHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["Description"] = this.description;
        data["Speed"] = this.speed;
        data["Distance"] = this.distance;
        super.toJSON(data);
        return data;
    }

    clone(): VehicleTrackingHistory {
        const json = this.toJSON();
        let result = new VehicleTrackingHistory();
        result.init(json);
        return result;
    }
}

export interface IVehicleTrackingHistory extends IBaseModel {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    lat?: number;
    lon?: number;
    description?: string | undefined;
    speed?: number;
    distance?: number;
}

export class ExternalPostedOrderVehicle extends BaseModel implements IExternalPostedOrderVehicle {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    externalPostedOrder?: ExternalPostedOrder | undefined;
    externalPostedOrderId?: number;

    constructor(data?: IExternalPostedOrderVehicle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicle = _data["Vehicle"] ? Vehicle.fromJS(_data["Vehicle"]) : <any>undefined;
            this.vehicleId = _data["VehicleId"];
            this.externalPostedOrder = _data["ExternalPostedOrder"] ? ExternalPostedOrder.fromJS(_data["ExternalPostedOrder"]) : <any>undefined;
            this.externalPostedOrderId = _data["ExternalPostedOrderId"];
        }
    }

    static override fromJS(data: any): ExternalPostedOrderVehicle {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPostedOrderVehicle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["VehicleId"] = this.vehicleId;
        data["ExternalPostedOrder"] = this.externalPostedOrder ? this.externalPostedOrder.toJSON() : <any>undefined;
        data["ExternalPostedOrderId"] = this.externalPostedOrderId;
        super.toJSON(data);
        return data;
    }

    clone(): ExternalPostedOrderVehicle {
        const json = this.toJSON();
        let result = new ExternalPostedOrderVehicle();
        result.init(json);
        return result;
    }
}

export interface IExternalPostedOrderVehicle extends IBaseModel {
    vehicle?: Vehicle | undefined;
    vehicleId?: number;
    externalPostedOrder?: ExternalPostedOrder | undefined;
    externalPostedOrderId?: number;
}

/** 1 = Draft 2 = Ready 3 = InProgress 4 = Canceled 5 = Completed 6 = OnHold 7 = Closed */
export enum OrderStatus {
    Draft = 1,
    Ready = 2,
    InProgress = 3,
    Canceled = 4,
    Completed = 5,
    OnHold = 6,
    Closed = 7,
}

export class OrderCustomerExternalLink extends BaseModel implements IOrderCustomerExternalLink {
    order?: Order | undefined;
    orderId?: number;
    link?: string | undefined;
    expireAt?: moment.Moment;

    constructor(data?: IOrderCustomerExternalLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.link = _data["Link"];
            this.expireAt = _data["ExpireAt"] ? moment(_data["ExpireAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderCustomerExternalLink {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCustomerExternalLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["Link"] = this.link;
        data["ExpireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): OrderCustomerExternalLink {
        const json = this.toJSON();
        let result = new OrderCustomerExternalLink();
        result.init(json);
        return result;
    }
}

export interface IOrderCustomerExternalLink extends IBaseModel {
    order?: Order | undefined;
    orderId?: number;
    link?: string | undefined;
    expireAt?: moment.Moment;
}

export class FileOrder extends File implements IFileOrder {
    order?: Order | undefined;

    constructor(data?: IFileOrder) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileOrder {
        data = typeof data === 'object' ? data : {};
        let result = new FileOrder();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileOrder {
        const json = this.toJSON();
        let result = new FileOrder();
        result.init(json);
        return result;
    }
}

export interface IFileOrder extends IFile {
    order?: Order | undefined;
}

export class NotesOrder extends Notes implements INotesOrder {
    order?: Order | undefined;

    constructor(data?: INotesOrder) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotesOrder {
        data = typeof data === 'object' ? data : {};
        let result = new NotesOrder();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NotesOrder {
        const json = this.toJSON();
        let result = new NotesOrder();
        result.init(json);
        return result;
    }
}

export interface INotesOrder extends INotes {
    order?: Order | undefined;
}

export class OrderLogs extends BaseModel implements IOrderLogs {
    log?: string | undefined;
    content?: OrderLogContentOfIOrderLogContent | undefined;
    order?: Order | undefined;
    orderId?: number;
    createdBy?: string | undefined;

    constructor(data?: IOrderLogs) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.log = _data["Log"];
            this.content = _data["Content"] ? OrderLogContentOfIOrderLogContent.fromJS(_data["Content"]) : <any>undefined;
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.createdBy = _data["CreatedBy"];
        }
    }

    static override fromJS(data: any): OrderLogs {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLogs();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Log"] = this.log;
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["CreatedBy"] = this.createdBy;
        super.toJSON(data);
        return data;
    }

    clone(): OrderLogs {
        const json = this.toJSON();
        let result = new OrderLogs();
        result.init(json);
        return result;
    }
}

export interface IOrderLogs extends IBaseModel {
    log?: string | undefined;
    content?: OrderLogContentOfIOrderLogContent | undefined;
    order?: Order | undefined;
    orderId?: number;
    createdBy?: string | undefined;
}

export class OrderLogContentOfIOrderLogContent implements IOrderLogContentOfIOrderLogContent {
    type?: OrderLogContentType;
    content?: IOrderLogContent | undefined;

    constructor(data?: IOrderLogContentOfIOrderLogContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.content = _data["Content"] ? IOrderLogContent.fromJS(_data["Content"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderLogContentOfIOrderLogContent {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLogContentOfIOrderLogContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderLogContentOfIOrderLogContent {
        const json = this.toJSON();
        let result = new OrderLogContentOfIOrderLogContent();
        result.init(json);
        return result;
    }
}

export interface IOrderLogContentOfIOrderLogContent {
    type?: OrderLogContentType;
    content?: IOrderLogContent | undefined;
}

/** 2 = UpdateDrivers 3 = UpdateVehicle 4 = UpdateOrderNotes 5 = UpdateOrderNumber */
export enum OrderLogContentType {
    UpdateDrivers = 2,
    UpdateVehicle = 3,
    UpdateOrderNotes = 4,
    UpdateOrderNumber = 5,
}

export abstract class IOrderLogContent implements IIOrderLogContent {

    constructor(data?: IIOrderLogContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IOrderLogContent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IOrderLogContent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IOrderLogContent {
        throw new Error("The abstract class 'IOrderLogContent' cannot be instantiated.");
    }
}

export interface IIOrderLogContent {
}

export class OrderStop extends BaseModel implements IOrderStop {
    type?: OrderStopType;
    orderStopAddress?: OrderStopAddress | undefined;
    orderStopAddressId?: number | undefined;
    description?: string | undefined;
    date?: moment.Moment;
    dateEnd?: moment.Moment | undefined;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    notifiedOn?: number | undefined;
    notifiedAt?: moment.Moment | undefined;
    files?: FileOrderStop[] | undefined;
    order?: Order | undefined;
    orderId?: number;
    pickUpCargoItems?: OrderCargoItem[] | undefined;
    deliveryCargoItems?: OrderCargoItem[] | undefined;

    constructor(data?: IOrderStop) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["Type"];
            this.orderStopAddress = _data["OrderStopAddress"] ? OrderStopAddress.fromJS(_data["OrderStopAddress"]) : <any>undefined;
            this.orderStopAddressId = _data["OrderStopAddressId"];
            this.description = _data["Description"];
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.dateEnd = _data["DateEnd"] ? moment(_data["DateEnd"].toString()) : <any>undefined;
            this.isDirectOrASAP = _data["IsDirectOrASAP"];
            this.pOCName = _data["POCName"];
            this.pOCPhone = _data["POCPhone"];
            this.arrived = _data["Arrived"] ? moment(_data["Arrived"].toString()) : <any>undefined;
            this.departed = _data["Departed"] ? moment(_data["Departed"].toString()) : <any>undefined;
            this.notifiedOn = _data["NotifiedOn"];
            this.notifiedAt = _data["NotifiedAt"] ? moment(_data["NotifiedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(FileOrderStop.fromJS(item));
            }
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            if (Array.isArray(_data["PickUpCargoItems"])) {
                this.pickUpCargoItems = [] as any;
                for (let item of _data["PickUpCargoItems"])
                    this.pickUpCargoItems!.push(OrderCargoItem.fromJS(item));
            }
            if (Array.isArray(_data["DeliveryCargoItems"])) {
                this.deliveryCargoItems = [] as any;
                for (let item of _data["DeliveryCargoItems"])
                    this.deliveryCargoItems!.push(OrderCargoItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OrderStop {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStop();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["OrderStopAddress"] = this.orderStopAddress ? this.orderStopAddress.toJSON() : <any>undefined;
        data["OrderStopAddressId"] = this.orderStopAddressId;
        data["Description"] = this.description;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["DateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["IsDirectOrASAP"] = this.isDirectOrASAP;
        data["POCName"] = this.pOCName;
        data["POCPhone"] = this.pOCPhone;
        data["Arrived"] = this.arrived ? this.arrived.toISOString() : <any>undefined;
        data["Departed"] = this.departed ? this.departed.toISOString() : <any>undefined;
        data["NotifiedOn"] = this.notifiedOn;
        data["NotifiedAt"] = this.notifiedAt ? this.notifiedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item.toJSON());
        }
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        if (Array.isArray(this.pickUpCargoItems)) {
            data["PickUpCargoItems"] = [];
            for (let item of this.pickUpCargoItems)
                data["PickUpCargoItems"].push(item.toJSON());
        }
        if (Array.isArray(this.deliveryCargoItems)) {
            data["DeliveryCargoItems"] = [];
            for (let item of this.deliveryCargoItems)
                data["DeliveryCargoItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrderStop {
        const json = this.toJSON();
        let result = new OrderStop();
        result.init(json);
        return result;
    }
}

export interface IOrderStop extends IBaseModel {
    type?: OrderStopType;
    orderStopAddress?: OrderStopAddress | undefined;
    orderStopAddressId?: number | undefined;
    description?: string | undefined;
    date?: moment.Moment;
    dateEnd?: moment.Moment | undefined;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    notifiedOn?: number | undefined;
    notifiedAt?: moment.Moment | undefined;
    files?: FileOrderStop[] | undefined;
    order?: Order | undefined;
    orderId?: number;
    pickUpCargoItems?: OrderCargoItem[] | undefined;
    deliveryCargoItems?: OrderCargoItem[] | undefined;
}

/** 1 = Shipper 2 = Consignee */
export enum OrderStopType {
    Shipper = 1,
    Consignee = 2,
}

export class OrderStopAddress extends AddressBase implements IOrderStopAddress {
    type?: OrderStopType;
    lon?: number | undefined;
    lat?: number | undefined;
    orderStops?: OrderStop[] | undefined;

    constructor(data?: IOrderStopAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["Type"];
            this.lon = _data["Lon"];
            this.lat = _data["Lat"];
            if (Array.isArray(_data["OrderStops"])) {
                this.orderStops = [] as any;
                for (let item of _data["OrderStops"])
                    this.orderStops!.push(OrderStop.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OrderStopAddress {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopAddress();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Lon"] = this.lon;
        data["Lat"] = this.lat;
        if (Array.isArray(this.orderStops)) {
            data["OrderStops"] = [];
            for (let item of this.orderStops)
                data["OrderStops"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrderStopAddress {
        const json = this.toJSON();
        let result = new OrderStopAddress();
        result.init(json);
        return result;
    }
}

export interface IOrderStopAddress extends IAddressBase {
    type?: OrderStopType;
    lon?: number | undefined;
    lat?: number | undefined;
    orderStops?: OrderStop[] | undefined;
}

export class FileOrderStop extends File implements IFileOrderStop {
    order?: OrderStop | undefined;

    constructor(data?: IFileOrderStop) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["Order"] ? OrderStop.fromJS(_data["Order"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileOrderStop {
        data = typeof data === 'object' ? data : {};
        let result = new FileOrderStop();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileOrderStop {
        const json = this.toJSON();
        let result = new FileOrderStop();
        result.init(json);
        return result;
    }
}

export interface IFileOrderStop extends IFile {
    order?: OrderStop | undefined;
}

export class OrderCargoItem extends BaseModel implements IOrderCargoItem {
    description?: string | undefined;
    packing?: string | undefined;
    hazardous?: boolean;
    pieceUnits?: number;
    actualPieceUnits?: number | undefined;
    weight?: number;
    actualWeight?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    pickUp?: OrderStop | undefined;
    pickUpId?: number | undefined;
    delivery?: OrderStop | undefined;
    deliveryId?: number | undefined;
    order?: Order | undefined;
    orderId?: number;
    cargoType?: OrderItemType;

    constructor(data?: IOrderCargoItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["Description"];
            this.packing = _data["Packing"];
            this.hazardous = _data["Hazardous"];
            this.pieceUnits = _data["PieceUnits"];
            this.actualPieceUnits = _data["ActualPieceUnits"];
            this.weight = _data["Weight"];
            this.actualWeight = _data["ActualWeight"];
            this.height = _data["Height"];
            this.width = _data["Width"];
            this.length = _data["Length"];
            this.pickUp = _data["PickUp"] ? OrderStop.fromJS(_data["PickUp"]) : <any>undefined;
            this.pickUpId = _data["PickUpId"];
            this.delivery = _data["Delivery"] ? OrderStop.fromJS(_data["Delivery"]) : <any>undefined;
            this.deliveryId = _data["DeliveryId"];
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.cargoType = _data["CargoType"];
        }
    }

    static override fromJS(data: any): OrderCargoItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCargoItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["Packing"] = this.packing;
        data["Hazardous"] = this.hazardous;
        data["PieceUnits"] = this.pieceUnits;
        data["ActualPieceUnits"] = this.actualPieceUnits;
        data["Weight"] = this.weight;
        data["ActualWeight"] = this.actualWeight;
        data["Height"] = this.height;
        data["Width"] = this.width;
        data["Length"] = this.length;
        data["PickUp"] = this.pickUp ? this.pickUp.toJSON() : <any>undefined;
        data["PickUpId"] = this.pickUpId;
        data["Delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["DeliveryId"] = this.deliveryId;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["CargoType"] = this.cargoType;
        super.toJSON(data);
        return data;
    }

    clone(): OrderCargoItem {
        const json = this.toJSON();
        let result = new OrderCargoItem();
        result.init(json);
        return result;
    }
}

export interface IOrderCargoItem extends IBaseModel {
    description?: string | undefined;
    packing?: string | undefined;
    hazardous?: boolean;
    pieceUnits?: number;
    actualPieceUnits?: number | undefined;
    weight?: number;
    actualWeight?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    pickUp?: OrderStop | undefined;
    pickUpId?: number | undefined;
    delivery?: OrderStop | undefined;
    deliveryId?: number | undefined;
    order?: Order | undefined;
    orderId?: number;
    cargoType?: OrderItemType;
}

/** 1 = GeneralFreight 2 = HouseholdGoods 3 = MetalSheetsCoilsRolls 4 = MotorVehicles 5 = DriveTowAway 6 = LogsPolesBeamsLumber 7 = BuildingMaterials 8 = MobileHomes 9 = MachineryLargeObjects 10 = FreshProduce 11 = LiquidsGases 12 = IntermodalCont 13 = Passengers 14 = OilfieldEquipment 15 = Livestock 16 = GrainFeedHay 17 = CoalCoke 18 = Meat 19 = GarbageRefuse 20 = USMail 21 = Chemicals 22 = CommoditiesDryBulk 23 = RefrigeratedFood 24 = Beverages 25 = PaperProducts 26 = Utilities 27 = AgriculturalFarmSupplies 28 = Construction 29 = WaterWell */
export enum OrderItemType {
    GeneralFreight = 1,
    HouseholdGoods = 2,
    MetalSheetsCoilsRolls = 3,
    MotorVehicles = 4,
    DriveTowAway = 5,
    LogsPolesBeamsLumber = 6,
    BuildingMaterials = 7,
    MobileHomes = 8,
    MachineryLargeObjects = 9,
    FreshProduce = 10,
    LiquidsGases = 11,
    IntermodalCont = 12,
    Passengers = 13,
    OilfieldEquipment = 14,
    Livestock = 15,
    GrainFeedHay = 16,
    CoalCoke = 17,
    Meat = 18,
    GarbageRefuse = 19,
    USMail = 20,
    Chemicals = 21,
    CommoditiesDryBulk = 22,
    RefrigeratedFood = 23,
    Beverages = 24,
    PaperProducts = 25,
    Utilities = 26,
    AgriculturalFarmSupplies = 27,
    Construction = 28,
    WaterWell = 29,
}

export class OrderTask extends BaseModel implements IOrderTask {
    status?: OrderTaskStatus;
    type?: OrderTaskType;
    finishedAt?: moment.Moment | undefined;
    finishedBy?: string | undefined;
    assignedTo?: string | undefined;
    assignedBy?: string | undefined;
    assignedAt?: moment.Moment | undefined;
    order?: Order | undefined;
    orderId?: number;
    taskNote?: string | undefined;
    taskDue?: moment.Moment;

    constructor(data?: IOrderTask) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["Status"];
            this.type = _data["Type"];
            this.finishedAt = _data["FinishedAt"] ? moment(_data["FinishedAt"].toString()) : <any>undefined;
            this.finishedBy = _data["FinishedBy"];
            this.assignedTo = _data["AssignedTo"];
            this.assignedBy = _data["AssignedBy"];
            this.assignedAt = _data["AssignedAt"] ? moment(_data["AssignedAt"].toString()) : <any>undefined;
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.taskNote = _data["TaskNote"];
            this.taskDue = _data["TaskDue"] ? moment(_data["TaskDue"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderTask {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTask();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["Type"] = this.type;
        data["FinishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["FinishedBy"] = this.finishedBy;
        data["AssignedTo"] = this.assignedTo;
        data["AssignedBy"] = this.assignedBy;
        data["AssignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["TaskNote"] = this.taskNote;
        data["TaskDue"] = this.taskDue ? this.taskDue.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): OrderTask {
        const json = this.toJSON();
        let result = new OrderTask();
        result.init(json);
        return result;
    }
}

export interface IOrderTask extends IBaseModel {
    status?: OrderTaskStatus;
    type?: OrderTaskType;
    finishedAt?: moment.Moment | undefined;
    finishedBy?: string | undefined;
    assignedTo?: string | undefined;
    assignedBy?: string | undefined;
    assignedAt?: moment.Moment | undefined;
    order?: Order | undefined;
    orderId?: number;
    taskNote?: string | undefined;
    taskDue?: moment.Moment;
}

/** 1 = Open 2 = OpenNotified 3 = Finished */
export enum OrderTaskStatus {
    Open = 1,
    OpenNotified = 2,
    Finished = 3,
}

/** 1 = General 2 = Accounting */
export enum OrderTaskType {
    General = 1,
    Accounting = 2,
}

export class OrderMetrics implements IOrderMetrics {
    order?: Order | undefined;
    orderId?: number;
    from?: string | undefined;
    to?: string | undefined;
    fromZip?: string | undefined;
    toZip?: string | undefined;
    pickUp?: moment.Moment;
    drop?: moment.Moment;
    weight?: number | undefined;
    pieceUnits?: number | undefined;

    constructor(data?: IOrderMetrics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["Order"] ? Order.fromJS(_data["Order"]) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.fromZip = _data["FromZip"];
            this.toZip = _data["ToZip"];
            this.pickUp = _data["PickUp"] ? moment(_data["PickUp"].toString()) : <any>undefined;
            this.drop = _data["Drop"] ? moment(_data["Drop"].toString()) : <any>undefined;
            this.weight = _data["Weight"];
            this.pieceUnits = _data["PieceUnits"];
        }
    }

    static fromJS(data: any): OrderMetrics {
        data = typeof data === 'object' ? data : {};
        let result = new OrderMetrics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["From"] = this.from;
        data["To"] = this.to;
        data["FromZip"] = this.fromZip;
        data["ToZip"] = this.toZip;
        data["PickUp"] = this.pickUp ? this.pickUp.toISOString() : <any>undefined;
        data["Drop"] = this.drop ? this.drop.toISOString() : <any>undefined;
        data["Weight"] = this.weight;
        data["PieceUnits"] = this.pieceUnits;
        return data;
    }

    clone(): OrderMetrics {
        const json = this.toJSON();
        let result = new OrderMetrics();
        result.init(json);
        return result;
    }
}

export interface IOrderMetrics {
    order?: Order | undefined;
    orderId?: number;
    from?: string | undefined;
    to?: string | undefined;
    fromZip?: string | undefined;
    toZip?: string | undefined;
    pickUp?: moment.Moment;
    drop?: moment.Moment;
    weight?: number | undefined;
    pieceUnits?: number | undefined;
}

export class FileCustomer extends File implements IFileCustomer {
    customer?: Customer | undefined;

    constructor(data?: IFileCustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FileCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new FileCustomer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): FileCustomer {
        const json = this.toJSON();
        let result = new FileCustomer();
        result.init(json);
        return result;
    }
}

export interface IFileCustomer extends IFile {
    customer?: Customer | undefined;
}

/** 1 = Sylectus 2 = Inbox */
export enum OrderSource {
    Sylectus = 1,
    Inbox = 2,
}

export class CompanyIntegrationUserSettings extends BaseModel implements ICompanyIntegrationUserSettings {
    user?: string | undefined;
    settingsJSON?: string | undefined;
    companyIntegrationId?: number;
    companyIntegration?: CompanyIntegration | undefined;

    constructor(data?: ICompanyIntegrationUserSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["User"];
            this.settingsJSON = _data["SettingsJSON"];
            this.companyIntegrationId = _data["CompanyIntegrationId"];
            this.companyIntegration = _data["CompanyIntegration"] ? CompanyIntegration.fromJS(_data["CompanyIntegration"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CompanyIntegrationUserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIntegrationUserSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User"] = this.user;
        data["SettingsJSON"] = this.settingsJSON;
        data["CompanyIntegrationId"] = this.companyIntegrationId;
        data["CompanyIntegration"] = this.companyIntegration ? this.companyIntegration.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): CompanyIntegrationUserSettings {
        const json = this.toJSON();
        let result = new CompanyIntegrationUserSettings();
        result.init(json);
        return result;
    }
}

export interface ICompanyIntegrationUserSettings extends IBaseModel {
    user?: string | undefined;
    settingsJSON?: string | undefined;
    companyIntegrationId?: number;
    companyIntegration?: CompanyIntegration | undefined;
}

export class QBOAccountItem implements IQBOAccountItem {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IQBOAccountItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): QBOAccountItem {
        data = typeof data === 'object' ? data : {};
        let result = new QBOAccountItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): QBOAccountItem {
        const json = this.toJSON();
        let result = new QBOAccountItem();
        result.init(json);
        return result;
    }
}

export interface IQBOAccountItem {
    id?: string | undefined;
    name?: string | undefined;
}

export class DataListResultOfCustomerListModel implements IDataListResultOfCustomerListModel {
    items?: CustomerListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfCustomerListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(CustomerListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfCustomerListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfCustomerListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfCustomerListModel {
        const json = this.toJSON();
        let result = new DataListResultOfCustomerListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfCustomerListModel {
    items?: CustomerListModel[] | undefined;
    count?: number;
}

export class CustomerListModel implements ICustomerListModel {
    id?: number;
    name?: string | undefined;
    companyName?: string | undefined;
    state?: string | undefined;
    uSDOT?: string | undefined;
    mcNumber?: string | undefined;
    phone?: string | undefined;
    displayName?: string | undefined;
    notes?: string | undefined;
    noteType?: CustomerNoteType;

    constructor(data?: ICustomerListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.companyName = _data["CompanyName"];
            this.state = _data["State"];
            this.uSDOT = _data["USDOT"];
            this.mcNumber = _data["McNumber"];
            this.phone = _data["Phone"];
            this.displayName = _data["DisplayName"];
            this.notes = _data["Notes"];
            this.noteType = _data["NoteType"];
        }
    }

    static fromJS(data: any): CustomerListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CompanyName"] = this.companyName;
        data["State"] = this.state;
        data["USDOT"] = this.uSDOT;
        data["McNumber"] = this.mcNumber;
        data["Phone"] = this.phone;
        data["DisplayName"] = this.displayName;
        data["Notes"] = this.notes;
        data["NoteType"] = this.noteType;
        return data;
    }

    clone(): CustomerListModel {
        const json = this.toJSON();
        let result = new CustomerListModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerListModel {
    id?: number;
    name?: string | undefined;
    companyName?: string | undefined;
    state?: string | undefined;
    uSDOT?: string | undefined;
    mcNumber?: string | undefined;
    phone?: string | undefined;
    displayName?: string | undefined;
    notes?: string | undefined;
    noteType?: CustomerNoteType;
}

export class DataListGetParamsOfCustomerListFilters implements IDataListGetParamsOfCustomerListFilters {
    filter?: CustomerListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfCustomerListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? CustomerListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfCustomerListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfCustomerListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfCustomerListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfCustomerListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfCustomerListFilters {
    filter?: CustomerListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class CustomerListFilters implements ICustomerListFilters {
    search?: string | undefined;

    constructor(data?: ICustomerListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): CustomerListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): CustomerListFilters {
        const json = this.toJSON();
        let result = new CustomerListFilters();
        result.init(json);
        return result;
    }
}

export interface ICustomerListFilters {
    search?: string | undefined;
}

export class DataListResultOfContactListModel implements IDataListResultOfContactListModel {
    items?: ContactListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfContactListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ContactListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfContactListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfContactListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfContactListModel {
        const json = this.toJSON();
        let result = new DataListResultOfContactListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfContactListModel {
    items?: ContactListModel[] | undefined;
    count?: number;
}

export class ContactListModel implements IContactListModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IContactListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.extension = _data["Extension"];
        }
    }

    static fromJS(data: any): ContactListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Extension"] = this.extension;
        return data;
    }

    clone(): ContactListModel {
        const json = this.toJSON();
        let result = new ContactListModel();
        result.init(json);
        return result;
    }
}

export interface IContactListModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
}

export class DataListGetParamsOfContactListFilters implements IDataListGetParamsOfContactListFilters {
    filter?: ContactListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfContactListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? ContactListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfContactListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfContactListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfContactListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfContactListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfContactListFilters {
    filter?: ContactListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class ContactListFilters implements IContactListFilters {
    search?: string | undefined;
    customerId?: number | undefined;

    constructor(data?: IContactListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.customerId = _data["CustomerId"];
        }
    }

    static fromJS(data: any): ContactListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["CustomerId"] = this.customerId;
        return data;
    }

    clone(): ContactListFilters {
        const json = this.toJSON();
        let result = new ContactListFilters();
        result.init(json);
        return result;
    }
}

export interface IContactListFilters {
    search?: string | undefined;
    customerId?: number | undefined;
}

export class CustomerEditModel implements ICustomerEditModel {
    id?: number | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    mcPrefix?: string | undefined;
    mcNumber?: number | undefined;
    uSDOT?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    remitName?: string | undefined;
    remitAddress?: string | undefined;
    remitAddress2?: string | undefined;
    remitCity?: string | undefined;
    remitState?: string | undefined;
    remitZIP?: string | undefined;
    phone?: string | undefined;
    defaultPayerId?: number | undefined;
    defaultPayer?: string | undefined;
    defaultPaymentNetTermId?: number | undefined;
    notes?: string | undefined;
    noteType?: CustomerNoteType;

    constructor(data?: ICustomerEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.companyName = _data["CompanyName"];
            this.mcPrefix = _data["McPrefix"];
            this.mcNumber = _data["McNumber"];
            this.uSDOT = _data["USDOT"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.remitName = _data["RemitName"];
            this.remitAddress = _data["RemitAddress"];
            this.remitAddress2 = _data["RemitAddress2"];
            this.remitCity = _data["RemitCity"];
            this.remitState = _data["RemitState"];
            this.remitZIP = _data["RemitZIP"];
            this.phone = _data["Phone"];
            this.defaultPayerId = _data["DefaultPayerId"];
            this.defaultPayer = _data["DefaultPayer"];
            this.defaultPaymentNetTermId = _data["DefaultPaymentNetTermId"];
            this.notes = _data["Notes"];
            this.noteType = _data["NoteType"];
        }
    }

    static fromJS(data: any): CustomerEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CompanyName"] = this.companyName;
        data["McPrefix"] = this.mcPrefix;
        data["McNumber"] = this.mcNumber;
        data["USDOT"] = this.uSDOT;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["RemitName"] = this.remitName;
        data["RemitAddress"] = this.remitAddress;
        data["RemitAddress2"] = this.remitAddress2;
        data["RemitCity"] = this.remitCity;
        data["RemitState"] = this.remitState;
        data["RemitZIP"] = this.remitZIP;
        data["Phone"] = this.phone;
        data["DefaultPayerId"] = this.defaultPayerId;
        data["DefaultPayer"] = this.defaultPayer;
        data["DefaultPaymentNetTermId"] = this.defaultPaymentNetTermId;
        data["Notes"] = this.notes;
        data["NoteType"] = this.noteType;
        return data;
    }

    clone(): CustomerEditModel {
        const json = this.toJSON();
        let result = new CustomerEditModel();
        result.init(json);
        return result;
    }
}

export interface ICustomerEditModel {
    id?: number | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    mcPrefix?: string | undefined;
    mcNumber?: number | undefined;
    uSDOT?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    remitName?: string | undefined;
    remitAddress?: string | undefined;
    remitAddress2?: string | undefined;
    remitCity?: string | undefined;
    remitState?: string | undefined;
    remitZIP?: string | undefined;
    phone?: string | undefined;
    defaultPayerId?: number | undefined;
    defaultPayer?: string | undefined;
    defaultPaymentNetTermId?: number | undefined;
    notes?: string | undefined;
    noteType?: CustomerNoteType;
}

export class ContactEditModel implements IContactEditModel {
    id?: number | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    customerIds?: number[] | undefined;

    constructor(data?: IContactEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.phone = _data["Phone"];
            this.extension = _data["Extension"];
            this.email = _data["Email"];
            this.title = _data["Title"];
            if (Array.isArray(_data["CustomerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["CustomerIds"])
                    this.customerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ContactEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Phone"] = this.phone;
        data["Extension"] = this.extension;
        data["Email"] = this.email;
        data["Title"] = this.title;
        if (Array.isArray(this.customerIds)) {
            data["CustomerIds"] = [];
            for (let item of this.customerIds)
                data["CustomerIds"].push(item);
        }
        return data;
    }

    clone(): ContactEditModel {
        const json = this.toJSON();
        let result = new ContactEditModel();
        result.init(json);
        return result;
    }
}

export interface IContactEditModel {
    id?: number | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    title?: string | undefined;
    customerIds?: number[] | undefined;
}

export class ContactViewModel extends ContactEditModel implements IContactViewModel {
    customers?: NamedValueLong[] | undefined;

    constructor(data?: IContactViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Customers"])) {
                this.customers = [] as any;
                for (let item of _data["Customers"])
                    this.customers!.push(NamedValueLong.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["Customers"] = [];
            for (let item of this.customers)
                data["Customers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContactViewModel {
        const json = this.toJSON();
        let result = new ContactViewModel();
        result.init(json);
        return result;
    }
}

export interface IContactViewModel extends IContactEditModel {
    customers?: NamedValueLong[] | undefined;
}

export class VehicleAvailability implements IVehicleAvailability {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    desLat?: number | undefined;
    desLon?: number | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number;
    states?: string[] | undefined;
    availableAt?: moment.Moment | undefined;
    notifiedAt?: moment.Moment;
    isLiveLocationUpdated?: boolean;

    constructor(data?: IVehicleAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["VehicleId"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.desLat = _data["DesLat"];
            this.desLon = _data["DesLon"];
            this.maxMiles = _data["MaxMiles"];
            this.pickUpRadius = _data["PickUpRadius"];
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(item);
            }
            this.availableAt = _data["AvailableAt"] ? moment(_data["AvailableAt"].toString()) : <any>undefined;
            this.notifiedAt = _data["NotifiedAt"] ? moment(_data["NotifiedAt"].toString()) : <any>undefined;
            this.isLiveLocationUpdated = _data["IsLiveLocationUpdated"];
        }
    }

    static fromJS(data: any): VehicleAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["DesLat"] = this.desLat;
        data["DesLon"] = this.desLon;
        data["MaxMiles"] = this.maxMiles;
        data["PickUpRadius"] = this.pickUpRadius;
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item);
        }
        data["AvailableAt"] = this.availableAt ? this.availableAt.toISOString() : <any>undefined;
        data["NotifiedAt"] = this.notifiedAt ? this.notifiedAt.toISOString() : <any>undefined;
        data["IsLiveLocationUpdated"] = this.isLiveLocationUpdated;
        return data;
    }

    clone(): VehicleAvailability {
        const json = this.toJSON();
        let result = new VehicleAvailability();
        result.init(json);
        return result;
    }
}

export interface IVehicleAvailability {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    desLat?: number | undefined;
    desLon?: number | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number;
    states?: string[] | undefined;
    availableAt?: moment.Moment | undefined;
    notifiedAt?: moment.Moment;
    isLiveLocationUpdated?: boolean;
}

export class DataListResultOfDriverListModel implements IDataListResultOfDriverListModel {
    items?: DriverListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfDriverListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(DriverListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfDriverListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfDriverListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfDriverListModel {
        const json = this.toJSON();
        let result = new DataListResultOfDriverListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfDriverListModel {
    items?: DriverListModel[] | undefined;
    count?: number;
}

export class DriverListModel implements IDriverListModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    vehicleId?: number | undefined;
    vehicle?: string | undefined;
    hOS?: Driver_HOS | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    note?: string | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    hasIntegrations?: boolean;

    constructor(data?: IDriverListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.active = _data["Active"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.carrierId = _data["CarrierId"];
            this.carrierName = _data["CarrierName"];
            this.vehicleId = _data["VehicleId"];
            this.vehicle = _data["Vehicle"];
            this.hOS = _data["HOS"] ? Driver_HOS.fromJS(_data["HOS"]) : <any>undefined;
            this.driverLicenseExpiration = _data["DriverLicenseExpiration"] ? moment(_data["DriverLicenseExpiration"].toString()) : <any>undefined;
            this.medicalExpiration = _data["MedicalExpiration"] ? moment(_data["MedicalExpiration"].toString()) : <any>undefined;
            this.twicExpiration = _data["TwicExpiration"] ? moment(_data["TwicExpiration"].toString()) : <any>undefined;
            this.note = _data["Note"];
            this.driverLicenseState = _data["DriverLicenseState"];
            this.driverLicense = _data["DriverLicense"];
            this.hasIntegrations = _data["HasIntegrations"];
        }
    }

    static fromJS(data: any): DriverListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Active"] = this.active;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CarrierId"] = this.carrierId;
        data["CarrierName"] = this.carrierName;
        data["VehicleId"] = this.vehicleId;
        data["Vehicle"] = this.vehicle;
        data["HOS"] = this.hOS ? this.hOS.toJSON() : <any>undefined;
        data["DriverLicenseExpiration"] = this.driverLicenseExpiration ? this.driverLicenseExpiration.toISOString() : <any>undefined;
        data["MedicalExpiration"] = this.medicalExpiration ? this.medicalExpiration.toISOString() : <any>undefined;
        data["TwicExpiration"] = this.twicExpiration ? this.twicExpiration.toISOString() : <any>undefined;
        data["Note"] = this.note;
        data["DriverLicenseState"] = this.driverLicenseState;
        data["DriverLicense"] = this.driverLicense;
        data["HasIntegrations"] = this.hasIntegrations;
        return data;
    }

    clone(): DriverListModel {
        const json = this.toJSON();
        let result = new DriverListModel();
        result.init(json);
        return result;
    }
}

export interface IDriverListModel {
    id?: number;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    vehicleId?: number | undefined;
    vehicle?: string | undefined;
    hOS?: Driver_HOS | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    note?: string | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    hasIntegrations?: boolean;
}

export class DataListGetParamsOfDriverListFilters implements IDataListGetParamsOfDriverListFilters {
    filter?: DriverListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfDriverListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? DriverListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfDriverListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfDriverListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfDriverListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfDriverListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfDriverListFilters {
    filter?: DriverListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class DriverListFilters implements IDriverListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;
    integrationId?: number | undefined;

    constructor(data?: IDriverListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
            this.carrierId = _data["CarrierId"];
            this.integrationId = _data["IntegrationId"];
        }
    }

    static fromJS(data: any): DriverListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DriverListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        data["CarrierId"] = this.carrierId;
        data["IntegrationId"] = this.integrationId;
        return data;
    }

    clone(): DriverListFilters {
        const json = this.toJSON();
        let result = new DriverListFilters();
        result.init(json);
        return result;
    }
}

export interface IDriverListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;
    integrationId?: number | undefined;
}

export class DriverShortListModel implements IDriverShortListModel {
    id?: number;
    fullName?: string | undefined;
    carrierId?: number | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IDriverShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.carrierId = _data["CarrierId"];
            this.carrier = _data["Carrier"];
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): DriverShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CarrierId"] = this.carrierId;
        data["Carrier"] = this.carrier;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): DriverShortListModel {
        const json = this.toJSON();
        let result = new DriverShortListModel();
        result.init(json);
        return result;
    }
}

export interface IDriverShortListModel {
    id?: number;
    fullName?: string | undefined;
    carrierId?: number | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;
}

export class DriverEditModel implements IDriverEditModel {
    id?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    carrierId?: number | undefined;
    vehicleId?: number | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IDriverEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.carrierId = _data["CarrierId"];
            this.vehicleId = _data["VehicleId"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.note = _data["Note"];
            this.driverLicenseExpiration = _data["DriverLicenseExpiration"] ? moment(_data["DriverLicenseExpiration"].toString()) : <any>undefined;
            this.medicalExpiration = _data["MedicalExpiration"] ? moment(_data["MedicalExpiration"].toString()) : <any>undefined;
            this.twicExpiration = _data["TwicExpiration"] ? moment(_data["TwicExpiration"].toString()) : <any>undefined;
            this.driverLicenseState = _data["DriverLicenseState"];
            this.driverLicense = _data["DriverLicense"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): DriverEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["CarrierId"] = this.carrierId;
        data["VehicleId"] = this.vehicleId;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["Note"] = this.note;
        data["DriverLicenseExpiration"] = this.driverLicenseExpiration ? this.driverLicenseExpiration.toISOString() : <any>undefined;
        data["MedicalExpiration"] = this.medicalExpiration ? this.medicalExpiration.toISOString() : <any>undefined;
        data["TwicExpiration"] = this.twicExpiration ? this.twicExpiration.toISOString() : <any>undefined;
        data["DriverLicenseState"] = this.driverLicenseState;
        data["DriverLicense"] = this.driverLicense;
        data["Active"] = this.active;
        return data;
    }

    clone(): DriverEditModel {
        const json = this.toJSON();
        let result = new DriverEditModel();
        result.init(json);
        return result;
    }
}

export interface IDriverEditModel {
    id?: number | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    carrierId?: number | undefined;
    vehicleId?: number | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    driverLicenseExpiration?: moment.Moment | undefined;
    medicalExpiration?: moment.Moment | undefined;
    twicExpiration?: moment.Moment | undefined;
    driverLicenseState?: string | undefined;
    driverLicense?: string | undefined;
    active?: boolean | undefined;
}

export class DriverRatingNoteEditModel implements IDriverRatingNoteEditModel {
    driverId?: number;
    carrierId?: number;
    orderId?: number;
    note?: string | undefined;
    type?: CarrierRatingNoteType;

    constructor(data?: IDriverRatingNoteEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverId = _data["DriverId"];
            this.carrierId = _data["CarrierId"];
            this.orderId = _data["OrderId"];
            this.note = _data["Note"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): DriverRatingNoteEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverRatingNoteEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DriverId"] = this.driverId;
        data["CarrierId"] = this.carrierId;
        data["OrderId"] = this.orderId;
        data["Note"] = this.note;
        data["Type"] = this.type;
        return data;
    }

    clone(): DriverRatingNoteEditModel {
        const json = this.toJSON();
        let result = new DriverRatingNoteEditModel();
        result.init(json);
        return result;
    }
}

export interface IDriverRatingNoteEditModel {
    driverId?: number;
    carrierId?: number;
    orderId?: number;
    note?: string | undefined;
    type?: CarrierRatingNoteType;
}

export class DataListResultOfEmailMessageListItem implements IDataListResultOfEmailMessageListItem {
    items?: EmailMessageListItem[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfEmailMessageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(EmailMessageListItem.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfEmailMessageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfEmailMessageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfEmailMessageListItem {
        const json = this.toJSON();
        let result = new DataListResultOfEmailMessageListItem();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfEmailMessageListItem {
    items?: EmailMessageListItem[] | undefined;
    count?: number;
}

export class EmailMessageListItem implements IEmailMessageListItem {
    id?: number;
    subject?: string | undefined;
    from?: EmailContact[] | undefined;
    to?: EmailContact[] | undefined;
    cc?: EmailContact[] | undefined;
    bcc?: EmailContact[] | undefined;
    receivedDate?: moment.Moment;
    sortDate?: moment.Moment;
    isHtml?: boolean;
    messageId?: string | undefined;
    inReplyTo?: string | undefined;
    references?: string | undefined;
    threadId?: number | undefined;
    integrationId?: number;
    messagesCount?: number;
    isSent?: boolean;
    isRead?: boolean;
    attachments?: EmailAttachmentListItem[] | undefined;
    isExtractionProcessed?: boolean;
    isExtractionSuccessful?: boolean;

    constructor(data?: IEmailMessageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.subject = _data["Subject"];
            if (Array.isArray(_data["From"])) {
                this.from = [] as any;
                for (let item of _data["From"])
                    this.from!.push(EmailContact.fromJS(item));
            }
            if (Array.isArray(_data["To"])) {
                this.to = [] as any;
                for (let item of _data["To"])
                    this.to!.push(EmailContact.fromJS(item));
            }
            if (Array.isArray(_data["Cc"])) {
                this.cc = [] as any;
                for (let item of _data["Cc"])
                    this.cc!.push(EmailContact.fromJS(item));
            }
            if (Array.isArray(_data["Bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["Bcc"])
                    this.bcc!.push(EmailContact.fromJS(item));
            }
            this.receivedDate = _data["ReceivedDate"] ? moment(_data["ReceivedDate"].toString()) : <any>undefined;
            this.sortDate = _data["SortDate"] ? moment(_data["SortDate"].toString()) : <any>undefined;
            this.isHtml = _data["IsHtml"];
            this.messageId = _data["MessageId"];
            this.inReplyTo = _data["InReplyTo"];
            this.references = _data["References"];
            this.threadId = _data["ThreadId"];
            this.integrationId = _data["IntegrationId"];
            this.messagesCount = _data["MessagesCount"];
            this.isSent = _data["IsSent"];
            this.isRead = _data["IsRead"];
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(EmailAttachmentListItem.fromJS(item));
            }
            this.isExtractionProcessed = _data["IsExtractionProcessed"];
            this.isExtractionSuccessful = _data["IsExtractionSuccessful"];
        }
    }

    static fromJS(data: any): EmailMessageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Subject"] = this.subject;
        if (Array.isArray(this.from)) {
            data["From"] = [];
            for (let item of this.from)
                data["From"].push(item.toJSON());
        }
        if (Array.isArray(this.to)) {
            data["To"] = [];
            for (let item of this.to)
                data["To"].push(item.toJSON());
        }
        if (Array.isArray(this.cc)) {
            data["Cc"] = [];
            for (let item of this.cc)
                data["Cc"].push(item.toJSON());
        }
        if (Array.isArray(this.bcc)) {
            data["Bcc"] = [];
            for (let item of this.bcc)
                data["Bcc"].push(item.toJSON());
        }
        data["ReceivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["SortDate"] = this.sortDate ? this.sortDate.toISOString() : <any>undefined;
        data["IsHtml"] = this.isHtml;
        data["MessageId"] = this.messageId;
        data["InReplyTo"] = this.inReplyTo;
        data["References"] = this.references;
        data["ThreadId"] = this.threadId;
        data["IntegrationId"] = this.integrationId;
        data["MessagesCount"] = this.messagesCount;
        data["IsSent"] = this.isSent;
        data["IsRead"] = this.isRead;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item.toJSON());
        }
        data["IsExtractionProcessed"] = this.isExtractionProcessed;
        data["IsExtractionSuccessful"] = this.isExtractionSuccessful;
        return data;
    }

    clone(): EmailMessageListItem {
        const json = this.toJSON();
        let result = new EmailMessageListItem();
        result.init(json);
        return result;
    }
}

export interface IEmailMessageListItem {
    id?: number;
    subject?: string | undefined;
    from?: EmailContact[] | undefined;
    to?: EmailContact[] | undefined;
    cc?: EmailContact[] | undefined;
    bcc?: EmailContact[] | undefined;
    receivedDate?: moment.Moment;
    sortDate?: moment.Moment;
    isHtml?: boolean;
    messageId?: string | undefined;
    inReplyTo?: string | undefined;
    references?: string | undefined;
    threadId?: number | undefined;
    integrationId?: number;
    messagesCount?: number;
    isSent?: boolean;
    isRead?: boolean;
    attachments?: EmailAttachmentListItem[] | undefined;
    isExtractionProcessed?: boolean;
    isExtractionSuccessful?: boolean;
}

export class EmailContact implements IEmailContact {
    name?: string | undefined;
    address?: string | undefined;

    constructor(data?: IEmailContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.address = _data["Address"];
        }
    }

    static fromJS(data: any): EmailContact {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Address"] = this.address;
        return data;
    }

    clone(): EmailContact {
        const json = this.toJSON();
        let result = new EmailContact();
        result.init(json);
        return result;
    }
}

export interface IEmailContact {
    name?: string | undefined;
    address?: string | undefined;
}

export class EmailAttachmentListItem implements IEmailAttachmentListItem {
    id?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    contentId?: string | undefined;
    filePath?: string | undefined;

    constructor(data?: IEmailAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fileName = _data["FileName"];
            this.contentType = _data["ContentType"];
            this.size = _data["Size"];
            this.contentId = _data["ContentId"];
            this.filePath = _data["FilePath"];
        }
    }

    static fromJS(data: any): EmailAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FileName"] = this.fileName;
        data["ContentType"] = this.contentType;
        data["Size"] = this.size;
        data["ContentId"] = this.contentId;
        data["FilePath"] = this.filePath;
        return data;
    }

    clone(): EmailAttachmentListItem {
        const json = this.toJSON();
        let result = new EmailAttachmentListItem();
        result.init(json);
        return result;
    }
}

export interface IEmailAttachmentListItem {
    id?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    size?: number;
    contentId?: string | undefined;
    filePath?: string | undefined;
}

export class EmailMessageThreadItem extends EmailMessageListItem implements IEmailMessageThreadItem {
    body?: string | undefined;

    constructor(data?: IEmailMessageThreadItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["Body"];
        }
    }

    static override fromJS(data: any): EmailMessageThreadItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessageThreadItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Body"] = this.body;
        super.toJSON(data);
        return data;
    }

    clone(): EmailMessageThreadItem {
        const json = this.toJSON();
        let result = new EmailMessageThreadItem();
        result.init(json);
        return result;
    }
}

export interface IEmailMessageThreadItem extends IEmailMessageListItem {
    body?: string | undefined;
}

export class EmailIntegrationItem implements IEmailIntegrationItem {
    id?: number;
    name?: string | undefined;
    unreadCount?: number;

    constructor(data?: IEmailIntegrationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.unreadCount = _data["UnreadCount"];
        }
    }

    static fromJS(data: any): EmailIntegrationItem {
        data = typeof data === 'object' ? data : {};
        let result = new EmailIntegrationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["UnreadCount"] = this.unreadCount;
        return data;
    }

    clone(): EmailIntegrationItem {
        const json = this.toJSON();
        let result = new EmailIntegrationItem();
        result.init(json);
        return result;
    }
}

export interface IEmailIntegrationItem {
    id?: number;
    name?: string | undefined;
    unreadCount?: number;
}

export class ExtractedObject implements IExtractedObject {
    postingExpires?: moment.Moment | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    miles?: number;
    vehicleType?: string | undefined;
    phone?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    orderReferences?: string | undefined;
    notes?: string | undefined;
    loadType?: string | undefined;
    hazardous?: boolean;
    fastLoad?: boolean;
    dockLevel?: boolean;
    pays?: number | undefined;
    pallets?: Pallet[] | undefined;

    constructor(data?: IExtractedObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postingExpires = _data["PostingExpires"] ? moment(_data["PostingExpires"].toString()) : <any>undefined;
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.miles = _data["Miles"];
            this.vehicleType = _data["VehicleType"];
            this.phone = _data["Phone"];
            this.postedBy = _data["PostedBy"];
            this.postedByEmail = _data["PostedByEmail"];
            this.orderReferences = _data["OrderReferences"];
            this.notes = _data["Notes"];
            this.loadType = _data["LoadType"];
            this.hazardous = _data["Hazardous"];
            this.fastLoad = _data["FastLoad"];
            this.dockLevel = _data["DockLevel"];
            this.pays = _data["Pays"];
            if (Array.isArray(_data["Pallets"])) {
                this.pallets = [] as any;
                for (let item of _data["Pallets"])
                    this.pallets!.push(Pallet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtractedObject {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractedObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PostingExpires"] = this.postingExpires ? this.postingExpires.toISOString() : <any>undefined;
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["Miles"] = this.miles;
        data["VehicleType"] = this.vehicleType;
        data["Phone"] = this.phone;
        data["PostedBy"] = this.postedBy;
        data["PostedByEmail"] = this.postedByEmail;
        data["OrderReferences"] = this.orderReferences;
        data["Notes"] = this.notes;
        data["LoadType"] = this.loadType;
        data["Hazardous"] = this.hazardous;
        data["FastLoad"] = this.fastLoad;
        data["DockLevel"] = this.dockLevel;
        data["Pays"] = this.pays;
        if (Array.isArray(this.pallets)) {
            data["Pallets"] = [];
            for (let item of this.pallets)
                data["Pallets"].push(item.toJSON());
        }
        return data;
    }

    clone(): ExtractedObject {
        const json = this.toJSON();
        let result = new ExtractedObject();
        result.init(json);
        return result;
    }
}

export interface IExtractedObject {
    postingExpires?: moment.Moment | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    miles?: number;
    vehicleType?: string | undefined;
    phone?: string | undefined;
    postedBy?: string | undefined;
    postedByEmail?: string | undefined;
    orderReferences?: string | undefined;
    notes?: string | undefined;
    loadType?: string | undefined;
    hazardous?: boolean;
    fastLoad?: boolean;
    dockLevel?: boolean;
    pays?: number | undefined;
    pallets?: Pallet[] | undefined;
}

export class Pallet implements IPallet {
    tag?: string | undefined;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    canStack?: boolean;
    dims?: string | undefined;

    constructor(data?: IPallet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["Tag"];
            this.length = _data["Length"];
            this.width = _data["Width"];
            this.height = _data["Height"];
            this.weight = _data["Weight"];
            this.canStack = _data["CanStack"];
            this.dims = _data["Dims"];
        }
    }

    static fromJS(data: any): Pallet {
        data = typeof data === 'object' ? data : {};
        let result = new Pallet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Tag"] = this.tag;
        data["Length"] = this.length;
        data["Width"] = this.width;
        data["Height"] = this.height;
        data["Weight"] = this.weight;
        data["CanStack"] = this.canStack;
        data["Dims"] = this.dims;
        return data;
    }

    clone(): Pallet {
        const json = this.toJSON();
        let result = new Pallet();
        result.init(json);
        return result;
    }
}

export interface IPallet {
    tag?: string | undefined;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    canStack?: boolean;
    dims?: string | undefined;
}

/** 1 = AI 2 = FullCircleTMS 3 = Sylectus */
export enum IntegrationSettingOrderParserType {
    AI = 1,
    FullCircleTMS = 2,
    Sylectus = 3,
}

/** 1 = Order 2 = Stop 3 = OrderNote 4 = Driver 5 = Vehicle 6 = License 7 = Carrier 8 = Common 9 = Customer */
export enum FileItemType {
    Order = 1,
    Stop = 2,
    OrderNote = 3,
    Driver = 4,
    Vehicle = 5,
    License = 6,
    Carrier = 7,
    Common = 8,
    Customer = 9,
}

export class FileListItem implements IFileListItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: FileType;

    constructor(data?: IFileListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): FileListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Type"] = this.type;
        return data;
    }

    clone(): FileListItem {
        const json = this.toJSON();
        let result = new FileListItem();
        result.init(json);
        return result;
    }
}

export interface IFileListItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    type?: FileType;
}

export class DataListResultOfIntegrationListModel implements IDataListResultOfIntegrationListModel {
    items?: IntegrationListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfIntegrationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(IntegrationListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfIntegrationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfIntegrationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfIntegrationListModel {
        const json = this.toJSON();
        let result = new DataListResultOfIntegrationListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfIntegrationListModel {
    items?: IntegrationListModel[] | undefined;
    count?: number;
}

export class IntegrationListModel implements IIntegrationListModel {
    id?: number;
    createdAt?: moment.Moment;
    name?: string | undefined;
    active?: boolean;
    type?: IntegrationType;
    carrierName?: string | undefined;
    drivers?: number;
    vehicles?: number;
    isPersonalized?: boolean;

    constructor(data?: IIntegrationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.carrierName = _data["CarrierName"];
            this.drivers = _data["Drivers"];
            this.vehicles = _data["Vehicles"];
            this.isPersonalized = _data["IsPersonalized"];
        }
    }

    static fromJS(data: any): IntegrationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["CarrierName"] = this.carrierName;
        data["Drivers"] = this.drivers;
        data["Vehicles"] = this.vehicles;
        data["IsPersonalized"] = this.isPersonalized;
        return data;
    }

    clone(): IntegrationListModel {
        const json = this.toJSON();
        let result = new IntegrationListModel();
        result.init(json);
        return result;
    }
}

export interface IIntegrationListModel {
    id?: number;
    createdAt?: moment.Moment;
    name?: string | undefined;
    active?: boolean;
    type?: IntegrationType;
    carrierName?: string | undefined;
    drivers?: number;
    vehicles?: number;
    isPersonalized?: boolean;
}

export class DataListGetParamsOfIntegrationListFilters implements IDataListGetParamsOfIntegrationListFilters {
    filter?: IntegrationListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfIntegrationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? IntegrationListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfIntegrationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfIntegrationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfIntegrationListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfIntegrationListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfIntegrationListFilters {
    filter?: IntegrationListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class IntegrationListFilters implements IIntegrationListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;

    constructor(data?: IIntegrationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
            this.carrierId = _data["CarrierId"];
        }
    }

    static fromJS(data: any): IntegrationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        data["CarrierId"] = this.carrierId;
        return data;
    }

    clone(): IntegrationListFilters {
        const json = this.toJSON();
        let result = new IntegrationListFilters();
        result.init(json);
        return result;
    }
}

export interface IIntegrationListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;
}

export class IntegrationEditModel implements IIntegrationEditModel {
    id?: number | undefined;
    carrierId?: number | undefined;
    type?: IntegrationType;
    name?: string | undefined;
    active?: boolean | undefined;
    isPersonalized?: boolean;
    settings?: IntegrationSettings | undefined;
    vehicleMapping?: IntegrationMappingItemEdit[] | undefined;
    userMapping?: IntegrationMappingItemEdit[] | undefined;

    constructor(data?: IIntegrationEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.carrierId = _data["CarrierId"];
            this.type = _data["Type"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.isPersonalized = _data["IsPersonalized"];
            this.settings = _data["Settings"] ? IntegrationSettings.fromJS(_data["Settings"]) : <any>undefined;
            if (Array.isArray(_data["VehicleMapping"])) {
                this.vehicleMapping = [] as any;
                for (let item of _data["VehicleMapping"])
                    this.vehicleMapping!.push(IntegrationMappingItemEdit.fromJS(item));
            }
            if (Array.isArray(_data["UserMapping"])) {
                this.userMapping = [] as any;
                for (let item of _data["UserMapping"])
                    this.userMapping!.push(IntegrationMappingItemEdit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntegrationEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CarrierId"] = this.carrierId;
        data["Type"] = this.type;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["IsPersonalized"] = this.isPersonalized;
        data["Settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.vehicleMapping)) {
            data["VehicleMapping"] = [];
            for (let item of this.vehicleMapping)
                data["VehicleMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.userMapping)) {
            data["UserMapping"] = [];
            for (let item of this.userMapping)
                data["UserMapping"].push(item.toJSON());
        }
        return data;
    }

    clone(): IntegrationEditModel {
        const json = this.toJSON();
        let result = new IntegrationEditModel();
        result.init(json);
        return result;
    }
}

export interface IIntegrationEditModel {
    id?: number | undefined;
    carrierId?: number | undefined;
    type?: IntegrationType;
    name?: string | undefined;
    active?: boolean | undefined;
    isPersonalized?: boolean;
    settings?: IntegrationSettings | undefined;
    vehicleMapping?: IntegrationMappingItemEdit[] | undefined;
    userMapping?: IntegrationMappingItemEdit[] | undefined;
}

export class IntegrationMappingItemEdit implements IIntegrationMappingItemEdit {
    id?: number;
    externalId?: string | undefined;

    constructor(data?: IIntegrationMappingItemEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.externalId = _data["ExternalId"];
        }
    }

    static fromJS(data: any): IntegrationMappingItemEdit {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationMappingItemEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExternalId"] = this.externalId;
        return data;
    }

    clone(): IntegrationMappingItemEdit {
        const json = this.toJSON();
        let result = new IntegrationMappingItemEdit();
        result.init(json);
        return result;
    }
}

export interface IIntegrationMappingItemEdit {
    id?: number;
    externalId?: string | undefined;
}

export class NamedValue implements INamedValue {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: INamedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValue {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValue {
        const json = this.toJSON();
        let result = new NamedValue();
        result.init(json);
        return result;
    }
}

export interface INamedValue {
    id?: string | undefined;
    name?: string | undefined;
}

export class DataListResultOfInvoiceListModel implements IDataListResultOfInvoiceListModel {
    items?: InvoiceListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfInvoiceListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InvoiceListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfInvoiceListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfInvoiceListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfInvoiceListModel {
        const json = this.toJSON();
        let result = new DataListResultOfInvoiceListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfInvoiceListModel {
    items?: InvoiceListModel[] | undefined;
    count?: number;
}

export class InvoiceListModel implements IInvoiceListModel {
    id?: number;
    number?: number;
    status?: InvoiceStatus;
    closedOn?: moment.Moment | undefined;
    dueDate?: moment.Moment;
    customer?: string | undefined;
    payer?: string | undefined;
    paymentNetTerm?: string | undefined;
    orderId?: number;
    reference?: string | undefined;
    paymentNetTermDays?: number;
    invoiceAge?: number;
    overdue?: boolean;
    createdAt?: moment.Moment;
    amount?: number;
    commission?: number;
    paidAmount?: number;
    invoiceDate?: moment.Moment;

    constructor(data?: IInvoiceListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.number = _data["Number"];
            this.status = _data["Status"];
            this.closedOn = _data["ClosedOn"] ? moment(_data["ClosedOn"].toString()) : <any>undefined;
            this.dueDate = _data["DueDate"] ? moment(_data["DueDate"].toString()) : <any>undefined;
            this.customer = _data["Customer"];
            this.payer = _data["Payer"];
            this.paymentNetTerm = _data["PaymentNetTerm"];
            this.orderId = _data["OrderId"];
            this.reference = _data["Reference"];
            this.paymentNetTermDays = _data["PaymentNetTermDays"];
            this.invoiceAge = _data["InvoiceAge"];
            this.overdue = _data["Overdue"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.commission = _data["Commission"];
            this.paidAmount = _data["PaidAmount"];
            this.invoiceDate = _data["InvoiceDate"] ? moment(_data["InvoiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceListModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Number"] = this.number;
        data["Status"] = this.status;
        data["ClosedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["DueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["Customer"] = this.customer;
        data["Payer"] = this.payer;
        data["PaymentNetTerm"] = this.paymentNetTerm;
        data["OrderId"] = this.orderId;
        data["Reference"] = this.reference;
        data["PaymentNetTermDays"] = this.paymentNetTermDays;
        data["InvoiceAge"] = this.invoiceAge;
        data["Overdue"] = this.overdue;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["Commission"] = this.commission;
        data["PaidAmount"] = this.paidAmount;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): InvoiceListModel {
        const json = this.toJSON();
        let result = new InvoiceListModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListModel {
    id?: number;
    number?: number;
    status?: InvoiceStatus;
    closedOn?: moment.Moment | undefined;
    dueDate?: moment.Moment;
    customer?: string | undefined;
    payer?: string | undefined;
    paymentNetTerm?: string | undefined;
    orderId?: number;
    reference?: string | undefined;
    paymentNetTermDays?: number;
    invoiceAge?: number;
    overdue?: boolean;
    createdAt?: moment.Moment;
    amount?: number;
    commission?: number;
    paidAmount?: number;
    invoiceDate?: moment.Moment;
}

export class DataListGetParamsOfInvoiceListFilters implements IDataListGetParamsOfInvoiceListFilters {
    filter?: InvoiceListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfInvoiceListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? InvoiceListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfInvoiceListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfInvoiceListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfInvoiceListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfInvoiceListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfInvoiceListFilters {
    filter?: InvoiceListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class InvoiceListFilters implements IInvoiceListFilters {
    search?: string | undefined;
    statuses?: InvoiceStatus[] | undefined;
    overdue?: boolean;

    constructor(data?: IInvoiceListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            if (Array.isArray(_data["Statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["Statuses"])
                    this.statuses!.push(item);
            }
            this.overdue = _data["Overdue"];
        }
    }

    static fromJS(data: any): InvoiceListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        if (Array.isArray(this.statuses)) {
            data["Statuses"] = [];
            for (let item of this.statuses)
                data["Statuses"].push(item);
        }
        data["Overdue"] = this.overdue;
        return data;
    }

    clone(): InvoiceListFilters {
        const json = this.toJSON();
        let result = new InvoiceListFilters();
        result.init(json);
        return result;
    }
}

export interface IInvoiceListFilters {
    search?: string | undefined;
    statuses?: InvoiceStatus[] | undefined;
    overdue?: boolean;
}

export class NewInvoiceBasedOnOrderEditModel implements INewInvoiceBasedOnOrderEditModel {
    orderId?: number;
    number?: number;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    payerId?: number;
    paymentNetTermId?: number;
    invoiceDate?: moment.Moment;
    reference?: string | undefined;

    constructor(data?: INewInvoiceBasedOnOrderEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.number = _data["Number"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.payerId = _data["PayerId"];
            this.paymentNetTermId = _data["PaymentNetTermId"];
            this.invoiceDate = _data["InvoiceDate"] ? moment(_data["InvoiceDate"].toString()) : <any>undefined;
            this.reference = _data["Reference"];
        }
    }

    static fromJS(data: any): NewInvoiceBasedOnOrderEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewInvoiceBasedOnOrderEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["Number"] = this.number;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["PayerId"] = this.payerId;
        data["PaymentNetTermId"] = this.paymentNetTermId;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["Reference"] = this.reference;
        return data;
    }

    clone(): NewInvoiceBasedOnOrderEditModel {
        const json = this.toJSON();
        let result = new NewInvoiceBasedOnOrderEditModel();
        result.init(json);
        return result;
    }
}

export interface INewInvoiceBasedOnOrderEditModel {
    orderId?: number;
    number?: number;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    payerId?: number;
    paymentNetTermId?: number;
    invoiceDate?: moment.Moment;
    reference?: string | undefined;
}

export class OpenInvoicesByCustomerModel implements IOpenInvoicesByCustomerModel {
    id?: number;
    amount?: number;
    paidAmount?: number;
    orderNo?: string | undefined;
    reference?: string | undefined;
    invoiceDate?: moment.Moment;

    constructor(data?: IOpenInvoicesByCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.amount = _data["Amount"];
            this.paidAmount = _data["PaidAmount"];
            this.orderNo = _data["OrderNo"];
            this.reference = _data["Reference"];
            this.invoiceDate = _data["InvoiceDate"] ? moment(_data["InvoiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OpenInvoicesByCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OpenInvoicesByCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Amount"] = this.amount;
        data["PaidAmount"] = this.paidAmount;
        data["OrderNo"] = this.orderNo;
        data["Reference"] = this.reference;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): OpenInvoicesByCustomerModel {
        const json = this.toJSON();
        let result = new OpenInvoicesByCustomerModel();
        result.init(json);
        return result;
    }
}

export interface IOpenInvoicesByCustomerModel {
    id?: number;
    amount?: number;
    paidAmount?: number;
    orderNo?: string | undefined;
    reference?: string | undefined;
    invoiceDate?: moment.Moment;
}

export class InvoiceShortModel implements IInvoiceShortModel {
    id?: number;
    number?: number;
    status?: InvoiceStatus;
    customer?: string | undefined;
    orderId?: number;
    reference?: string | undefined;
    amount?: number;
    invoiceDate?: moment.Moment;

    constructor(data?: IInvoiceShortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.number = _data["Number"];
            this.status = _data["Status"];
            this.customer = _data["Customer"];
            this.orderId = _data["OrderId"];
            this.reference = _data["Reference"];
            this.amount = _data["Amount"];
            this.invoiceDate = _data["InvoiceDate"] ? moment(_data["InvoiceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceShortModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceShortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Number"] = this.number;
        data["Status"] = this.status;
        data["Customer"] = this.customer;
        data["OrderId"] = this.orderId;
        data["Reference"] = this.reference;
        data["Amount"] = this.amount;
        data["InvoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): InvoiceShortModel {
        const json = this.toJSON();
        let result = new InvoiceShortModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceShortModel {
    id?: number;
    number?: number;
    status?: InvoiceStatus;
    customer?: string | undefined;
    orderId?: number;
    reference?: string | undefined;
    amount?: number;
    invoiceDate?: moment.Moment;
}

export class InvoiceMetrics implements IInvoiceMetrics {
    numberTotal?: number | undefined;
    total?: number | undefined;
    closed?: number | undefined;
    closedTotal?: number | undefined;
    closedPaidTotal?: number | undefined;

    constructor(data?: IInvoiceMetrics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberTotal = _data["NumberTotal"];
            this.total = _data["Total"];
            this.closed = _data["Closed"];
            this.closedTotal = _data["ClosedTotal"];
            this.closedPaidTotal = _data["ClosedPaidTotal"];
        }
    }

    static fromJS(data: any): InvoiceMetrics {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceMetrics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NumberTotal"] = this.numberTotal;
        data["Total"] = this.total;
        data["Closed"] = this.closed;
        data["ClosedTotal"] = this.closedTotal;
        data["ClosedPaidTotal"] = this.closedPaidTotal;
        return data;
    }

    clone(): InvoiceMetrics {
        const json = this.toJSON();
        let result = new InvoiceMetrics();
        result.init(json);
        return result;
    }
}

export interface IInvoiceMetrics {
    numberTotal?: number | undefined;
    total?: number | undefined;
    closed?: number | undefined;
    closedTotal?: number | undefined;
    closedPaidTotal?: number | undefined;
}

export class InvoiceMetricsRequest implements IInvoiceMetricsRequest {
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;

    constructor(data?: IInvoiceMetricsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceMetricsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceMetricsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }

    clone(): InvoiceMetricsRequest {
        const json = this.toJSON();
        let result = new InvoiceMetricsRequest();
        result.init(json);
        return result;
    }
}

export interface IInvoiceMetricsRequest {
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
}

export class ARMetrics implements IARMetrics {
    open?: number | undefined;
    openTotal?: number | undefined;
    overdue?: number | undefined;
    overdueTotal?: number | undefined;

    constructor(data?: IARMetrics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.open = _data["Open"];
            this.openTotal = _data["OpenTotal"];
            this.overdue = _data["Overdue"];
            this.overdueTotal = _data["OverdueTotal"];
        }
    }

    static fromJS(data: any): ARMetrics {
        data = typeof data === 'object' ? data : {};
        let result = new ARMetrics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Open"] = this.open;
        data["OpenTotal"] = this.openTotal;
        data["Overdue"] = this.overdue;
        data["OverdueTotal"] = this.overdueTotal;
        return data;
    }

    clone(): ARMetrics {
        const json = this.toJSON();
        let result = new ARMetrics();
        result.init(json);
        return result;
    }
}

export interface IARMetrics {
    open?: number | undefined;
    openTotal?: number | undefined;
    overdue?: number | undefined;
    overdueTotal?: number | undefined;
}

export class DataListResultOfMessageLogListModel implements IDataListResultOfMessageLogListModel {
    items?: MessageLogListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfMessageLogListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(MessageLogListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfMessageLogListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfMessageLogListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfMessageLogListModel {
        const json = this.toJSON();
        let result = new DataListResultOfMessageLogListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfMessageLogListModel {
    items?: MessageLogListModel[] | undefined;
    count?: number;
}

export class MessageLogListModel implements IMessageLogListModel {
    sid?: string | undefined;
    number?: number;
    message?: string | undefined;
    errorMessage?: string | undefined;
    created?: moment.Moment | undefined;

    constructor(data?: IMessageLogListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sid = _data["Sid"];
            this.number = _data["Number"];
            this.message = _data["Message"];
            this.errorMessage = _data["ErrorMessage"];
            this.created = _data["Created"] ? moment(_data["Created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageLogListModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageLogListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sid"] = this.sid;
        data["Number"] = this.number;
        data["Message"] = this.message;
        data["ErrorMessage"] = this.errorMessage;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }

    clone(): MessageLogListModel {
        const json = this.toJSON();
        let result = new MessageLogListModel();
        result.init(json);
        return result;
    }
}

export interface IMessageLogListModel {
    sid?: string | undefined;
    number?: number;
    message?: string | undefined;
    errorMessage?: string | undefined;
    created?: moment.Moment | undefined;
}

export class DataListGetParamsOfMessageLogListFilters implements IDataListGetParamsOfMessageLogListFilters {
    filter?: MessageLogListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfMessageLogListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? MessageLogListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfMessageLogListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfMessageLogListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfMessageLogListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfMessageLogListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfMessageLogListFilters {
    filter?: MessageLogListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class MessageLogListFilters implements IMessageLogListFilters {
    search?: string | undefined;

    constructor(data?: IMessageLogListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): MessageLogListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new MessageLogListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): MessageLogListFilters {
        const json = this.toJSON();
        let result = new MessageLogListFilters();
        result.init(json);
        return result;
    }
}

export interface IMessageLogListFilters {
    search?: string | undefined;
}

export class NewNoteModel implements INewNoteModel {
    note?: string | undefined;
    referenceId?: number;
    noteItemType?: NoteItemType;
    noteType?: NoteType;

    constructor(data?: INewNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["Note"];
            this.referenceId = _data["ReferenceId"];
            this.noteItemType = _data["NoteItemType"];
            this.noteType = _data["NoteType"];
        }
    }

    static fromJS(data: any): NewNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Note"] = this.note;
        data["ReferenceId"] = this.referenceId;
        data["NoteItemType"] = this.noteItemType;
        data["NoteType"] = this.noteType;
        return data;
    }

    clone(): NewNoteModel {
        const json = this.toJSON();
        let result = new NewNoteModel();
        result.init(json);
        return result;
    }
}

export interface INewNoteModel {
    note?: string | undefined;
    referenceId?: number;
    noteItemType?: NoteItemType;
    noteType?: NoteType;
}

/** 1 = Order 2 = Driver 3 = Vehicle 4 = Carrier */
export enum NoteItemType {
    Order = 1,
    Driver = 2,
    Vehicle = 3,
    Carrier = 4,
}

export class NoteListItem implements INoteListItem {
    id?: number;
    notes?: string | undefined;
    type?: NoteType;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;

    constructor(data?: INoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.notes = _data["Notes"];
            this.type = _data["Type"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): NoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new NoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Notes"] = this.notes;
        data["Type"] = this.type;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        return data;
    }

    clone(): NoteListItem {
        const json = this.toJSON();
        let result = new NoteListItem();
        result.init(json);
        return result;
    }
}

export interface INoteListItem {
    id?: number;
    notes?: string | undefined;
    type?: NoteType;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
}

export class DataListResultOfOrderModelListView implements IDataListResultOfOrderModelListView {
    items?: OrderModelListView[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOrderModelListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrderModelListView.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOrderModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOrderModelListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOrderModelListView {
        const json = this.toJSON();
        let result = new DataListResultOfOrderModelListView();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOrderModelListView {
    items?: OrderModelListView[] | undefined;
    count?: number;
}

export class OrderModelListView implements IOrderModelListView {
    id?: number;
    status?: OrderStatus;
    rate?: number;
    vehicle?: string | undefined;
    vehicleId?: number | undefined;
    carrier?: string | undefined;
    drivers?: string[] | undefined;
    customer?: string | undefined;
    customerId?: number | undefined;
    contact?: string | undefined;
    orderNumber?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    miles?: number;
    weight?: number | undefined;
    pieceUnits?: number | undefined;
    createdAt?: moment.Moment;
    location?: string | undefined;
    displayLocation?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    stopType?: OrderStopType | undefined;
    stopStatusType?: OrderStopStatusType | undefined;
    currentStop?: number | undefined;
    stops?: number | undefined;
    stopState?: string | undefined;
    remainingMiles?: number | undefined;
    orderNotes?: OrderNotesList[] | undefined;
    pickUp?: moment.Moment;
    drop?: moment.Moment;

    constructor(data?: IOrderModelListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.status = _data["Status"];
            this.rate = _data["Rate"];
            this.vehicle = _data["Vehicle"];
            this.vehicleId = _data["VehicleId"];
            this.carrier = _data["Carrier"];
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(item);
            }
            this.customer = _data["Customer"];
            this.customerId = _data["CustomerId"];
            this.contact = _data["Contact"];
            this.orderNumber = _data["OrderNumber"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.miles = _data["Miles"];
            this.weight = _data["Weight"];
            this.pieceUnits = _data["PieceUnits"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.location = _data["Location"];
            this.displayLocation = _data["DisplayLocation"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.stopType = _data["StopType"];
            this.stopStatusType = _data["StopStatusType"];
            this.currentStop = _data["CurrentStop"];
            this.stops = _data["Stops"];
            this.stopState = _data["StopState"];
            this.remainingMiles = _data["RemainingMiles"];
            if (Array.isArray(_data["OrderNotes"])) {
                this.orderNotes = [] as any;
                for (let item of _data["OrderNotes"])
                    this.orderNotes!.push(OrderNotesList.fromJS(item));
            }
            this.pickUp = _data["PickUp"] ? moment(_data["PickUp"].toString()) : <any>undefined;
            this.drop = _data["Drop"] ? moment(_data["Drop"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModelListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Status"] = this.status;
        data["Rate"] = this.rate;
        data["Vehicle"] = this.vehicle;
        data["VehicleId"] = this.vehicleId;
        data["Carrier"] = this.carrier;
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item);
        }
        data["Customer"] = this.customer;
        data["CustomerId"] = this.customerId;
        data["Contact"] = this.contact;
        data["OrderNumber"] = this.orderNumber;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Miles"] = this.miles;
        data["Weight"] = this.weight;
        data["PieceUnits"] = this.pieceUnits;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Location"] = this.location;
        data["DisplayLocation"] = this.displayLocation;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["StopType"] = this.stopType;
        data["StopStatusType"] = this.stopStatusType;
        data["CurrentStop"] = this.currentStop;
        data["Stops"] = this.stops;
        data["StopState"] = this.stopState;
        data["RemainingMiles"] = this.remainingMiles;
        if (Array.isArray(this.orderNotes)) {
            data["OrderNotes"] = [];
            for (let item of this.orderNotes)
                data["OrderNotes"].push(item.toJSON());
        }
        data["PickUp"] = this.pickUp ? this.pickUp.toISOString() : <any>undefined;
        data["Drop"] = this.drop ? this.drop.toISOString() : <any>undefined;
        return data;
    }

    clone(): OrderModelListView {
        const json = this.toJSON();
        let result = new OrderModelListView();
        result.init(json);
        return result;
    }
}

export interface IOrderModelListView {
    id?: number;
    status?: OrderStatus;
    rate?: number;
    vehicle?: string | undefined;
    vehicleId?: number | undefined;
    carrier?: string | undefined;
    drivers?: string[] | undefined;
    customer?: string | undefined;
    customerId?: number | undefined;
    contact?: string | undefined;
    orderNumber?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    miles?: number;
    weight?: number | undefined;
    pieceUnits?: number | undefined;
    createdAt?: moment.Moment;
    location?: string | undefined;
    displayLocation?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    stopType?: OrderStopType | undefined;
    stopStatusType?: OrderStopStatusType | undefined;
    currentStop?: number | undefined;
    stops?: number | undefined;
    stopState?: string | undefined;
    remainingMiles?: number | undefined;
    orderNotes?: OrderNotesList[] | undefined;
    pickUp?: moment.Moment;
    drop?: moment.Moment;
}

/** 1 = Arrived 2 = Heading */
export enum OrderStopStatusType {
    Arrived = 1,
    Heading = 2,
}

export class OrderNotesList implements IOrderNotesList {
    notes?: string | undefined;
    type?: NoteType;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;

    constructor(data?: IOrderNotesList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["Notes"];
            this.type = _data["Type"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): OrderNotesList {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNotesList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Notes"] = this.notes;
        data["Type"] = this.type;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        return data;
    }

    clone(): OrderNotesList {
        const json = this.toJSON();
        let result = new OrderNotesList();
        result.init(json);
        return result;
    }
}

export interface IOrderNotesList {
    notes?: string | undefined;
    type?: NoteType;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
}

export class DataListGetParamsOfOrderListFilters implements IDataListGetParamsOfOrderListFilters {
    filter?: OrderListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrderListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrderListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrderListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrderListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrderListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrderListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrderListFilters {
    filter?: OrderListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrderListFilters implements IOrderListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    driversIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    fromZip?: string | undefined;
    fromRadius?: number | undefined;
    toZip?: string | undefined;
    toRadius?: number | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
    statuses?: OrderStatus[] | undefined;

    constructor(data?: IOrderListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["DriversIds"])) {
                this.driversIds = [] as any;
                for (let item of _data["DriversIds"])
                    this.driversIds!.push(item);
            }
            if (Array.isArray(_data["CarrierIds"])) {
                this.carrierIds = [] as any;
                for (let item of _data["CarrierIds"])
                    this.carrierIds!.push(item);
            }
            this.fromZip = _data["FromZip"];
            this.fromRadius = _data["FromRadius"];
            this.toZip = _data["ToZip"];
            this.toRadius = _data["ToRadius"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            if (Array.isArray(_data["Statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["Statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        if (Array.isArray(this.driversIds)) {
            data["DriversIds"] = [];
            for (let item of this.driversIds)
                data["DriversIds"].push(item);
        }
        if (Array.isArray(this.carrierIds)) {
            data["CarrierIds"] = [];
            for (let item of this.carrierIds)
                data["CarrierIds"].push(item);
        }
        data["FromZip"] = this.fromZip;
        data["FromRadius"] = this.fromRadius;
        data["ToZip"] = this.toZip;
        data["ToRadius"] = this.toRadius;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["Statuses"] = [];
            for (let item of this.statuses)
                data["Statuses"].push(item);
        }
        return data;
    }

    clone(): OrderListFilters {
        const json = this.toJSON();
        let result = new OrderListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrderListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    driversIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    fromZip?: string | undefined;
    fromRadius?: number | undefined;
    toZip?: string | undefined;
    toRadius?: number | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
    statuses?: OrderStatus[] | undefined;
}

export class DataListGetParamsOfOrderCompleteListFilters implements IDataListGetParamsOfOrderCompleteListFilters {
    filter?: OrderCompleteListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrderCompleteListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrderCompleteListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrderCompleteListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrderCompleteListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrderCompleteListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrderCompleteListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrderCompleteListFilters {
    filter?: OrderCompleteListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrderCompleteListFilters implements IOrderCompleteListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    driversIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    type?: OrderCompleteType;

    constructor(data?: IOrderCompleteListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["DriversIds"])) {
                this.driversIds = [] as any;
                for (let item of _data["DriversIds"])
                    this.driversIds!.push(item);
            }
            if (Array.isArray(_data["CarrierIds"])) {
                this.carrierIds = [] as any;
                for (let item of _data["CarrierIds"])
                    this.carrierIds!.push(item);
            }
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): OrderCompleteListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCompleteListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        if (Array.isArray(this.driversIds)) {
            data["DriversIds"] = [];
            for (let item of this.driversIds)
                data["DriversIds"].push(item);
        }
        if (Array.isArray(this.carrierIds)) {
            data["CarrierIds"] = [];
            for (let item of this.carrierIds)
                data["CarrierIds"].push(item);
        }
        data["Type"] = this.type;
        return data;
    }

    clone(): OrderCompleteListFilters {
        const json = this.toJSON();
        let result = new OrderCompleteListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrderCompleteListFilters {
    search?: string | undefined;
    vehicleIds?: number[] | undefined;
    driversIds?: number[] | undefined;
    carrierIds?: number[] | undefined;
    type?: OrderCompleteType;
}

/** 1 = NotInvoiced 2 = NotPaid */
export enum OrderCompleteType {
    NotInvoiced = 1,
    NotPaid = 2,
}

export class OrderViewModel implements IOrderViewModel {
    id?: number;
    customerId?: number | undefined;
    customer?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    customerMC?: string | undefined;
    contactId?: number | undefined;
    contact?: string | undefined;
    contactPhone?: string | undefined;
    contactEmail?: string | undefined;
    orderNo?: string | undefined;
    team?: boolean;
    driverSharedNotes?: string | undefined;
    rate?: number;
    carrierRate?: number;
    vehicle?: string | undefined;
    vehicleId?: number | undefined;
    vehicleLocation?: string | undefined;
    displayLocation?: string | undefined;
    carrier?: string | undefined;
    status?: OrderStatus;
    drivers?: OrderDriverViewModel[] | undefined;
    driverIds?: number[] | undefined;
    canUpdateDrivers?: boolean;
    canUpdateVehicle?: boolean;
    canUpdateLocation?: boolean;
    canUpdateStops?: boolean;
    canUpdateItems?: boolean;
    canUpdateCustomer?: boolean;
    canUpdate?: boolean;
    canUpdateRate?: boolean;
    canMarkAsDraft?: boolean;
    canMarkAsReady?: boolean;
    canMarkAsInProgress?: boolean;
    canMarkAsCanceled?: boolean;
    canMarkAsCompleted?: boolean;
    canMarkAsClosed?: boolean;
    canMarkAsOnHold?: boolean;
    warnings?: string[] | undefined;
    errors?: string[] | undefined;
    hasCarrierReview?: boolean;
    hasCarrierReviewNote?: boolean;
    hasDriverReview?: boolean;
    carrierId?: number | undefined;
    externalLink?: string | undefined;

    constructor(data?: IOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"];
            this.customerNoteType = _data["CustomerNoteType"];
            this.customerNote = _data["CustomerNote"];
            this.customerMC = _data["CustomerMC"];
            this.contactId = _data["ContactId"];
            this.contact = _data["Contact"];
            this.contactPhone = _data["ContactPhone"];
            this.contactEmail = _data["ContactEmail"];
            this.orderNo = _data["OrderNo"];
            this.team = _data["Team"];
            this.driverSharedNotes = _data["DriverSharedNotes"];
            this.rate = _data["Rate"];
            this.carrierRate = _data["CarrierRate"];
            this.vehicle = _data["Vehicle"];
            this.vehicleId = _data["VehicleId"];
            this.vehicleLocation = _data["VehicleLocation"];
            this.displayLocation = _data["DisplayLocation"];
            this.carrier = _data["Carrier"];
            this.status = _data["Status"];
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(OrderDriverViewModel.fromJS(item));
            }
            if (Array.isArray(_data["DriverIds"])) {
                this.driverIds = [] as any;
                for (let item of _data["DriverIds"])
                    this.driverIds!.push(item);
            }
            this.canUpdateDrivers = _data["CanUpdateDrivers"];
            this.canUpdateVehicle = _data["CanUpdateVehicle"];
            this.canUpdateLocation = _data["CanUpdateLocation"];
            this.canUpdateStops = _data["CanUpdateStops"];
            this.canUpdateItems = _data["CanUpdateItems"];
            this.canUpdateCustomer = _data["CanUpdateCustomer"];
            this.canUpdate = _data["CanUpdate"];
            this.canUpdateRate = _data["CanUpdateRate"];
            this.canMarkAsDraft = _data["CanMarkAsDraft"];
            this.canMarkAsReady = _data["CanMarkAsReady"];
            this.canMarkAsInProgress = _data["CanMarkAsInProgress"];
            this.canMarkAsCanceled = _data["CanMarkAsCanceled"];
            this.canMarkAsCompleted = _data["CanMarkAsCompleted"];
            this.canMarkAsClosed = _data["CanMarkAsClosed"];
            this.canMarkAsOnHold = _data["CanMarkAsOnHold"];
            if (Array.isArray(_data["Warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["Warnings"])
                    this.warnings!.push(item);
            }
            if (Array.isArray(_data["Errors"])) {
                this.errors = [] as any;
                for (let item of _data["Errors"])
                    this.errors!.push(item);
            }
            this.hasCarrierReview = _data["HasCarrierReview"];
            this.hasCarrierReviewNote = _data["HasCarrierReviewNote"];
            this.hasDriverReview = _data["HasDriverReview"];
            this.carrierId = _data["CarrierId"];
            this.externalLink = _data["ExternalLink"];
        }
    }

    static fromJS(data: any): OrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer;
        data["CustomerNoteType"] = this.customerNoteType;
        data["CustomerNote"] = this.customerNote;
        data["CustomerMC"] = this.customerMC;
        data["ContactId"] = this.contactId;
        data["Contact"] = this.contact;
        data["ContactPhone"] = this.contactPhone;
        data["ContactEmail"] = this.contactEmail;
        data["OrderNo"] = this.orderNo;
        data["Team"] = this.team;
        data["DriverSharedNotes"] = this.driverSharedNotes;
        data["Rate"] = this.rate;
        data["CarrierRate"] = this.carrierRate;
        data["Vehicle"] = this.vehicle;
        data["VehicleId"] = this.vehicleId;
        data["VehicleLocation"] = this.vehicleLocation;
        data["DisplayLocation"] = this.displayLocation;
        data["Carrier"] = this.carrier;
        data["Status"] = this.status;
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.driverIds)) {
            data["DriverIds"] = [];
            for (let item of this.driverIds)
                data["DriverIds"].push(item);
        }
        data["CanUpdateDrivers"] = this.canUpdateDrivers;
        data["CanUpdateVehicle"] = this.canUpdateVehicle;
        data["CanUpdateLocation"] = this.canUpdateLocation;
        data["CanUpdateStops"] = this.canUpdateStops;
        data["CanUpdateItems"] = this.canUpdateItems;
        data["CanUpdateCustomer"] = this.canUpdateCustomer;
        data["CanUpdate"] = this.canUpdate;
        data["CanUpdateRate"] = this.canUpdateRate;
        data["CanMarkAsDraft"] = this.canMarkAsDraft;
        data["CanMarkAsReady"] = this.canMarkAsReady;
        data["CanMarkAsInProgress"] = this.canMarkAsInProgress;
        data["CanMarkAsCanceled"] = this.canMarkAsCanceled;
        data["CanMarkAsCompleted"] = this.canMarkAsCompleted;
        data["CanMarkAsClosed"] = this.canMarkAsClosed;
        data["CanMarkAsOnHold"] = this.canMarkAsOnHold;
        if (Array.isArray(this.warnings)) {
            data["Warnings"] = [];
            for (let item of this.warnings)
                data["Warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        data["HasCarrierReview"] = this.hasCarrierReview;
        data["HasCarrierReviewNote"] = this.hasCarrierReviewNote;
        data["HasDriverReview"] = this.hasDriverReview;
        data["CarrierId"] = this.carrierId;
        data["ExternalLink"] = this.externalLink;
        return data;
    }

    clone(): OrderViewModel {
        const json = this.toJSON();
        let result = new OrderViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderViewModel {
    id?: number;
    customerId?: number | undefined;
    customer?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    customerMC?: string | undefined;
    contactId?: number | undefined;
    contact?: string | undefined;
    contactPhone?: string | undefined;
    contactEmail?: string | undefined;
    orderNo?: string | undefined;
    team?: boolean;
    driverSharedNotes?: string | undefined;
    rate?: number;
    carrierRate?: number;
    vehicle?: string | undefined;
    vehicleId?: number | undefined;
    vehicleLocation?: string | undefined;
    displayLocation?: string | undefined;
    carrier?: string | undefined;
    status?: OrderStatus;
    drivers?: OrderDriverViewModel[] | undefined;
    driverIds?: number[] | undefined;
    canUpdateDrivers?: boolean;
    canUpdateVehicle?: boolean;
    canUpdateLocation?: boolean;
    canUpdateStops?: boolean;
    canUpdateItems?: boolean;
    canUpdateCustomer?: boolean;
    canUpdate?: boolean;
    canUpdateRate?: boolean;
    canMarkAsDraft?: boolean;
    canMarkAsReady?: boolean;
    canMarkAsInProgress?: boolean;
    canMarkAsCanceled?: boolean;
    canMarkAsCompleted?: boolean;
    canMarkAsClosed?: boolean;
    canMarkAsOnHold?: boolean;
    warnings?: string[] | undefined;
    errors?: string[] | undefined;
    hasCarrierReview?: boolean;
    hasCarrierReviewNote?: boolean;
    hasDriverReview?: boolean;
    carrierId?: number | undefined;
    externalLink?: string | undefined;
}

export class OrderDriverViewModel implements IOrderDriverViewModel {
    fullName?: string | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IOrderDriverViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.carrier = _data["Carrier"];
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): OrderDriverViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDriverViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["Carrier"] = this.carrier;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): OrderDriverViewModel {
        const json = this.toJSON();
        let result = new OrderDriverViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderDriverViewModel {
    fullName?: string | undefined;
    carrier?: string | undefined;
    phone?: string | undefined;
}

export class OrderStopEditModel implements IOrderStopEditModel {
    id?: number;
    orderStopAddressId?: number | undefined;
    type?: OrderStopType;
    date?: moment.Moment;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    description?: string | undefined;
    dateEnd?: moment.Moment | undefined;

    constructor(data?: IOrderStopEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.orderStopAddressId = _data["OrderStopAddressId"];
            this.type = _data["Type"];
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.isDirectOrASAP = _data["IsDirectOrASAP"];
            this.pOCName = _data["POCName"];
            this.pOCPhone = _data["POCPhone"];
            this.arrived = _data["Arrived"] ? moment(_data["Arrived"].toString()) : <any>undefined;
            this.departed = _data["Departed"] ? moment(_data["Departed"].toString()) : <any>undefined;
            this.description = _data["Description"];
            this.dateEnd = _data["DateEnd"] ? moment(_data["DateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderStopEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["OrderStopAddressId"] = this.orderStopAddressId;
        data["Type"] = this.type;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["IsDirectOrASAP"] = this.isDirectOrASAP;
        data["POCName"] = this.pOCName;
        data["POCPhone"] = this.pOCPhone;
        data["Arrived"] = this.arrived ? this.arrived.toISOString() : <any>undefined;
        data["Departed"] = this.departed ? this.departed.toISOString() : <any>undefined;
        data["Description"] = this.description;
        data["DateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): OrderStopEditModel {
        const json = this.toJSON();
        let result = new OrderStopEditModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStopEditModel {
    id?: number;
    orderStopAddressId?: number | undefined;
    type?: OrderStopType;
    date?: moment.Moment;
    isDirectOrASAP?: boolean;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    description?: string | undefined;
    dateEnd?: moment.Moment | undefined;
}

export class OrderStopViewModel extends OrderStopEditModel implements IOrderStopViewModel {
    fullAddress?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    addressNote?: string | undefined;

    constructor(data?: IOrderStopViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullAddress = _data["FullAddress"];
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipCode = _data["ZipCode"];
            this.country = _data["Country"];
            this.addressNote = _data["AddressNote"];
        }
    }

    static override fromJS(data: any): OrderStopViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullAddress"] = this.fullAddress;
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZipCode"] = this.zipCode;
        data["Country"] = this.country;
        data["AddressNote"] = this.addressNote;
        super.toJSON(data);
        return data;
    }

    clone(): OrderStopViewModel {
        const json = this.toJSON();
        let result = new OrderStopViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStopViewModel extends IOrderStopEditModel {
    fullAddress?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    addressNote?: string | undefined;
}

export class OrderItemViewModel implements IOrderItemViewModel {
    id?: number;
    description?: string | undefined;
    packing?: string | undefined;
    hazardous?: boolean;
    pieceUnits?: number;
    weight?: number;
    height?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    cargoType?: OrderItemType;

    constructor(data?: IOrderItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.packing = _data["Packing"];
            this.hazardous = _data["Hazardous"];
            this.pieceUnits = _data["PieceUnits"];
            this.weight = _data["Weight"];
            this.height = _data["Height"];
            this.width = _data["Width"];
            this.length = _data["Length"];
            this.cargoType = _data["CargoType"];
        }
    }

    static fromJS(data: any): OrderItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Packing"] = this.packing;
        data["Hazardous"] = this.hazardous;
        data["PieceUnits"] = this.pieceUnits;
        data["Weight"] = this.weight;
        data["Height"] = this.height;
        data["Width"] = this.width;
        data["Length"] = this.length;
        data["CargoType"] = this.cargoType;
        return data;
    }

    clone(): OrderItemViewModel {
        const json = this.toJSON();
        let result = new OrderItemViewModel();
        result.init(json);
        return result;
    }
}

export interface IOrderItemViewModel {
    id?: number;
    description?: string | undefined;
    packing?: string | undefined;
    hazardous?: boolean;
    pieceUnits?: number;
    weight?: number;
    height?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    cargoType?: OrderItemType;
}

export class OrderFullInfo implements IOrderFullInfo {
    orderDetails?: OrderViewModel | undefined;
    stops?: OrderStopViewModel[] | undefined;
    items?: OrderItemViewModel[] | undefined;
    fileRateConfirmations?: FileListItem[] | undefined;
    fileBillsOfLanding?: FileListItem[] | undefined;
    fileProofsOfDelivery?: FileListItem[] | undefined;
    orderCargo?: FileListItem[] | undefined;
    notes?: NoteListItem[] | undefined;
    noteAccounting?: NoteListItem[] | undefined;

    constructor(data?: IOrderFullInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetails = _data["OrderDetails"] ? OrderViewModel.fromJS(_data["OrderDetails"]) : <any>undefined;
            if (Array.isArray(_data["Stops"])) {
                this.stops = [] as any;
                for (let item of _data["Stops"])
                    this.stops!.push(OrderStopViewModel.fromJS(item));
            }
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrderItemViewModel.fromJS(item));
            }
            if (Array.isArray(_data["FileRateConfirmations"])) {
                this.fileRateConfirmations = [] as any;
                for (let item of _data["FileRateConfirmations"])
                    this.fileRateConfirmations!.push(FileListItem.fromJS(item));
            }
            if (Array.isArray(_data["FileBillsOfLanding"])) {
                this.fileBillsOfLanding = [] as any;
                for (let item of _data["FileBillsOfLanding"])
                    this.fileBillsOfLanding!.push(FileListItem.fromJS(item));
            }
            if (Array.isArray(_data["FileProofsOfDelivery"])) {
                this.fileProofsOfDelivery = [] as any;
                for (let item of _data["FileProofsOfDelivery"])
                    this.fileProofsOfDelivery!.push(FileListItem.fromJS(item));
            }
            if (Array.isArray(_data["OrderCargo"])) {
                this.orderCargo = [] as any;
                for (let item of _data["OrderCargo"])
                    this.orderCargo!.push(FileListItem.fromJS(item));
            }
            if (Array.isArray(_data["Notes"])) {
                this.notes = [] as any;
                for (let item of _data["Notes"])
                    this.notes!.push(NoteListItem.fromJS(item));
            }
            if (Array.isArray(_data["NoteAccounting"])) {
                this.noteAccounting = [] as any;
                for (let item of _data["NoteAccounting"])
                    this.noteAccounting!.push(NoteListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderFullInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFullInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderDetails"] = this.orderDetails ? this.orderDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.stops)) {
            data["Stops"] = [];
            for (let item of this.stops)
                data["Stops"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        if (Array.isArray(this.fileRateConfirmations)) {
            data["FileRateConfirmations"] = [];
            for (let item of this.fileRateConfirmations)
                data["FileRateConfirmations"].push(item.toJSON());
        }
        if (Array.isArray(this.fileBillsOfLanding)) {
            data["FileBillsOfLanding"] = [];
            for (let item of this.fileBillsOfLanding)
                data["FileBillsOfLanding"].push(item.toJSON());
        }
        if (Array.isArray(this.fileProofsOfDelivery)) {
            data["FileProofsOfDelivery"] = [];
            for (let item of this.fileProofsOfDelivery)
                data["FileProofsOfDelivery"].push(item.toJSON());
        }
        if (Array.isArray(this.orderCargo)) {
            data["OrderCargo"] = [];
            for (let item of this.orderCargo)
                data["OrderCargo"].push(item.toJSON());
        }
        if (Array.isArray(this.notes)) {
            data["Notes"] = [];
            for (let item of this.notes)
                data["Notes"].push(item.toJSON());
        }
        if (Array.isArray(this.noteAccounting)) {
            data["NoteAccounting"] = [];
            for (let item of this.noteAccounting)
                data["NoteAccounting"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderFullInfo {
        const json = this.toJSON();
        let result = new OrderFullInfo();
        result.init(json);
        return result;
    }
}

export interface IOrderFullInfo {
    orderDetails?: OrderViewModel | undefined;
    stops?: OrderStopViewModel[] | undefined;
    items?: OrderItemViewModel[] | undefined;
    fileRateConfirmations?: FileListItem[] | undefined;
    fileBillsOfLanding?: FileListItem[] | undefined;
    fileProofsOfDelivery?: FileListItem[] | undefined;
    orderCargo?: FileListItem[] | undefined;
    notes?: NoteListItem[] | undefined;
    noteAccounting?: NoteListItem[] | undefined;
}

export class DateRequest implements IDateRequest {
    date?: moment.Moment | undefined;

    constructor(data?: IDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }

    clone(): DateRequest {
        const json = this.toJSON();
        let result = new DateRequest();
        result.init(json);
        return result;
    }
}

export interface IDateRequest {
    date?: moment.Moment | undefined;
}

export class InProgressStopGroup implements IInProgressStopGroup {
    date?: moment.Moment;
    items?: InProgressStop[] | undefined;

    constructor(data?: IInProgressStopGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InProgressStop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InProgressStopGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InProgressStopGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }

    clone(): InProgressStopGroup {
        const json = this.toJSON();
        let result = new InProgressStopGroup();
        result.init(json);
        return result;
    }
}

export interface IInProgressStopGroup {
    date?: moment.Moment;
    items?: InProgressStop[] | undefined;
}

export class InProgressStop implements IInProgressStop {
    id?: number;
    status?: OrderStatus;
    vehicleNumber?: number | undefined;
    carrier?: string | undefined;
    vehicleId?: number | undefined;
    orderId?: number;
    address?: string | undefined;
    cityStateZip?: string | undefined;
    date?: moment.Moment;
    dateEnd?: moment.Moment | undefined;
    name?: string | undefined;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    description?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    type?: OrderStopType;
    drivers?: string[] | undefined;
    customer?: string | undefined;

    constructor(data?: IInProgressStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.status = _data["Status"];
            this.vehicleNumber = _data["VehicleNumber"];
            this.carrier = _data["Carrier"];
            this.vehicleId = _data["VehicleId"];
            this.orderId = _data["OrderId"];
            this.address = _data["Address"];
            this.cityStateZip = _data["CityStateZip"];
            this.date = _data["Date"] ? moment(_data["Date"].toString()) : <any>undefined;
            this.dateEnd = _data["DateEnd"] ? moment(_data["DateEnd"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.pOCName = _data["POCName"];
            this.pOCPhone = _data["POCPhone"];
            this.description = _data["Description"];
            this.arrived = _data["Arrived"] ? moment(_data["Arrived"].toString()) : <any>undefined;
            this.departed = _data["Departed"] ? moment(_data["Departed"].toString()) : <any>undefined;
            this.type = _data["Type"];
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(item);
            }
            this.customer = _data["customer"];
        }
    }

    static fromJS(data: any): InProgressStop {
        data = typeof data === 'object' ? data : {};
        let result = new InProgressStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Status"] = this.status;
        data["VehicleNumber"] = this.vehicleNumber;
        data["Carrier"] = this.carrier;
        data["VehicleId"] = this.vehicleId;
        data["OrderId"] = this.orderId;
        data["Address"] = this.address;
        data["CityStateZip"] = this.cityStateZip;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["DateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["POCName"] = this.pOCName;
        data["POCPhone"] = this.pOCPhone;
        data["Description"] = this.description;
        data["Arrived"] = this.arrived ? this.arrived.toISOString() : <any>undefined;
        data["Departed"] = this.departed ? this.departed.toISOString() : <any>undefined;
        data["Type"] = this.type;
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item);
        }
        data["customer"] = this.customer;
        return data;
    }

    clone(): InProgressStop {
        const json = this.toJSON();
        let result = new InProgressStop();
        result.init(json);
        return result;
    }
}

export interface IInProgressStop {
    id?: number;
    status?: OrderStatus;
    vehicleNumber?: number | undefined;
    carrier?: string | undefined;
    vehicleId?: number | undefined;
    orderId?: number;
    address?: string | undefined;
    cityStateZip?: string | undefined;
    date?: moment.Moment;
    dateEnd?: moment.Moment | undefined;
    name?: string | undefined;
    pOCName?: string | undefined;
    pOCPhone?: string | undefined;
    description?: string | undefined;
    arrived?: moment.Moment | undefined;
    departed?: moment.Moment | undefined;
    type?: OrderStopType;
    drivers?: string[] | undefined;
    customer?: string | undefined;
}

export class DataListResultOfOrderStopAddressModel implements IDataListResultOfOrderStopAddressModel {
    items?: OrderStopAddressModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOrderStopAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrderStopAddressModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOrderStopAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOrderStopAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOrderStopAddressModel {
        const json = this.toJSON();
        let result = new DataListResultOfOrderStopAddressModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOrderStopAddressModel {
    items?: OrderStopAddressModel[] | undefined;
    count?: number;
}

export class OrderStopAddressModel implements IOrderStopAddressModel {
    id?: number | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    fullAddress?: string | undefined;
    type?: OrderStopType;

    constructor(data?: IOrderStopAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zIP = _data["ZIP"];
            this.country = _data["Country"];
            this.note = _data["Note"];
            this.fullAddress = _data["FullAddress"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): OrderStopAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["ZIP"] = this.zIP;
        data["Country"] = this.country;
        data["Note"] = this.note;
        data["FullAddress"] = this.fullAddress;
        data["Type"] = this.type;
        return data;
    }

    clone(): OrderStopAddressModel {
        const json = this.toJSON();
        let result = new OrderStopAddressModel();
        result.init(json);
        return result;
    }
}

export interface IOrderStopAddressModel {
    id?: number | undefined;
    name?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zIP?: string | undefined;
    country?: string | undefined;
    note?: string | undefined;
    fullAddress?: string | undefined;
    type?: OrderStopType;
}

export class DataListGetParamsOfOrderStopAddressListFilters implements IDataListGetParamsOfOrderStopAddressListFilters {
    filter?: OrderStopAddressListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrderStopAddressListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrderStopAddressListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrderStopAddressListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrderStopAddressListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrderStopAddressListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrderStopAddressListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrderStopAddressListFilters {
    filter?: OrderStopAddressListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrderStopAddressListFilters implements IOrderStopAddressListFilters {
    search?: string | undefined;
    type?: OrderStopType;

    constructor(data?: IOrderStopAddressListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): OrderStopAddressListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStopAddressListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Type"] = this.type;
        return data;
    }

    clone(): OrderStopAddressListFilters {
        const json = this.toJSON();
        let result = new OrderStopAddressListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrderStopAddressListFilters {
    search?: string | undefined;
    type?: OrderStopType;
}

export class OrderQuoteModel implements IOrderQuoteModel {
    id?: number | undefined;
    rate?: number | undefined;
    visibility?: OrderQuoteVisibilityType;
    customerId?: number;
    vehicleType?: VehicleType;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpInside?: boolean;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryInside?: boolean;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    overrideDriversPreferences?: boolean;

    constructor(data?: IOrderQuoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.rate = _data["Rate"];
            this.visibility = _data["Visibility"];
            this.customerId = _data["CustomerId"];
            this.vehicleType = _data["VehicleType"];
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.pickUpInside = _data["PickUpInside"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.deliveryInside = _data["DeliveryInside"];
            this.pieces = _data["Pieces"];
            this.weight = _data["Weight"];
            this.dims = _data["Dims"];
            this.notes = _data["Notes"];
            this.orderNumber = _data["OrderNumber"];
            this.dockLevel = _data["DockLevel"];
            this.hazardous = _data["Hazardous"];
            this.liftGate = _data["LiftGate"];
            this.palletJack = _data["PalletJack"];
            this.overrideDriversPreferences = _data["OverrideDriversPreferences"];
        }
    }

    static fromJS(data: any): OrderQuoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Rate"] = this.rate;
        data["Visibility"] = this.visibility;
        data["CustomerId"] = this.customerId;
        data["VehicleType"] = this.vehicleType;
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["PickUpInside"] = this.pickUpInside;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["DeliveryInside"] = this.deliveryInside;
        data["Pieces"] = this.pieces;
        data["Weight"] = this.weight;
        data["Dims"] = this.dims;
        data["Notes"] = this.notes;
        data["OrderNumber"] = this.orderNumber;
        data["DockLevel"] = this.dockLevel;
        data["Hazardous"] = this.hazardous;
        data["LiftGate"] = this.liftGate;
        data["PalletJack"] = this.palletJack;
        data["OverrideDriversPreferences"] = this.overrideDriversPreferences;
        return data;
    }

    clone(): OrderQuoteModel {
        const json = this.toJSON();
        let result = new OrderQuoteModel();
        result.init(json);
        return result;
    }
}

export interface IOrderQuoteModel {
    id?: number | undefined;
    rate?: number | undefined;
    visibility?: OrderQuoteVisibilityType;
    customerId?: number;
    vehicleType?: VehicleType;
    pickUpZip?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    pickUpInside?: boolean;
    deliveryZip?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    deliveryInside?: boolean;
    pieces?: number;
    weight?: number;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    overrideDriversPreferences?: boolean;
}

export class OrderQuoteModelView extends OrderQuoteModel implements IOrderQuoteModelView {
    miles?: number;
    bids?: number;
    lastPostedAt?: moment.Moment | undefined;
    orderId?: number | undefined;
    status?: OrderQuoteStatus;
    customer?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;

    constructor(data?: IOrderQuoteModelView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.miles = _data["Miles"];
            this.bids = _data["Bids"];
            this.lastPostedAt = _data["LastPostedAt"] ? moment(_data["LastPostedAt"].toString()) : <any>undefined;
            this.orderId = _data["OrderId"];
            this.status = _data["Status"];
            this.customer = _data["Customer"];
            this.pickUpCity = _data["PickUpCity"];
            this.pickUpState = _data["PickUpState"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryState = _data["DeliveryState"];
        }
    }

    static override fromJS(data: any): OrderQuoteModelView {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuoteModelView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Miles"] = this.miles;
        data["Bids"] = this.bids;
        data["LastPostedAt"] = this.lastPostedAt ? this.lastPostedAt.toISOString() : <any>undefined;
        data["OrderId"] = this.orderId;
        data["Status"] = this.status;
        data["Customer"] = this.customer;
        data["PickUpCity"] = this.pickUpCity;
        data["PickUpState"] = this.pickUpState;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryState"] = this.deliveryState;
        super.toJSON(data);
        return data;
    }

    clone(): OrderQuoteModelView {
        const json = this.toJSON();
        let result = new OrderQuoteModelView();
        result.init(json);
        return result;
    }
}

export interface IOrderQuoteModelView extends IOrderQuoteModel {
    miles?: number;
    bids?: number;
    lastPostedAt?: moment.Moment | undefined;
    orderId?: number | undefined;
    status?: OrderQuoteStatus;
    customer?: string | undefined;
    pickUpCity?: string | undefined;
    pickUpState?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryState?: string | undefined;
}

export class DataListResultOfOrderQuoteModelListView implements IDataListResultOfOrderQuoteModelListView {
    items?: OrderQuoteModelListView[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOrderQuoteModelListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrderQuoteModelListView.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOrderQuoteModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOrderQuoteModelListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOrderQuoteModelListView {
        const json = this.toJSON();
        let result = new DataListResultOfOrderQuoteModelListView();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOrderQuoteModelListView {
    items?: OrderQuoteModelListView[] | undefined;
    count?: number;
}

export class OrderQuoteModelListView implements IOrderQuoteModelListView {
    id?: number;
    customer?: string | undefined;
    rate?: number | undefined;
    from?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    to?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    bids?: number;
    overrideDriversPreferences?: boolean;
    status?: OrderQuoteStatus;
    vehicleType?: VehicleType;
    lastPostedAt?: moment.Moment | undefined;
    orderId?: number | undefined;

    constructor(data?: IOrderQuoteModelListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customer = _data["Customer"];
            this.rate = _data["Rate"];
            this.from = _data["From"];
            this.pickUpASAP = _data["PickUpASAP"];
            this.pickUpDateTime = _data["PickUpDateTime"] ? moment(_data["PickUpDateTime"].toString()) : <any>undefined;
            this.to = _data["To"];
            this.deliverDirect = _data["DeliverDirect"];
            this.deliveryDateTime = _data["DeliveryDateTime"] ? moment(_data["DeliveryDateTime"].toString()) : <any>undefined;
            this.miles = _data["Miles"];
            this.pieces = _data["Pieces"];
            this.weight = _data["Weight"];
            this.dockLevel = _data["DockLevel"];
            this.hazardous = _data["Hazardous"];
            this.liftGate = _data["LiftGate"];
            this.palletJack = _data["PalletJack"];
            this.dims = _data["Dims"];
            this.notes = _data["Notes"];
            this.orderNumber = _data["OrderNumber"];
            this.bids = _data["Bids"];
            this.overrideDriversPreferences = _data["OverrideDriversPreferences"];
            this.status = _data["Status"];
            this.vehicleType = _data["VehicleType"];
            this.lastPostedAt = _data["LastPostedAt"] ? moment(_data["LastPostedAt"].toString()) : <any>undefined;
            this.orderId = _data["OrderId"];
        }
    }

    static fromJS(data: any): OrderQuoteModelListView {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuoteModelListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Customer"] = this.customer;
        data["Rate"] = this.rate;
        data["From"] = this.from;
        data["PickUpASAP"] = this.pickUpASAP;
        data["PickUpDateTime"] = this.pickUpDateTime ? this.pickUpDateTime.toISOString() : <any>undefined;
        data["To"] = this.to;
        data["DeliverDirect"] = this.deliverDirect;
        data["DeliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["Miles"] = this.miles;
        data["Pieces"] = this.pieces;
        data["Weight"] = this.weight;
        data["DockLevel"] = this.dockLevel;
        data["Hazardous"] = this.hazardous;
        data["LiftGate"] = this.liftGate;
        data["PalletJack"] = this.palletJack;
        data["Dims"] = this.dims;
        data["Notes"] = this.notes;
        data["OrderNumber"] = this.orderNumber;
        data["Bids"] = this.bids;
        data["OverrideDriversPreferences"] = this.overrideDriversPreferences;
        data["Status"] = this.status;
        data["VehicleType"] = this.vehicleType;
        data["LastPostedAt"] = this.lastPostedAt ? this.lastPostedAt.toISOString() : <any>undefined;
        data["OrderId"] = this.orderId;
        return data;
    }

    clone(): OrderQuoteModelListView {
        const json = this.toJSON();
        let result = new OrderQuoteModelListView();
        result.init(json);
        return result;
    }
}

export interface IOrderQuoteModelListView {
    id?: number;
    customer?: string | undefined;
    rate?: number | undefined;
    from?: string | undefined;
    pickUpASAP?: boolean;
    pickUpDateTime?: moment.Moment | undefined;
    to?: string | undefined;
    deliverDirect?: boolean;
    deliveryDateTime?: moment.Moment | undefined;
    miles?: number;
    pieces?: number;
    weight?: number;
    dockLevel?: boolean;
    hazardous?: boolean;
    liftGate?: boolean;
    palletJack?: boolean;
    dims?: string | undefined;
    notes?: string | undefined;
    orderNumber?: string | undefined;
    bids?: number;
    overrideDriversPreferences?: boolean;
    status?: OrderQuoteStatus;
    vehicleType?: VehicleType;
    lastPostedAt?: moment.Moment | undefined;
    orderId?: number | undefined;
}

export class DataListGetParamsOfOrderQuoteListFilters implements IDataListGetParamsOfOrderQuoteListFilters {
    filter?: OrderQuoteListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrderQuoteListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrderQuoteListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrderQuoteListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrderQuoteListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrderQuoteListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrderQuoteListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrderQuoteListFilters {
    filter?: OrderQuoteListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrderQuoteListFilters implements IOrderQuoteListFilters {

    constructor(data?: IOrderQuoteListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): OrderQuoteListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrderQuoteListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): OrderQuoteListFilters {
        const json = this.toJSON();
        let result = new OrderQuoteListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrderQuoteListFilters {
}

export class DataListResultOfOrderTaskListModel implements IDataListResultOfOrderTaskListModel {
    items?: OrderTaskListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOrderTaskListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OrderTaskListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOrderTaskListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOrderTaskListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOrderTaskListModel {
        const json = this.toJSON();
        let result = new DataListResultOfOrderTaskListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOrderTaskListModel {
    items?: OrderTaskListModel[] | undefined;
    count?: number;
}

export class OrderTaskModel implements IOrderTaskModel {
    id?: number | undefined;
    type?: OrderTaskType;
    assignedTo?: string | undefined;
    orderId?: number | undefined;
    taskNote?: string | undefined;
    taskDue?: moment.Moment;

    constructor(data?: IOrderTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.assignedTo = _data["AssignedTo"];
            this.orderId = _data["OrderId"];
            this.taskNote = _data["TaskNote"];
            this.taskDue = _data["TaskDue"] ? moment(_data["TaskDue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["AssignedTo"] = this.assignedTo;
        data["OrderId"] = this.orderId;
        data["TaskNote"] = this.taskNote;
        data["TaskDue"] = this.taskDue ? this.taskDue.toISOString() : <any>undefined;
        return data;
    }

    clone(): OrderTaskModel {
        const json = this.toJSON();
        let result = new OrderTaskModel();
        result.init(json);
        return result;
    }
}

export interface IOrderTaskModel {
    id?: number | undefined;
    type?: OrderTaskType;
    assignedTo?: string | undefined;
    orderId?: number | undefined;
    taskNote?: string | undefined;
    taskDue?: moment.Moment;
}

export class OrderTaskListModel extends OrderTaskModel implements IOrderTaskListModel {
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    status?: OrderTaskStatus;
    finishedAt?: moment.Moment | undefined;
    finishedBy?: string | undefined;
    assignedBy?: string | undefined;
    assignedAt?: moment.Moment | undefined;

    constructor(data?: IOrderTaskListModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.status = _data["Status"];
            this.finishedAt = _data["FinishedAt"] ? moment(_data["FinishedAt"].toString()) : <any>undefined;
            this.finishedBy = _data["FinishedBy"];
            this.assignedBy = _data["AssignedBy"];
            this.assignedAt = _data["AssignedAt"] ? moment(_data["AssignedAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): OrderTaskListModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTaskListModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["Status"] = this.status;
        data["FinishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["FinishedBy"] = this.finishedBy;
        data["AssignedBy"] = this.assignedBy;
        data["AssignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): OrderTaskListModel {
        const json = this.toJSON();
        let result = new OrderTaskListModel();
        result.init(json);
        return result;
    }
}

export interface IOrderTaskListModel extends IOrderTaskModel {
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    status?: OrderTaskStatus;
    finishedAt?: moment.Moment | undefined;
    finishedBy?: string | undefined;
    assignedBy?: string | undefined;
    assignedAt?: moment.Moment | undefined;
}

export class DataListGetParamsOfOrderTaskListFilters implements IDataListGetParamsOfOrderTaskListFilters {
    filter?: OrderTaskListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOrderTaskListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OrderTaskListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOrderTaskListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOrderTaskListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOrderTaskListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOrderTaskListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOrderTaskListFilters {
    filter?: OrderTaskListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OrderTaskListFilters implements IOrderTaskListFilters {
    search?: string | undefined;
    statuses?: OrderTaskStatus[] | undefined;
    types?: OrderTaskType[] | undefined;
    assignedTo?: string[] | undefined;
    orderIds?: number[] | undefined;

    constructor(data?: IOrderTaskListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            if (Array.isArray(_data["Statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["Statuses"])
                    this.statuses!.push(item);
            }
            if (Array.isArray(_data["Types"])) {
                this.types = [] as any;
                for (let item of _data["Types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["AssignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["AssignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["OrderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["OrderIds"])
                    this.orderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderTaskListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTaskListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        if (Array.isArray(this.statuses)) {
            data["Statuses"] = [];
            for (let item of this.statuses)
                data["Statuses"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["Types"] = [];
            for (let item of this.types)
                data["Types"].push(item);
        }
        if (Array.isArray(this.assignedTo)) {
            data["AssignedTo"] = [];
            for (let item of this.assignedTo)
                data["AssignedTo"].push(item);
        }
        if (Array.isArray(this.orderIds)) {
            data["OrderIds"] = [];
            for (let item of this.orderIds)
                data["OrderIds"].push(item);
        }
        return data;
    }

    clone(): OrderTaskListFilters {
        const json = this.toJSON();
        let result = new OrderTaskListFilters();
        result.init(json);
        return result;
    }
}

export interface IOrderTaskListFilters {
    search?: string | undefined;
    statuses?: OrderTaskStatus[] | undefined;
    types?: OrderTaskType[] | undefined;
    assignedTo?: string[] | undefined;
    orderIds?: number[] | undefined;
}

export class OrderTaskAssignRequest implements IOrderTaskAssignRequest {
    id?: number;
    assignTo?: string | undefined;

    constructor(data?: IOrderTaskAssignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.assignTo = _data["AssignTo"];
        }
    }

    static fromJS(data: any): OrderTaskAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTaskAssignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AssignTo"] = this.assignTo;
        return data;
    }

    clone(): OrderTaskAssignRequest {
        const json = this.toJSON();
        let result = new OrderTaskAssignRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderTaskAssignRequest {
    id?: number;
    assignTo?: string | undefined;
}

export class OrderTaskFinishRequest implements IOrderTaskFinishRequest {
    id?: number;

    constructor(data?: IOrderTaskFinishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): OrderTaskFinishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTaskFinishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data;
    }

    clone(): OrderTaskFinishRequest {
        const json = this.toJSON();
        let result = new OrderTaskFinishRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderTaskFinishRequest {
    id?: number;
}

export class DataListResultOfOwnerAccountListModel implements IDataListResultOfOwnerAccountListModel {
    items?: OwnerAccountListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfOwnerAccountListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(OwnerAccountListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfOwnerAccountListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfOwnerAccountListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfOwnerAccountListModel {
        const json = this.toJSON();
        let result = new DataListResultOfOwnerAccountListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfOwnerAccountListModel {
    items?: OwnerAccountListModel[] | undefined;
    count?: number;
}

export class OwnerAccountListModel implements IOwnerAccountListModel {
    id?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    status?: TenantOwnerStatus;
    vehicles?: string[] | undefined;
    carrier?: string | undefined;

    constructor(data?: IOwnerAccountListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.status = _data["Status"];
            if (Array.isArray(_data["Vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["Vehicles"])
                    this.vehicles!.push(item);
            }
            this.carrier = _data["Carrier"];
        }
    }

    static fromJS(data: any): OwnerAccountListModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccountListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Status"] = this.status;
        if (Array.isArray(this.vehicles)) {
            data["Vehicles"] = [];
            for (let item of this.vehicles)
                data["Vehicles"].push(item);
        }
        data["Carrier"] = this.carrier;
        return data;
    }

    clone(): OwnerAccountListModel {
        const json = this.toJSON();
        let result = new OwnerAccountListModel();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccountListModel {
    id?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    status?: TenantOwnerStatus;
    vehicles?: string[] | undefined;
    carrier?: string | undefined;
}

export class DataListGetParamsOfOwnerAccountListFilters implements IDataListGetParamsOfOwnerAccountListFilters {
    filter?: OwnerAccountListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfOwnerAccountListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? OwnerAccountListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfOwnerAccountListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfOwnerAccountListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfOwnerAccountListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfOwnerAccountListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfOwnerAccountListFilters {
    filter?: OwnerAccountListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class OwnerAccountListFilters implements IOwnerAccountListFilters {
    search?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IOwnerAccountListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): OwnerAccountListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccountListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        return data;
    }

    clone(): OwnerAccountListFilters {
        const json = this.toJSON();
        let result = new OwnerAccountListFilters();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccountListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
}

export abstract class OwnerAccountBaseModel implements IOwnerAccountBaseModel {
    name?: string | undefined;
    vehicleIds?: number[] | undefined;
    carrierId?: number | undefined;

    constructor(data?: IOwnerAccountBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            this.carrierId = _data["CarrierId"];
        }
    }

    static fromJS(data: any): OwnerAccountBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OwnerAccountBaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        data["CarrierId"] = this.carrierId;
        return data;
    }

    clone(): OwnerAccountBaseModel {
        throw new Error("The abstract class 'OwnerAccountBaseModel' cannot be instantiated.");
    }
}

export interface IOwnerAccountBaseModel {
    name?: string | undefined;
    vehicleIds?: number[] | undefined;
    carrierId?: number | undefined;
}

export class OwnerAccountNewModel extends OwnerAccountBaseModel implements IOwnerAccountNewModel {
    email?: string | undefined;

    constructor(data?: IOwnerAccountNewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["Email"];
        }
    }

    static override fromJS(data: any): OwnerAccountNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccountNewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        super.toJSON(data);
        return data;
    }

    clone(): OwnerAccountNewModel {
        const json = this.toJSON();
        let result = new OwnerAccountNewModel();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccountNewModel extends IOwnerAccountBaseModel {
    email?: string | undefined;
}

export class OwnerAccountEditModel extends OwnerAccountBaseModel implements IOwnerAccountEditModel {
    id?: number;
    email?: string | undefined;

    constructor(data?: IOwnerAccountEditModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.email = _data["Email"];
        }
    }

    static override fromJS(data: any): OwnerAccountEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccountEditModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Email"] = this.email;
        super.toJSON(data);
        return data;
    }

    clone(): OwnerAccountEditModel {
        const json = this.toJSON();
        let result = new OwnerAccountEditModel();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccountEditModel extends IOwnerAccountBaseModel {
    id?: number;
    email?: string | undefined;
}

export class OwnerAccountEditViewModel extends OwnerAccountEditModel implements IOwnerAccountEditViewModel {
    status?: TenantOwnerStatus;

    constructor(data?: IOwnerAccountEditViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["Status"];
        }
    }

    static override fromJS(data: any): OwnerAccountEditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerAccountEditViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        super.toJSON(data);
        return data;
    }

    clone(): OwnerAccountEditViewModel {
        const json = this.toJSON();
        let result = new OwnerAccountEditViewModel();
        result.init(json);
        return result;
    }
}

export interface IOwnerAccountEditViewModel extends IOwnerAccountEditModel {
    status?: TenantOwnerStatus;
}

export class DataListResultOfPaymentNetTermListModel implements IDataListResultOfPaymentNetTermListModel {
    items?: PaymentNetTermListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPaymentNetTermListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PaymentNetTermListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPaymentNetTermListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPaymentNetTermListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPaymentNetTermListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPaymentNetTermListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPaymentNetTermListModel {
    items?: PaymentNetTermListModel[] | undefined;
    count?: number;
}

export class PaymentNetTermListModel implements IPaymentNetTermListModel {
    id?: number;
    name?: string | undefined;
    netTerm?: number;
    commission?: number;
    createdAt?: moment.Moment;

    constructor(data?: IPaymentNetTermListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.netTerm = _data["NetTerm"];
            this.commission = _data["Commission"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentNetTermListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNetTermListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["NetTerm"] = this.netTerm;
        data["Commission"] = this.commission;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): PaymentNetTermListModel {
        const json = this.toJSON();
        let result = new PaymentNetTermListModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentNetTermListModel {
    id?: number;
    name?: string | undefined;
    netTerm?: number;
    commission?: number;
    createdAt?: moment.Moment;
}

export class DataListGetParamsOfPaymentNetTermListFilters implements IDataListGetParamsOfPaymentNetTermListFilters {
    filter?: PaymentNetTermListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPaymentNetTermListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PaymentNetTermListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPaymentNetTermListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPaymentNetTermListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPaymentNetTermListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPaymentNetTermListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPaymentNetTermListFilters {
    filter?: PaymentNetTermListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PaymentNetTermListFilters implements IPaymentNetTermListFilters {
    search?: string | undefined;

    constructor(data?: IPaymentNetTermListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PaymentNetTermListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNetTermListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PaymentNetTermListFilters {
        const json = this.toJSON();
        let result = new PaymentNetTermListFilters();
        result.init(json);
        return result;
    }
}

export interface IPaymentNetTermListFilters {
    search?: string | undefined;
}

export class DataListResultOfPaymentListModel implements IDataListResultOfPaymentListModel {
    items?: PaymentListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPaymentListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PaymentListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPaymentListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPaymentListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPaymentListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPaymentListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPaymentListModel {
    items?: PaymentListModel[] | undefined;
    count?: number;
}

export class PaymentListModel implements IPaymentListModel {
    id?: number;
    createdAt?: moment.Moment;
    customer?: string | undefined;
    amount?: number;
    paymentDate?: moment.Moment;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    invoiceAmount?: number;
    type?: string | undefined;
    invoices?: number[] | undefined;

    constructor(data?: IPaymentListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.customer = _data["Customer"];
            this.amount = _data["Amount"];
            this.paymentDate = _data["PaymentDate"] ? moment(_data["PaymentDate"].toString()) : <any>undefined;
            this.reference = _data["Reference"];
            this.checkNumber = _data["CheckNumber"];
            this.invoiceAmount = _data["InvoiceAmount"];
            this.type = _data["Type"];
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Customer"] = this.customer;
        data["Amount"] = this.amount;
        data["PaymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["Reference"] = this.reference;
        data["CheckNumber"] = this.checkNumber;
        data["InvoiceAmount"] = this.invoiceAmount;
        data["Type"] = this.type;
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item);
        }
        return data;
    }

    clone(): PaymentListModel {
        const json = this.toJSON();
        let result = new PaymentListModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentListModel {
    id?: number;
    createdAt?: moment.Moment;
    customer?: string | undefined;
    amount?: number;
    paymentDate?: moment.Moment;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    invoiceAmount?: number;
    type?: string | undefined;
    invoices?: number[] | undefined;
}

export class DataListGetParamsOfPaymentListFilters implements IDataListGetParamsOfPaymentListFilters {
    filter?: PaymentListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPaymentListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PaymentListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPaymentListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPaymentListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPaymentListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPaymentListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPaymentListFilters {
    filter?: PaymentListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PaymentListFilters implements IPaymentListFilters {
    search?: string | undefined;

    constructor(data?: IPaymentListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PaymentListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PaymentListFilters {
        const json = this.toJSON();
        let result = new PaymentListFilters();
        result.init(json);
        return result;
    }
}

export interface IPaymentListFilters {
    search?: string | undefined;
}

export class PaymentNetTermEditModel implements IPaymentNetTermEditModel {
    id?: number | undefined;
    name?: string | undefined;
    netTerm?: number;
    commission?: number;

    constructor(data?: IPaymentNetTermEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.netTerm = _data["NetTerm"];
            this.commission = _data["Commission"];
        }
    }

    static fromJS(data: any): PaymentNetTermEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNetTermEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["NetTerm"] = this.netTerm;
        data["Commission"] = this.commission;
        return data;
    }

    clone(): PaymentNetTermEditModel {
        const json = this.toJSON();
        let result = new PaymentNetTermEditModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentNetTermEditModel {
    id?: number | undefined;
    name?: string | undefined;
    netTerm?: number;
    commission?: number;
}

export class PaymentEditModel implements IPaymentEditModel {
    id?: number | undefined;
    customerId?: number;
    paymentDate?: moment.Moment;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    type?: PaymentMethodType;
    paymentInvoices?: PaymentInvoice2[] | undefined;

    constructor(data?: IPaymentEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.paymentDate = _data["PaymentDate"] ? moment(_data["PaymentDate"].toString()) : <any>undefined;
            this.reference = _data["Reference"];
            this.checkNumber = _data["CheckNumber"];
            this.type = _data["Type"];
            if (Array.isArray(_data["PaymentInvoices"])) {
                this.paymentInvoices = [] as any;
                for (let item of _data["PaymentInvoices"])
                    this.paymentInvoices!.push(PaymentInvoice2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["PaymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["Reference"] = this.reference;
        data["CheckNumber"] = this.checkNumber;
        data["Type"] = this.type;
        if (Array.isArray(this.paymentInvoices)) {
            data["PaymentInvoices"] = [];
            for (let item of this.paymentInvoices)
                data["PaymentInvoices"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaymentEditModel {
        const json = this.toJSON();
        let result = new PaymentEditModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentEditModel {
    id?: number | undefined;
    customerId?: number;
    paymentDate?: moment.Moment;
    reference?: string | undefined;
    checkNumber?: string | undefined;
    type?: PaymentMethodType;
    paymentInvoices?: PaymentInvoice2[] | undefined;
}

export class PaymentInvoice2 implements IPaymentInvoice2 {
    invoiceId?: number;
    amount?: number;
    closeInvoice?: boolean;

    constructor(data?: IPaymentInvoice2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.amount = _data["Amount"];
            this.closeInvoice = _data["CloseInvoice"];
        }
    }

    static fromJS(data: any): PaymentInvoice2 {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInvoice2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["Amount"] = this.amount;
        data["CloseInvoice"] = this.closeInvoice;
        return data;
    }

    clone(): PaymentInvoice2 {
        const json = this.toJSON();
        let result = new PaymentInvoice2();
        result.init(json);
        return result;
    }
}

export interface IPaymentInvoice2 {
    invoiceId?: number;
    amount?: number;
    closeInvoice?: boolean;
}

export class RTSImportRecordResponseOfRTSPurchaseResult implements IRTSImportRecordResponseOfRTSPurchaseResult {
    record?: RTSPurchaseResult | undefined;
    invoice?: InvoiceShortModel | undefined;

    constructor(data?: IRTSImportRecordResponseOfRTSPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.record = _data["Record"] ? RTSPurchaseResult.fromJS(_data["Record"]) : <any>undefined;
            this.invoice = _data["Invoice"] ? InvoiceShortModel.fromJS(_data["Invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RTSImportRecordResponseOfRTSPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RTSImportRecordResponseOfRTSPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Record"] = this.record ? this.record.toJSON() : <any>undefined;
        data["Invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): RTSImportRecordResponseOfRTSPurchaseResult {
        const json = this.toJSON();
        let result = new RTSImportRecordResponseOfRTSPurchaseResult();
        result.init(json);
        return result;
    }
}

export interface IRTSImportRecordResponseOfRTSPurchaseResult {
    record?: RTSPurchaseResult | undefined;
    invoice?: InvoiceShortModel | undefined;
}

export class RTSPurchaseResult implements IRTSPurchaseResult {
    status?: string | undefined;
    invoiceNumber?: number;
    loadPO?: string | undefined;
    invoiceAmount?: number;
    fundedAmount?: number;

    constructor(data?: IRTSPurchaseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.loadPO = _data["LoadPO"];
            this.invoiceAmount = _data["InvoiceAmount"];
            this.fundedAmount = _data["FundedAmount"];
        }
    }

    static fromJS(data: any): RTSPurchaseResult {
        data = typeof data === 'object' ? data : {};
        let result = new RTSPurchaseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["LoadPO"] = this.loadPO;
        data["InvoiceAmount"] = this.invoiceAmount;
        data["FundedAmount"] = this.fundedAmount;
        return data;
    }

    clone(): RTSPurchaseResult {
        const json = this.toJSON();
        let result = new RTSPurchaseResult();
        result.init(json);
        return result;
    }
}

export interface IRTSPurchaseResult {
    status?: string | undefined;
    invoiceNumber?: number;
    loadPO?: string | undefined;
    invoiceAmount?: number;
    fundedAmount?: number;
}

export class DataListResultOfPayoutAccountListModel implements IDataListResultOfPayoutAccountListModel {
    items?: PayoutAccountListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPayoutAccountListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PayoutAccountListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPayoutAccountListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPayoutAccountListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPayoutAccountListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPayoutAccountListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPayoutAccountListModel {
    items?: PayoutAccountListModel[] | undefined;
    count?: number;
}

export class PayoutAccountEditModel implements IPayoutAccountEditModel {
    id?: number;
    name?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    type?: PayoutAccountType;
    taxNumber?: string | undefined;
    carrierIds?: number[] | undefined;
    driverIds?: number[] | undefined;

    constructor(data?: IPayoutAccountEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.street = _data["Street"];
            this.street2 = _data["Street2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipcode = _data["Zipcode"];
            this.type = _data["Type"];
            this.taxNumber = _data["TaxNumber"];
            if (Array.isArray(_data["CarrierIds"])) {
                this.carrierIds = [] as any;
                for (let item of _data["CarrierIds"])
                    this.carrierIds!.push(item);
            }
            if (Array.isArray(_data["DriverIds"])) {
                this.driverIds = [] as any;
                for (let item of _data["DriverIds"])
                    this.driverIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PayoutAccountEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Street"] = this.street;
        data["Street2"] = this.street2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zipcode"] = this.zipcode;
        data["Type"] = this.type;
        data["TaxNumber"] = this.taxNumber;
        if (Array.isArray(this.carrierIds)) {
            data["CarrierIds"] = [];
            for (let item of this.carrierIds)
                data["CarrierIds"].push(item);
        }
        if (Array.isArray(this.driverIds)) {
            data["DriverIds"] = [];
            for (let item of this.driverIds)
                data["DriverIds"].push(item);
        }
        return data;
    }

    clone(): PayoutAccountEditModel {
        const json = this.toJSON();
        let result = new PayoutAccountEditModel();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountEditModel {
    id?: number;
    name?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    type?: PayoutAccountType;
    taxNumber?: string | undefined;
    carrierIds?: number[] | undefined;
    driverIds?: number[] | undefined;
}

export class PayoutAccountListModel extends PayoutAccountEditModel implements IPayoutAccountListModel {
    balance?: number;

    constructor(data?: IPayoutAccountListModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.balance = _data["Balance"];
        }
    }

    static override fromJS(data: any): PayoutAccountListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountListModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Balance"] = this.balance;
        super.toJSON(data);
        return data;
    }

    clone(): PayoutAccountListModel {
        const json = this.toJSON();
        let result = new PayoutAccountListModel();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountListModel extends IPayoutAccountEditModel {
    balance?: number;
}

export class DataListGetParamsOfPayoutAccountListFilters implements IDataListGetParamsOfPayoutAccountListFilters {
    filter?: PayoutAccountListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPayoutAccountListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PayoutAccountListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPayoutAccountListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPayoutAccountListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPayoutAccountListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPayoutAccountListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPayoutAccountListFilters {
    filter?: PayoutAccountListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PayoutAccountListFilters implements IPayoutAccountListFilters {
    search?: string | undefined;
    type?: PayoutAccountType;

    constructor(data?: IPayoutAccountListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): PayoutAccountListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Type"] = this.type;
        return data;
    }

    clone(): PayoutAccountListFilters {
        const json = this.toJSON();
        let result = new PayoutAccountListFilters();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountListFilters {
    search?: string | undefined;
    type?: PayoutAccountType;
}

export class PayoutAccountAdjustBalanceEdit implements IPayoutAccountAdjustBalanceEdit {
    id?: number;
    adjustment?: number;
    description?: string | undefined;

    constructor(data?: IPayoutAccountAdjustBalanceEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.adjustment = _data["Adjustment"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): PayoutAccountAdjustBalanceEdit {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutAccountAdjustBalanceEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Adjustment"] = this.adjustment;
        data["Description"] = this.description;
        return data;
    }

    clone(): PayoutAccountAdjustBalanceEdit {
        const json = this.toJSON();
        let result = new PayoutAccountAdjustBalanceEdit();
        result.init(json);
        return result;
    }
}

export interface IPayoutAccountAdjustBalanceEdit {
    id?: number;
    adjustment?: number;
    description?: string | undefined;
}

export class DriverCompensationEdit implements IDriverCompensationEdit {
    id?: number;
    amount?: number;
    driverId?: number;
    type?: OrderPayoutDriverCompensationType;
    description?: string | undefined;

    constructor(data?: IDriverCompensationEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.amount = _data["Amount"];
            this.driverId = _data["DriverId"];
            this.type = _data["Type"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): DriverCompensationEdit {
        data = typeof data === 'object' ? data : {};
        let result = new DriverCompensationEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Amount"] = this.amount;
        data["DriverId"] = this.driverId;
        data["Type"] = this.type;
        data["Description"] = this.description;
        return data;
    }

    clone(): DriverCompensationEdit {
        const json = this.toJSON();
        let result = new DriverCompensationEdit();
        result.init(json);
        return result;
    }
}

export interface IDriverCompensationEdit {
    id?: number;
    amount?: number;
    driverId?: number;
    type?: OrderPayoutDriverCompensationType;
    description?: string | undefined;
}

export class CarrierCompensationEdit implements ICarrierCompensationEdit {
    id?: number;
    amount?: number;
    carrierId?: number;
    description?: string | undefined;

    constructor(data?: ICarrierCompensationEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.amount = _data["Amount"];
            this.carrierId = _data["CarrierId"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): CarrierCompensationEdit {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierCompensationEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Amount"] = this.amount;
        data["CarrierId"] = this.carrierId;
        data["Description"] = this.description;
        return data;
    }

    clone(): CarrierCompensationEdit {
        const json = this.toJSON();
        let result = new CarrierCompensationEdit();
        result.init(json);
        return result;
    }
}

export interface ICarrierCompensationEdit {
    id?: number;
    amount?: number;
    carrierId?: number;
    description?: string | undefined;
}

export class OrderExpenseEdit implements IOrderExpenseEdit {
    id?: number;
    amount?: number;
    type?: OrderExpenseType;
    description?: string | undefined;

    constructor(data?: IOrderExpenseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.amount = _data["Amount"];
            this.type = _data["Type"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): OrderExpenseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new OrderExpenseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Amount"] = this.amount;
        data["Type"] = this.type;
        data["Description"] = this.description;
        return data;
    }

    clone(): OrderExpenseEdit {
        const json = this.toJSON();
        let result = new OrderExpenseEdit();
        result.init(json);
        return result;
    }
}

export interface IOrderExpenseEdit {
    id?: number;
    amount?: number;
    type?: OrderExpenseType;
    description?: string | undefined;
}

export class RadarData implements IRadarData {
    items?: RadarModel[] | undefined;
    sourceUpdates?: LastUpdatedAt[] | undefined;

    constructor(data?: IRadarData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(RadarModel.fromJS(item));
            }
            if (Array.isArray(_data["SourceUpdates"])) {
                this.sourceUpdates = [] as any;
                for (let item of _data["SourceUpdates"])
                    this.sourceUpdates!.push(LastUpdatedAt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RadarData {
        data = typeof data === 'object' ? data : {};
        let result = new RadarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceUpdates)) {
            data["SourceUpdates"] = [];
            for (let item of this.sourceUpdates)
                data["SourceUpdates"].push(item.toJSON());
        }
        return data;
    }

    clone(): RadarData {
        const json = this.toJSON();
        let result = new RadarData();
        result.init(json);
        return result;
    }
}

export interface IRadarData {
    items?: RadarModel[] | undefined;
    sourceUpdates?: LastUpdatedAt[] | undefined;
}

export class RadarModel implements IRadarModel {
    id?: number;
    contact?: string | undefined;
    contactPhone?: string | undefined;
    contactEmail?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    pickup?: string | undefined;
    pickupDate?: moment.Moment | undefined;
    drop?: string | undefined;
    miles?: number;
    pieces?: number;
    fromZip?: string | undefined;
    fromState?: string | undefined;
    deliveryState?: string | undefined;
    toZip?: string | undefined;
    weight?: number;
    note?: string | undefined;
    orderNumber?: string | undefined;
    vehicleType?: string | undefined;
    price?: number;
    postedFrom?: moment.Moment | undefined;
    postedTo?: moment.Moment | undefined;
    source?: OrderSource;
    bidIds?: number[] | undefined;
    vehicleNumbers?: number[] | undefined;
    vehicleIds?: number[] | undefined;
    customer?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    customerName?: string | undefined;
    customerMc?: string | undefined;
    isViewed?: boolean;
    integration?: string | undefined;
    integrationsId?: number | undefined;
    integrationId?: number | undefined;

    constructor(data?: IRadarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.contact = _data["Contact"];
            this.contactPhone = _data["ContactPhone"];
            this.contactEmail = _data["ContactEmail"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.pickup = _data["Pickup"];
            this.pickupDate = _data["PickupDate"] ? moment(_data["PickupDate"].toString()) : <any>undefined;
            this.drop = _data["Drop"];
            this.miles = _data["Miles"];
            this.pieces = _data["Pieces"];
            this.fromZip = _data["FromZip"];
            this.fromState = _data["FromState"];
            this.deliveryState = _data["DeliveryState"];
            this.toZip = _data["ToZip"];
            this.weight = _data["Weight"];
            this.note = _data["Note"];
            this.orderNumber = _data["OrderNumber"];
            this.vehicleType = _data["VehicleType"];
            this.price = _data["Price"];
            this.postedFrom = _data["PostedFrom"] ? moment(_data["PostedFrom"].toString()) : <any>undefined;
            this.postedTo = _data["PostedTo"] ? moment(_data["PostedTo"].toString()) : <any>undefined;
            this.source = _data["Source"];
            if (Array.isArray(_data["BidIds"])) {
                this.bidIds = [] as any;
                for (let item of _data["BidIds"])
                    this.bidIds!.push(item);
            }
            if (Array.isArray(_data["VehicleNumbers"])) {
                this.vehicleNumbers = [] as any;
                for (let item of _data["VehicleNumbers"])
                    this.vehicleNumbers!.push(item);
            }
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            this.customer = _data["Customer"];
            this.customerNoteType = _data["CustomerNoteType"];
            this.customerNote = _data["CustomerNote"];
            this.customerName = _data["CustomerName"];
            this.customerMc = _data["CustomerMc"];
            this.isViewed = _data["IsViewed"];
            this.integration = _data["Integration"];
            this.integrationsId = _data["IntegrationsId"];
            this.integrationId = _data["IntegrationId"];
        }
    }

    static fromJS(data: any): RadarModel {
        data = typeof data === 'object' ? data : {};
        let result = new RadarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Contact"] = this.contact;
        data["ContactPhone"] = this.contactPhone;
        data["ContactEmail"] = this.contactEmail;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Pickup"] = this.pickup;
        data["PickupDate"] = this.pickupDate ? this.pickupDate.toISOString() : <any>undefined;
        data["Drop"] = this.drop;
        data["Miles"] = this.miles;
        data["Pieces"] = this.pieces;
        data["FromZip"] = this.fromZip;
        data["FromState"] = this.fromState;
        data["DeliveryState"] = this.deliveryState;
        data["ToZip"] = this.toZip;
        data["Weight"] = this.weight;
        data["Note"] = this.note;
        data["OrderNumber"] = this.orderNumber;
        data["VehicleType"] = this.vehicleType;
        data["Price"] = this.price;
        data["PostedFrom"] = this.postedFrom ? this.postedFrom.toISOString() : <any>undefined;
        data["PostedTo"] = this.postedTo ? this.postedTo.toISOString() : <any>undefined;
        data["Source"] = this.source;
        if (Array.isArray(this.bidIds)) {
            data["BidIds"] = [];
            for (let item of this.bidIds)
                data["BidIds"].push(item);
        }
        if (Array.isArray(this.vehicleNumbers)) {
            data["VehicleNumbers"] = [];
            for (let item of this.vehicleNumbers)
                data["VehicleNumbers"].push(item);
        }
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        data["Customer"] = this.customer;
        data["CustomerNoteType"] = this.customerNoteType;
        data["CustomerNote"] = this.customerNote;
        data["CustomerName"] = this.customerName;
        data["CustomerMc"] = this.customerMc;
        data["IsViewed"] = this.isViewed;
        data["Integration"] = this.integration;
        data["IntegrationsId"] = this.integrationsId;
        data["IntegrationId"] = this.integrationId;
        return data;
    }

    clone(): RadarModel {
        const json = this.toJSON();
        let result = new RadarModel();
        result.init(json);
        return result;
    }
}

export interface IRadarModel {
    id?: number;
    contact?: string | undefined;
    contactPhone?: string | undefined;
    contactEmail?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    pickup?: string | undefined;
    pickupDate?: moment.Moment | undefined;
    drop?: string | undefined;
    miles?: number;
    pieces?: number;
    fromZip?: string | undefined;
    fromState?: string | undefined;
    deliveryState?: string | undefined;
    toZip?: string | undefined;
    weight?: number;
    note?: string | undefined;
    orderNumber?: string | undefined;
    vehicleType?: string | undefined;
    price?: number;
    postedFrom?: moment.Moment | undefined;
    postedTo?: moment.Moment | undefined;
    source?: OrderSource;
    bidIds?: number[] | undefined;
    vehicleNumbers?: number[] | undefined;
    vehicleIds?: number[] | undefined;
    customer?: string | undefined;
    customerNoteType?: CustomerNoteType | undefined;
    customerNote?: string | undefined;
    customerName?: string | undefined;
    customerMc?: string | undefined;
    isViewed?: boolean;
    integration?: string | undefined;
    integrationsId?: number | undefined;
    integrationId?: number | undefined;
}

export class LastUpdatedAt implements ILastUpdatedAt {
    source?: string | undefined;
    logType?: CompanyIntegrationLogType | undefined;
    lastSync?: moment.Moment | undefined;

    constructor(data?: ILastUpdatedAt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["Source"];
            this.logType = _data["LogType"];
            this.lastSync = _data["LastSync"] ? moment(_data["LastSync"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LastUpdatedAt {
        data = typeof data === 'object' ? data : {};
        let result = new LastUpdatedAt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Source"] = this.source;
        data["LogType"] = this.logType;
        data["LastSync"] = this.lastSync ? this.lastSync.toISOString() : <any>undefined;
        return data;
    }

    clone(): LastUpdatedAt {
        const json = this.toJSON();
        let result = new LastUpdatedAt();
        result.init(json);
        return result;
    }
}

export interface ILastUpdatedAt {
    source?: string | undefined;
    logType?: CompanyIntegrationLogType | undefined;
    lastSync?: moment.Moment | undefined;
}

export class DataListResultOfRadarModel implements IDataListResultOfRadarModel {
    items?: RadarModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfRadarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(RadarModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfRadarModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfRadarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfRadarModel {
        const json = this.toJSON();
        let result = new DataListResultOfRadarModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfRadarModel {
    items?: RadarModel[] | undefined;
    count?: number;
}

export class RadarSearchDataResponse extends DataListResultOfRadarModel implements IRadarSearchDataResponse {
    sourceUpdates?: LastUpdatedAt[] | undefined;

    constructor(data?: IRadarSearchDataResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["SourceUpdates"])) {
                this.sourceUpdates = [] as any;
                for (let item of _data["SourceUpdates"])
                    this.sourceUpdates!.push(LastUpdatedAt.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RadarSearchDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RadarSearchDataResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceUpdates)) {
            data["SourceUpdates"] = [];
            for (let item of this.sourceUpdates)
                data["SourceUpdates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RadarSearchDataResponse {
        const json = this.toJSON();
        let result = new RadarSearchDataResponse();
        result.init(json);
        return result;
    }
}

export interface IRadarSearchDataResponse extends IDataListResultOfRadarModel {
    sourceUpdates?: LastUpdatedAt[] | undefined;
}

export class DataListGetParamsOfGetOrdersSearchParams implements IDataListGetParamsOfGetOrdersSearchParams {
    filter?: GetOrdersSearchParams | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfGetOrdersSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? GetOrdersSearchParams.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfGetOrdersSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfGetOrdersSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfGetOrdersSearchParams {
        const json = this.toJSON();
        let result = new DataListGetParamsOfGetOrdersSearchParams();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfGetOrdersSearchParams {
    filter?: GetOrdersSearchParams | undefined;
    pageSize?: number;
    offset?: number;
}

export class GetOrdersSearchParams implements IGetOrdersSearchParams {
    pickUpZip?: string | undefined;
    pickUpRadius?: number | undefined;
    deliveryZip?: string | undefined;
    deliveryRadius?: number | undefined;

    constructor(data?: IGetOrdersSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickUpZip = _data["PickUpZip"];
            this.pickUpRadius = _data["PickUpRadius"];
            this.deliveryZip = _data["DeliveryZip"];
            this.deliveryRadius = _data["DeliveryRadius"];
        }
    }

    static fromJS(data: any): GetOrdersSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PickUpZip"] = this.pickUpZip;
        data["PickUpRadius"] = this.pickUpRadius;
        data["DeliveryZip"] = this.deliveryZip;
        data["DeliveryRadius"] = this.deliveryRadius;
        return data;
    }

    clone(): GetOrdersSearchParams {
        const json = this.toJSON();
        let result = new GetOrdersSearchParams();
        result.init(json);
        return result;
    }
}

export interface IGetOrdersSearchParams {
    pickUpZip?: string | undefined;
    pickUpRadius?: number | undefined;
    deliveryZip?: string | undefined;
    deliveryRadius?: number | undefined;
}

export class ZipCodeInfo implements IZipCodeInfo {
    id?: number;
    zip?: string | undefined;
    primaryCity?: string | undefined;
    acceptableCities?: string | undefined;
    unacceptableCities?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    timezone?: string | undefined;
    areaCodes?: string | undefined;
    worldRegion?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
    shortInfo?: string | undefined;

    constructor(data?: IZipCodeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.zip = _data["Zip"];
            this.primaryCity = _data["PrimaryCity"];
            this.acceptableCities = _data["AcceptableCities"];
            this.unacceptableCities = _data["UnacceptableCities"];
            this.state = _data["State"];
            this.county = _data["County"];
            this.timezone = _data["Timezone"];
            this.areaCodes = _data["AreaCodes"];
            this.worldRegion = _data["WorldRegion"];
            this.country = _data["Country"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.shortInfo = _data["ShortInfo"];
        }
    }

    static fromJS(data: any): ZipCodeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ZipCodeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Zip"] = this.zip;
        data["PrimaryCity"] = this.primaryCity;
        data["AcceptableCities"] = this.acceptableCities;
        data["UnacceptableCities"] = this.unacceptableCities;
        data["State"] = this.state;
        data["County"] = this.county;
        data["Timezone"] = this.timezone;
        data["AreaCodes"] = this.areaCodes;
        data["WorldRegion"] = this.worldRegion;
        data["Country"] = this.country;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["ShortInfo"] = this.shortInfo;
        return data;
    }

    clone(): ZipCodeInfo {
        const json = this.toJSON();
        let result = new ZipCodeInfo();
        result.init(json);
        return result;
    }
}

export interface IZipCodeInfo {
    id?: number;
    zip?: string | undefined;
    primaryCity?: string | undefined;
    acceptableCities?: string | undefined;
    unacceptableCities?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    timezone?: string | undefined;
    areaCodes?: string | undefined;
    worldRegion?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
    shortInfo?: string | undefined;
}

export class OrderVehicleMatchDebugResponse implements IOrderVehicleMatchDebugResponse {
    vehicle?: OrderVehicleMatchDebugVehicleSummary | undefined;
    orderResults?: OrderVehicleMatchDebugOrderResult[] | undefined;
    vehicleNotFound?: boolean;

    constructor(data?: IOrderVehicleMatchDebugResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle = _data["Vehicle"] ? OrderVehicleMatchDebugVehicleSummary.fromJS(_data["Vehicle"]) : <any>undefined;
            if (Array.isArray(_data["OrderResults"])) {
                this.orderResults = [] as any;
                for (let item of _data["OrderResults"])
                    this.orderResults!.push(OrderVehicleMatchDebugOrderResult.fromJS(item));
            }
            this.vehicleNotFound = _data["VehicleNotFound"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.orderResults)) {
            data["OrderResults"] = [];
            for (let item of this.orderResults)
                data["OrderResults"].push(item.toJSON());
        }
        data["VehicleNotFound"] = this.vehicleNotFound;
        return data;
    }

    clone(): OrderVehicleMatchDebugResponse {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugResponse();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugResponse {
    vehicle?: OrderVehicleMatchDebugVehicleSummary | undefined;
    orderResults?: OrderVehicleMatchDebugOrderResult[] | undefined;
    vehicleNotFound?: boolean;
}

export class OrderVehicleMatchDebugVehicleSummary implements IOrderVehicleMatchDebugVehicleSummary {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    desLat?: number | undefined;
    desLon?: number | undefined;
    pickUpRadius?: number;

    constructor(data?: IOrderVehicleMatchDebugVehicleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["VehicleId"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.desLat = _data["DesLat"];
            this.desLon = _data["DesLon"];
            this.pickUpRadius = _data["PickUpRadius"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugVehicleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugVehicleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["DesLat"] = this.desLat;
        data["DesLon"] = this.desLon;
        data["PickUpRadius"] = this.pickUpRadius;
        return data;
    }

    clone(): OrderVehicleMatchDebugVehicleSummary {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugVehicleSummary();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugVehicleSummary {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    desLat?: number | undefined;
    desLon?: number | undefined;
    pickUpRadius?: number;
}

export class OrderVehicleMatchDebugOrderResult implements IOrderVehicleMatchDebugOrderResult {
    orderId?: number;
    orderType?: OrderSourceType;
    notFound?: boolean;
    eligible?: boolean;
    conditions?: OrderVehicleMatchDebugConditionResult[] | undefined;
    location?: OrderVehicleMatchDebugLocationResult | undefined;
    inPostedOrderCache?: boolean;
    vehicleMappedToOrderInCache?: boolean;

    constructor(data?: IOrderVehicleMatchDebugOrderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.orderType = _data["OrderType"];
            this.notFound = _data["NotFound"];
            this.eligible = _data["Eligible"];
            if (Array.isArray(_data["Conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["Conditions"])
                    this.conditions!.push(OrderVehicleMatchDebugConditionResult.fromJS(item));
            }
            this.location = _data["Location"] ? OrderVehicleMatchDebugLocationResult.fromJS(_data["Location"]) : <any>undefined;
            this.inPostedOrderCache = _data["InPostedOrderCache"];
            this.vehicleMappedToOrderInCache = _data["VehicleMappedToOrderInCache"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugOrderResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugOrderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["OrderType"] = this.orderType;
        data["NotFound"] = this.notFound;
        data["Eligible"] = this.eligible;
        if (Array.isArray(this.conditions)) {
            data["Conditions"] = [];
            for (let item of this.conditions)
                data["Conditions"].push(item.toJSON());
        }
        data["Location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["InPostedOrderCache"] = this.inPostedOrderCache;
        data["VehicleMappedToOrderInCache"] = this.vehicleMappedToOrderInCache;
        return data;
    }

    clone(): OrderVehicleMatchDebugOrderResult {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugOrderResult();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugOrderResult {
    orderId?: number;
    orderType?: OrderSourceType;
    notFound?: boolean;
    eligible?: boolean;
    conditions?: OrderVehicleMatchDebugConditionResult[] | undefined;
    location?: OrderVehicleMatchDebugLocationResult | undefined;
    inPostedOrderCache?: boolean;
    vehicleMappedToOrderInCache?: boolean;
}

export class OrderVehicleMatchDebugConditionResult implements IOrderVehicleMatchDebugConditionResult {
    name?: string | undefined;
    applied?: boolean;
    matched?: boolean;
    vehicleValue?: string | undefined;
    orderValue?: string | undefined;

    constructor(data?: IOrderVehicleMatchDebugConditionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.applied = _data["Applied"];
            this.matched = _data["Matched"];
            this.vehicleValue = _data["VehicleValue"];
            this.orderValue = _data["OrderValue"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugConditionResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugConditionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Applied"] = this.applied;
        data["Matched"] = this.matched;
        data["VehicleValue"] = this.vehicleValue;
        data["OrderValue"] = this.orderValue;
        return data;
    }

    clone(): OrderVehicleMatchDebugConditionResult {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugConditionResult();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugConditionResult {
    name?: string | undefined;
    applied?: boolean;
    matched?: boolean;
    vehicleValue?: string | undefined;
    orderValue?: string | undefined;
}

export class OrderVehicleMatchDebugLocationResult implements IOrderVehicleMatchDebugLocationResult {
    distanceFromCurrent?: number | undefined;
    distanceFromDestination?: number | undefined;
    withinRadiusFromCurrent?: boolean;
    withinRadiusFromDestination?: boolean;

    constructor(data?: IOrderVehicleMatchDebugLocationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distanceFromCurrent = _data["DistanceFromCurrent"];
            this.distanceFromDestination = _data["DistanceFromDestination"];
            this.withinRadiusFromCurrent = _data["WithinRadiusFromCurrent"];
            this.withinRadiusFromDestination = _data["WithinRadiusFromDestination"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugLocationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugLocationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DistanceFromCurrent"] = this.distanceFromCurrent;
        data["DistanceFromDestination"] = this.distanceFromDestination;
        data["WithinRadiusFromCurrent"] = this.withinRadiusFromCurrent;
        data["WithinRadiusFromDestination"] = this.withinRadiusFromDestination;
        return data;
    }

    clone(): OrderVehicleMatchDebugLocationResult {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugLocationResult();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugLocationResult {
    distanceFromCurrent?: number | undefined;
    distanceFromDestination?: number | undefined;
    withinRadiusFromCurrent?: boolean;
    withinRadiusFromDestination?: boolean;
}

export class OrderVehicleMatchDebugRequest implements IOrderVehicleMatchDebugRequest {
    vehicleId?: number;
    orders?: OrderVehicleMatchDebugOrderRequest[] | undefined;

    constructor(data?: IOrderVehicleMatchDebugRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["VehicleId"];
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(OrderVehicleMatchDebugOrderRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrderVehicleMatchDebugRequest {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugRequest {
    vehicleId?: number;
    orders?: OrderVehicleMatchDebugOrderRequest[] | undefined;
}

export class OrderVehicleMatchDebugOrderRequest implements IOrderVehicleMatchDebugOrderRequest {
    orderId?: number;
    orderType?: OrderSourceType;

    constructor(data?: IOrderVehicleMatchDebugOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.orderType = _data["OrderType"];
        }
    }

    static fromJS(data: any): OrderVehicleMatchDebugOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVehicleMatchDebugOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["OrderType"] = this.orderType;
        return data;
    }

    clone(): OrderVehicleMatchDebugOrderRequest {
        const json = this.toJSON();
        let result = new OrderVehicleMatchDebugOrderRequest();
        result.init(json);
        return result;
    }
}

export interface IOrderVehicleMatchDebugOrderRequest {
    orderId?: number;
    orderType?: OrderSourceType;
}

export class RateEntry implements IRateEntry {
    origin?: Region;
    groups?: RateGroup[] | undefined;

    constructor(data?: IRateEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["Origin"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(RateGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RateEntry {
        data = typeof data === 'object' ? data : {};
        let result = new RateEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Origin"] = this.origin;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item.toJSON());
        }
        return data;
    }

    clone(): RateEntry {
        const json = this.toJSON();
        let result = new RateEntry();
        result.init(json);
        return result;
    }
}

export interface IRateEntry {
    origin?: Region;
    groups?: RateGroup[] | undefined;
}

/** 1 = EastNorthCentral 2 = EastSouthCentral 3 = MidAtlantic 4 = Mountain 5 = NewEngland 6 = Pacific 7 = SouthAtlantic 8 = WestNorthCentral 9 = WestSouthCentral */
export enum Region {
    EastNorthCentral = 1,
    EastSouthCentral = 2,
    MidAtlantic = 3,
    Mountain = 4,
    NewEngland = 5,
    Pacific = 6,
    SouthAtlantic = 7,
    WestNorthCentral = 8,
    WestSouthCentral = 9,
}

export class RateGroup implements IRateGroup {
    destinations?: Region[] | undefined;
    rate?: RatePerMile | undefined;

    constructor(data?: IRateGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["Destinations"])
                    this.destinations!.push(item);
            }
            this.rate = _data["Rate"] ? RatePerMile.fromJS(_data["Rate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RateGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RateGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinations)) {
            data["Destinations"] = [];
            for (let item of this.destinations)
                data["Destinations"].push(item);
        }
        data["Rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        return data;
    }

    clone(): RateGroup {
        const json = this.toJSON();
        let result = new RateGroup();
        result.init(json);
        return result;
    }
}

export interface IRateGroup {
    destinations?: Region[] | undefined;
    rate?: RatePerMile | undefined;
}

export class RatePerMile implements IRatePerMile {
    sprinter?: number;
    smallStraight?: number;
    largeStraight?: number;

    constructor(data?: IRatePerMile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sprinter = _data["Sprinter"];
            this.smallStraight = _data["SmallStraight"];
            this.largeStraight = _data["LargeStraight"];
        }
    }

    static fromJS(data: any): RatePerMile {
        data = typeof data === 'object' ? data : {};
        let result = new RatePerMile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sprinter"] = this.sprinter;
        data["SmallStraight"] = this.smallStraight;
        data["LargeStraight"] = this.largeStraight;
        return data;
    }

    clone(): RatePerMile {
        const json = this.toJSON();
        let result = new RatePerMile();
        result.init(json);
        return result;
    }
}

export interface IRatePerMile {
    sprinter?: number;
    smallStraight?: number;
    largeStraight?: number;
}

export class RegionDefinition implements IRegionDefinition {
    id?: number;
    name?: string | undefined;
    states?: string[] | undefined;

    constructor(data?: IRegionDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(item);
            }
        }
    }

    static fromJS(data: any): RegionDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item);
        }
        return data;
    }

    clone(): RegionDefinition {
        const json = this.toJSON();
        let result = new RegionDefinition();
        result.init(json);
        return result;
    }
}

export interface IRegionDefinition {
    id?: number;
    name?: string | undefined;
    states?: string[] | undefined;
}

export class BidRateSettings implements IBidRateSettings {
    enableAutoBid?: boolean;
    rate?: number;
    allowedRateRange?: number;
    disableAt?: moment.Moment | undefined;

    constructor(data?: IBidRateSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableAutoBid = _data["EnableAutoBid"];
            this.rate = _data["Rate"];
            this.allowedRateRange = _data["AllowedRateRange"];
            this.disableAt = _data["DisableAt"] ? moment(_data["DisableAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BidRateSettings {
        data = typeof data === 'object' ? data : {};
        let result = new BidRateSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EnableAutoBid"] = this.enableAutoBid;
        data["Rate"] = this.rate;
        data["AllowedRateRange"] = this.allowedRateRange;
        data["DisableAt"] = this.disableAt ? this.disableAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): BidRateSettings {
        const json = this.toJSON();
        let result = new BidRateSettings();
        result.init(json);
        return result;
    }
}

export interface IBidRateSettings {
    enableAutoBid?: boolean;
    rate?: number;
    allowedRateRange?: number;
    disableAt?: moment.Moment | undefined;
}

export class BidSmtpSettings implements IBidSmtpSettings {
    smtpIntegrationId?: number | undefined;

    constructor(data?: IBidSmtpSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smtpIntegrationId = _data["SmtpIntegrationId"];
        }
    }

    static fromJS(data: any): BidSmtpSettings {
        data = typeof data === 'object' ? data : {};
        let result = new BidSmtpSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SmtpIntegrationId"] = this.smtpIntegrationId;
        return data;
    }

    clone(): BidSmtpSettings {
        const json = this.toJSON();
        let result = new BidSmtpSettings();
        result.init(json);
        return result;
    }
}

export interface IBidSmtpSettings {
    smtpIntegrationId?: number | undefined;
}

export class CompanySettings implements ICompanySettings {
    officePhone?: string | undefined;
    officeEmail?: string | undefined;
    dispatchPhone?: string | undefined;
    dispatchEmail?: string | undefined;
    mcNumber?: string | undefined;

    constructor(data?: ICompanySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officePhone = _data["OfficePhone"];
            this.officeEmail = _data["OfficeEmail"];
            this.dispatchPhone = _data["DispatchPhone"];
            this.dispatchEmail = _data["DispatchEmail"];
            this.mcNumber = _data["McNumber"];
        }
    }

    static fromJS(data: any): CompanySettings {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OfficePhone"] = this.officePhone;
        data["OfficeEmail"] = this.officeEmail;
        data["DispatchPhone"] = this.dispatchPhone;
        data["DispatchEmail"] = this.dispatchEmail;
        data["McNumber"] = this.mcNumber;
        return data;
    }

    clone(): CompanySettings {
        const json = this.toJSON();
        let result = new CompanySettings();
        result.init(json);
        return result;
    }
}

export interface ICompanySettings {
    officePhone?: string | undefined;
    officeEmail?: string | undefined;
    dispatchPhone?: string | undefined;
    dispatchEmail?: string | undefined;
    mcNumber?: string | undefined;
}

export class EmailBidSettings implements IEmailBidSettings {
    subjectTemplate?: string | undefined;
    bodyTemplate?: string | undefined;
    fromDisplayTemplate?: string | undefined;
    fromEmail?: string | undefined;
    cCEmail?: string | undefined;

    constructor(data?: IEmailBidSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectTemplate = _data["SubjectTemplate"];
            this.bodyTemplate = _data["BodyTemplate"];
            this.fromDisplayTemplate = _data["FromDisplayTemplate"];
            this.fromEmail = _data["FromEmail"];
            this.cCEmail = _data["CCEmail"];
        }
    }

    static fromJS(data: any): EmailBidSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EmailBidSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubjectTemplate"] = this.subjectTemplate;
        data["BodyTemplate"] = this.bodyTemplate;
        data["FromDisplayTemplate"] = this.fromDisplayTemplate;
        data["FromEmail"] = this.fromEmail;
        data["CCEmail"] = this.cCEmail;
        return data;
    }

    clone(): EmailBidSettings {
        const json = this.toJSON();
        let result = new EmailBidSettings();
        result.init(json);
        return result;
    }
}

export interface IEmailBidSettings {
    subjectTemplate?: string | undefined;
    bodyTemplate?: string | undefined;
    fromDisplayTemplate?: string | undefined;
    fromEmail?: string | undefined;
    cCEmail?: string | undefined;
}

export class EmailBidSettingParam implements IEmailBidSettingParam {
    param?: string | undefined;
    example?: string | undefined;

    constructor(data?: IEmailBidSettingParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.param = _data["Param"];
            this.example = _data["Example"];
        }
    }

    static fromJS(data: any): EmailBidSettingParam {
        data = typeof data === 'object' ? data : {};
        let result = new EmailBidSettingParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Param"] = this.param;
        data["Example"] = this.example;
        return data;
    }

    clone(): EmailBidSettingParam {
        const json = this.toJSON();
        let result = new EmailBidSettingParam();
        result.init(json);
        return result;
    }
}

export interface IEmailBidSettingParam {
    param?: string | undefined;
    example?: string | undefined;
}

export class SendTestBidEmailModel implements ISendTestBidEmailModel {
    subject?: string | undefined;
    body?: string | undefined;
    fromDisplay?: string | undefined;

    constructor(data?: ISendTestBidEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["Subject"];
            this.body = _data["Body"];
            this.fromDisplay = _data["FromDisplay"];
        }
    }

    static fromJS(data: any): SendTestBidEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestBidEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subject"] = this.subject;
        data["Body"] = this.body;
        data["FromDisplay"] = this.fromDisplay;
        return data;
    }

    clone(): SendTestBidEmailModel {
        const json = this.toJSON();
        let result = new SendTestBidEmailModel();
        result.init(json);
        return result;
    }
}

export interface ISendTestBidEmailModel {
    subject?: string | undefined;
    body?: string | undefined;
    fromDisplay?: string | undefined;
}

export class LogoSettings implements ILogoSettings {
    base64?: string | undefined;

    constructor(data?: ILogoSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["Base64"];
        }
    }

    static fromJS(data: any): LogoSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LogoSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Base64"] = this.base64;
        return data;
    }

    clone(): LogoSettings {
        const json = this.toJSON();
        let result = new LogoSettings();
        result.init(json);
        return result;
    }
}

export interface ILogoSettings {
    base64?: string | undefined;
}

export class DataListResultOfTelegramChannelListModel implements IDataListResultOfTelegramChannelListModel {
    items?: TelegramChannelListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfTelegramChannelListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TelegramChannelListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfTelegramChannelListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfTelegramChannelListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfTelegramChannelListModel {
        const json = this.toJSON();
        let result = new DataListResultOfTelegramChannelListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfTelegramChannelListModel {
    items?: TelegramChannelListModel[] | undefined;
    count?: number;
}

export class TelegramChannelListModel implements ITelegramChannelListModel {
    id?: number;
    title?: string | undefined;
    createdAt?: moment.Moment;
    telegramSettingsCount?: number;

    constructor(data?: ITelegramChannelListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.telegramSettingsCount = _data["TelegramSettingsCount"];
        }
    }

    static fromJS(data: any): TelegramChannelListModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["TelegramSettingsCount"] = this.telegramSettingsCount;
        return data;
    }

    clone(): TelegramChannelListModel {
        const json = this.toJSON();
        let result = new TelegramChannelListModel();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelListModel {
    id?: number;
    title?: string | undefined;
    createdAt?: moment.Moment;
    telegramSettingsCount?: number;
}

export class DataListGetParamsOfTelegramChannelListFilters implements IDataListGetParamsOfTelegramChannelListFilters {
    filter?: TelegramChannelListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfTelegramChannelListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? TelegramChannelListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfTelegramChannelListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfTelegramChannelListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfTelegramChannelListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfTelegramChannelListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfTelegramChannelListFilters {
    filter?: TelegramChannelListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class TelegramChannelListFilters implements ITelegramChannelListFilters {
    search?: string | undefined;

    constructor(data?: ITelegramChannelListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): TelegramChannelListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): TelegramChannelListFilters {
        const json = this.toJSON();
        let result = new TelegramChannelListFilters();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelListFilters {
    search?: string | undefined;
}

export class DataListResultOfTelegramChannelSettingsListModel implements IDataListResultOfTelegramChannelSettingsListModel {
    items?: TelegramChannelSettingsListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfTelegramChannelSettingsListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TelegramChannelSettingsListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfTelegramChannelSettingsListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfTelegramChannelSettingsListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfTelegramChannelSettingsListModel {
        const json = this.toJSON();
        let result = new DataListResultOfTelegramChannelSettingsListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfTelegramChannelSettingsListModel {
    items?: TelegramChannelSettingsListModel[] | undefined;
    count?: number;
}

export class TelegramChannelSettingsListModel implements ITelegramChannelSettingsListModel {
    id?: number;
    title?: string | undefined;
    vehicleNumbers?: string[] | undefined;
    drivers?: string[] | undefined;
    createdAt?: moment.Moment;
    active?: boolean;
    type?: TelegramChannelType;

    constructor(data?: ITelegramChannelSettingsListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            if (Array.isArray(_data["VehicleNumbers"])) {
                this.vehicleNumbers = [] as any;
                for (let item of _data["VehicleNumbers"])
                    this.vehicleNumbers!.push(item);
            }
            if (Array.isArray(_data["Drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["Drivers"])
                    this.drivers!.push(item);
            }
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.active = _data["Active"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): TelegramChannelSettingsListModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelSettingsListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        if (Array.isArray(this.vehicleNumbers)) {
            data["VehicleNumbers"] = [];
            for (let item of this.vehicleNumbers)
                data["VehicleNumbers"].push(item);
        }
        if (Array.isArray(this.drivers)) {
            data["Drivers"] = [];
            for (let item of this.drivers)
                data["Drivers"].push(item);
        }
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Active"] = this.active;
        data["Type"] = this.type;
        return data;
    }

    clone(): TelegramChannelSettingsListModel {
        const json = this.toJSON();
        let result = new TelegramChannelSettingsListModel();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelSettingsListModel {
    id?: number;
    title?: string | undefined;
    vehicleNumbers?: string[] | undefined;
    drivers?: string[] | undefined;
    createdAt?: moment.Moment;
    active?: boolean;
    type?: TelegramChannelType;
}

export class DataListGetParamsOfTelegramChannelSettingsListFilters implements IDataListGetParamsOfTelegramChannelSettingsListFilters {
    filter?: TelegramChannelSettingsListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfTelegramChannelSettingsListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? TelegramChannelSettingsListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfTelegramChannelSettingsListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfTelegramChannelSettingsListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfTelegramChannelSettingsListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfTelegramChannelSettingsListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfTelegramChannelSettingsListFilters {
    filter?: TelegramChannelSettingsListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class TelegramChannelSettingsListFilters implements ITelegramChannelSettingsListFilters {
    search?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ITelegramChannelSettingsListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): TelegramChannelSettingsListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelSettingsListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        return data;
    }

    clone(): TelegramChannelSettingsListFilters {
        const json = this.toJSON();
        let result = new TelegramChannelSettingsListFilters();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelSettingsListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
}

export class TelegramChannelModel implements ITelegramChannelModel {
    id?: number;
    title?: string | undefined;

    constructor(data?: ITelegramChannelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
        }
    }

    static fromJS(data: any): TelegramChannelModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        return data;
    }

    clone(): TelegramChannelModel {
        const json = this.toJSON();
        let result = new TelegramChannelModel();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelModel {
    id?: number;
    title?: string | undefined;
}

export class TelegramChannelSettingsModel implements ITelegramChannelSettingsModel {
    id?: number | undefined;
    active?: boolean;
    telegramChannelId?: number;
    type?: TelegramChannelType;
    vehicleIds?: number[] | undefined;
    driverIds?: number[] | undefined;
    orderFeedSettings?: OrderFeedSettings | undefined;

    constructor(data?: ITelegramChannelSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.telegramChannelId = _data["TelegramChannelId"];
            this.type = _data["Type"];
            if (Array.isArray(_data["VehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["VehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["DriverIds"])) {
                this.driverIds = [] as any;
                for (let item of _data["DriverIds"])
                    this.driverIds!.push(item);
            }
            this.orderFeedSettings = _data["OrderFeedSettings"] ? OrderFeedSettings.fromJS(_data["OrderFeedSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TelegramChannelSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelegramChannelSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["TelegramChannelId"] = this.telegramChannelId;
        data["Type"] = this.type;
        if (Array.isArray(this.vehicleIds)) {
            data["VehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["VehicleIds"].push(item);
        }
        if (Array.isArray(this.driverIds)) {
            data["DriverIds"] = [];
            for (let item of this.driverIds)
                data["DriverIds"].push(item);
        }
        data["OrderFeedSettings"] = this.orderFeedSettings ? this.orderFeedSettings.toJSON() : <any>undefined;
        return data;
    }

    clone(): TelegramChannelSettingsModel {
        const json = this.toJSON();
        let result = new TelegramChannelSettingsModel();
        result.init(json);
        return result;
    }
}

export interface ITelegramChannelSettingsModel {
    id?: number | undefined;
    active?: boolean;
    telegramChannelId?: number;
    type?: TelegramChannelType;
    vehicleIds?: number[] | undefined;
    driverIds?: number[] | undefined;
    orderFeedSettings?: OrderFeedSettings | undefined;
}

export class UserInfo implements IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.userEmail = _data["UserEmail"];
            this.isAdmin = _data["IsAdmin"];
            this.userType = _data["UserType"];
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
            if (Array.isArray(_data["AdminClaims"])) {
                this.adminClaims = [] as any;
                for (let item of _data["AdminClaims"])
                    this.adminClaims!.push(item);
            }
            this.tenantId = _data["TenantId"];
            this.pusherSettings = _data["PusherSettings"] ? PusherSettings.fromJS(_data["PusherSettings"]) : <any>undefined;
            if (Array.isArray(_data["Tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["Tenants"])
                    this.tenants!.push(NamedValueLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["UserEmail"] = this.userEmail;
        data["IsAdmin"] = this.isAdmin;
        data["UserType"] = this.userType;
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        if (Array.isArray(this.adminClaims)) {
            data["AdminClaims"] = [];
            for (let item of this.adminClaims)
                data["AdminClaims"].push(item);
        }
        data["TenantId"] = this.tenantId;
        data["PusherSettings"] = this.pusherSettings ? this.pusherSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.tenants)) {
            data["Tenants"] = [];
            for (let item of this.tenants)
                data["Tenants"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;
}

/** 1 = Internal 2 = Tenant */
export enum UserType {
    Internal = 1,
    Tenant = 2,
}

/** 0 = FullAccess 1 = OrganizationAdmin 2 = UsersListView 3 = UsersEdit 4 = RoleListView 5 = RoleEdit 6 = TenantListView 7 = DriverListView 8 = DriverEdit 9 = CarrierListView 10 = CarrierEdit 11 = IntegrationListView 12 = IntegrationEdit 13 = IntegrationUserSettingsEdit 14 = IntegrationUserSettingsView 15 = VehicleListView 16 = VehicleEdit 17 = OrderTaskEdit 18 = OrderTaskView 19 = EditVehicleAvailability 20 = DeleteFile 21 = TenantNew 22 = CompanyUser 23 = SettingsEditView 24 = RadarView 25 = BidListView 26 = BidWon 27 = BidForceWon 28 = BidReject 29 = BidCreate 30 = OrderListView 31 = OrderEdit 32 = OrderVehicle 33 = OrderDrivers 34 = OrderNew 35 = OrderDraft 36 = OrderReady 37 = OrderOnHold 38 = OrderProgress 39 = OrderCancel 40 = OrderComplete 41 = OrderClose 42 = OrderNotification 43 = CustomerEdit 44 = ContactEdit 45 = TelegramChannelEdit 46 = AccountingInvoicing 47 = AccountingPayments 48 = AccountingAdmin 49 = AccountingSummary 50 = TrackingDeviceEdit 51 = OrderQuoteListView 52 = OrderQuoteEdit 53 = OwnerAccountEdit 54 = OwnerAccountListView 55 = AccountPayout 56 = AccountPayoutAdmin 57 = MobileLogView 58 = Inbox 59 = RateSettingsEdit */
export enum TenantClaims {
    FullAccess = 0,
    OrganizationAdmin = 1,
    UsersListView = 2,
    UsersEdit = 3,
    RoleListView = 4,
    RoleEdit = 5,
    TenantListView = 6,
    DriverListView = 7,
    DriverEdit = 8,
    CarrierListView = 9,
    CarrierEdit = 10,
    IntegrationListView = 11,
    IntegrationEdit = 12,
    IntegrationUserSettingsEdit = 13,
    IntegrationUserSettingsView = 14,
    VehicleListView = 15,
    VehicleEdit = 16,
    OrderTaskEdit = 17,
    OrderTaskView = 18,
    EditVehicleAvailability = 19,
    DeleteFile = 20,
    TenantNew = 21,
    CompanyUser = 22,
    SettingsEditView = 23,
    RadarView = 24,
    BidListView = 25,
    BidWon = 26,
    BidForceWon = 27,
    BidReject = 28,
    BidCreate = 29,
    OrderListView = 30,
    OrderEdit = 31,
    OrderVehicle = 32,
    OrderDrivers = 33,
    OrderNew = 34,
    OrderDraft = 35,
    OrderReady = 36,
    OrderOnHold = 37,
    OrderProgress = 38,
    OrderCancel = 39,
    OrderComplete = 40,
    OrderClose = 41,
    OrderNotification = 42,
    CustomerEdit = 43,
    ContactEdit = 44,
    TelegramChannelEdit = 45,
    AccountingInvoicing = 46,
    AccountingPayments = 47,
    AccountingAdmin = 48,
    AccountingSummary = 49,
    TrackingDeviceEdit = 50,
    OrderQuoteListView = 51,
    OrderQuoteEdit = 52,
    OwnerAccountEdit = 53,
    OwnerAccountListView = 54,
    AccountPayout = 55,
    AccountPayoutAdmin = 56,
    MobileLogView = 57,
    Inbox = 58,
    RateSettingsEdit = 59,
}

/** 0 = FullAccess 1 = HangfireDashboard */
export enum InternalClaims {
    FullAccess = 0,
    HangfireDashboard = 1,
}

export class PusherSettings implements IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;

    constructor(data?: IPusherSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cluster = _data["Cluster"];
            this.appKey = _data["AppKey"];
            this.pusherNamespace = _data["PusherNamespace"];
            this.channelAuthorization = _data["ChannelAuthorization"];
        }
    }

    static fromJS(data: any): PusherSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PusherSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Cluster"] = this.cluster;
        data["AppKey"] = this.appKey;
        data["PusherNamespace"] = this.pusherNamespace;
        data["ChannelAuthorization"] = this.channelAuthorization;
        return data;
    }

    clone(): PusherSettings {
        const json = this.toJSON();
        let result = new PusherSettings();
        result.init(json);
        return result;
    }
}

export interface IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;
}

export class TenantInfo implements ITenantInfo {
    name?: string | undefined;
    states?: State[] | undefined;
    cargoTypes?: EnumViewItem[] | undefined;

    constructor(data?: ITenantInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(State.fromJS(item));
            }
            if (Array.isArray(_data["CargoTypes"])) {
                this.cargoTypes = [] as any;
                for (let item of _data["CargoTypes"])
                    this.cargoTypes!.push(EnumViewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TenantInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item.toJSON());
        }
        if (Array.isArray(this.cargoTypes)) {
            data["CargoTypes"] = [];
            for (let item of this.cargoTypes)
                data["CargoTypes"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantInfo {
        const json = this.toJSON();
        let result = new TenantInfo();
        result.init(json);
        return result;
    }
}

export interface ITenantInfo {
    name?: string | undefined;
    states?: State[] | undefined;
    cargoTypes?: EnumViewItem[] | undefined;
}

export class State implements IState {
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Code"] = this.code;
        return data;
    }

    clone(): State {
        const json = this.toJSON();
        let result = new State();
        result.init(json);
        return result;
    }
}

export interface IState {
    name?: string | undefined;
    code?: string | undefined;
}

export class EnumViewItem implements IEnumViewItem {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IEnumViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): EnumViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnumViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): EnumViewItem {
        const json = this.toJSON();
        let result = new EnumViewItem();
        result.init(json);
        return result;
    }
}

export interface IEnumViewItem {
    id?: string | undefined;
    name?: string | undefined;
}

export class DataListResultOfTrackingDeviceModel implements IDataListResultOfTrackingDeviceModel {
    items?: TrackingDeviceModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfTrackingDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TrackingDeviceModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfTrackingDeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfTrackingDeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfTrackingDeviceModel {
        const json = this.toJSON();
        let result = new DataListResultOfTrackingDeviceModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfTrackingDeviceModel {
    items?: TrackingDeviceModel[] | undefined;
    count?: number;
}

export class TrackingDeviceModel implements ITrackingDeviceModel {
    id?: number;
    name?: string | undefined;
    phoneNumber?: number;
    vehicle?: string | undefined;
    vehicleCarrier?: string | undefined;
    driver?: string | undefined;
    driverCarrier?: string | undefined;
    enableVehicleLocationUpdate?: boolean;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    createdAt?: moment.Moment;
    active?: boolean;
    isDeviceTrackingEnabled?: boolean;
    deviceData?: DeviceData | undefined;

    constructor(data?: ITrackingDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.phoneNumber = _data["PhoneNumber"];
            this.vehicle = _data["Vehicle"];
            this.vehicleCarrier = _data["VehicleCarrier"];
            this.driver = _data["Driver"];
            this.driverCarrier = _data["DriverCarrier"];
            this.enableVehicleLocationUpdate = _data["EnableVehicleLocationUpdate"];
            this.displayLocation = _data["DisplayLocation"];
            this.location = _data["Location"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.active = _data["Active"];
            this.isDeviceTrackingEnabled = _data["IsDeviceTrackingEnabled"];
            this.deviceData = _data["DeviceData"] ? DeviceData.fromJS(_data["DeviceData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrackingDeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingDeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["PhoneNumber"] = this.phoneNumber;
        data["Vehicle"] = this.vehicle;
        data["VehicleCarrier"] = this.vehicleCarrier;
        data["Driver"] = this.driver;
        data["DriverCarrier"] = this.driverCarrier;
        data["EnableVehicleLocationUpdate"] = this.enableVehicleLocationUpdate;
        data["DisplayLocation"] = this.displayLocation;
        data["Location"] = this.location;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Active"] = this.active;
        data["IsDeviceTrackingEnabled"] = this.isDeviceTrackingEnabled;
        data["DeviceData"] = this.deviceData ? this.deviceData.toJSON() : <any>undefined;
        return data;
    }

    clone(): TrackingDeviceModel {
        const json = this.toJSON();
        let result = new TrackingDeviceModel();
        result.init(json);
        return result;
    }
}

export interface ITrackingDeviceModel {
    id?: number;
    name?: string | undefined;
    phoneNumber?: number;
    vehicle?: string | undefined;
    vehicleCarrier?: string | undefined;
    driver?: string | undefined;
    driverCarrier?: string | undefined;
    enableVehicleLocationUpdate?: boolean;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    createdAt?: moment.Moment;
    active?: boolean;
    isDeviceTrackingEnabled?: boolean;
    deviceData?: DeviceData | undefined;
}

export class DataListGetParamsOfTrackingDeviceListFilters implements IDataListGetParamsOfTrackingDeviceListFilters {
    filter?: TrackingDeviceListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfTrackingDeviceListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? TrackingDeviceListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfTrackingDeviceListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfTrackingDeviceListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfTrackingDeviceListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfTrackingDeviceListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfTrackingDeviceListFilters {
    filter?: TrackingDeviceListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class TrackingDeviceListFilters implements ITrackingDeviceListFilters {
    search?: string | undefined;

    constructor(data?: ITrackingDeviceListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): TrackingDeviceListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingDeviceListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): TrackingDeviceListFilters {
        const json = this.toJSON();
        let result = new TrackingDeviceListFilters();
        result.init(json);
        return result;
    }
}

export interface ITrackingDeviceListFilters {
    search?: string | undefined;
}

export class TrackingDeviceEditModel implements ITrackingDeviceEditModel {
    id?: number;
    name?: string | undefined;
    vehicleId?: number | undefined;
    enableVehicleLocationUpdate?: boolean;
    active?: boolean;

    constructor(data?: ITrackingDeviceEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.vehicleId = _data["VehicleId"];
            this.enableVehicleLocationUpdate = _data["EnableVehicleLocationUpdate"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): TrackingDeviceEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingDeviceEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["VehicleId"] = this.vehicleId;
        data["EnableVehicleLocationUpdate"] = this.enableVehicleLocationUpdate;
        data["Active"] = this.active;
        return data;
    }

    clone(): TrackingDeviceEditModel {
        const json = this.toJSON();
        let result = new TrackingDeviceEditModel();
        result.init(json);
        return result;
    }
}

export interface ITrackingDeviceEditModel {
    id?: number;
    name?: string | undefined;
    vehicleId?: number | undefined;
    enableVehicleLocationUpdate?: boolean;
    active?: boolean;
}

export class DataListResultOfVehicleListModel implements IDataListResultOfVehicleListModel {
    items?: VehicleListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfVehicleListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(VehicleListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfVehicleListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfVehicleListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfVehicleListModel {
        const json = this.toJSON();
        let result = new DataListResultOfVehicleListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfVehicleListModel {
    items?: VehicleListModel[] | undefined;
    count?: number;
}

export class VehicleListModel implements IVehicleListModel {
    id?: number;
    createdAt?: moment.Moment;
    number?: number;
    vIN?: string | undefined;
    specs?: string | undefined;
    dims?: string | undefined;
    displayName?: string | undefined;
    active?: boolean;
    type?: VehicleType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    maxLoad?: number;
    carrierName?: string | undefined;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    hasIntegrations?: boolean;
    distance?: number | undefined;
    registrationExpirationDate?: moment.Moment;
    rating?: RatingModel | undefined;
    customPeriodRating?: RatingModel | undefined;
    carrierRating?: RatingModel | undefined;
    carrierCustomPeriodRating?: RatingModel | undefined;

    constructor(data?: IVehicleListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.number = _data["Number"];
            this.vIN = _data["VIN"];
            this.specs = _data["Specs"];
            this.dims = _data["Dims"];
            this.displayName = _data["DisplayName"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.licenseState = _data["LicenseState"];
            this.licenseNumber = _data["LicenseNumber"];
            this.maxLoad = _data["MaxLoad"];
            this.carrierName = _data["CarrierName"];
            this.displayLocation = _data["DisplayLocation"];
            this.location = _data["Location"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.hasIntegrations = _data["HasIntegrations"];
            this.distance = _data["Distance"];
            this.registrationExpirationDate = _data["RegistrationExpirationDate"] ? moment(_data["RegistrationExpirationDate"].toString()) : <any>undefined;
            this.rating = _data["Rating"] ? RatingModel.fromJS(_data["Rating"]) : <any>undefined;
            this.customPeriodRating = _data["CustomPeriodRating"] ? RatingModel.fromJS(_data["CustomPeriodRating"]) : <any>undefined;
            this.carrierRating = _data["CarrierRating"] ? RatingModel.fromJS(_data["CarrierRating"]) : <any>undefined;
            this.carrierCustomPeriodRating = _data["CarrierCustomPeriodRating"] ? RatingModel.fromJS(_data["CarrierCustomPeriodRating"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleListModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Number"] = this.number;
        data["VIN"] = this.vIN;
        data["Specs"] = this.specs;
        data["Dims"] = this.dims;
        data["DisplayName"] = this.displayName;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["LicenseState"] = this.licenseState;
        data["LicenseNumber"] = this.licenseNumber;
        data["MaxLoad"] = this.maxLoad;
        data["CarrierName"] = this.carrierName;
        data["DisplayLocation"] = this.displayLocation;
        data["Location"] = this.location;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["HasIntegrations"] = this.hasIntegrations;
        data["Distance"] = this.distance;
        data["RegistrationExpirationDate"] = this.registrationExpirationDate ? this.registrationExpirationDate.toISOString() : <any>undefined;
        data["Rating"] = this.rating ? this.rating.toJSON() : <any>undefined;
        data["CustomPeriodRating"] = this.customPeriodRating ? this.customPeriodRating.toJSON() : <any>undefined;
        data["CarrierRating"] = this.carrierRating ? this.carrierRating.toJSON() : <any>undefined;
        data["CarrierCustomPeriodRating"] = this.carrierCustomPeriodRating ? this.carrierCustomPeriodRating.toJSON() : <any>undefined;
        return data;
    }

    clone(): VehicleListModel {
        const json = this.toJSON();
        let result = new VehicleListModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleListModel {
    id?: number;
    createdAt?: moment.Moment;
    number?: number;
    vIN?: string | undefined;
    specs?: string | undefined;
    dims?: string | undefined;
    displayName?: string | undefined;
    active?: boolean;
    type?: VehicleType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    maxLoad?: number;
    carrierName?: string | undefined;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    hasIntegrations?: boolean;
    distance?: number | undefined;
    registrationExpirationDate?: moment.Moment;
    rating?: RatingModel | undefined;
    customPeriodRating?: RatingModel | undefined;
    carrierRating?: RatingModel | undefined;
    carrierCustomPeriodRating?: RatingModel | undefined;
}

export class DataListGetParamsOfVehicleListFilters implements IDataListGetParamsOfVehicleListFilters {
    filter?: VehicleListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfVehicleListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? VehicleListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfVehicleListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfVehicleListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfVehicleListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfVehicleListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfVehicleListFilters {
    filter?: VehicleListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class VehicleListFilters implements IVehicleListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;
    zip?: string | undefined;
    radius?: number | undefined;

    constructor(data?: IVehicleListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.active = _data["Active"];
            this.carrierId = _data["CarrierId"];
            this.zip = _data["Zip"];
            this.radius = _data["Radius"];
        }
    }

    static fromJS(data: any): VehicleListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["Active"] = this.active;
        data["CarrierId"] = this.carrierId;
        data["Zip"] = this.zip;
        data["Radius"] = this.radius;
        return data;
    }

    clone(): VehicleListFilters {
        const json = this.toJSON();
        let result = new VehicleListFilters();
        result.init(json);
        return result;
    }
}

export interface IVehicleListFilters {
    search?: string | undefined;
    active?: boolean | undefined;
    carrierId?: number | undefined;
    zip?: string | undefined;
    radius?: number | undefined;
}

export class VehicleShortListModel implements IVehicleShortListModel {
    id?: number;
    displayName?: string | undefined;
    carrierId?: number | undefined;
    specs?: string | undefined;
    dims?: string | undefined;
    carrierName?: string | undefined;
    number?: number;
    location?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    locatedAt?: moment.Moment | undefined;
    displayLocation?: string | undefined;
    vehicleType?: VehicleType;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    hasPalletJack?: boolean;
    latestBidAt?: moment.Moment | undefined;

    constructor(data?: IVehicleShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.displayName = _data["DisplayName"];
            this.carrierId = _data["CarrierId"];
            this.specs = _data["Specs"];
            this.dims = _data["Dims"];
            this.carrierName = _data["CarrierName"];
            this.number = _data["Number"];
            this.location = _data["Location"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.displayLocation = _data["DisplayLocation"];
            this.vehicleType = _data["VehicleType"];
            this.isDockHigh = _data["IsDockHigh"];
            this.hasLiftGate = _data["HasLiftGate"];
            this.hasPalletJack = _data["HasPalletJack"];
            this.latestBidAt = _data["LatestBidAt"] ? moment(_data["LatestBidAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DisplayName"] = this.displayName;
        data["CarrierId"] = this.carrierId;
        data["Specs"] = this.specs;
        data["Dims"] = this.dims;
        data["CarrierName"] = this.carrierName;
        data["Number"] = this.number;
        data["Location"] = this.location;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["DisplayLocation"] = this.displayLocation;
        data["VehicleType"] = this.vehicleType;
        data["IsDockHigh"] = this.isDockHigh;
        data["HasLiftGate"] = this.hasLiftGate;
        data["HasPalletJack"] = this.hasPalletJack;
        data["LatestBidAt"] = this.latestBidAt ? this.latestBidAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): VehicleShortListModel {
        const json = this.toJSON();
        let result = new VehicleShortListModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleShortListModel {
    id?: number;
    displayName?: string | undefined;
    carrierId?: number | undefined;
    specs?: string | undefined;
    dims?: string | undefined;
    carrierName?: string | undefined;
    number?: number;
    location?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
    locatedAt?: moment.Moment | undefined;
    displayLocation?: string | undefined;
    vehicleType?: VehicleType;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    hasPalletJack?: boolean;
    latestBidAt?: moment.Moment | undefined;
}

export class VehicleAvailabilityModel implements IVehicleAvailabilityModel {
    id?: number;
    number?: number;
    model?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locationAt?: moment.Moment | undefined;
    lastBookedAt?: moment.Moment | undefined;
    lastBookedOrderId?: number | undefined;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    hasIntegration?: boolean;
    orders?: VehicleAvailabilityOrderModel[] | undefined;
    availability?: FleetViewVehicleAvailabilityModel | undefined;
    status?: VehicleRadarAvailabilityStatus;
    speed?: number | undefined;
    lat?: number | undefined;
    lon?: number | undefined;

    constructor(data?: IVehicleAvailabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.number = _data["Number"];
            this.model = _data["Model"];
            this.year = _data["Year"];
            this.make = _data["Make"];
            this.displayLocation = _data["DisplayLocation"];
            this.location = _data["Location"];
            this.locationAt = _data["LocationAt"] ? moment(_data["LocationAt"].toString()) : <any>undefined;
            this.lastBookedAt = _data["LastBookedAt"] ? moment(_data["LastBookedAt"].toString()) : <any>undefined;
            this.lastBookedOrderId = _data["LastBookedOrderId"];
            this.carrierId = _data["CarrierId"];
            this.carrierName = _data["CarrierName"];
            this.hasIntegration = _data["HasIntegration"];
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(VehicleAvailabilityOrderModel.fromJS(item));
            }
            this.availability = _data["Availability"] ? FleetViewVehicleAvailabilityModel.fromJS(_data["Availability"]) : <any>undefined;
            this.status = _data["Status"];
            this.speed = _data["Speed"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
        }
    }

    static fromJS(data: any): VehicleAvailabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAvailabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Number"] = this.number;
        data["Model"] = this.model;
        data["Year"] = this.year;
        data["Make"] = this.make;
        data["DisplayLocation"] = this.displayLocation;
        data["Location"] = this.location;
        data["LocationAt"] = this.locationAt ? this.locationAt.toISOString() : <any>undefined;
        data["LastBookedAt"] = this.lastBookedAt ? this.lastBookedAt.toISOString() : <any>undefined;
        data["LastBookedOrderId"] = this.lastBookedOrderId;
        data["CarrierId"] = this.carrierId;
        data["CarrierName"] = this.carrierName;
        data["HasIntegration"] = this.hasIntegration;
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        data["Availability"] = this.availability ? this.availability.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["Speed"] = this.speed;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        return data;
    }

    clone(): VehicleAvailabilityModel {
        const json = this.toJSON();
        let result = new VehicleAvailabilityModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleAvailabilityModel {
    id?: number;
    number?: number;
    model?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    displayLocation?: string | undefined;
    location?: string | undefined;
    locationAt?: moment.Moment | undefined;
    lastBookedAt?: moment.Moment | undefined;
    lastBookedOrderId?: number | undefined;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    hasIntegration?: boolean;
    orders?: VehicleAvailabilityOrderModel[] | undefined;
    availability?: FleetViewVehicleAvailabilityModel | undefined;
    status?: VehicleRadarAvailabilityStatus;
    speed?: number | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
}

export class VehicleAvailabilityOrderModel implements IVehicleAvailabilityOrderModel {
    orderId?: number;
    pickUpDate?: moment.Moment;
    pickUpLocation?: string | undefined;
    deliveryDate?: moment.Moment;
    deliveryLocation?: string | undefined;

    constructor(data?: IVehicleAvailabilityOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.pickUpDate = _data["PickUpDate"] ? moment(_data["PickUpDate"].toString()) : <any>undefined;
            this.pickUpLocation = _data["PickUpLocation"];
            this.deliveryDate = _data["DeliveryDate"] ? moment(_data["DeliveryDate"].toString()) : <any>undefined;
            this.deliveryLocation = _data["DeliveryLocation"];
        }
    }

    static fromJS(data: any): VehicleAvailabilityOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAvailabilityOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["PickUpDate"] = this.pickUpDate ? this.pickUpDate.toISOString() : <any>undefined;
        data["PickUpLocation"] = this.pickUpLocation;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["DeliveryLocation"] = this.deliveryLocation;
        return data;
    }

    clone(): VehicleAvailabilityOrderModel {
        const json = this.toJSON();
        let result = new VehicleAvailabilityOrderModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleAvailabilityOrderModel {
    orderId?: number;
    pickUpDate?: moment.Moment;
    pickUpLocation?: string | undefined;
    deliveryDate?: moment.Moment;
    deliveryLocation?: string | undefined;
}

export class FleetViewVehicleAvailabilityModel implements IFleetViewVehicleAvailabilityModel {
    availableAt?: moment.Moment | undefined;
    status?: VehicleAvailabilityStatus;
    location?: string | undefined;
    states?: string[] | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number | undefined;
    partial?: boolean;
    note?: string | undefined;

    constructor(data?: IFleetViewVehicleAvailabilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableAt = _data["AvailableAt"] ? moment(_data["AvailableAt"].toString()) : <any>undefined;
            this.status = _data["Status"];
            this.location = _data["Location"];
            if (Array.isArray(_data["States"])) {
                this.states = [] as any;
                for (let item of _data["States"])
                    this.states!.push(item);
            }
            this.maxMiles = _data["MaxMiles"];
            this.pickUpRadius = _data["PickUpRadius"];
            this.partial = _data["Partial"];
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): FleetViewVehicleAvailabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new FleetViewVehicleAvailabilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AvailableAt"] = this.availableAt ? this.availableAt.toISOString() : <any>undefined;
        data["Status"] = this.status;
        data["Location"] = this.location;
        if (Array.isArray(this.states)) {
            data["States"] = [];
            for (let item of this.states)
                data["States"].push(item);
        }
        data["MaxMiles"] = this.maxMiles;
        data["PickUpRadius"] = this.pickUpRadius;
        data["Partial"] = this.partial;
        data["Note"] = this.note;
        return data;
    }

    clone(): FleetViewVehicleAvailabilityModel {
        const json = this.toJSON();
        let result = new FleetViewVehicleAvailabilityModel();
        result.init(json);
        return result;
    }
}

export interface IFleetViewVehicleAvailabilityModel {
    availableAt?: moment.Moment | undefined;
    status?: VehicleAvailabilityStatus;
    location?: string | undefined;
    states?: string[] | undefined;
    maxMiles?: number | undefined;
    pickUpRadius?: number | undefined;
    partial?: boolean;
    note?: string | undefined;
}

/** 1 = Available 2 = InProgressAvailable 3 = InProgress 4 = Unavailable 5 = Broken */
export enum VehicleRadarAvailabilityStatus {
    Available = 1,
    InProgressAvailable = 2,
    InProgress = 3,
    Unavailable = 4,
    Broken = 5,
}

export class UpdateVehicleAvailabilityModel extends FleetViewVehicleAvailabilityModel implements IUpdateVehicleAvailabilityModel {
    vehicleId?: number;

    constructor(data?: IUpdateVehicleAvailabilityModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.vehicleId = _data["VehicleId"];
        }
    }

    static override fromJS(data: any): UpdateVehicleAvailabilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleAvailabilityModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        super.toJSON(data);
        return data;
    }

    clone(): UpdateVehicleAvailabilityModel {
        const json = this.toJSON();
        let result = new UpdateVehicleAvailabilityModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleAvailabilityModel extends IFleetViewVehicleAvailabilityModel {
    vehicleId?: number;
}

export class VehicleFleetViewModel extends VehicleShortListModel implements IVehicleFleetViewModel {
    speed?: number | undefined;
    fuel?: number | undefined;
    model?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    bearing?: any | undefined;
    orderIds?: VehicleFleetOrderViewModel[] | undefined;

    constructor(data?: IVehicleFleetViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.speed = _data["Speed"];
            this.fuel = _data["Fuel"];
            this.model = _data["Model"];
            this.year = _data["Year"];
            this.make = _data["Make"];
            this.bearing = _data["Bearing"];
            if (Array.isArray(_data["OrderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["OrderIds"])
                    this.orderIds!.push(VehicleFleetOrderViewModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): VehicleFleetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleFleetViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Speed"] = this.speed;
        data["Fuel"] = this.fuel;
        data["Model"] = this.model;
        data["Year"] = this.year;
        data["Make"] = this.make;
        data["Bearing"] = this.bearing;
        if (Array.isArray(this.orderIds)) {
            data["OrderIds"] = [];
            for (let item of this.orderIds)
                data["OrderIds"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): VehicleFleetViewModel {
        const json = this.toJSON();
        let result = new VehicleFleetViewModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleFleetViewModel extends IVehicleShortListModel {
    speed?: number | undefined;
    fuel?: number | undefined;
    model?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    bearing?: any | undefined;
    orderIds?: VehicleFleetOrderViewModel[] | undefined;
}

export class VehicleFleetOrderViewModel implements IVehicleFleetOrderViewModel {
    orderId?: number;
    from?: string | undefined;
    to?: string | undefined;

    constructor(data?: IVehicleFleetOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["OrderId"];
            this.from = _data["From"];
            this.to = _data["To"];
        }
    }

    static fromJS(data: any): VehicleFleetOrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleFleetOrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderId"] = this.orderId;
        data["From"] = this.from;
        data["To"] = this.to;
        return data;
    }

    clone(): VehicleFleetOrderViewModel {
        const json = this.toJSON();
        let result = new VehicleFleetOrderViewModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleFleetOrderViewModel {
    orderId?: number;
    from?: string | undefined;
    to?: string | undefined;
}

export class VehicleEditModel implements IVehicleEditModel {
    id?: number | undefined;
    number?: number;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    active?: boolean | undefined;
    type?: VehicleType;
    fuelType?: FuelType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    doorWidth?: number;
    doorHeight?: number;
    boxHeight?: number;
    boxWidth?: number;
    boxLength?: number;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    liftGate?: number | undefined;
    hasAirRide?: boolean;
    hasETrack?: boolean;
    hasStraps?: boolean;
    hasBlankets?: boolean;
    maxLoad?: number;
    hasPalletJack?: boolean;
    hasTeam?: boolean;
    floorType?: VehicleFloorType;
    hasSideDoor?: boolean;
    hasRamps?: boolean;
    carrierId?: number | undefined;
    defaultDriverIds?: number[] | undefined;
    registrationExpirationDate?: moment.Moment;

    constructor(data?: IVehicleEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.number = _data["Number"];
            this.vIN = _data["VIN"];
            this.year = _data["Year"];
            this.make = _data["Make"];
            this.model = _data["Model"];
            this.active = _data["Active"];
            this.type = _data["Type"];
            this.fuelType = _data["FuelType"];
            this.licenseState = _data["LicenseState"];
            this.licenseNumber = _data["LicenseNumber"];
            this.doorWidth = _data["DoorWidth"];
            this.doorHeight = _data["DoorHeight"];
            this.boxHeight = _data["BoxHeight"];
            this.boxWidth = _data["BoxWidth"];
            this.boxLength = _data["BoxLength"];
            this.isDockHigh = _data["IsDockHigh"];
            this.hasLiftGate = _data["HasLiftGate"];
            this.liftGate = _data["LiftGate"];
            this.hasAirRide = _data["HasAirRide"];
            this.hasETrack = _data["HasETrack"];
            this.hasStraps = _data["HasStraps"];
            this.hasBlankets = _data["HasBlankets"];
            this.maxLoad = _data["MaxLoad"];
            this.hasPalletJack = _data["HasPalletJack"];
            this.hasTeam = _data["HasTeam"];
            this.floorType = _data["FloorType"];
            this.hasSideDoor = _data["HasSideDoor"];
            this.hasRamps = _data["HasRamps"];
            this.carrierId = _data["CarrierId"];
            if (Array.isArray(_data["DefaultDriverIds"])) {
                this.defaultDriverIds = [] as any;
                for (let item of _data["DefaultDriverIds"])
                    this.defaultDriverIds!.push(item);
            }
            this.registrationExpirationDate = _data["RegistrationExpirationDate"] ? moment(_data["RegistrationExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Number"] = this.number;
        data["VIN"] = this.vIN;
        data["Year"] = this.year;
        data["Make"] = this.make;
        data["Model"] = this.model;
        data["Active"] = this.active;
        data["Type"] = this.type;
        data["FuelType"] = this.fuelType;
        data["LicenseState"] = this.licenseState;
        data["LicenseNumber"] = this.licenseNumber;
        data["DoorWidth"] = this.doorWidth;
        data["DoorHeight"] = this.doorHeight;
        data["BoxHeight"] = this.boxHeight;
        data["BoxWidth"] = this.boxWidth;
        data["BoxLength"] = this.boxLength;
        data["IsDockHigh"] = this.isDockHigh;
        data["HasLiftGate"] = this.hasLiftGate;
        data["LiftGate"] = this.liftGate;
        data["HasAirRide"] = this.hasAirRide;
        data["HasETrack"] = this.hasETrack;
        data["HasStraps"] = this.hasStraps;
        data["HasBlankets"] = this.hasBlankets;
        data["MaxLoad"] = this.maxLoad;
        data["HasPalletJack"] = this.hasPalletJack;
        data["HasTeam"] = this.hasTeam;
        data["FloorType"] = this.floorType;
        data["HasSideDoor"] = this.hasSideDoor;
        data["HasRamps"] = this.hasRamps;
        data["CarrierId"] = this.carrierId;
        if (Array.isArray(this.defaultDriverIds)) {
            data["DefaultDriverIds"] = [];
            for (let item of this.defaultDriverIds)
                data["DefaultDriverIds"].push(item);
        }
        data["RegistrationExpirationDate"] = this.registrationExpirationDate ? this.registrationExpirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): VehicleEditModel {
        const json = this.toJSON();
        let result = new VehicleEditModel();
        result.init(json);
        return result;
    }
}

export interface IVehicleEditModel {
    id?: number | undefined;
    number?: number;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    active?: boolean | undefined;
    type?: VehicleType;
    fuelType?: FuelType;
    licenseState?: string | undefined;
    licenseNumber?: string | undefined;
    doorWidth?: number;
    doorHeight?: number;
    boxHeight?: number;
    boxWidth?: number;
    boxLength?: number;
    isDockHigh?: boolean;
    hasLiftGate?: boolean;
    liftGate?: number | undefined;
    hasAirRide?: boolean;
    hasETrack?: boolean;
    hasStraps?: boolean;
    hasBlankets?: boolean;
    maxLoad?: number;
    hasPalletJack?: boolean;
    hasTeam?: boolean;
    floorType?: VehicleFloorType;
    hasSideDoor?: boolean;
    hasRamps?: boolean;
    carrierId?: number | undefined;
    defaultDriverIds?: number[] | undefined;
    registrationExpirationDate?: moment.Moment;
}

export class VehicleTrackingData implements IVehicleTrackingData {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    speed?: number | undefined;
    description?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    eLDIntegration?: string | undefined;
    deviceData?: DeviceData | undefined;
    isDeviceTrackingEnabled?: boolean;

    constructor(data?: IVehicleTrackingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["VehicleId"];
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.speed = _data["Speed"];
            this.description = _data["Description"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.eLDIntegration = _data["ELDIntegration"];
            this.deviceData = _data["DeviceData"] ? DeviceData.fromJS(_data["DeviceData"]) : <any>undefined;
            this.isDeviceTrackingEnabled = _data["IsDeviceTrackingEnabled"];
        }
    }

    static fromJS(data: any): VehicleTrackingData {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTrackingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["Speed"] = this.speed;
        data["Description"] = this.description;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["ELDIntegration"] = this.eLDIntegration;
        data["DeviceData"] = this.deviceData ? this.deviceData.toJSON() : <any>undefined;
        data["IsDeviceTrackingEnabled"] = this.isDeviceTrackingEnabled;
        return data;
    }

    clone(): VehicleTrackingData {
        const json = this.toJSON();
        let result = new VehicleTrackingData();
        result.init(json);
        return result;
    }
}

export interface IVehicleTrackingData {
    vehicleId?: number;
    lat?: number | undefined;
    lon?: number | undefined;
    speed?: number | undefined;
    description?: string | undefined;
    locatedAt?: moment.Moment | undefined;
    eLDIntegration?: string | undefined;
    deviceData?: DeviceData | undefined;
    isDeviceTrackingEnabled?: boolean;
}

export class VehicleLocationHistoryPoint implements IVehicleLocationHistoryPoint {
    lat?: number;
    lon?: number;
    speed?: number;
    description?: string | undefined;
    locatedAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    distance?: number;

    constructor(data?: IVehicleLocationHistoryPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["Lat"];
            this.lon = _data["Lon"];
            this.speed = _data["Speed"];
            this.description = _data["Description"];
            this.locatedAt = _data["LocatedAt"] ? moment(_data["LocatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? moment(_data["UpdatedAt"].toString()) : <any>undefined;
            this.distance = _data["Distance"];
        }
    }

    static fromJS(data: any): VehicleLocationHistoryPoint {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocationHistoryPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Lat"] = this.lat;
        data["Lon"] = this.lon;
        data["Speed"] = this.speed;
        data["Description"] = this.description;
        data["LocatedAt"] = this.locatedAt ? this.locatedAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["Distance"] = this.distance;
        return data;
    }

    clone(): VehicleLocationHistoryPoint {
        const json = this.toJSON();
        let result = new VehicleLocationHistoryPoint();
        result.init(json);
        return result;
    }
}

export interface IVehicleLocationHistoryPoint {
    lat?: number;
    lon?: number;
    speed?: number;
    description?: string | undefined;
    locatedAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    distance?: number;
}

export class VehicleLocationHistoryPointsRequest implements IVehicleLocationHistoryPointsRequest {
    vehicleId?: number;
    from?: moment.Moment;
    to?: moment.Moment | undefined;

    constructor(data?: IVehicleLocationHistoryPointsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["VehicleId"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleLocationHistoryPointsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocationHistoryPointsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleId"] = this.vehicleId;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }

    clone(): VehicleLocationHistoryPointsRequest {
        const json = this.toJSON();
        let result = new VehicleLocationHistoryPointsRequest();
        result.init(json);
        return result;
    }
}

export interface IVehicleLocationHistoryPointsRequest {
    vehicleId?: number;
    from?: moment.Moment;
    to?: moment.Moment | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}